// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Host Variables */
:host {
  --grid-auto-row-height: 0;
  --grid-fill-color: var(--ids-layout-grid-color-background);
  --grid-text-color: var(--ids-layout-grid-color-text);
  --min-col-width: 0;
  --max-col-width: 1fr;
  --min-row-height: 0;
  --min-row-width: 1fr;
  --sticky-position: 0;
}

/* Grid Variables */
/* Host and ids-layout-grid Base */
:host,
.ids-layout-grid {
  display: grid;
  grid-gap: 16px;
  justify-content: start;
  box-sizing: border-box;
}

/* Grid Columms - Base */
:host([cols="1"]),
.ids-layout-grid-cols-1 {
  width: 100%;
  grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="1"]),
.ids-layout-grid > .ids-layout-grid-col-span-1 {
  grid-column: span 1/span 1;
}

:host(.ids-layout-grid) > ::slotted([col-start="1"]),
.ids-layout-grid > .ids-layout-grid-col-start-1 {
  grid-column-start: 1;
}

:host(.ids-layout-grid) > ::slotted([col-end="1"]),
.ids-layout-grid > .ids-layout-grid-col-end-1 {
  grid-column-end: 1;
}

:host([cols="2"]),
.ids-layout-grid-cols-2 {
  width: 100%;
  grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="2"]),
.ids-layout-grid > .ids-layout-grid-col-span-2 {
  grid-column: span 2/span 2;
}

:host(.ids-layout-grid) > ::slotted([col-start="2"]),
.ids-layout-grid > .ids-layout-grid-col-start-2 {
  grid-column-start: 2;
}

:host(.ids-layout-grid) > ::slotted([col-end="2"]),
.ids-layout-grid > .ids-layout-grid-col-end-2 {
  grid-column-end: 2;
}

:host([cols="3"]),
.ids-layout-grid-cols-3 {
  width: 100%;
  grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="3"]),
.ids-layout-grid > .ids-layout-grid-col-span-3 {
  grid-column: span 3/span 3;
}

:host(.ids-layout-grid) > ::slotted([col-start="3"]),
.ids-layout-grid > .ids-layout-grid-col-start-3 {
  grid-column-start: 3;
}

:host(.ids-layout-grid) > ::slotted([col-end="3"]),
.ids-layout-grid > .ids-layout-grid-col-end-3 {
  grid-column-end: 3;
}

:host([cols="4"]),
.ids-layout-grid-cols-4 {
  width: 100%;
  grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="4"]),
.ids-layout-grid > .ids-layout-grid-col-span-4 {
  grid-column: span 4/span 4;
}

:host(.ids-layout-grid) > ::slotted([col-start="4"]),
.ids-layout-grid > .ids-layout-grid-col-start-4 {
  grid-column-start: 4;
}

:host(.ids-layout-grid) > ::slotted([col-end="4"]),
.ids-layout-grid > .ids-layout-grid-col-end-4 {
  grid-column-end: 4;
}

:host([cols="5"]),
.ids-layout-grid-cols-5 {
  width: 100%;
  grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="5"]),
.ids-layout-grid > .ids-layout-grid-col-span-5 {
  grid-column: span 5/span 5;
}

:host(.ids-layout-grid) > ::slotted([col-start="5"]),
.ids-layout-grid > .ids-layout-grid-col-start-5 {
  grid-column-start: 5;
}

:host(.ids-layout-grid) > ::slotted([col-end="5"]),
.ids-layout-grid > .ids-layout-grid-col-end-5 {
  grid-column-end: 5;
}

:host([cols="6"]),
.ids-layout-grid-cols-6 {
  width: 100%;
  grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="6"]),
.ids-layout-grid > .ids-layout-grid-col-span-6 {
  grid-column: span 6/span 6;
}

:host(.ids-layout-grid) > ::slotted([col-start="6"]),
.ids-layout-grid > .ids-layout-grid-col-start-6 {
  grid-column-start: 6;
}

:host(.ids-layout-grid) > ::slotted([col-end="6"]),
.ids-layout-grid > .ids-layout-grid-col-end-6 {
  grid-column-end: 6;
}

:host([cols="7"]),
.ids-layout-grid-cols-7 {
  width: 100%;
  grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="7"]),
.ids-layout-grid > .ids-layout-grid-col-span-7 {
  grid-column: span 7/span 7;
}

:host(.ids-layout-grid) > ::slotted([col-start="7"]),
.ids-layout-grid > .ids-layout-grid-col-start-7 {
  grid-column-start: 7;
}

:host(.ids-layout-grid) > ::slotted([col-end="7"]),
.ids-layout-grid > .ids-layout-grid-col-end-7 {
  grid-column-end: 7;
}

:host([cols="8"]),
.ids-layout-grid-cols-8 {
  width: 100%;
  grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="8"]),
.ids-layout-grid > .ids-layout-grid-col-span-8 {
  grid-column: span 8/span 8;
}

:host(.ids-layout-grid) > ::slotted([col-start="8"]),
.ids-layout-grid > .ids-layout-grid-col-start-8 {
  grid-column-start: 8;
}

:host(.ids-layout-grid) > ::slotted([col-end="8"]),
.ids-layout-grid > .ids-layout-grid-col-end-8 {
  grid-column-end: 8;
}

:host([cols="9"]),
.ids-layout-grid-cols-9 {
  width: 100%;
  grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="9"]),
.ids-layout-grid > .ids-layout-grid-col-span-9 {
  grid-column: span 9/span 9;
}

:host(.ids-layout-grid) > ::slotted([col-start="9"]),
.ids-layout-grid > .ids-layout-grid-col-start-9 {
  grid-column-start: 9;
}

:host(.ids-layout-grid) > ::slotted([col-end="9"]),
.ids-layout-grid > .ids-layout-grid-col-end-9 {
  grid-column-end: 9;
}

:host([cols="10"]),
.ids-layout-grid-cols-10 {
  width: 100%;
  grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="10"]),
.ids-layout-grid > .ids-layout-grid-col-span-10 {
  grid-column: span 10/span 10;
}

:host(.ids-layout-grid) > ::slotted([col-start="10"]),
.ids-layout-grid > .ids-layout-grid-col-start-10 {
  grid-column-start: 10;
}

:host(.ids-layout-grid) > ::slotted([col-end="10"]),
.ids-layout-grid > .ids-layout-grid-col-end-10 {
  grid-column-end: 10;
}

:host([cols="11"]),
.ids-layout-grid-cols-11 {
  width: 100%;
  grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="11"]),
.ids-layout-grid > .ids-layout-grid-col-span-11 {
  grid-column: span 11/span 11;
}

:host(.ids-layout-grid) > ::slotted([col-start="11"]),
.ids-layout-grid > .ids-layout-grid-col-start-11 {
  grid-column-start: 11;
}

:host(.ids-layout-grid) > ::slotted([col-end="11"]),
.ids-layout-grid > .ids-layout-grid-col-end-11 {
  grid-column-end: 11;
}

:host([cols="12"]),
.ids-layout-grid-cols-12 {
  width: 100%;
  grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="12"]),
.ids-layout-grid > .ids-layout-grid-col-span-12 {
  grid-column: span 12/span 12;
}

:host(.ids-layout-grid) > ::slotted([col-start="12"]),
.ids-layout-grid > .ids-layout-grid-col-start-12 {
  grid-column-start: 12;
}

:host(.ids-layout-grid) > ::slotted([col-end="12"]),
.ids-layout-grid > .ids-layout-grid-col-end-12 {
  grid-column-end: 12;
}

:host([cols="13"]),
.ids-layout-grid-cols-13 {
  width: 100%;
  grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="13"]),
.ids-layout-grid > .ids-layout-grid-col-span-13 {
  grid-column: span 13/span 13;
}

:host(.ids-layout-grid) > ::slotted([col-start="13"]),
.ids-layout-grid > .ids-layout-grid-col-start-13 {
  grid-column-start: 13;
}

:host(.ids-layout-grid) > ::slotted([col-end="13"]),
.ids-layout-grid > .ids-layout-grid-col-end-13 {
  grid-column-end: 13;
}

:host([cols="14"]),
.ids-layout-grid-cols-14 {
  width: 100%;
  grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="14"]),
.ids-layout-grid > .ids-layout-grid-col-span-14 {
  grid-column: span 14/span 14;
}

:host(.ids-layout-grid) > ::slotted([col-start="14"]),
.ids-layout-grid > .ids-layout-grid-col-start-14 {
  grid-column-start: 14;
}

:host(.ids-layout-grid) > ::slotted([col-end="14"]),
.ids-layout-grid > .ids-layout-grid-col-end-14 {
  grid-column-end: 14;
}

:host([cols="15"]),
.ids-layout-grid-cols-15 {
  width: 100%;
  grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="15"]),
.ids-layout-grid > .ids-layout-grid-col-span-15 {
  grid-column: span 15/span 15;
}

:host(.ids-layout-grid) > ::slotted([col-start="15"]),
.ids-layout-grid > .ids-layout-grid-col-start-15 {
  grid-column-start: 15;
}

:host(.ids-layout-grid) > ::slotted([col-end="15"]),
.ids-layout-grid > .ids-layout-grid-col-end-15 {
  grid-column-end: 15;
}

:host([cols="16"]),
.ids-layout-grid-cols-16 {
  width: 100%;
  grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="16"]),
.ids-layout-grid > .ids-layout-grid-col-span-16 {
  grid-column: span 16/span 16;
}

:host(.ids-layout-grid) > ::slotted([col-start="16"]),
.ids-layout-grid > .ids-layout-grid-col-start-16 {
  grid-column-start: 16;
}

:host(.ids-layout-grid) > ::slotted([col-end="16"]),
.ids-layout-grid > .ids-layout-grid-col-end-16 {
  grid-column-end: 16;
}

:host([cols="17"]),
.ids-layout-grid-cols-17 {
  width: 100%;
  grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="17"]),
.ids-layout-grid > .ids-layout-grid-col-span-17 {
  grid-column: span 17/span 17;
}

:host(.ids-layout-grid) > ::slotted([col-start="17"]),
.ids-layout-grid > .ids-layout-grid-col-start-17 {
  grid-column-start: 17;
}

:host(.ids-layout-grid) > ::slotted([col-end="17"]),
.ids-layout-grid > .ids-layout-grid-col-end-17 {
  grid-column-end: 17;
}

:host([cols="18"]),
.ids-layout-grid-cols-18 {
  width: 100%;
  grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="18"]),
.ids-layout-grid > .ids-layout-grid-col-span-18 {
  grid-column: span 18/span 18;
}

:host(.ids-layout-grid) > ::slotted([col-start="18"]),
.ids-layout-grid > .ids-layout-grid-col-start-18 {
  grid-column-start: 18;
}

:host(.ids-layout-grid) > ::slotted([col-end="18"]),
.ids-layout-grid > .ids-layout-grid-col-end-18 {
  grid-column-end: 18;
}

:host([cols="19"]),
.ids-layout-grid-cols-19 {
  width: 100%;
  grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="19"]),
.ids-layout-grid > .ids-layout-grid-col-span-19 {
  grid-column: span 19/span 19;
}

:host(.ids-layout-grid) > ::slotted([col-start="19"]),
.ids-layout-grid > .ids-layout-grid-col-start-19 {
  grid-column-start: 19;
}

:host(.ids-layout-grid) > ::slotted([col-end="19"]),
.ids-layout-grid > .ids-layout-grid-col-end-19 {
  grid-column-end: 19;
}

:host([cols="20"]),
.ids-layout-grid-cols-20 {
  width: 100%;
  grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="20"]),
.ids-layout-grid > .ids-layout-grid-col-span-20 {
  grid-column: span 20/span 20;
}

:host(.ids-layout-grid) > ::slotted([col-start="20"]),
.ids-layout-grid > .ids-layout-grid-col-start-20 {
  grid-column-start: 20;
}

:host(.ids-layout-grid) > ::slotted([col-end="20"]),
.ids-layout-grid > .ids-layout-grid-col-end-20 {
  grid-column-end: 20;
}

:host([cols="21"]),
.ids-layout-grid-cols-21 {
  width: 100%;
  grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="21"]),
.ids-layout-grid > .ids-layout-grid-col-span-21 {
  grid-column: span 21/span 21;
}

:host(.ids-layout-grid) > ::slotted([col-start="21"]),
.ids-layout-grid > .ids-layout-grid-col-start-21 {
  grid-column-start: 21;
}

:host(.ids-layout-grid) > ::slotted([col-end="21"]),
.ids-layout-grid > .ids-layout-grid-col-end-21 {
  grid-column-end: 21;
}

:host([cols="22"]),
.ids-layout-grid-cols-22 {
  width: 100%;
  grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="22"]),
.ids-layout-grid > .ids-layout-grid-col-span-22 {
  grid-column: span 22/span 22;
}

:host(.ids-layout-grid) > ::slotted([col-start="22"]),
.ids-layout-grid > .ids-layout-grid-col-start-22 {
  grid-column-start: 22;
}

:host(.ids-layout-grid) > ::slotted([col-end="22"]),
.ids-layout-grid > .ids-layout-grid-col-end-22 {
  grid-column-end: 22;
}

:host([cols="23"]),
.ids-layout-grid-cols-23 {
  width: 100%;
  grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="23"]),
.ids-layout-grid > .ids-layout-grid-col-span-23 {
  grid-column: span 23/span 23;
}

:host(.ids-layout-grid) > ::slotted([col-start="23"]),
.ids-layout-grid > .ids-layout-grid-col-start-23 {
  grid-column-start: 23;
}

:host(.ids-layout-grid) > ::slotted([col-end="23"]),
.ids-layout-grid > .ids-layout-grid-col-end-23 {
  grid-column-end: 23;
}

:host([cols="24"]),
.ids-layout-grid-cols-24 {
  width: 100%;
  grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="24"]),
.ids-layout-grid > .ids-layout-grid-col-span-24 {
  grid-column: span 24/span 24;
}

:host(.ids-layout-grid) > ::slotted([col-start="24"]),
.ids-layout-grid > .ids-layout-grid-col-start-24 {
  grid-column-start: 24;
}

:host(.ids-layout-grid) > ::slotted([col-end="24"]),
.ids-layout-grid > .ids-layout-grid-col-end-24 {
  grid-column-end: 24;
}

/* Grid Rows - Base */
:host([rows="1"]),
.ids-layout-grid-rows-1 {
  grid-template-rows: repeat(1, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="1"]),
.ids-layout-grid > .ids-layout-grid-row-span-1 {
  grid-row: span 1/span 1;
}

:host(.ids-layout-grid) > ::slotted([order="1"]),
.ids-layout-grid > .ids-layout-grid-order-1 {
  order: 1;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="2"]),
.ids-layout-grid-rows-2 {
  grid-template-rows: repeat(2, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="2"]),
.ids-layout-grid > .ids-layout-grid-row-span-2 {
  grid-row: span 2/span 2;
}

:host(.ids-layout-grid) > ::slotted([order="2"]),
.ids-layout-grid > .ids-layout-grid-order-2 {
  order: 2;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="3"]),
.ids-layout-grid-rows-3 {
  grid-template-rows: repeat(3, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="3"]),
.ids-layout-grid > .ids-layout-grid-row-span-3 {
  grid-row: span 3/span 3;
}

:host(.ids-layout-grid) > ::slotted([order="3"]),
.ids-layout-grid > .ids-layout-grid-order-3 {
  order: 3;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="4"]),
.ids-layout-grid-rows-4 {
  grid-template-rows: repeat(4, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="4"]),
.ids-layout-grid > .ids-layout-grid-row-span-4 {
  grid-row: span 4/span 4;
}

:host(.ids-layout-grid) > ::slotted([order="4"]),
.ids-layout-grid > .ids-layout-grid-order-4 {
  order: 4;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="5"]),
.ids-layout-grid-rows-5 {
  grid-template-rows: repeat(5, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="5"]),
.ids-layout-grid > .ids-layout-grid-row-span-5 {
  grid-row: span 5/span 5;
}

:host(.ids-layout-grid) > ::slotted([order="5"]),
.ids-layout-grid > .ids-layout-grid-order-5 {
  order: 5;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="6"]),
.ids-layout-grid-rows-6 {
  grid-template-rows: repeat(6, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="6"]),
.ids-layout-grid > .ids-layout-grid-row-span-6 {
  grid-row: span 6/span 6;
}

:host(.ids-layout-grid) > ::slotted([order="6"]),
.ids-layout-grid > .ids-layout-grid-order-6 {
  order: 6;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="7"]),
.ids-layout-grid-rows-7 {
  grid-template-rows: repeat(7, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="7"]),
.ids-layout-grid > .ids-layout-grid-row-span-7 {
  grid-row: span 7/span 7;
}

:host(.ids-layout-grid) > ::slotted([order="7"]),
.ids-layout-grid > .ids-layout-grid-order-7 {
  order: 7;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="8"]),
.ids-layout-grid-rows-8 {
  grid-template-rows: repeat(8, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="8"]),
.ids-layout-grid > .ids-layout-grid-row-span-8 {
  grid-row: span 8/span 8;
}

:host(.ids-layout-grid) > ::slotted([order="8"]),
.ids-layout-grid > .ids-layout-grid-order-8 {
  order: 8;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="9"]),
.ids-layout-grid-rows-9 {
  grid-template-rows: repeat(9, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="9"]),
.ids-layout-grid > .ids-layout-grid-row-span-9 {
  grid-row: span 9/span 9;
}

:host(.ids-layout-grid) > ::slotted([order="9"]),
.ids-layout-grid > .ids-layout-grid-order-9 {
  order: 9;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="10"]),
.ids-layout-grid-rows-10 {
  grid-template-rows: repeat(10, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="10"]),
.ids-layout-grid > .ids-layout-grid-row-span-10 {
  grid-row: span 10/span 10;
}

:host(.ids-layout-grid) > ::slotted([order="10"]),
.ids-layout-grid > .ids-layout-grid-order-10 {
  order: 10;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="11"]),
.ids-layout-grid-rows-11 {
  grid-template-rows: repeat(11, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="11"]),
.ids-layout-grid > .ids-layout-grid-row-span-11 {
  grid-row: span 11/span 11;
}

:host(.ids-layout-grid) > ::slotted([order="11"]),
.ids-layout-grid > .ids-layout-grid-order-11 {
  order: 11;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="12"]),
.ids-layout-grid-rows-12 {
  grid-template-rows: repeat(12, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="12"]),
.ids-layout-grid > .ids-layout-grid-row-span-12 {
  grid-row: span 12/span 12;
}

:host(.ids-layout-grid) > ::slotted([order="12"]),
.ids-layout-grid > .ids-layout-grid-order-12 {
  order: 12;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="13"]),
.ids-layout-grid-rows-13 {
  grid-template-rows: repeat(13, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="13"]),
.ids-layout-grid > .ids-layout-grid-row-span-13 {
  grid-row: span 13/span 13;
}

:host(.ids-layout-grid) > ::slotted([order="13"]),
.ids-layout-grid > .ids-layout-grid-order-13 {
  order: 13;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="14"]),
.ids-layout-grid-rows-14 {
  grid-template-rows: repeat(14, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="14"]),
.ids-layout-grid > .ids-layout-grid-row-span-14 {
  grid-row: span 14/span 14;
}

:host(.ids-layout-grid) > ::slotted([order="14"]),
.ids-layout-grid > .ids-layout-grid-order-14 {
  order: 14;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="15"]),
.ids-layout-grid-rows-15 {
  grid-template-rows: repeat(15, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="15"]),
.ids-layout-grid > .ids-layout-grid-row-span-15 {
  grid-row: span 15/span 15;
}

:host(.ids-layout-grid) > ::slotted([order="15"]),
.ids-layout-grid > .ids-layout-grid-order-15 {
  order: 15;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="16"]),
.ids-layout-grid-rows-16 {
  grid-template-rows: repeat(16, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="16"]),
.ids-layout-grid > .ids-layout-grid-row-span-16 {
  grid-row: span 16/span 16;
}

:host(.ids-layout-grid) > ::slotted([order="16"]),
.ids-layout-grid > .ids-layout-grid-order-16 {
  order: 16;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="17"]),
.ids-layout-grid-rows-17 {
  grid-template-rows: repeat(17, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="17"]),
.ids-layout-grid > .ids-layout-grid-row-span-17 {
  grid-row: span 17/span 17;
}

:host(.ids-layout-grid) > ::slotted([order="17"]),
.ids-layout-grid > .ids-layout-grid-order-17 {
  order: 17;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="18"]),
.ids-layout-grid-rows-18 {
  grid-template-rows: repeat(18, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="18"]),
.ids-layout-grid > .ids-layout-grid-row-span-18 {
  grid-row: span 18/span 18;
}

:host(.ids-layout-grid) > ::slotted([order="18"]),
.ids-layout-grid > .ids-layout-grid-order-18 {
  order: 18;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="19"]),
.ids-layout-grid-rows-19 {
  grid-template-rows: repeat(19, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="19"]),
.ids-layout-grid > .ids-layout-grid-row-span-19 {
  grid-row: span 19/span 19;
}

:host(.ids-layout-grid) > ::slotted([order="19"]),
.ids-layout-grid > .ids-layout-grid-order-19 {
  order: 19;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="20"]),
.ids-layout-grid-rows-20 {
  grid-template-rows: repeat(20, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="20"]),
.ids-layout-grid > .ids-layout-grid-row-span-20 {
  grid-row: span 20/span 20;
}

:host(.ids-layout-grid) > ::slotted([order="20"]),
.ids-layout-grid > .ids-layout-grid-order-20 {
  order: 20;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="21"]),
.ids-layout-grid-rows-21 {
  grid-template-rows: repeat(21, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="21"]),
.ids-layout-grid > .ids-layout-grid-row-span-21 {
  grid-row: span 21/span 21;
}

:host(.ids-layout-grid) > ::slotted([order="21"]),
.ids-layout-grid > .ids-layout-grid-order-21 {
  order: 21;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="22"]),
.ids-layout-grid-rows-22 {
  grid-template-rows: repeat(22, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="22"]),
.ids-layout-grid > .ids-layout-grid-row-span-22 {
  grid-row: span 22/span 22;
}

:host(.ids-layout-grid) > ::slotted([order="22"]),
.ids-layout-grid > .ids-layout-grid-order-22 {
  order: 22;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="23"]),
.ids-layout-grid-rows-23 {
  grid-template-rows: repeat(23, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="23"]),
.ids-layout-grid > .ids-layout-grid-row-span-23 {
  grid-row: span 23/span 23;
}

:host(.ids-layout-grid) > ::slotted([order="23"]),
.ids-layout-grid > .ids-layout-grid-order-23 {
  order: 23;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="24"]),
.ids-layout-grid-rows-24 {
  grid-template-rows: repeat(24, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="24"]),
.ids-layout-grid > .ids-layout-grid-row-span-24 {
  grid-row: span 24/span 24;
}

:host(.ids-layout-grid) > ::slotted([order="24"]),
.ids-layout-grid > .ids-layout-grid-order-24 {
  order: 24;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="25"]),
.ids-layout-grid-rows-25 {
  grid-template-rows: repeat(25, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="25"]),
.ids-layout-grid > .ids-layout-grid-row-span-25 {
  grid-row: span 25/span 25;
}

:host(.ids-layout-grid) > ::slotted([order="25"]),
.ids-layout-grid > .ids-layout-grid-order-25 {
  order: 25;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="26"]),
.ids-layout-grid-rows-26 {
  grid-template-rows: repeat(26, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="26"]),
.ids-layout-grid > .ids-layout-grid-row-span-26 {
  grid-row: span 26/span 26;
}

:host(.ids-layout-grid) > ::slotted([order="26"]),
.ids-layout-grid > .ids-layout-grid-order-26 {
  order: 26;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="27"]),
.ids-layout-grid-rows-27 {
  grid-template-rows: repeat(27, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="27"]),
.ids-layout-grid > .ids-layout-grid-row-span-27 {
  grid-row: span 27/span 27;
}

:host(.ids-layout-grid) > ::slotted([order="27"]),
.ids-layout-grid > .ids-layout-grid-order-27 {
  order: 27;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="28"]),
.ids-layout-grid-rows-28 {
  grid-template-rows: repeat(28, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="28"]),
.ids-layout-grid > .ids-layout-grid-row-span-28 {
  grid-row: span 28/span 28;
}

:host(.ids-layout-grid) > ::slotted([order="28"]),
.ids-layout-grid > .ids-layout-grid-order-28 {
  order: 28;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="29"]),
.ids-layout-grid-rows-29 {
  grid-template-rows: repeat(29, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="29"]),
.ids-layout-grid > .ids-layout-grid-row-span-29 {
  grid-row: span 29/span 29;
}

:host(.ids-layout-grid) > ::slotted([order="29"]),
.ids-layout-grid > .ids-layout-grid-order-29 {
  order: 29;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="30"]),
.ids-layout-grid-rows-30 {
  grid-template-rows: repeat(30, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="30"]),
.ids-layout-grid > .ids-layout-grid-row-span-30 {
  grid-row: span 30/span 30;
}

:host(.ids-layout-grid) > ::slotted([order="30"]),
.ids-layout-grid > .ids-layout-grid-order-30 {
  order: 30;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="31"]),
.ids-layout-grid-rows-31 {
  grid-template-rows: repeat(31, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="31"]),
.ids-layout-grid > .ids-layout-grid-row-span-31 {
  grid-row: span 31/span 31;
}

:host(.ids-layout-grid) > ::slotted([order="31"]),
.ids-layout-grid > .ids-layout-grid-order-31 {
  order: 31;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="32"]),
.ids-layout-grid-rows-32 {
  grid-template-rows: repeat(32, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="32"]),
.ids-layout-grid > .ids-layout-grid-row-span-32 {
  grid-row: span 32/span 32;
}

:host(.ids-layout-grid) > ::slotted([order="32"]),
.ids-layout-grid > .ids-layout-grid-order-32 {
  order: 32;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="33"]),
.ids-layout-grid-rows-33 {
  grid-template-rows: repeat(33, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="33"]),
.ids-layout-grid > .ids-layout-grid-row-span-33 {
  grid-row: span 33/span 33;
}

:host(.ids-layout-grid) > ::slotted([order="33"]),
.ids-layout-grid > .ids-layout-grid-order-33 {
  order: 33;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="34"]),
.ids-layout-grid-rows-34 {
  grid-template-rows: repeat(34, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="34"]),
.ids-layout-grid > .ids-layout-grid-row-span-34 {
  grid-row: span 34/span 34;
}

:host(.ids-layout-grid) > ::slotted([order="34"]),
.ids-layout-grid > .ids-layout-grid-order-34 {
  order: 34;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="35"]),
.ids-layout-grid-rows-35 {
  grid-template-rows: repeat(35, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="35"]),
.ids-layout-grid > .ids-layout-grid-row-span-35 {
  grid-row: span 35/span 35;
}

:host(.ids-layout-grid) > ::slotted([order="35"]),
.ids-layout-grid > .ids-layout-grid-order-35 {
  order: 35;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="36"]),
.ids-layout-grid-rows-36 {
  grid-template-rows: repeat(36, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="36"]),
.ids-layout-grid > .ids-layout-grid-row-span-36 {
  grid-row: span 36/span 36;
}

:host(.ids-layout-grid) > ::slotted([order="36"]),
.ids-layout-grid > .ids-layout-grid-order-36 {
  order: 36;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="37"]),
.ids-layout-grid-rows-37 {
  grid-template-rows: repeat(37, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="37"]),
.ids-layout-grid > .ids-layout-grid-row-span-37 {
  grid-row: span 37/span 37;
}

:host(.ids-layout-grid) > ::slotted([order="37"]),
.ids-layout-grid > .ids-layout-grid-order-37 {
  order: 37;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="38"]),
.ids-layout-grid-rows-38 {
  grid-template-rows: repeat(38, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="38"]),
.ids-layout-grid > .ids-layout-grid-row-span-38 {
  grid-row: span 38/span 38;
}

:host(.ids-layout-grid) > ::slotted([order="38"]),
.ids-layout-grid > .ids-layout-grid-order-38 {
  order: 38;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="39"]),
.ids-layout-grid-rows-39 {
  grid-template-rows: repeat(39, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="39"]),
.ids-layout-grid > .ids-layout-grid-row-span-39 {
  grid-row: span 39/span 39;
}

:host(.ids-layout-grid) > ::slotted([order="39"]),
.ids-layout-grid > .ids-layout-grid-order-39 {
  order: 39;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="40"]),
.ids-layout-grid-rows-40 {
  grid-template-rows: repeat(40, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="40"]),
.ids-layout-grid > .ids-layout-grid-row-span-40 {
  grid-row: span 40/span 40;
}

:host(.ids-layout-grid) > ::slotted([order="40"]),
.ids-layout-grid > .ids-layout-grid-order-40 {
  order: 40;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="41"]),
.ids-layout-grid-rows-41 {
  grid-template-rows: repeat(41, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="41"]),
.ids-layout-grid > .ids-layout-grid-row-span-41 {
  grid-row: span 41/span 41;
}

:host(.ids-layout-grid) > ::slotted([order="41"]),
.ids-layout-grid > .ids-layout-grid-order-41 {
  order: 41;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="42"]),
.ids-layout-grid-rows-42 {
  grid-template-rows: repeat(42, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="42"]),
.ids-layout-grid > .ids-layout-grid-row-span-42 {
  grid-row: span 42/span 42;
}

:host(.ids-layout-grid) > ::slotted([order="42"]),
.ids-layout-grid > .ids-layout-grid-order-42 {
  order: 42;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="43"]),
.ids-layout-grid-rows-43 {
  grid-template-rows: repeat(43, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="43"]),
.ids-layout-grid > .ids-layout-grid-row-span-43 {
  grid-row: span 43/span 43;
}

:host(.ids-layout-grid) > ::slotted([order="43"]),
.ids-layout-grid > .ids-layout-grid-order-43 {
  order: 43;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="44"]),
.ids-layout-grid-rows-44 {
  grid-template-rows: repeat(44, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="44"]),
.ids-layout-grid > .ids-layout-grid-row-span-44 {
  grid-row: span 44/span 44;
}

:host(.ids-layout-grid) > ::slotted([order="44"]),
.ids-layout-grid > .ids-layout-grid-order-44 {
  order: 44;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="45"]),
.ids-layout-grid-rows-45 {
  grid-template-rows: repeat(45, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="45"]),
.ids-layout-grid > .ids-layout-grid-row-span-45 {
  grid-row: span 45/span 45;
}

:host(.ids-layout-grid) > ::slotted([order="45"]),
.ids-layout-grid > .ids-layout-grid-order-45 {
  order: 45;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="46"]),
.ids-layout-grid-rows-46 {
  grid-template-rows: repeat(46, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="46"]),
.ids-layout-grid > .ids-layout-grid-row-span-46 {
  grid-row: span 46/span 46;
}

:host(.ids-layout-grid) > ::slotted([order="46"]),
.ids-layout-grid > .ids-layout-grid-order-46 {
  order: 46;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="47"]),
.ids-layout-grid-rows-47 {
  grid-template-rows: repeat(47, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="47"]),
.ids-layout-grid > .ids-layout-grid-row-span-47 {
  grid-row: span 47/span 47;
}

:host(.ids-layout-grid) > ::slotted([order="47"]),
.ids-layout-grid > .ids-layout-grid-order-47 {
  order: 47;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="48"]),
.ids-layout-grid-rows-48 {
  grid-template-rows: repeat(48, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="48"]),
.ids-layout-grid > .ids-layout-grid-row-span-48 {
  grid-row: span 48/span 48;
}

:host(.ids-layout-grid) > ::slotted([order="48"]),
.ids-layout-grid > .ids-layout-grid-order-48 {
  order: 48;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="49"]),
.ids-layout-grid-rows-49 {
  grid-template-rows: repeat(49, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="49"]),
.ids-layout-grid > .ids-layout-grid-row-span-49 {
  grid-row: span 49/span 49;
}

:host(.ids-layout-grid) > ::slotted([order="49"]),
.ids-layout-grid > .ids-layout-grid-order-49 {
  order: 49;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="50"]),
.ids-layout-grid-rows-50 {
  grid-template-rows: repeat(50, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="50"]),
.ids-layout-grid > .ids-layout-grid-row-span-50 {
  grid-row: span 50/span 50;
}

:host(.ids-layout-grid) > ::slotted([order="50"]),
.ids-layout-grid > .ids-layout-grid-order-50 {
  order: 50;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

@media (min-width: 320px) {
  :host(:not([enable-container])[cols-xs="1"]),
  .ids-layout-grid-cols-xs-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="2"]),
  .ids-layout-grid-cols-xs-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="3"]),
  .ids-layout-grid-cols-xs-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="4"]),
  .ids-layout-grid-cols-xs-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="5"]),
  .ids-layout-grid-cols-xs-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="6"]),
  .ids-layout-grid-cols-xs-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="7"]),
  .ids-layout-grid-cols-xs-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="8"]),
  .ids-layout-grid-cols-xs-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="9"]),
  .ids-layout-grid-cols-xs-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="10"]),
  .ids-layout-grid-cols-xs-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="11"]),
  .ids-layout-grid-cols-xs-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="12"]),
  .ids-layout-grid-cols-xs-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="13"]),
  .ids-layout-grid-cols-xs-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="14"]),
  .ids-layout-grid-cols-xs-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="15"]),
  .ids-layout-grid-cols-xs-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="16"]),
  .ids-layout-grid-cols-xs-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="17"]),
  .ids-layout-grid-cols-xs-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="18"]),
  .ids-layout-grid-cols-xs-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="19"]),
  .ids-layout-grid-cols-xs-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="20"]),
  .ids-layout-grid-cols-xs-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="21"]),
  .ids-layout-grid-cols-xs-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="22"]),
  .ids-layout-grid-cols-xs-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="23"]),
  .ids-layout-grid-cols-xs-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="24"]),
  .ids-layout-grid-cols-xs-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([flow-xs=row]),
  .ids-layout-grid-flow-xs-row {
    grid-auto-flow: row;
  }
  :host([flow-xs=column]),
  .ids-layout-grid-flow-xs-col {
    grid-auto-flow: column;
  }
  :host([flow-xs=dense]),
  .ids-layout-grid-flow-xs-dense {
    grid-auto-flow: dense;
  }
  :host([flow-xs=row-dense]),
  .ids-layout-grid-flow-xs-row-dense {
    grid-auto-flow: row dense;
  }
  :host([flow-xs=column-dense]),
  .ids-layout-grid-flow-xs-col-dense {
    grid-auto-flow: column dense;
  }
}
@media (min-width: 600px) {
  :host(:not([enable-container])[cols-sm="1"]),
  .ids-layout-grid-cols-sm-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="2"]),
  .ids-layout-grid-cols-sm-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="3"]),
  .ids-layout-grid-cols-sm-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="4"]),
  .ids-layout-grid-cols-sm-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="5"]),
  .ids-layout-grid-cols-sm-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="6"]),
  .ids-layout-grid-cols-sm-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="7"]),
  .ids-layout-grid-cols-sm-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="8"]),
  .ids-layout-grid-cols-sm-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="9"]),
  .ids-layout-grid-cols-sm-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="10"]),
  .ids-layout-grid-cols-sm-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="11"]),
  .ids-layout-grid-cols-sm-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="12"]),
  .ids-layout-grid-cols-sm-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="13"]),
  .ids-layout-grid-cols-sm-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="14"]),
  .ids-layout-grid-cols-sm-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="15"]),
  .ids-layout-grid-cols-sm-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="16"]),
  .ids-layout-grid-cols-sm-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="17"]),
  .ids-layout-grid-cols-sm-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="18"]),
  .ids-layout-grid-cols-sm-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="19"]),
  .ids-layout-grid-cols-sm-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="20"]),
  .ids-layout-grid-cols-sm-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="21"]),
  .ids-layout-grid-cols-sm-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="22"]),
  .ids-layout-grid-cols-sm-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="23"]),
  .ids-layout-grid-cols-sm-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="24"]),
  .ids-layout-grid-cols-sm-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([flow-sm=row]),
  .ids-layout-grid-flow-sm-row {
    grid-auto-flow: row;
  }
  :host([flow-sm=column]),
  .ids-layout-grid-flow-sm-col {
    grid-auto-flow: column;
  }
  :host([flow-sm=dense]),
  .ids-layout-grid-flow-sm-dense {
    grid-auto-flow: dense;
  }
  :host([flow-sm=row-dense]),
  .ids-layout-grid-flow-sm-row-dense {
    grid-auto-flow: row dense;
  }
  :host([flow-sm=column-dense]),
  .ids-layout-grid-flow-sm-col-dense {
    grid-auto-flow: column dense;
  }
}
@media (min-width: 840px) {
  :host(:not([enable-container])[cols-md="1"]),
  .ids-layout-grid-cols-md-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="2"]),
  .ids-layout-grid-cols-md-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="3"]),
  .ids-layout-grid-cols-md-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="4"]),
  .ids-layout-grid-cols-md-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="5"]),
  .ids-layout-grid-cols-md-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="6"]),
  .ids-layout-grid-cols-md-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="7"]),
  .ids-layout-grid-cols-md-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="8"]),
  .ids-layout-grid-cols-md-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="9"]),
  .ids-layout-grid-cols-md-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="10"]),
  .ids-layout-grid-cols-md-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="11"]),
  .ids-layout-grid-cols-md-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="12"]),
  .ids-layout-grid-cols-md-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="13"]),
  .ids-layout-grid-cols-md-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="14"]),
  .ids-layout-grid-cols-md-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="15"]),
  .ids-layout-grid-cols-md-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="16"]),
  .ids-layout-grid-cols-md-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="17"]),
  .ids-layout-grid-cols-md-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="18"]),
  .ids-layout-grid-cols-md-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="19"]),
  .ids-layout-grid-cols-md-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="20"]),
  .ids-layout-grid-cols-md-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="21"]),
  .ids-layout-grid-cols-md-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="22"]),
  .ids-layout-grid-cols-md-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="23"]),
  .ids-layout-grid-cols-md-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="24"]),
  .ids-layout-grid-cols-md-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([flow-md=row]),
  .ids-layout-grid-flow-md-row {
    grid-auto-flow: row;
  }
  :host([flow-md=column]),
  .ids-layout-grid-flow-md-col {
    grid-auto-flow: column;
  }
  :host([flow-md=dense]),
  .ids-layout-grid-flow-md-dense {
    grid-auto-flow: dense;
  }
  :host([flow-md=row-dense]),
  .ids-layout-grid-flow-md-row-dense {
    grid-auto-flow: row dense;
  }
  :host([flow-md=column-dense]),
  .ids-layout-grid-flow-md-col-dense {
    grid-auto-flow: column dense;
  }
}
@media (min-width: 1024px) {
  :host(:not([enable-container])[cols-lg="1"]),
  .ids-layout-grid-cols-lg-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="2"]),
  .ids-layout-grid-cols-lg-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="3"]),
  .ids-layout-grid-cols-lg-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="4"]),
  .ids-layout-grid-cols-lg-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="5"]),
  .ids-layout-grid-cols-lg-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="6"]),
  .ids-layout-grid-cols-lg-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="7"]),
  .ids-layout-grid-cols-lg-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="8"]),
  .ids-layout-grid-cols-lg-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="9"]),
  .ids-layout-grid-cols-lg-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="10"]),
  .ids-layout-grid-cols-lg-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="11"]),
  .ids-layout-grid-cols-lg-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="12"]),
  .ids-layout-grid-cols-lg-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="13"]),
  .ids-layout-grid-cols-lg-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="14"]),
  .ids-layout-grid-cols-lg-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="15"]),
  .ids-layout-grid-cols-lg-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="16"]),
  .ids-layout-grid-cols-lg-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="17"]),
  .ids-layout-grid-cols-lg-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="18"]),
  .ids-layout-grid-cols-lg-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="19"]),
  .ids-layout-grid-cols-lg-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="20"]),
  .ids-layout-grid-cols-lg-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="21"]),
  .ids-layout-grid-cols-lg-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="22"]),
  .ids-layout-grid-cols-lg-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="23"]),
  .ids-layout-grid-cols-lg-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="24"]),
  .ids-layout-grid-cols-lg-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([flow-lg=row]),
  .ids-layout-grid-flow-lg-row {
    grid-auto-flow: row;
  }
  :host([flow-lg=column]),
  .ids-layout-grid-flow-lg-col {
    grid-auto-flow: column;
  }
  :host([flow-lg=dense]),
  .ids-layout-grid-flow-lg-dense {
    grid-auto-flow: dense;
  }
  :host([flow-lg=row-dense]),
  .ids-layout-grid-flow-lg-row-dense {
    grid-auto-flow: row dense;
  }
  :host([flow-lg=column-dense]),
  .ids-layout-grid-flow-lg-col-dense {
    grid-auto-flow: column dense;
  }
}
@media (min-width: 1280px) {
  :host(:not([enable-container])[cols-xl="1"]),
  .ids-layout-grid-cols-xl-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="2"]),
  .ids-layout-grid-cols-xl-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="3"]),
  .ids-layout-grid-cols-xl-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="4"]),
  .ids-layout-grid-cols-xl-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="5"]),
  .ids-layout-grid-cols-xl-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="6"]),
  .ids-layout-grid-cols-xl-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="7"]),
  .ids-layout-grid-cols-xl-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="8"]),
  .ids-layout-grid-cols-xl-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="9"]),
  .ids-layout-grid-cols-xl-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="10"]),
  .ids-layout-grid-cols-xl-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="11"]),
  .ids-layout-grid-cols-xl-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="12"]),
  .ids-layout-grid-cols-xl-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="13"]),
  .ids-layout-grid-cols-xl-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="14"]),
  .ids-layout-grid-cols-xl-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="15"]),
  .ids-layout-grid-cols-xl-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="16"]),
  .ids-layout-grid-cols-xl-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="17"]),
  .ids-layout-grid-cols-xl-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="18"]),
  .ids-layout-grid-cols-xl-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="19"]),
  .ids-layout-grid-cols-xl-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="20"]),
  .ids-layout-grid-cols-xl-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="21"]),
  .ids-layout-grid-cols-xl-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="22"]),
  .ids-layout-grid-cols-xl-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="23"]),
  .ids-layout-grid-cols-xl-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="24"]),
  .ids-layout-grid-cols-xl-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([flow-xl=row]),
  .ids-layout-grid-flow-xl-row {
    grid-auto-flow: row;
  }
  :host([flow-xl=column]),
  .ids-layout-grid-flow-xl-col {
    grid-auto-flow: column;
  }
  :host([flow-xl=dense]),
  .ids-layout-grid-flow-xl-dense {
    grid-auto-flow: dense;
  }
  :host([flow-xl=row-dense]),
  .ids-layout-grid-flow-xl-row-dense {
    grid-auto-flow: row dense;
  }
  :host([flow-xl=column-dense]),
  .ids-layout-grid-flow-xl-col-dense {
    grid-auto-flow: column dense;
  }
}
@media (min-width: 1440px) {
  :host(:not([enable-container])[cols-xxl="1"]),
  .ids-layout-grid-cols-xxl-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="2"]),
  .ids-layout-grid-cols-xxl-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="3"]),
  .ids-layout-grid-cols-xxl-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="4"]),
  .ids-layout-grid-cols-xxl-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="5"]),
  .ids-layout-grid-cols-xxl-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="6"]),
  .ids-layout-grid-cols-xxl-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="7"]),
  .ids-layout-grid-cols-xxl-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="8"]),
  .ids-layout-grid-cols-xxl-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="9"]),
  .ids-layout-grid-cols-xxl-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="10"]),
  .ids-layout-grid-cols-xxl-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="11"]),
  .ids-layout-grid-cols-xxl-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="12"]),
  .ids-layout-grid-cols-xxl-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="13"]),
  .ids-layout-grid-cols-xxl-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="14"]),
  .ids-layout-grid-cols-xxl-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="15"]),
  .ids-layout-grid-cols-xxl-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="16"]),
  .ids-layout-grid-cols-xxl-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="17"]),
  .ids-layout-grid-cols-xxl-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="18"]),
  .ids-layout-grid-cols-xxl-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="19"]),
  .ids-layout-grid-cols-xxl-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="20"]),
  .ids-layout-grid-cols-xxl-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="21"]),
  .ids-layout-grid-cols-xxl-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="22"]),
  .ids-layout-grid-cols-xxl-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="23"]),
  .ids-layout-grid-cols-xxl-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="24"]),
  .ids-layout-grid-cols-xxl-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([flow-xxl=row]),
  .ids-layout-grid-flow-xxl-row {
    grid-auto-flow: row;
  }
  :host([flow-xxl=column]),
  .ids-layout-grid-flow-xxl-col {
    grid-auto-flow: column;
  }
  :host([flow-xxl=dense]),
  .ids-layout-grid-flow-xxl-dense {
    grid-auto-flow: dense;
  }
  :host([flow-xxl=row-dense]),
  .ids-layout-grid-flow-xxl-row-dense {
    grid-auto-flow: row dense;
  }
  :host([flow-xxl=column-dense]),
  .ids-layout-grid-flow-xxl-col-dense {
    grid-auto-flow: column dense;
  }
}
@container (min-width: 320px) {
  :host([cols-xs="1"]),
  .ids-layout-grid-cols-xs-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="2"]),
  .ids-layout-grid-cols-xs-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="3"]),
  .ids-layout-grid-cols-xs-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="4"]),
  .ids-layout-grid-cols-xs-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="5"]),
  .ids-layout-grid-cols-xs-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="6"]),
  .ids-layout-grid-cols-xs-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="7"]),
  .ids-layout-grid-cols-xs-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="8"]),
  .ids-layout-grid-cols-xs-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="9"]),
  .ids-layout-grid-cols-xs-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="10"]),
  .ids-layout-grid-cols-xs-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="11"]),
  .ids-layout-grid-cols-xs-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="12"]),
  .ids-layout-grid-cols-xs-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="13"]),
  .ids-layout-grid-cols-xs-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="14"]),
  .ids-layout-grid-cols-xs-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="15"]),
  .ids-layout-grid-cols-xs-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="16"]),
  .ids-layout-grid-cols-xs-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="17"]),
  .ids-layout-grid-cols-xs-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="18"]),
  .ids-layout-grid-cols-xs-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="19"]),
  .ids-layout-grid-cols-xs-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="20"]),
  .ids-layout-grid-cols-xs-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="21"]),
  .ids-layout-grid-cols-xs-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="22"]),
  .ids-layout-grid-cols-xs-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="23"]),
  .ids-layout-grid-cols-xs-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="24"]),
  .ids-layout-grid-cols-xs-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
}
@container (min-width: 600px) {
  :host([cols-sm="1"]),
  .ids-layout-grid-cols-sm-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="2"]),
  .ids-layout-grid-cols-sm-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="3"]),
  .ids-layout-grid-cols-sm-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="4"]),
  .ids-layout-grid-cols-sm-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="5"]),
  .ids-layout-grid-cols-sm-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="6"]),
  .ids-layout-grid-cols-sm-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="7"]),
  .ids-layout-grid-cols-sm-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="8"]),
  .ids-layout-grid-cols-sm-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="9"]),
  .ids-layout-grid-cols-sm-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="10"]),
  .ids-layout-grid-cols-sm-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="11"]),
  .ids-layout-grid-cols-sm-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="12"]),
  .ids-layout-grid-cols-sm-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="13"]),
  .ids-layout-grid-cols-sm-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="14"]),
  .ids-layout-grid-cols-sm-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="15"]),
  .ids-layout-grid-cols-sm-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="16"]),
  .ids-layout-grid-cols-sm-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="17"]),
  .ids-layout-grid-cols-sm-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="18"]),
  .ids-layout-grid-cols-sm-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="19"]),
  .ids-layout-grid-cols-sm-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="20"]),
  .ids-layout-grid-cols-sm-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="21"]),
  .ids-layout-grid-cols-sm-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="22"]),
  .ids-layout-grid-cols-sm-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="23"]),
  .ids-layout-grid-cols-sm-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="24"]),
  .ids-layout-grid-cols-sm-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
}
@container (min-width: 840px) {
  :host([cols-md="1"]),
  .ids-layout-grid-cols-md-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="2"]),
  .ids-layout-grid-cols-md-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="3"]),
  .ids-layout-grid-cols-md-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="4"]),
  .ids-layout-grid-cols-md-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="5"]),
  .ids-layout-grid-cols-md-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="6"]),
  .ids-layout-grid-cols-md-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="7"]),
  .ids-layout-grid-cols-md-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="8"]),
  .ids-layout-grid-cols-md-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="9"]),
  .ids-layout-grid-cols-md-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="10"]),
  .ids-layout-grid-cols-md-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="11"]),
  .ids-layout-grid-cols-md-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="12"]),
  .ids-layout-grid-cols-md-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="13"]),
  .ids-layout-grid-cols-md-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="14"]),
  .ids-layout-grid-cols-md-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="15"]),
  .ids-layout-grid-cols-md-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="16"]),
  .ids-layout-grid-cols-md-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="17"]),
  .ids-layout-grid-cols-md-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="18"]),
  .ids-layout-grid-cols-md-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="19"]),
  .ids-layout-grid-cols-md-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="20"]),
  .ids-layout-grid-cols-md-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="21"]),
  .ids-layout-grid-cols-md-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="22"]),
  .ids-layout-grid-cols-md-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="23"]),
  .ids-layout-grid-cols-md-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="24"]),
  .ids-layout-grid-cols-md-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
}
@container (min-width: 1024px) {
  :host([cols-lg="1"]),
  .ids-layout-grid-cols-lg-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="2"]),
  .ids-layout-grid-cols-lg-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="3"]),
  .ids-layout-grid-cols-lg-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="4"]),
  .ids-layout-grid-cols-lg-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="5"]),
  .ids-layout-grid-cols-lg-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="6"]),
  .ids-layout-grid-cols-lg-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="7"]),
  .ids-layout-grid-cols-lg-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="8"]),
  .ids-layout-grid-cols-lg-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="9"]),
  .ids-layout-grid-cols-lg-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="10"]),
  .ids-layout-grid-cols-lg-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="11"]),
  .ids-layout-grid-cols-lg-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="12"]),
  .ids-layout-grid-cols-lg-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="13"]),
  .ids-layout-grid-cols-lg-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="14"]),
  .ids-layout-grid-cols-lg-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="15"]),
  .ids-layout-grid-cols-lg-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="16"]),
  .ids-layout-grid-cols-lg-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="17"]),
  .ids-layout-grid-cols-lg-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="18"]),
  .ids-layout-grid-cols-lg-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="19"]),
  .ids-layout-grid-cols-lg-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="20"]),
  .ids-layout-grid-cols-lg-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="21"]),
  .ids-layout-grid-cols-lg-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="22"]),
  .ids-layout-grid-cols-lg-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="23"]),
  .ids-layout-grid-cols-lg-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="24"]),
  .ids-layout-grid-cols-lg-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
}
@container (min-width: 1280px) {
  :host([cols-xl="1"]),
  .ids-layout-grid-cols-xl-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="2"]),
  .ids-layout-grid-cols-xl-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="3"]),
  .ids-layout-grid-cols-xl-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="4"]),
  .ids-layout-grid-cols-xl-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="5"]),
  .ids-layout-grid-cols-xl-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="6"]),
  .ids-layout-grid-cols-xl-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="7"]),
  .ids-layout-grid-cols-xl-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="8"]),
  .ids-layout-grid-cols-xl-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="9"]),
  .ids-layout-grid-cols-xl-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="10"]),
  .ids-layout-grid-cols-xl-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="11"]),
  .ids-layout-grid-cols-xl-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="12"]),
  .ids-layout-grid-cols-xl-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="13"]),
  .ids-layout-grid-cols-xl-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="14"]),
  .ids-layout-grid-cols-xl-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="15"]),
  .ids-layout-grid-cols-xl-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="16"]),
  .ids-layout-grid-cols-xl-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="17"]),
  .ids-layout-grid-cols-xl-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="18"]),
  .ids-layout-grid-cols-xl-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="19"]),
  .ids-layout-grid-cols-xl-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="20"]),
  .ids-layout-grid-cols-xl-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="21"]),
  .ids-layout-grid-cols-xl-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="22"]),
  .ids-layout-grid-cols-xl-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="23"]),
  .ids-layout-grid-cols-xl-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="24"]),
  .ids-layout-grid-cols-xl-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
}
@container (min-width: 1440px) {
  :host([cols-xxl="1"]),
  .ids-layout-grid-cols-xxl-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="2"]),
  .ids-layout-grid-cols-xxl-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="3"]),
  .ids-layout-grid-cols-xxl-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="4"]),
  .ids-layout-grid-cols-xxl-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="5"]),
  .ids-layout-grid-cols-xxl-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="6"]),
  .ids-layout-grid-cols-xxl-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="7"]),
  .ids-layout-grid-cols-xxl-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="8"]),
  .ids-layout-grid-cols-xxl-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="9"]),
  .ids-layout-grid-cols-xxl-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="10"]),
  .ids-layout-grid-cols-xxl-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="11"]),
  .ids-layout-grid-cols-xxl-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="12"]),
  .ids-layout-grid-cols-xxl-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="13"]),
  .ids-layout-grid-cols-xxl-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="14"]),
  .ids-layout-grid-cols-xxl-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="15"]),
  .ids-layout-grid-cols-xxl-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="16"]),
  .ids-layout-grid-cols-xxl-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="17"]),
  .ids-layout-grid-cols-xxl-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="18"]),
  .ids-layout-grid-cols-xxl-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="19"]),
  .ids-layout-grid-cols-xxl-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="20"]),
  .ids-layout-grid-cols-xxl-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="21"]),
  .ids-layout-grid-cols-xxl-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="22"]),
  .ids-layout-grid-cols-xxl-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="23"]),
  .ids-layout-grid-cols-xxl-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="24"]),
  .ids-layout-grid-cols-xxl-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
}
/* Use media queries by default */
@media (min-width: 320px) {
  :host(:not([enable-container])) > ::slotted([col-span-xs="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-1 {
    grid-column: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-1 {
    grid-column-start: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-1 {
    grid-column-end: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-2 {
    grid-column: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-2 {
    grid-column-start: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-2 {
    grid-column-end: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-3 {
    grid-column: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-3 {
    grid-column-start: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-3 {
    grid-column-end: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-4 {
    grid-column: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-4 {
    grid-column-start: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-4 {
    grid-column-end: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-5 {
    grid-column: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-5 {
    grid-column-start: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-5 {
    grid-column-end: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-6 {
    grid-column: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-6 {
    grid-column-start: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-6 {
    grid-column-end: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-7 {
    grid-column: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-7 {
    grid-column-start: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-7 {
    grid-column-end: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-8 {
    grid-column: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-8 {
    grid-column-start: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-8 {
    grid-column-end: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-9 {
    grid-column: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-9 {
    grid-column-start: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-9 {
    grid-column-end: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-10 {
    grid-column: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-10 {
    grid-column-start: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-10 {
    grid-column-end: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-11 {
    grid-column: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-11 {
    grid-column-start: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-11 {
    grid-column-end: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-12 {
    grid-column: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-12 {
    grid-column-start: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-12 {
    grid-column-end: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-13 {
    grid-column: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-13 {
    grid-column-start: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-13 {
    grid-column-end: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-14 {
    grid-column: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-14 {
    grid-column-start: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-14 {
    grid-column-end: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-15 {
    grid-column: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-15 {
    grid-column-start: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-15 {
    grid-column-end: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-16 {
    grid-column: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-16 {
    grid-column-start: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-16 {
    grid-column-end: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-17 {
    grid-column: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-17 {
    grid-column-start: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-17 {
    grid-column-end: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-18 {
    grid-column: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-18 {
    grid-column-start: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-18 {
    grid-column-end: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-19 {
    grid-column: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-19 {
    grid-column-start: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-19 {
    grid-column-end: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-20 {
    grid-column: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-20 {
    grid-column-start: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-20 {
    grid-column-end: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-21 {
    grid-column: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-21 {
    grid-column-start: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-21 {
    grid-column-end: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-22 {
    grid-column: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-22 {
    grid-column-start: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-22 {
    grid-column-end: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-23 {
    grid-column: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-23 {
    grid-column-start: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-23 {
    grid-column-end: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-24 {
    grid-column: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-24 {
    grid-column-start: 24;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-24 {
    grid-column-end: 24;
  }
  :host(:not([enable-container]))[rows-xs="1"], :host(:not([enable-container])).ids-layout-grid-rows-xs-1,
  .ids-layout-grid:not([enable-container])[rows-xs="1"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-1 {
    grid-row: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-1 {
    order: 1;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="2"], :host(:not([enable-container])).ids-layout-grid-rows-xs-2,
  .ids-layout-grid:not([enable-container])[rows-xs="2"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-2 {
    grid-row: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-2 {
    order: 2;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="3"], :host(:not([enable-container])).ids-layout-grid-rows-xs-3,
  .ids-layout-grid:not([enable-container])[rows-xs="3"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-3 {
    grid-row: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-3 {
    order: 3;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="4"], :host(:not([enable-container])).ids-layout-grid-rows-xs-4,
  .ids-layout-grid:not([enable-container])[rows-xs="4"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-4 {
    grid-row: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-4 {
    order: 4;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="5"], :host(:not([enable-container])).ids-layout-grid-rows-xs-5,
  .ids-layout-grid:not([enable-container])[rows-xs="5"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-5 {
    grid-row: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-5 {
    order: 5;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="6"], :host(:not([enable-container])).ids-layout-grid-rows-xs-6,
  .ids-layout-grid:not([enable-container])[rows-xs="6"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-6 {
    grid-row: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-6 {
    order: 6;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="7"], :host(:not([enable-container])).ids-layout-grid-rows-xs-7,
  .ids-layout-grid:not([enable-container])[rows-xs="7"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-7 {
    grid-row: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-7 {
    order: 7;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="8"], :host(:not([enable-container])).ids-layout-grid-rows-xs-8,
  .ids-layout-grid:not([enable-container])[rows-xs="8"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-8 {
    grid-row: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-8 {
    order: 8;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="9"], :host(:not([enable-container])).ids-layout-grid-rows-xs-9,
  .ids-layout-grid:not([enable-container])[rows-xs="9"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-9 {
    grid-row: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-9 {
    order: 9;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="10"], :host(:not([enable-container])).ids-layout-grid-rows-xs-10,
  .ids-layout-grid:not([enable-container])[rows-xs="10"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-10 {
    grid-row: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-10 {
    order: 10;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="11"], :host(:not([enable-container])).ids-layout-grid-rows-xs-11,
  .ids-layout-grid:not([enable-container])[rows-xs="11"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-11 {
    grid-row: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-11 {
    order: 11;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="12"], :host(:not([enable-container])).ids-layout-grid-rows-xs-12,
  .ids-layout-grid:not([enable-container])[rows-xs="12"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-12 {
    grid-row: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-12 {
    order: 12;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="13"], :host(:not([enable-container])).ids-layout-grid-rows-xs-13,
  .ids-layout-grid:not([enable-container])[rows-xs="13"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-13 {
    grid-row: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-13 {
    order: 13;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="14"], :host(:not([enable-container])).ids-layout-grid-rows-xs-14,
  .ids-layout-grid:not([enable-container])[rows-xs="14"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-14 {
    grid-row: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-14 {
    order: 14;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="15"], :host(:not([enable-container])).ids-layout-grid-rows-xs-15,
  .ids-layout-grid:not([enable-container])[rows-xs="15"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-15 {
    grid-row: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-15 {
    order: 15;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="16"], :host(:not([enable-container])).ids-layout-grid-rows-xs-16,
  .ids-layout-grid:not([enable-container])[rows-xs="16"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-16 {
    grid-row: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-16 {
    order: 16;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="17"], :host(:not([enable-container])).ids-layout-grid-rows-xs-17,
  .ids-layout-grid:not([enable-container])[rows-xs="17"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-17 {
    grid-row: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-17 {
    order: 17;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="18"], :host(:not([enable-container])).ids-layout-grid-rows-xs-18,
  .ids-layout-grid:not([enable-container])[rows-xs="18"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-18 {
    grid-row: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-18 {
    order: 18;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="19"], :host(:not([enable-container])).ids-layout-grid-rows-xs-19,
  .ids-layout-grid:not([enable-container])[rows-xs="19"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-19 {
    grid-row: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-19 {
    order: 19;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="20"], :host(:not([enable-container])).ids-layout-grid-rows-xs-20,
  .ids-layout-grid:not([enable-container])[rows-xs="20"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-20 {
    grid-row: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-20 {
    order: 20;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="21"], :host(:not([enable-container])).ids-layout-grid-rows-xs-21,
  .ids-layout-grid:not([enable-container])[rows-xs="21"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-21 {
    grid-row: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-21 {
    order: 21;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="22"], :host(:not([enable-container])).ids-layout-grid-rows-xs-22,
  .ids-layout-grid:not([enable-container])[rows-xs="22"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-22 {
    grid-row: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-22 {
    order: 22;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="23"], :host(:not([enable-container])).ids-layout-grid-rows-xs-23,
  .ids-layout-grid:not([enable-container])[rows-xs="23"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-23 {
    grid-row: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-23 {
    order: 23;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="24"], :host(:not([enable-container])).ids-layout-grid-rows-xs-24,
  .ids-layout-grid:not([enable-container])[rows-xs="24"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-24 {
    grid-row: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-24 {
    order: 24;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="25"], :host(:not([enable-container])).ids-layout-grid-rows-xs-25,
  .ids-layout-grid:not([enable-container])[rows-xs="25"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-25 {
    grid-row: span 25/span 25;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-25 {
    order: 25;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="26"], :host(:not([enable-container])).ids-layout-grid-rows-xs-26,
  .ids-layout-grid:not([enable-container])[rows-xs="26"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-26 {
    grid-row: span 26/span 26;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-26 {
    order: 26;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="27"], :host(:not([enable-container])).ids-layout-grid-rows-xs-27,
  .ids-layout-grid:not([enable-container])[rows-xs="27"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-27 {
    grid-row: span 27/span 27;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-27 {
    order: 27;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="28"], :host(:not([enable-container])).ids-layout-grid-rows-xs-28,
  .ids-layout-grid:not([enable-container])[rows-xs="28"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-28 {
    grid-row: span 28/span 28;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-28 {
    order: 28;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="29"], :host(:not([enable-container])).ids-layout-grid-rows-xs-29,
  .ids-layout-grid:not([enable-container])[rows-xs="29"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-29 {
    grid-row: span 29/span 29;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-29 {
    order: 29;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="30"], :host(:not([enable-container])).ids-layout-grid-rows-xs-30,
  .ids-layout-grid:not([enable-container])[rows-xs="30"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-30 {
    grid-row: span 30/span 30;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-30 {
    order: 30;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="31"], :host(:not([enable-container])).ids-layout-grid-rows-xs-31,
  .ids-layout-grid:not([enable-container])[rows-xs="31"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-31 {
    grid-row: span 31/span 31;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-31 {
    order: 31;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="32"], :host(:not([enable-container])).ids-layout-grid-rows-xs-32,
  .ids-layout-grid:not([enable-container])[rows-xs="32"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-32 {
    grid-row: span 32/span 32;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-32 {
    order: 32;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="33"], :host(:not([enable-container])).ids-layout-grid-rows-xs-33,
  .ids-layout-grid:not([enable-container])[rows-xs="33"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-33 {
    grid-row: span 33/span 33;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-33 {
    order: 33;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="34"], :host(:not([enable-container])).ids-layout-grid-rows-xs-34,
  .ids-layout-grid:not([enable-container])[rows-xs="34"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-34 {
    grid-row: span 34/span 34;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-34 {
    order: 34;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="35"], :host(:not([enable-container])).ids-layout-grid-rows-xs-35,
  .ids-layout-grid:not([enable-container])[rows-xs="35"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-35 {
    grid-row: span 35/span 35;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-35 {
    order: 35;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="36"], :host(:not([enable-container])).ids-layout-grid-rows-xs-36,
  .ids-layout-grid:not([enable-container])[rows-xs="36"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-36 {
    grid-row: span 36/span 36;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-36 {
    order: 36;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="37"], :host(:not([enable-container])).ids-layout-grid-rows-xs-37,
  .ids-layout-grid:not([enable-container])[rows-xs="37"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-37 {
    grid-row: span 37/span 37;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-37 {
    order: 37;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="38"], :host(:not([enable-container])).ids-layout-grid-rows-xs-38,
  .ids-layout-grid:not([enable-container])[rows-xs="38"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-38 {
    grid-row: span 38/span 38;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-38 {
    order: 38;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="39"], :host(:not([enable-container])).ids-layout-grid-rows-xs-39,
  .ids-layout-grid:not([enable-container])[rows-xs="39"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-39 {
    grid-row: span 39/span 39;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-39 {
    order: 39;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="40"], :host(:not([enable-container])).ids-layout-grid-rows-xs-40,
  .ids-layout-grid:not([enable-container])[rows-xs="40"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-40 {
    grid-row: span 40/span 40;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-40 {
    order: 40;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="41"], :host(:not([enable-container])).ids-layout-grid-rows-xs-41,
  .ids-layout-grid:not([enable-container])[rows-xs="41"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-41 {
    grid-row: span 41/span 41;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-41 {
    order: 41;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="42"], :host(:not([enable-container])).ids-layout-grid-rows-xs-42,
  .ids-layout-grid:not([enable-container])[rows-xs="42"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-42 {
    grid-row: span 42/span 42;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-42 {
    order: 42;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="43"], :host(:not([enable-container])).ids-layout-grid-rows-xs-43,
  .ids-layout-grid:not([enable-container])[rows-xs="43"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-43 {
    grid-row: span 43/span 43;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-43 {
    order: 43;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="44"], :host(:not([enable-container])).ids-layout-grid-rows-xs-44,
  .ids-layout-grid:not([enable-container])[rows-xs="44"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-44 {
    grid-row: span 44/span 44;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-44 {
    order: 44;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="45"], :host(:not([enable-container])).ids-layout-grid-rows-xs-45,
  .ids-layout-grid:not([enable-container])[rows-xs="45"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-45 {
    grid-row: span 45/span 45;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-45 {
    order: 45;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="46"], :host(:not([enable-container])).ids-layout-grid-rows-xs-46,
  .ids-layout-grid:not([enable-container])[rows-xs="46"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-46 {
    grid-row: span 46/span 46;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-46 {
    order: 46;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="47"], :host(:not([enable-container])).ids-layout-grid-rows-xs-47,
  .ids-layout-grid:not([enable-container])[rows-xs="47"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-47 {
    grid-row: span 47/span 47;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-47 {
    order: 47;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="48"], :host(:not([enable-container])).ids-layout-grid-rows-xs-48,
  .ids-layout-grid:not([enable-container])[rows-xs="48"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-48 {
    grid-row: span 48/span 48;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-48 {
    order: 48;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="49"], :host(:not([enable-container])).ids-layout-grid-rows-xs-49,
  .ids-layout-grid:not([enable-container])[rows-xs="49"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-49 {
    grid-row: span 49/span 49;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-49 {
    order: 49;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="50"], :host(:not([enable-container])).ids-layout-grid-rows-xs-50,
  .ids-layout-grid:not([enable-container])[rows-xs="50"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-50 {
    grid-row: span 50/span 50;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-50 {
    order: 50;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container])) > ::slotted([hide=xs]),
  .ids-layout-grid:not([enable-container]) > ::slotted([hide=xs]) {
    display: block;
  }
}
@media (min-width: 600px) {
  :host(:not([enable-container])) > ::slotted([col-span-sm="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-1 {
    grid-column: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-1 {
    grid-column-start: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-1 {
    grid-column-end: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-2 {
    grid-column: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-2 {
    grid-column-start: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-2 {
    grid-column-end: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-3 {
    grid-column: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-3 {
    grid-column-start: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-3 {
    grid-column-end: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-4 {
    grid-column: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-4 {
    grid-column-start: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-4 {
    grid-column-end: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-5 {
    grid-column: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-5 {
    grid-column-start: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-5 {
    grid-column-end: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-6 {
    grid-column: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-6 {
    grid-column-start: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-6 {
    grid-column-end: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-7 {
    grid-column: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-7 {
    grid-column-start: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-7 {
    grid-column-end: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-8 {
    grid-column: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-8 {
    grid-column-start: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-8 {
    grid-column-end: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-9 {
    grid-column: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-9 {
    grid-column-start: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-9 {
    grid-column-end: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-10 {
    grid-column: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-10 {
    grid-column-start: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-10 {
    grid-column-end: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-11 {
    grid-column: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-11 {
    grid-column-start: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-11 {
    grid-column-end: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-12 {
    grid-column: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-12 {
    grid-column-start: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-12 {
    grid-column-end: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-13 {
    grid-column: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-13 {
    grid-column-start: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-13 {
    grid-column-end: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-14 {
    grid-column: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-14 {
    grid-column-start: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-14 {
    grid-column-end: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-15 {
    grid-column: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-15 {
    grid-column-start: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-15 {
    grid-column-end: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-16 {
    grid-column: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-16 {
    grid-column-start: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-16 {
    grid-column-end: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-17 {
    grid-column: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-17 {
    grid-column-start: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-17 {
    grid-column-end: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-18 {
    grid-column: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-18 {
    grid-column-start: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-18 {
    grid-column-end: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-19 {
    grid-column: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-19 {
    grid-column-start: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-19 {
    grid-column-end: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-20 {
    grid-column: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-20 {
    grid-column-start: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-20 {
    grid-column-end: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-21 {
    grid-column: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-21 {
    grid-column-start: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-21 {
    grid-column-end: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-22 {
    grid-column: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-22 {
    grid-column-start: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-22 {
    grid-column-end: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-23 {
    grid-column: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-23 {
    grid-column-start: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-23 {
    grid-column-end: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-24 {
    grid-column: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-24 {
    grid-column-start: 24;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-24 {
    grid-column-end: 24;
  }
  :host(:not([enable-container]))[rows-sm="1"], :host(:not([enable-container])).ids-layout-grid-rows-sm-1,
  .ids-layout-grid:not([enable-container])[rows-sm="1"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-1 {
    grid-row: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-1 {
    order: 1;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="2"], :host(:not([enable-container])).ids-layout-grid-rows-sm-2,
  .ids-layout-grid:not([enable-container])[rows-sm="2"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-2 {
    grid-row: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-2 {
    order: 2;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="3"], :host(:not([enable-container])).ids-layout-grid-rows-sm-3,
  .ids-layout-grid:not([enable-container])[rows-sm="3"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-3 {
    grid-row: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-3 {
    order: 3;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="4"], :host(:not([enable-container])).ids-layout-grid-rows-sm-4,
  .ids-layout-grid:not([enable-container])[rows-sm="4"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-4 {
    grid-row: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-4 {
    order: 4;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="5"], :host(:not([enable-container])).ids-layout-grid-rows-sm-5,
  .ids-layout-grid:not([enable-container])[rows-sm="5"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-5 {
    grid-row: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-5 {
    order: 5;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="6"], :host(:not([enable-container])).ids-layout-grid-rows-sm-6,
  .ids-layout-grid:not([enable-container])[rows-sm="6"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-6 {
    grid-row: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-6 {
    order: 6;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="7"], :host(:not([enable-container])).ids-layout-grid-rows-sm-7,
  .ids-layout-grid:not([enable-container])[rows-sm="7"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-7 {
    grid-row: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-7 {
    order: 7;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="8"], :host(:not([enable-container])).ids-layout-grid-rows-sm-8,
  .ids-layout-grid:not([enable-container])[rows-sm="8"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-8 {
    grid-row: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-8 {
    order: 8;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="9"], :host(:not([enable-container])).ids-layout-grid-rows-sm-9,
  .ids-layout-grid:not([enable-container])[rows-sm="9"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-9 {
    grid-row: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-9 {
    order: 9;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="10"], :host(:not([enable-container])).ids-layout-grid-rows-sm-10,
  .ids-layout-grid:not([enable-container])[rows-sm="10"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-10 {
    grid-row: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-10 {
    order: 10;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="11"], :host(:not([enable-container])).ids-layout-grid-rows-sm-11,
  .ids-layout-grid:not([enable-container])[rows-sm="11"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-11 {
    grid-row: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-11 {
    order: 11;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="12"], :host(:not([enable-container])).ids-layout-grid-rows-sm-12,
  .ids-layout-grid:not([enable-container])[rows-sm="12"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-12 {
    grid-row: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-12 {
    order: 12;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="13"], :host(:not([enable-container])).ids-layout-grid-rows-sm-13,
  .ids-layout-grid:not([enable-container])[rows-sm="13"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-13 {
    grid-row: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-13 {
    order: 13;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="14"], :host(:not([enable-container])).ids-layout-grid-rows-sm-14,
  .ids-layout-grid:not([enable-container])[rows-sm="14"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-14 {
    grid-row: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-14 {
    order: 14;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="15"], :host(:not([enable-container])).ids-layout-grid-rows-sm-15,
  .ids-layout-grid:not([enable-container])[rows-sm="15"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-15 {
    grid-row: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-15 {
    order: 15;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="16"], :host(:not([enable-container])).ids-layout-grid-rows-sm-16,
  .ids-layout-grid:not([enable-container])[rows-sm="16"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-16 {
    grid-row: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-16 {
    order: 16;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="17"], :host(:not([enable-container])).ids-layout-grid-rows-sm-17,
  .ids-layout-grid:not([enable-container])[rows-sm="17"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-17 {
    grid-row: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-17 {
    order: 17;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="18"], :host(:not([enable-container])).ids-layout-grid-rows-sm-18,
  .ids-layout-grid:not([enable-container])[rows-sm="18"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-18 {
    grid-row: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-18 {
    order: 18;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="19"], :host(:not([enable-container])).ids-layout-grid-rows-sm-19,
  .ids-layout-grid:not([enable-container])[rows-sm="19"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-19 {
    grid-row: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-19 {
    order: 19;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="20"], :host(:not([enable-container])).ids-layout-grid-rows-sm-20,
  .ids-layout-grid:not([enable-container])[rows-sm="20"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-20 {
    grid-row: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-20 {
    order: 20;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="21"], :host(:not([enable-container])).ids-layout-grid-rows-sm-21,
  .ids-layout-grid:not([enable-container])[rows-sm="21"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-21 {
    grid-row: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-21 {
    order: 21;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="22"], :host(:not([enable-container])).ids-layout-grid-rows-sm-22,
  .ids-layout-grid:not([enable-container])[rows-sm="22"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-22 {
    grid-row: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-22 {
    order: 22;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="23"], :host(:not([enable-container])).ids-layout-grid-rows-sm-23,
  .ids-layout-grid:not([enable-container])[rows-sm="23"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-23 {
    grid-row: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-23 {
    order: 23;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="24"], :host(:not([enable-container])).ids-layout-grid-rows-sm-24,
  .ids-layout-grid:not([enable-container])[rows-sm="24"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-24 {
    grid-row: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-24 {
    order: 24;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="25"], :host(:not([enable-container])).ids-layout-grid-rows-sm-25,
  .ids-layout-grid:not([enable-container])[rows-sm="25"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-25 {
    grid-row: span 25/span 25;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-25 {
    order: 25;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="26"], :host(:not([enable-container])).ids-layout-grid-rows-sm-26,
  .ids-layout-grid:not([enable-container])[rows-sm="26"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-26 {
    grid-row: span 26/span 26;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-26 {
    order: 26;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="27"], :host(:not([enable-container])).ids-layout-grid-rows-sm-27,
  .ids-layout-grid:not([enable-container])[rows-sm="27"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-27 {
    grid-row: span 27/span 27;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-27 {
    order: 27;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="28"], :host(:not([enable-container])).ids-layout-grid-rows-sm-28,
  .ids-layout-grid:not([enable-container])[rows-sm="28"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-28 {
    grid-row: span 28/span 28;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-28 {
    order: 28;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="29"], :host(:not([enable-container])).ids-layout-grid-rows-sm-29,
  .ids-layout-grid:not([enable-container])[rows-sm="29"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-29 {
    grid-row: span 29/span 29;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-29 {
    order: 29;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="30"], :host(:not([enable-container])).ids-layout-grid-rows-sm-30,
  .ids-layout-grid:not([enable-container])[rows-sm="30"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-30 {
    grid-row: span 30/span 30;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-30 {
    order: 30;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="31"], :host(:not([enable-container])).ids-layout-grid-rows-sm-31,
  .ids-layout-grid:not([enable-container])[rows-sm="31"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-31 {
    grid-row: span 31/span 31;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-31 {
    order: 31;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="32"], :host(:not([enable-container])).ids-layout-grid-rows-sm-32,
  .ids-layout-grid:not([enable-container])[rows-sm="32"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-32 {
    grid-row: span 32/span 32;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-32 {
    order: 32;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="33"], :host(:not([enable-container])).ids-layout-grid-rows-sm-33,
  .ids-layout-grid:not([enable-container])[rows-sm="33"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-33 {
    grid-row: span 33/span 33;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-33 {
    order: 33;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="34"], :host(:not([enable-container])).ids-layout-grid-rows-sm-34,
  .ids-layout-grid:not([enable-container])[rows-sm="34"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-34 {
    grid-row: span 34/span 34;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-34 {
    order: 34;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="35"], :host(:not([enable-container])).ids-layout-grid-rows-sm-35,
  .ids-layout-grid:not([enable-container])[rows-sm="35"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-35 {
    grid-row: span 35/span 35;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-35 {
    order: 35;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="36"], :host(:not([enable-container])).ids-layout-grid-rows-sm-36,
  .ids-layout-grid:not([enable-container])[rows-sm="36"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-36 {
    grid-row: span 36/span 36;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-36 {
    order: 36;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="37"], :host(:not([enable-container])).ids-layout-grid-rows-sm-37,
  .ids-layout-grid:not([enable-container])[rows-sm="37"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-37 {
    grid-row: span 37/span 37;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-37 {
    order: 37;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="38"], :host(:not([enable-container])).ids-layout-grid-rows-sm-38,
  .ids-layout-grid:not([enable-container])[rows-sm="38"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-38 {
    grid-row: span 38/span 38;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-38 {
    order: 38;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="39"], :host(:not([enable-container])).ids-layout-grid-rows-sm-39,
  .ids-layout-grid:not([enable-container])[rows-sm="39"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-39 {
    grid-row: span 39/span 39;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-39 {
    order: 39;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="40"], :host(:not([enable-container])).ids-layout-grid-rows-sm-40,
  .ids-layout-grid:not([enable-container])[rows-sm="40"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-40 {
    grid-row: span 40/span 40;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-40 {
    order: 40;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="41"], :host(:not([enable-container])).ids-layout-grid-rows-sm-41,
  .ids-layout-grid:not([enable-container])[rows-sm="41"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-41 {
    grid-row: span 41/span 41;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-41 {
    order: 41;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="42"], :host(:not([enable-container])).ids-layout-grid-rows-sm-42,
  .ids-layout-grid:not([enable-container])[rows-sm="42"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-42 {
    grid-row: span 42/span 42;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-42 {
    order: 42;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="43"], :host(:not([enable-container])).ids-layout-grid-rows-sm-43,
  .ids-layout-grid:not([enable-container])[rows-sm="43"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-43 {
    grid-row: span 43/span 43;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-43 {
    order: 43;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="44"], :host(:not([enable-container])).ids-layout-grid-rows-sm-44,
  .ids-layout-grid:not([enable-container])[rows-sm="44"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-44 {
    grid-row: span 44/span 44;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-44 {
    order: 44;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="45"], :host(:not([enable-container])).ids-layout-grid-rows-sm-45,
  .ids-layout-grid:not([enable-container])[rows-sm="45"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-45 {
    grid-row: span 45/span 45;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-45 {
    order: 45;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="46"], :host(:not([enable-container])).ids-layout-grid-rows-sm-46,
  .ids-layout-grid:not([enable-container])[rows-sm="46"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-46 {
    grid-row: span 46/span 46;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-46 {
    order: 46;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="47"], :host(:not([enable-container])).ids-layout-grid-rows-sm-47,
  .ids-layout-grid:not([enable-container])[rows-sm="47"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-47 {
    grid-row: span 47/span 47;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-47 {
    order: 47;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="48"], :host(:not([enable-container])).ids-layout-grid-rows-sm-48,
  .ids-layout-grid:not([enable-container])[rows-sm="48"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-48 {
    grid-row: span 48/span 48;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-48 {
    order: 48;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="49"], :host(:not([enable-container])).ids-layout-grid-rows-sm-49,
  .ids-layout-grid:not([enable-container])[rows-sm="49"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-49 {
    grid-row: span 49/span 49;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-49 {
    order: 49;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="50"], :host(:not([enable-container])).ids-layout-grid-rows-sm-50,
  .ids-layout-grid:not([enable-container])[rows-sm="50"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-50 {
    grid-row: span 50/span 50;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-50 {
    order: 50;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container])) > ::slotted([hide=sm]),
  .ids-layout-grid:not([enable-container]) > ::slotted([hide=sm]) {
    display: block;
  }
}
@media (min-width: 840px) {
  :host(:not([enable-container])) > ::slotted([col-span-md="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-1 {
    grid-column: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-1 {
    grid-column-start: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-1 {
    grid-column-end: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-2 {
    grid-column: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-2 {
    grid-column-start: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-2 {
    grid-column-end: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-3 {
    grid-column: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-3 {
    grid-column-start: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-3 {
    grid-column-end: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-4 {
    grid-column: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-4 {
    grid-column-start: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-4 {
    grid-column-end: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-5 {
    grid-column: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-5 {
    grid-column-start: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-5 {
    grid-column-end: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-6 {
    grid-column: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-6 {
    grid-column-start: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-6 {
    grid-column-end: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-7 {
    grid-column: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-7 {
    grid-column-start: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-7 {
    grid-column-end: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-8 {
    grid-column: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-8 {
    grid-column-start: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-8 {
    grid-column-end: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-9 {
    grid-column: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-9 {
    grid-column-start: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-9 {
    grid-column-end: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-10 {
    grid-column: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-10 {
    grid-column-start: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-10 {
    grid-column-end: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-11 {
    grid-column: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-11 {
    grid-column-start: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-11 {
    grid-column-end: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-12 {
    grid-column: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-12 {
    grid-column-start: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-12 {
    grid-column-end: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-13 {
    grid-column: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-13 {
    grid-column-start: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-13 {
    grid-column-end: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-14 {
    grid-column: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-14 {
    grid-column-start: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-14 {
    grid-column-end: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-15 {
    grid-column: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-15 {
    grid-column-start: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-15 {
    grid-column-end: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-16 {
    grid-column: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-16 {
    grid-column-start: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-16 {
    grid-column-end: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-17 {
    grid-column: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-17 {
    grid-column-start: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-17 {
    grid-column-end: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-18 {
    grid-column: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-18 {
    grid-column-start: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-18 {
    grid-column-end: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-19 {
    grid-column: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-19 {
    grid-column-start: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-19 {
    grid-column-end: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-20 {
    grid-column: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-20 {
    grid-column-start: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-20 {
    grid-column-end: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-21 {
    grid-column: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-21 {
    grid-column-start: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-21 {
    grid-column-end: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-22 {
    grid-column: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-22 {
    grid-column-start: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-22 {
    grid-column-end: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-23 {
    grid-column: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-23 {
    grid-column-start: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-23 {
    grid-column-end: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-24 {
    grid-column: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-24 {
    grid-column-start: 24;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-24 {
    grid-column-end: 24;
  }
  :host(:not([enable-container]))[rows-md="1"], :host(:not([enable-container])).ids-layout-grid-rows-md-1,
  .ids-layout-grid:not([enable-container])[rows-md="1"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-1 {
    grid-row: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([order-md="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-1 {
    order: 1;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="2"], :host(:not([enable-container])).ids-layout-grid-rows-md-2,
  .ids-layout-grid:not([enable-container])[rows-md="2"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-2 {
    grid-row: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([order-md="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-2 {
    order: 2;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="3"], :host(:not([enable-container])).ids-layout-grid-rows-md-3,
  .ids-layout-grid:not([enable-container])[rows-md="3"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-3 {
    grid-row: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([order-md="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-3 {
    order: 3;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="4"], :host(:not([enable-container])).ids-layout-grid-rows-md-4,
  .ids-layout-grid:not([enable-container])[rows-md="4"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-4 {
    grid-row: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([order-md="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-4 {
    order: 4;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="5"], :host(:not([enable-container])).ids-layout-grid-rows-md-5,
  .ids-layout-grid:not([enable-container])[rows-md="5"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-5 {
    grid-row: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([order-md="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-5 {
    order: 5;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="6"], :host(:not([enable-container])).ids-layout-grid-rows-md-6,
  .ids-layout-grid:not([enable-container])[rows-md="6"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-6 {
    grid-row: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([order-md="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-6 {
    order: 6;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="7"], :host(:not([enable-container])).ids-layout-grid-rows-md-7,
  .ids-layout-grid:not([enable-container])[rows-md="7"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-7 {
    grid-row: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([order-md="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-7 {
    order: 7;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="8"], :host(:not([enable-container])).ids-layout-grid-rows-md-8,
  .ids-layout-grid:not([enable-container])[rows-md="8"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-8 {
    grid-row: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([order-md="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-8 {
    order: 8;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="9"], :host(:not([enable-container])).ids-layout-grid-rows-md-9,
  .ids-layout-grid:not([enable-container])[rows-md="9"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-9 {
    grid-row: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([order-md="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-9 {
    order: 9;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="10"], :host(:not([enable-container])).ids-layout-grid-rows-md-10,
  .ids-layout-grid:not([enable-container])[rows-md="10"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-10 {
    grid-row: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([order-md="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-10 {
    order: 10;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="11"], :host(:not([enable-container])).ids-layout-grid-rows-md-11,
  .ids-layout-grid:not([enable-container])[rows-md="11"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-11 {
    grid-row: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([order-md="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-11 {
    order: 11;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="12"], :host(:not([enable-container])).ids-layout-grid-rows-md-12,
  .ids-layout-grid:not([enable-container])[rows-md="12"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-12 {
    grid-row: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([order-md="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-12 {
    order: 12;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="13"], :host(:not([enable-container])).ids-layout-grid-rows-md-13,
  .ids-layout-grid:not([enable-container])[rows-md="13"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-13 {
    grid-row: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([order-md="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-13 {
    order: 13;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="14"], :host(:not([enable-container])).ids-layout-grid-rows-md-14,
  .ids-layout-grid:not([enable-container])[rows-md="14"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-14 {
    grid-row: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([order-md="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-14 {
    order: 14;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="15"], :host(:not([enable-container])).ids-layout-grid-rows-md-15,
  .ids-layout-grid:not([enable-container])[rows-md="15"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-15 {
    grid-row: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([order-md="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-15 {
    order: 15;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="16"], :host(:not([enable-container])).ids-layout-grid-rows-md-16,
  .ids-layout-grid:not([enable-container])[rows-md="16"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-16 {
    grid-row: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([order-md="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-16 {
    order: 16;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="17"], :host(:not([enable-container])).ids-layout-grid-rows-md-17,
  .ids-layout-grid:not([enable-container])[rows-md="17"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-17 {
    grid-row: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([order-md="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-17 {
    order: 17;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="18"], :host(:not([enable-container])).ids-layout-grid-rows-md-18,
  .ids-layout-grid:not([enable-container])[rows-md="18"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-18 {
    grid-row: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([order-md="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-18 {
    order: 18;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="19"], :host(:not([enable-container])).ids-layout-grid-rows-md-19,
  .ids-layout-grid:not([enable-container])[rows-md="19"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-19 {
    grid-row: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([order-md="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-19 {
    order: 19;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="20"], :host(:not([enable-container])).ids-layout-grid-rows-md-20,
  .ids-layout-grid:not([enable-container])[rows-md="20"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-20 {
    grid-row: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([order-md="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-20 {
    order: 20;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="21"], :host(:not([enable-container])).ids-layout-grid-rows-md-21,
  .ids-layout-grid:not([enable-container])[rows-md="21"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-21 {
    grid-row: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([order-md="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-21 {
    order: 21;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="22"], :host(:not([enable-container])).ids-layout-grid-rows-md-22,
  .ids-layout-grid:not([enable-container])[rows-md="22"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-22 {
    grid-row: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([order-md="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-22 {
    order: 22;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="23"], :host(:not([enable-container])).ids-layout-grid-rows-md-23,
  .ids-layout-grid:not([enable-container])[rows-md="23"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-23 {
    grid-row: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([order-md="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-23 {
    order: 23;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="24"], :host(:not([enable-container])).ids-layout-grid-rows-md-24,
  .ids-layout-grid:not([enable-container])[rows-md="24"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-24 {
    grid-row: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([order-md="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-24 {
    order: 24;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="25"], :host(:not([enable-container])).ids-layout-grid-rows-md-25,
  .ids-layout-grid:not([enable-container])[rows-md="25"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-25 {
    grid-row: span 25/span 25;
  }
  :host(:not([enable-container])) > ::slotted([order-md="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-25 {
    order: 25;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="26"], :host(:not([enable-container])).ids-layout-grid-rows-md-26,
  .ids-layout-grid:not([enable-container])[rows-md="26"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-26 {
    grid-row: span 26/span 26;
  }
  :host(:not([enable-container])) > ::slotted([order-md="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-26 {
    order: 26;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="27"], :host(:not([enable-container])).ids-layout-grid-rows-md-27,
  .ids-layout-grid:not([enable-container])[rows-md="27"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-27 {
    grid-row: span 27/span 27;
  }
  :host(:not([enable-container])) > ::slotted([order-md="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-27 {
    order: 27;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="28"], :host(:not([enable-container])).ids-layout-grid-rows-md-28,
  .ids-layout-grid:not([enable-container])[rows-md="28"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-28 {
    grid-row: span 28/span 28;
  }
  :host(:not([enable-container])) > ::slotted([order-md="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-28 {
    order: 28;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="29"], :host(:not([enable-container])).ids-layout-grid-rows-md-29,
  .ids-layout-grid:not([enable-container])[rows-md="29"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-29 {
    grid-row: span 29/span 29;
  }
  :host(:not([enable-container])) > ::slotted([order-md="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-29 {
    order: 29;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="30"], :host(:not([enable-container])).ids-layout-grid-rows-md-30,
  .ids-layout-grid:not([enable-container])[rows-md="30"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-30 {
    grid-row: span 30/span 30;
  }
  :host(:not([enable-container])) > ::slotted([order-md="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-30 {
    order: 30;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="31"], :host(:not([enable-container])).ids-layout-grid-rows-md-31,
  .ids-layout-grid:not([enable-container])[rows-md="31"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-31 {
    grid-row: span 31/span 31;
  }
  :host(:not([enable-container])) > ::slotted([order-md="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-31 {
    order: 31;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="32"], :host(:not([enable-container])).ids-layout-grid-rows-md-32,
  .ids-layout-grid:not([enable-container])[rows-md="32"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-32 {
    grid-row: span 32/span 32;
  }
  :host(:not([enable-container])) > ::slotted([order-md="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-32 {
    order: 32;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="33"], :host(:not([enable-container])).ids-layout-grid-rows-md-33,
  .ids-layout-grid:not([enable-container])[rows-md="33"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-33 {
    grid-row: span 33/span 33;
  }
  :host(:not([enable-container])) > ::slotted([order-md="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-33 {
    order: 33;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="34"], :host(:not([enable-container])).ids-layout-grid-rows-md-34,
  .ids-layout-grid:not([enable-container])[rows-md="34"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-34 {
    grid-row: span 34/span 34;
  }
  :host(:not([enable-container])) > ::slotted([order-md="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-34 {
    order: 34;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="35"], :host(:not([enable-container])).ids-layout-grid-rows-md-35,
  .ids-layout-grid:not([enable-container])[rows-md="35"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-35 {
    grid-row: span 35/span 35;
  }
  :host(:not([enable-container])) > ::slotted([order-md="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-35 {
    order: 35;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="36"], :host(:not([enable-container])).ids-layout-grid-rows-md-36,
  .ids-layout-grid:not([enable-container])[rows-md="36"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-36 {
    grid-row: span 36/span 36;
  }
  :host(:not([enable-container])) > ::slotted([order-md="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-36 {
    order: 36;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="37"], :host(:not([enable-container])).ids-layout-grid-rows-md-37,
  .ids-layout-grid:not([enable-container])[rows-md="37"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-37 {
    grid-row: span 37/span 37;
  }
  :host(:not([enable-container])) > ::slotted([order-md="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-37 {
    order: 37;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="38"], :host(:not([enable-container])).ids-layout-grid-rows-md-38,
  .ids-layout-grid:not([enable-container])[rows-md="38"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-38 {
    grid-row: span 38/span 38;
  }
  :host(:not([enable-container])) > ::slotted([order-md="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-38 {
    order: 38;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="39"], :host(:not([enable-container])).ids-layout-grid-rows-md-39,
  .ids-layout-grid:not([enable-container])[rows-md="39"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-39 {
    grid-row: span 39/span 39;
  }
  :host(:not([enable-container])) > ::slotted([order-md="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-39 {
    order: 39;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="40"], :host(:not([enable-container])).ids-layout-grid-rows-md-40,
  .ids-layout-grid:not([enable-container])[rows-md="40"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-40 {
    grid-row: span 40/span 40;
  }
  :host(:not([enable-container])) > ::slotted([order-md="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-40 {
    order: 40;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="41"], :host(:not([enable-container])).ids-layout-grid-rows-md-41,
  .ids-layout-grid:not([enable-container])[rows-md="41"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-41 {
    grid-row: span 41/span 41;
  }
  :host(:not([enable-container])) > ::slotted([order-md="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-41 {
    order: 41;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="42"], :host(:not([enable-container])).ids-layout-grid-rows-md-42,
  .ids-layout-grid:not([enable-container])[rows-md="42"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-42 {
    grid-row: span 42/span 42;
  }
  :host(:not([enable-container])) > ::slotted([order-md="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-42 {
    order: 42;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="43"], :host(:not([enable-container])).ids-layout-grid-rows-md-43,
  .ids-layout-grid:not([enable-container])[rows-md="43"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-43 {
    grid-row: span 43/span 43;
  }
  :host(:not([enable-container])) > ::slotted([order-md="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-43 {
    order: 43;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="44"], :host(:not([enable-container])).ids-layout-grid-rows-md-44,
  .ids-layout-grid:not([enable-container])[rows-md="44"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-44 {
    grid-row: span 44/span 44;
  }
  :host(:not([enable-container])) > ::slotted([order-md="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-44 {
    order: 44;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="45"], :host(:not([enable-container])).ids-layout-grid-rows-md-45,
  .ids-layout-grid:not([enable-container])[rows-md="45"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-45 {
    grid-row: span 45/span 45;
  }
  :host(:not([enable-container])) > ::slotted([order-md="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-45 {
    order: 45;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="46"], :host(:not([enable-container])).ids-layout-grid-rows-md-46,
  .ids-layout-grid:not([enable-container])[rows-md="46"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-46 {
    grid-row: span 46/span 46;
  }
  :host(:not([enable-container])) > ::slotted([order-md="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-46 {
    order: 46;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="47"], :host(:not([enable-container])).ids-layout-grid-rows-md-47,
  .ids-layout-grid:not([enable-container])[rows-md="47"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-47 {
    grid-row: span 47/span 47;
  }
  :host(:not([enable-container])) > ::slotted([order-md="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-47 {
    order: 47;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="48"], :host(:not([enable-container])).ids-layout-grid-rows-md-48,
  .ids-layout-grid:not([enable-container])[rows-md="48"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-48 {
    grid-row: span 48/span 48;
  }
  :host(:not([enable-container])) > ::slotted([order-md="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-48 {
    order: 48;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="49"], :host(:not([enable-container])).ids-layout-grid-rows-md-49,
  .ids-layout-grid:not([enable-container])[rows-md="49"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-49 {
    grid-row: span 49/span 49;
  }
  :host(:not([enable-container])) > ::slotted([order-md="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-49 {
    order: 49;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="50"], :host(:not([enable-container])).ids-layout-grid-rows-md-50,
  .ids-layout-grid:not([enable-container])[rows-md="50"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-50 {
    grid-row: span 50/span 50;
  }
  :host(:not([enable-container])) > ::slotted([order-md="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-50 {
    order: 50;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container])) > ::slotted([hide=md]),
  .ids-layout-grid:not([enable-container]) > ::slotted([hide=md]) {
    display: block;
  }
}
@media (min-width: 1024px) {
  :host(:not([enable-container])) > ::slotted([col-span-lg="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-1 {
    grid-column: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-1 {
    grid-column-start: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-1 {
    grid-column-end: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-2 {
    grid-column: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-2 {
    grid-column-start: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-2 {
    grid-column-end: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-3 {
    grid-column: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-3 {
    grid-column-start: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-3 {
    grid-column-end: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-4 {
    grid-column: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-4 {
    grid-column-start: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-4 {
    grid-column-end: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-5 {
    grid-column: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-5 {
    grid-column-start: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-5 {
    grid-column-end: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-6 {
    grid-column: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-6 {
    grid-column-start: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-6 {
    grid-column-end: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-7 {
    grid-column: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-7 {
    grid-column-start: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-7 {
    grid-column-end: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-8 {
    grid-column: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-8 {
    grid-column-start: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-8 {
    grid-column-end: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-9 {
    grid-column: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-9 {
    grid-column-start: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-9 {
    grid-column-end: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-10 {
    grid-column: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-10 {
    grid-column-start: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-10 {
    grid-column-end: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-11 {
    grid-column: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-11 {
    grid-column-start: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-11 {
    grid-column-end: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-12 {
    grid-column: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-12 {
    grid-column-start: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-12 {
    grid-column-end: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-13 {
    grid-column: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-13 {
    grid-column-start: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-13 {
    grid-column-end: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-14 {
    grid-column: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-14 {
    grid-column-start: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-14 {
    grid-column-end: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-15 {
    grid-column: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-15 {
    grid-column-start: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-15 {
    grid-column-end: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-16 {
    grid-column: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-16 {
    grid-column-start: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-16 {
    grid-column-end: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-17 {
    grid-column: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-17 {
    grid-column-start: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-17 {
    grid-column-end: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-18 {
    grid-column: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-18 {
    grid-column-start: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-18 {
    grid-column-end: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-19 {
    grid-column: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-19 {
    grid-column-start: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-19 {
    grid-column-end: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-20 {
    grid-column: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-20 {
    grid-column-start: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-20 {
    grid-column-end: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-21 {
    grid-column: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-21 {
    grid-column-start: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-21 {
    grid-column-end: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-22 {
    grid-column: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-22 {
    grid-column-start: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-22 {
    grid-column-end: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-23 {
    grid-column: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-23 {
    grid-column-start: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-23 {
    grid-column-end: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-24 {
    grid-column: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-24 {
    grid-column-start: 24;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-24 {
    grid-column-end: 24;
  }
  :host(:not([enable-container]))[rows-lg="1"], :host(:not([enable-container])).ids-layout-grid-rows-lg-1,
  .ids-layout-grid:not([enable-container])[rows-lg="1"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-1 {
    grid-row: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-1 {
    order: 1;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="2"], :host(:not([enable-container])).ids-layout-grid-rows-lg-2,
  .ids-layout-grid:not([enable-container])[rows-lg="2"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-2 {
    grid-row: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-2 {
    order: 2;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="3"], :host(:not([enable-container])).ids-layout-grid-rows-lg-3,
  .ids-layout-grid:not([enable-container])[rows-lg="3"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-3 {
    grid-row: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-3 {
    order: 3;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="4"], :host(:not([enable-container])).ids-layout-grid-rows-lg-4,
  .ids-layout-grid:not([enable-container])[rows-lg="4"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-4 {
    grid-row: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-4 {
    order: 4;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="5"], :host(:not([enable-container])).ids-layout-grid-rows-lg-5,
  .ids-layout-grid:not([enable-container])[rows-lg="5"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-5 {
    grid-row: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-5 {
    order: 5;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="6"], :host(:not([enable-container])).ids-layout-grid-rows-lg-6,
  .ids-layout-grid:not([enable-container])[rows-lg="6"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-6 {
    grid-row: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-6 {
    order: 6;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="7"], :host(:not([enable-container])).ids-layout-grid-rows-lg-7,
  .ids-layout-grid:not([enable-container])[rows-lg="7"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-7 {
    grid-row: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-7 {
    order: 7;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="8"], :host(:not([enable-container])).ids-layout-grid-rows-lg-8,
  .ids-layout-grid:not([enable-container])[rows-lg="8"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-8 {
    grid-row: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-8 {
    order: 8;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="9"], :host(:not([enable-container])).ids-layout-grid-rows-lg-9,
  .ids-layout-grid:not([enable-container])[rows-lg="9"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-9 {
    grid-row: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-9 {
    order: 9;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="10"], :host(:not([enable-container])).ids-layout-grid-rows-lg-10,
  .ids-layout-grid:not([enable-container])[rows-lg="10"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-10 {
    grid-row: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-10 {
    order: 10;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="11"], :host(:not([enable-container])).ids-layout-grid-rows-lg-11,
  .ids-layout-grid:not([enable-container])[rows-lg="11"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-11 {
    grid-row: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-11 {
    order: 11;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="12"], :host(:not([enable-container])).ids-layout-grid-rows-lg-12,
  .ids-layout-grid:not([enable-container])[rows-lg="12"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-12 {
    grid-row: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-12 {
    order: 12;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="13"], :host(:not([enable-container])).ids-layout-grid-rows-lg-13,
  .ids-layout-grid:not([enable-container])[rows-lg="13"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-13 {
    grid-row: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-13 {
    order: 13;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="14"], :host(:not([enable-container])).ids-layout-grid-rows-lg-14,
  .ids-layout-grid:not([enable-container])[rows-lg="14"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-14 {
    grid-row: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-14 {
    order: 14;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="15"], :host(:not([enable-container])).ids-layout-grid-rows-lg-15,
  .ids-layout-grid:not([enable-container])[rows-lg="15"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-15 {
    grid-row: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-15 {
    order: 15;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="16"], :host(:not([enable-container])).ids-layout-grid-rows-lg-16,
  .ids-layout-grid:not([enable-container])[rows-lg="16"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-16 {
    grid-row: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-16 {
    order: 16;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="17"], :host(:not([enable-container])).ids-layout-grid-rows-lg-17,
  .ids-layout-grid:not([enable-container])[rows-lg="17"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-17 {
    grid-row: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-17 {
    order: 17;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="18"], :host(:not([enable-container])).ids-layout-grid-rows-lg-18,
  .ids-layout-grid:not([enable-container])[rows-lg="18"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-18 {
    grid-row: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-18 {
    order: 18;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="19"], :host(:not([enable-container])).ids-layout-grid-rows-lg-19,
  .ids-layout-grid:not([enable-container])[rows-lg="19"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-19 {
    grid-row: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-19 {
    order: 19;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="20"], :host(:not([enable-container])).ids-layout-grid-rows-lg-20,
  .ids-layout-grid:not([enable-container])[rows-lg="20"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-20 {
    grid-row: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-20 {
    order: 20;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="21"], :host(:not([enable-container])).ids-layout-grid-rows-lg-21,
  .ids-layout-grid:not([enable-container])[rows-lg="21"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-21 {
    grid-row: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-21 {
    order: 21;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="22"], :host(:not([enable-container])).ids-layout-grid-rows-lg-22,
  .ids-layout-grid:not([enable-container])[rows-lg="22"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-22 {
    grid-row: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-22 {
    order: 22;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="23"], :host(:not([enable-container])).ids-layout-grid-rows-lg-23,
  .ids-layout-grid:not([enable-container])[rows-lg="23"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-23 {
    grid-row: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-23 {
    order: 23;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="24"], :host(:not([enable-container])).ids-layout-grid-rows-lg-24,
  .ids-layout-grid:not([enable-container])[rows-lg="24"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-24 {
    grid-row: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-24 {
    order: 24;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="25"], :host(:not([enable-container])).ids-layout-grid-rows-lg-25,
  .ids-layout-grid:not([enable-container])[rows-lg="25"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-25 {
    grid-row: span 25/span 25;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-25 {
    order: 25;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="26"], :host(:not([enable-container])).ids-layout-grid-rows-lg-26,
  .ids-layout-grid:not([enable-container])[rows-lg="26"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-26 {
    grid-row: span 26/span 26;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-26 {
    order: 26;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="27"], :host(:not([enable-container])).ids-layout-grid-rows-lg-27,
  .ids-layout-grid:not([enable-container])[rows-lg="27"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-27 {
    grid-row: span 27/span 27;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-27 {
    order: 27;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="28"], :host(:not([enable-container])).ids-layout-grid-rows-lg-28,
  .ids-layout-grid:not([enable-container])[rows-lg="28"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-28 {
    grid-row: span 28/span 28;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-28 {
    order: 28;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="29"], :host(:not([enable-container])).ids-layout-grid-rows-lg-29,
  .ids-layout-grid:not([enable-container])[rows-lg="29"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-29 {
    grid-row: span 29/span 29;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-29 {
    order: 29;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="30"], :host(:not([enable-container])).ids-layout-grid-rows-lg-30,
  .ids-layout-grid:not([enable-container])[rows-lg="30"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-30 {
    grid-row: span 30/span 30;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-30 {
    order: 30;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="31"], :host(:not([enable-container])).ids-layout-grid-rows-lg-31,
  .ids-layout-grid:not([enable-container])[rows-lg="31"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-31 {
    grid-row: span 31/span 31;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-31 {
    order: 31;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="32"], :host(:not([enable-container])).ids-layout-grid-rows-lg-32,
  .ids-layout-grid:not([enable-container])[rows-lg="32"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-32 {
    grid-row: span 32/span 32;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-32 {
    order: 32;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="33"], :host(:not([enable-container])).ids-layout-grid-rows-lg-33,
  .ids-layout-grid:not([enable-container])[rows-lg="33"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-33 {
    grid-row: span 33/span 33;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-33 {
    order: 33;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="34"], :host(:not([enable-container])).ids-layout-grid-rows-lg-34,
  .ids-layout-grid:not([enable-container])[rows-lg="34"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-34 {
    grid-row: span 34/span 34;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-34 {
    order: 34;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="35"], :host(:not([enable-container])).ids-layout-grid-rows-lg-35,
  .ids-layout-grid:not([enable-container])[rows-lg="35"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-35 {
    grid-row: span 35/span 35;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-35 {
    order: 35;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="36"], :host(:not([enable-container])).ids-layout-grid-rows-lg-36,
  .ids-layout-grid:not([enable-container])[rows-lg="36"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-36 {
    grid-row: span 36/span 36;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-36 {
    order: 36;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="37"], :host(:not([enable-container])).ids-layout-grid-rows-lg-37,
  .ids-layout-grid:not([enable-container])[rows-lg="37"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-37 {
    grid-row: span 37/span 37;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-37 {
    order: 37;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="38"], :host(:not([enable-container])).ids-layout-grid-rows-lg-38,
  .ids-layout-grid:not([enable-container])[rows-lg="38"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-38 {
    grid-row: span 38/span 38;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-38 {
    order: 38;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="39"], :host(:not([enable-container])).ids-layout-grid-rows-lg-39,
  .ids-layout-grid:not([enable-container])[rows-lg="39"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-39 {
    grid-row: span 39/span 39;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-39 {
    order: 39;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="40"], :host(:not([enable-container])).ids-layout-grid-rows-lg-40,
  .ids-layout-grid:not([enable-container])[rows-lg="40"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-40 {
    grid-row: span 40/span 40;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-40 {
    order: 40;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="41"], :host(:not([enable-container])).ids-layout-grid-rows-lg-41,
  .ids-layout-grid:not([enable-container])[rows-lg="41"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-41 {
    grid-row: span 41/span 41;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-41 {
    order: 41;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="42"], :host(:not([enable-container])).ids-layout-grid-rows-lg-42,
  .ids-layout-grid:not([enable-container])[rows-lg="42"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-42 {
    grid-row: span 42/span 42;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-42 {
    order: 42;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="43"], :host(:not([enable-container])).ids-layout-grid-rows-lg-43,
  .ids-layout-grid:not([enable-container])[rows-lg="43"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-43 {
    grid-row: span 43/span 43;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-43 {
    order: 43;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="44"], :host(:not([enable-container])).ids-layout-grid-rows-lg-44,
  .ids-layout-grid:not([enable-container])[rows-lg="44"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-44 {
    grid-row: span 44/span 44;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-44 {
    order: 44;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="45"], :host(:not([enable-container])).ids-layout-grid-rows-lg-45,
  .ids-layout-grid:not([enable-container])[rows-lg="45"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-45 {
    grid-row: span 45/span 45;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-45 {
    order: 45;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="46"], :host(:not([enable-container])).ids-layout-grid-rows-lg-46,
  .ids-layout-grid:not([enable-container])[rows-lg="46"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-46 {
    grid-row: span 46/span 46;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-46 {
    order: 46;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="47"], :host(:not([enable-container])).ids-layout-grid-rows-lg-47,
  .ids-layout-grid:not([enable-container])[rows-lg="47"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-47 {
    grid-row: span 47/span 47;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-47 {
    order: 47;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="48"], :host(:not([enable-container])).ids-layout-grid-rows-lg-48,
  .ids-layout-grid:not([enable-container])[rows-lg="48"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-48 {
    grid-row: span 48/span 48;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-48 {
    order: 48;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="49"], :host(:not([enable-container])).ids-layout-grid-rows-lg-49,
  .ids-layout-grid:not([enable-container])[rows-lg="49"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-49 {
    grid-row: span 49/span 49;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-49 {
    order: 49;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="50"], :host(:not([enable-container])).ids-layout-grid-rows-lg-50,
  .ids-layout-grid:not([enable-container])[rows-lg="50"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-50 {
    grid-row: span 50/span 50;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-50 {
    order: 50;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container])) > ::slotted([hide=lg]),
  .ids-layout-grid:not([enable-container]) > ::slotted([hide=lg]) {
    display: block;
  }
}
@media (min-width: 1280px) {
  :host(:not([enable-container])) > ::slotted([col-span-xl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-1 {
    grid-column: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-1 {
    grid-column-start: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-1 {
    grid-column-end: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-2 {
    grid-column: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-2 {
    grid-column-start: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-2 {
    grid-column-end: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-3 {
    grid-column: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-3 {
    grid-column-start: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-3 {
    grid-column-end: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-4 {
    grid-column: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-4 {
    grid-column-start: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-4 {
    grid-column-end: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-5 {
    grid-column: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-5 {
    grid-column-start: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-5 {
    grid-column-end: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-6 {
    grid-column: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-6 {
    grid-column-start: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-6 {
    grid-column-end: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-7 {
    grid-column: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-7 {
    grid-column-start: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-7 {
    grid-column-end: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-8 {
    grid-column: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-8 {
    grid-column-start: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-8 {
    grid-column-end: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-9 {
    grid-column: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-9 {
    grid-column-start: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-9 {
    grid-column-end: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-10 {
    grid-column: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-10 {
    grid-column-start: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-10 {
    grid-column-end: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-11 {
    grid-column: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-11 {
    grid-column-start: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-11 {
    grid-column-end: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-12 {
    grid-column: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-12 {
    grid-column-start: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-12 {
    grid-column-end: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-13 {
    grid-column: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-13 {
    grid-column-start: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-13 {
    grid-column-end: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-14 {
    grid-column: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-14 {
    grid-column-start: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-14 {
    grid-column-end: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-15 {
    grid-column: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-15 {
    grid-column-start: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-15 {
    grid-column-end: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-16 {
    grid-column: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-16 {
    grid-column-start: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-16 {
    grid-column-end: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-17 {
    grid-column: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-17 {
    grid-column-start: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-17 {
    grid-column-end: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-18 {
    grid-column: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-18 {
    grid-column-start: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-18 {
    grid-column-end: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-19 {
    grid-column: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-19 {
    grid-column-start: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-19 {
    grid-column-end: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-20 {
    grid-column: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-20 {
    grid-column-start: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-20 {
    grid-column-end: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-21 {
    grid-column: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-21 {
    grid-column-start: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-21 {
    grid-column-end: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-22 {
    grid-column: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-22 {
    grid-column-start: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-22 {
    grid-column-end: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-23 {
    grid-column: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-23 {
    grid-column-start: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-23 {
    grid-column-end: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-24 {
    grid-column: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-24 {
    grid-column-start: 24;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-24 {
    grid-column-end: 24;
  }
  :host(:not([enable-container]))[rows-xl="1"], :host(:not([enable-container])).ids-layout-grid-rows-xl-1,
  .ids-layout-grid:not([enable-container])[rows-xl="1"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-1 {
    grid-row: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-1 {
    order: 1;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="2"], :host(:not([enable-container])).ids-layout-grid-rows-xl-2,
  .ids-layout-grid:not([enable-container])[rows-xl="2"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-2 {
    grid-row: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-2 {
    order: 2;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="3"], :host(:not([enable-container])).ids-layout-grid-rows-xl-3,
  .ids-layout-grid:not([enable-container])[rows-xl="3"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-3 {
    grid-row: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-3 {
    order: 3;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="4"], :host(:not([enable-container])).ids-layout-grid-rows-xl-4,
  .ids-layout-grid:not([enable-container])[rows-xl="4"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-4 {
    grid-row: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-4 {
    order: 4;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="5"], :host(:not([enable-container])).ids-layout-grid-rows-xl-5,
  .ids-layout-grid:not([enable-container])[rows-xl="5"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-5 {
    grid-row: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-5 {
    order: 5;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="6"], :host(:not([enable-container])).ids-layout-grid-rows-xl-6,
  .ids-layout-grid:not([enable-container])[rows-xl="6"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-6 {
    grid-row: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-6 {
    order: 6;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="7"], :host(:not([enable-container])).ids-layout-grid-rows-xl-7,
  .ids-layout-grid:not([enable-container])[rows-xl="7"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-7 {
    grid-row: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-7 {
    order: 7;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="8"], :host(:not([enable-container])).ids-layout-grid-rows-xl-8,
  .ids-layout-grid:not([enable-container])[rows-xl="8"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-8 {
    grid-row: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-8 {
    order: 8;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="9"], :host(:not([enable-container])).ids-layout-grid-rows-xl-9,
  .ids-layout-grid:not([enable-container])[rows-xl="9"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-9 {
    grid-row: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-9 {
    order: 9;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="10"], :host(:not([enable-container])).ids-layout-grid-rows-xl-10,
  .ids-layout-grid:not([enable-container])[rows-xl="10"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-10 {
    grid-row: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-10 {
    order: 10;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="11"], :host(:not([enable-container])).ids-layout-grid-rows-xl-11,
  .ids-layout-grid:not([enable-container])[rows-xl="11"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-11 {
    grid-row: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-11 {
    order: 11;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="12"], :host(:not([enable-container])).ids-layout-grid-rows-xl-12,
  .ids-layout-grid:not([enable-container])[rows-xl="12"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-12 {
    grid-row: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-12 {
    order: 12;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="13"], :host(:not([enable-container])).ids-layout-grid-rows-xl-13,
  .ids-layout-grid:not([enable-container])[rows-xl="13"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-13 {
    grid-row: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-13 {
    order: 13;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="14"], :host(:not([enable-container])).ids-layout-grid-rows-xl-14,
  .ids-layout-grid:not([enable-container])[rows-xl="14"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-14 {
    grid-row: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-14 {
    order: 14;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="15"], :host(:not([enable-container])).ids-layout-grid-rows-xl-15,
  .ids-layout-grid:not([enable-container])[rows-xl="15"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-15 {
    grid-row: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-15 {
    order: 15;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="16"], :host(:not([enable-container])).ids-layout-grid-rows-xl-16,
  .ids-layout-grid:not([enable-container])[rows-xl="16"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-16 {
    grid-row: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-16 {
    order: 16;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="17"], :host(:not([enable-container])).ids-layout-grid-rows-xl-17,
  .ids-layout-grid:not([enable-container])[rows-xl="17"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-17 {
    grid-row: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-17 {
    order: 17;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="18"], :host(:not([enable-container])).ids-layout-grid-rows-xl-18,
  .ids-layout-grid:not([enable-container])[rows-xl="18"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-18 {
    grid-row: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-18 {
    order: 18;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="19"], :host(:not([enable-container])).ids-layout-grid-rows-xl-19,
  .ids-layout-grid:not([enable-container])[rows-xl="19"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-19 {
    grid-row: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-19 {
    order: 19;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="20"], :host(:not([enable-container])).ids-layout-grid-rows-xl-20,
  .ids-layout-grid:not([enable-container])[rows-xl="20"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-20 {
    grid-row: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-20 {
    order: 20;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="21"], :host(:not([enable-container])).ids-layout-grid-rows-xl-21,
  .ids-layout-grid:not([enable-container])[rows-xl="21"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-21 {
    grid-row: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-21 {
    order: 21;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="22"], :host(:not([enable-container])).ids-layout-grid-rows-xl-22,
  .ids-layout-grid:not([enable-container])[rows-xl="22"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-22 {
    grid-row: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-22 {
    order: 22;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="23"], :host(:not([enable-container])).ids-layout-grid-rows-xl-23,
  .ids-layout-grid:not([enable-container])[rows-xl="23"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-23 {
    grid-row: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-23 {
    order: 23;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="24"], :host(:not([enable-container])).ids-layout-grid-rows-xl-24,
  .ids-layout-grid:not([enable-container])[rows-xl="24"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-24 {
    grid-row: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-24 {
    order: 24;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="25"], :host(:not([enable-container])).ids-layout-grid-rows-xl-25,
  .ids-layout-grid:not([enable-container])[rows-xl="25"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-25 {
    grid-row: span 25/span 25;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-25 {
    order: 25;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="26"], :host(:not([enable-container])).ids-layout-grid-rows-xl-26,
  .ids-layout-grid:not([enable-container])[rows-xl="26"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-26 {
    grid-row: span 26/span 26;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-26 {
    order: 26;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="27"], :host(:not([enable-container])).ids-layout-grid-rows-xl-27,
  .ids-layout-grid:not([enable-container])[rows-xl="27"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-27 {
    grid-row: span 27/span 27;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-27 {
    order: 27;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="28"], :host(:not([enable-container])).ids-layout-grid-rows-xl-28,
  .ids-layout-grid:not([enable-container])[rows-xl="28"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-28 {
    grid-row: span 28/span 28;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-28 {
    order: 28;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="29"], :host(:not([enable-container])).ids-layout-grid-rows-xl-29,
  .ids-layout-grid:not([enable-container])[rows-xl="29"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-29 {
    grid-row: span 29/span 29;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-29 {
    order: 29;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="30"], :host(:not([enable-container])).ids-layout-grid-rows-xl-30,
  .ids-layout-grid:not([enable-container])[rows-xl="30"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-30 {
    grid-row: span 30/span 30;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-30 {
    order: 30;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="31"], :host(:not([enable-container])).ids-layout-grid-rows-xl-31,
  .ids-layout-grid:not([enable-container])[rows-xl="31"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-31 {
    grid-row: span 31/span 31;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-31 {
    order: 31;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="32"], :host(:not([enable-container])).ids-layout-grid-rows-xl-32,
  .ids-layout-grid:not([enable-container])[rows-xl="32"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-32 {
    grid-row: span 32/span 32;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-32 {
    order: 32;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="33"], :host(:not([enable-container])).ids-layout-grid-rows-xl-33,
  .ids-layout-grid:not([enable-container])[rows-xl="33"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-33 {
    grid-row: span 33/span 33;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-33 {
    order: 33;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="34"], :host(:not([enable-container])).ids-layout-grid-rows-xl-34,
  .ids-layout-grid:not([enable-container])[rows-xl="34"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-34 {
    grid-row: span 34/span 34;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-34 {
    order: 34;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="35"], :host(:not([enable-container])).ids-layout-grid-rows-xl-35,
  .ids-layout-grid:not([enable-container])[rows-xl="35"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-35 {
    grid-row: span 35/span 35;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-35 {
    order: 35;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="36"], :host(:not([enable-container])).ids-layout-grid-rows-xl-36,
  .ids-layout-grid:not([enable-container])[rows-xl="36"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-36 {
    grid-row: span 36/span 36;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-36 {
    order: 36;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="37"], :host(:not([enable-container])).ids-layout-grid-rows-xl-37,
  .ids-layout-grid:not([enable-container])[rows-xl="37"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-37 {
    grid-row: span 37/span 37;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-37 {
    order: 37;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="38"], :host(:not([enable-container])).ids-layout-grid-rows-xl-38,
  .ids-layout-grid:not([enable-container])[rows-xl="38"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-38 {
    grid-row: span 38/span 38;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-38 {
    order: 38;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="39"], :host(:not([enable-container])).ids-layout-grid-rows-xl-39,
  .ids-layout-grid:not([enable-container])[rows-xl="39"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-39 {
    grid-row: span 39/span 39;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-39 {
    order: 39;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="40"], :host(:not([enable-container])).ids-layout-grid-rows-xl-40,
  .ids-layout-grid:not([enable-container])[rows-xl="40"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-40 {
    grid-row: span 40/span 40;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-40 {
    order: 40;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="41"], :host(:not([enable-container])).ids-layout-grid-rows-xl-41,
  .ids-layout-grid:not([enable-container])[rows-xl="41"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-41 {
    grid-row: span 41/span 41;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-41 {
    order: 41;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="42"], :host(:not([enable-container])).ids-layout-grid-rows-xl-42,
  .ids-layout-grid:not([enable-container])[rows-xl="42"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-42 {
    grid-row: span 42/span 42;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-42 {
    order: 42;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="43"], :host(:not([enable-container])).ids-layout-grid-rows-xl-43,
  .ids-layout-grid:not([enable-container])[rows-xl="43"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-43 {
    grid-row: span 43/span 43;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-43 {
    order: 43;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="44"], :host(:not([enable-container])).ids-layout-grid-rows-xl-44,
  .ids-layout-grid:not([enable-container])[rows-xl="44"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-44 {
    grid-row: span 44/span 44;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-44 {
    order: 44;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="45"], :host(:not([enable-container])).ids-layout-grid-rows-xl-45,
  .ids-layout-grid:not([enable-container])[rows-xl="45"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-45 {
    grid-row: span 45/span 45;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-45 {
    order: 45;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="46"], :host(:not([enable-container])).ids-layout-grid-rows-xl-46,
  .ids-layout-grid:not([enable-container])[rows-xl="46"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-46 {
    grid-row: span 46/span 46;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-46 {
    order: 46;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="47"], :host(:not([enable-container])).ids-layout-grid-rows-xl-47,
  .ids-layout-grid:not([enable-container])[rows-xl="47"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-47 {
    grid-row: span 47/span 47;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-47 {
    order: 47;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="48"], :host(:not([enable-container])).ids-layout-grid-rows-xl-48,
  .ids-layout-grid:not([enable-container])[rows-xl="48"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-48 {
    grid-row: span 48/span 48;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-48 {
    order: 48;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="49"], :host(:not([enable-container])).ids-layout-grid-rows-xl-49,
  .ids-layout-grid:not([enable-container])[rows-xl="49"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-49 {
    grid-row: span 49/span 49;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-49 {
    order: 49;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="50"], :host(:not([enable-container])).ids-layout-grid-rows-xl-50,
  .ids-layout-grid:not([enable-container])[rows-xl="50"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-50 {
    grid-row: span 50/span 50;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-50 {
    order: 50;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container])) > ::slotted([hide=xl]),
  .ids-layout-grid:not([enable-container]) > ::slotted([hide=xl]) {
    display: block;
  }
}
@media (min-width: 1440px) {
  :host(:not([enable-container])) > ::slotted([col-span-xxl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-1 {
    grid-column: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-1 {
    grid-column-start: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-1 {
    grid-column-end: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-2 {
    grid-column: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-2 {
    grid-column-start: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-2 {
    grid-column-end: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-3 {
    grid-column: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-3 {
    grid-column-start: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-3 {
    grid-column-end: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-4 {
    grid-column: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-4 {
    grid-column-start: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-4 {
    grid-column-end: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-5 {
    grid-column: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-5 {
    grid-column-start: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-5 {
    grid-column-end: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-6 {
    grid-column: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-6 {
    grid-column-start: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-6 {
    grid-column-end: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-7 {
    grid-column: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-7 {
    grid-column-start: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-7 {
    grid-column-end: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-8 {
    grid-column: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-8 {
    grid-column-start: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-8 {
    grid-column-end: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-9 {
    grid-column: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-9 {
    grid-column-start: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-9 {
    grid-column-end: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-10 {
    grid-column: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-10 {
    grid-column-start: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-10 {
    grid-column-end: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-11 {
    grid-column: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-11 {
    grid-column-start: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-11 {
    grid-column-end: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-12 {
    grid-column: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-12 {
    grid-column-start: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-12 {
    grid-column-end: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-13 {
    grid-column: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-13 {
    grid-column-start: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-13 {
    grid-column-end: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-14 {
    grid-column: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-14 {
    grid-column-start: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-14 {
    grid-column-end: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-15 {
    grid-column: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-15 {
    grid-column-start: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-15 {
    grid-column-end: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-16 {
    grid-column: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-16 {
    grid-column-start: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-16 {
    grid-column-end: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-17 {
    grid-column: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-17 {
    grid-column-start: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-17 {
    grid-column-end: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-18 {
    grid-column: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-18 {
    grid-column-start: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-18 {
    grid-column-end: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-19 {
    grid-column: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-19 {
    grid-column-start: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-19 {
    grid-column-end: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-20 {
    grid-column: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-20 {
    grid-column-start: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-20 {
    grid-column-end: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-21 {
    grid-column: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-21 {
    grid-column-start: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-21 {
    grid-column-end: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-22 {
    grid-column: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-22 {
    grid-column-start: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-22 {
    grid-column-end: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-23 {
    grid-column: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-23 {
    grid-column-start: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-23 {
    grid-column-end: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-24 {
    grid-column: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-24 {
    grid-column-start: 24;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-24 {
    grid-column-end: 24;
  }
  :host(:not([enable-container]))[rows-xxl="1"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-1,
  .ids-layout-grid:not([enable-container])[rows-xxl="1"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-1 {
    grid-row: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-1 {
    order: 1;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="2"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-2,
  .ids-layout-grid:not([enable-container])[rows-xxl="2"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-2 {
    grid-row: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-2 {
    order: 2;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="3"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-3,
  .ids-layout-grid:not([enable-container])[rows-xxl="3"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-3 {
    grid-row: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-3 {
    order: 3;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="4"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-4,
  .ids-layout-grid:not([enable-container])[rows-xxl="4"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-4 {
    grid-row: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-4 {
    order: 4;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="5"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-5,
  .ids-layout-grid:not([enable-container])[rows-xxl="5"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-5 {
    grid-row: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-5 {
    order: 5;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="6"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-6,
  .ids-layout-grid:not([enable-container])[rows-xxl="6"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-6 {
    grid-row: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-6 {
    order: 6;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="7"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-7,
  .ids-layout-grid:not([enable-container])[rows-xxl="7"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-7 {
    grid-row: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-7 {
    order: 7;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="8"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-8,
  .ids-layout-grid:not([enable-container])[rows-xxl="8"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-8 {
    grid-row: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-8 {
    order: 8;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="9"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-9,
  .ids-layout-grid:not([enable-container])[rows-xxl="9"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-9 {
    grid-row: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-9 {
    order: 9;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="10"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-10,
  .ids-layout-grid:not([enable-container])[rows-xxl="10"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-10 {
    grid-row: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-10 {
    order: 10;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="11"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-11,
  .ids-layout-grid:not([enable-container])[rows-xxl="11"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-11 {
    grid-row: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-11 {
    order: 11;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="12"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-12,
  .ids-layout-grid:not([enable-container])[rows-xxl="12"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-12 {
    grid-row: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-12 {
    order: 12;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="13"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-13,
  .ids-layout-grid:not([enable-container])[rows-xxl="13"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-13 {
    grid-row: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-13 {
    order: 13;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="14"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-14,
  .ids-layout-grid:not([enable-container])[rows-xxl="14"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-14 {
    grid-row: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-14 {
    order: 14;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="15"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-15,
  .ids-layout-grid:not([enable-container])[rows-xxl="15"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-15 {
    grid-row: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-15 {
    order: 15;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="16"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-16,
  .ids-layout-grid:not([enable-container])[rows-xxl="16"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-16 {
    grid-row: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-16 {
    order: 16;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="17"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-17,
  .ids-layout-grid:not([enable-container])[rows-xxl="17"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-17 {
    grid-row: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-17 {
    order: 17;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="18"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-18,
  .ids-layout-grid:not([enable-container])[rows-xxl="18"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-18 {
    grid-row: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-18 {
    order: 18;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="19"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-19,
  .ids-layout-grid:not([enable-container])[rows-xxl="19"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-19 {
    grid-row: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-19 {
    order: 19;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="20"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-20,
  .ids-layout-grid:not([enable-container])[rows-xxl="20"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-20 {
    grid-row: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-20 {
    order: 20;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="21"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-21,
  .ids-layout-grid:not([enable-container])[rows-xxl="21"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-21 {
    grid-row: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-21 {
    order: 21;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="22"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-22,
  .ids-layout-grid:not([enable-container])[rows-xxl="22"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-22 {
    grid-row: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-22 {
    order: 22;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="23"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-23,
  .ids-layout-grid:not([enable-container])[rows-xxl="23"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-23 {
    grid-row: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-23 {
    order: 23;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="24"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-24,
  .ids-layout-grid:not([enable-container])[rows-xxl="24"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-24 {
    grid-row: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-24 {
    order: 24;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="25"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-25,
  .ids-layout-grid:not([enable-container])[rows-xxl="25"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-25 {
    grid-row: span 25/span 25;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-25 {
    order: 25;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="26"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-26,
  .ids-layout-grid:not([enable-container])[rows-xxl="26"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-26 {
    grid-row: span 26/span 26;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-26 {
    order: 26;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="27"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-27,
  .ids-layout-grid:not([enable-container])[rows-xxl="27"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-27 {
    grid-row: span 27/span 27;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-27 {
    order: 27;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="28"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-28,
  .ids-layout-grid:not([enable-container])[rows-xxl="28"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-28 {
    grid-row: span 28/span 28;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-28 {
    order: 28;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="29"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-29,
  .ids-layout-grid:not([enable-container])[rows-xxl="29"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-29 {
    grid-row: span 29/span 29;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-29 {
    order: 29;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="30"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-30,
  .ids-layout-grid:not([enable-container])[rows-xxl="30"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-30 {
    grid-row: span 30/span 30;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-30 {
    order: 30;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="31"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-31,
  .ids-layout-grid:not([enable-container])[rows-xxl="31"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-31 {
    grid-row: span 31/span 31;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-31 {
    order: 31;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="32"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-32,
  .ids-layout-grid:not([enable-container])[rows-xxl="32"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-32 {
    grid-row: span 32/span 32;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-32 {
    order: 32;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="33"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-33,
  .ids-layout-grid:not([enable-container])[rows-xxl="33"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-33 {
    grid-row: span 33/span 33;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-33 {
    order: 33;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="34"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-34,
  .ids-layout-grid:not([enable-container])[rows-xxl="34"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-34 {
    grid-row: span 34/span 34;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-34 {
    order: 34;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="35"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-35,
  .ids-layout-grid:not([enable-container])[rows-xxl="35"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-35 {
    grid-row: span 35/span 35;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-35 {
    order: 35;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="36"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-36,
  .ids-layout-grid:not([enable-container])[rows-xxl="36"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-36 {
    grid-row: span 36/span 36;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-36 {
    order: 36;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="37"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-37,
  .ids-layout-grid:not([enable-container])[rows-xxl="37"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-37 {
    grid-row: span 37/span 37;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-37 {
    order: 37;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="38"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-38,
  .ids-layout-grid:not([enable-container])[rows-xxl="38"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-38 {
    grid-row: span 38/span 38;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-38 {
    order: 38;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="39"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-39,
  .ids-layout-grid:not([enable-container])[rows-xxl="39"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-39 {
    grid-row: span 39/span 39;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-39 {
    order: 39;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="40"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-40,
  .ids-layout-grid:not([enable-container])[rows-xxl="40"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-40 {
    grid-row: span 40/span 40;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-40 {
    order: 40;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="41"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-41,
  .ids-layout-grid:not([enable-container])[rows-xxl="41"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-41 {
    grid-row: span 41/span 41;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-41 {
    order: 41;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="42"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-42,
  .ids-layout-grid:not([enable-container])[rows-xxl="42"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-42 {
    grid-row: span 42/span 42;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-42 {
    order: 42;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="43"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-43,
  .ids-layout-grid:not([enable-container])[rows-xxl="43"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-43 {
    grid-row: span 43/span 43;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-43 {
    order: 43;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="44"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-44,
  .ids-layout-grid:not([enable-container])[rows-xxl="44"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-44 {
    grid-row: span 44/span 44;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-44 {
    order: 44;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="45"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-45,
  .ids-layout-grid:not([enable-container])[rows-xxl="45"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-45 {
    grid-row: span 45/span 45;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-45 {
    order: 45;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="46"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-46,
  .ids-layout-grid:not([enable-container])[rows-xxl="46"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-46 {
    grid-row: span 46/span 46;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-46 {
    order: 46;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="47"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-47,
  .ids-layout-grid:not([enable-container])[rows-xxl="47"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-47 {
    grid-row: span 47/span 47;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-47 {
    order: 47;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="48"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-48,
  .ids-layout-grid:not([enable-container])[rows-xxl="48"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-48 {
    grid-row: span 48/span 48;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-48 {
    order: 48;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="49"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-49,
  .ids-layout-grid:not([enable-container])[rows-xxl="49"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-49 {
    grid-row: span 49/span 49;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-49 {
    order: 49;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="50"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-50,
  .ids-layout-grid:not([enable-container])[rows-xxl="50"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-50 {
    grid-row: span 50/span 50;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-50 {
    order: 50;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container])) > ::slotted([hide=xxl]),
  .ids-layout-grid:not([enable-container]) > ::slotted([hide=xxl]) {
    display: block;
  }
}

/* Use container queries if enabled */
:host([enable-container]),
.ids-layout-grid[enable-container] {
  container-type: inline-size;
}
@container (min-width: 320px) {
  :host([enable-container]) > ::slotted([col-span-xs="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-1,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-1 {
    grid-column: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([col-start-xs="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-1,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-1 {
    grid-column-start: 1;
  }
  :host([enable-container]) > ::slotted([col-end-xs="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-1,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-1 {
    grid-column-end: 1;
  }
  :host([enable-container]) > ::slotted([col-span-xs="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-2,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-2 {
    grid-column: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([col-start-xs="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-2,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-2 {
    grid-column-start: 2;
  }
  :host([enable-container]) > ::slotted([col-end-xs="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-2,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-2 {
    grid-column-end: 2;
  }
  :host([enable-container]) > ::slotted([col-span-xs="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-3,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-3 {
    grid-column: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([col-start-xs="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-3,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-3 {
    grid-column-start: 3;
  }
  :host([enable-container]) > ::slotted([col-end-xs="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-3,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-3 {
    grid-column-end: 3;
  }
  :host([enable-container]) > ::slotted([col-span-xs="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-4,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-4 {
    grid-column: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([col-start-xs="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-4,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-4 {
    grid-column-start: 4;
  }
  :host([enable-container]) > ::slotted([col-end-xs="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-4,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-4 {
    grid-column-end: 4;
  }
  :host([enable-container]) > ::slotted([col-span-xs="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-5,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-5 {
    grid-column: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([col-start-xs="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-5,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-5 {
    grid-column-start: 5;
  }
  :host([enable-container]) > ::slotted([col-end-xs="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-5,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-5 {
    grid-column-end: 5;
  }
  :host([enable-container]) > ::slotted([col-span-xs="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-6,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-6 {
    grid-column: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([col-start-xs="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-6,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-6 {
    grid-column-start: 6;
  }
  :host([enable-container]) > ::slotted([col-end-xs="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-6,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-6 {
    grid-column-end: 6;
  }
  :host([enable-container]) > ::slotted([col-span-xs="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-7,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-7 {
    grid-column: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([col-start-xs="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-7,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-7 {
    grid-column-start: 7;
  }
  :host([enable-container]) > ::slotted([col-end-xs="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-7,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-7 {
    grid-column-end: 7;
  }
  :host([enable-container]) > ::slotted([col-span-xs="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-8,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-8 {
    grid-column: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([col-start-xs="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-8,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-8 {
    grid-column-start: 8;
  }
  :host([enable-container]) > ::slotted([col-end-xs="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-8,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-8 {
    grid-column-end: 8;
  }
  :host([enable-container]) > ::slotted([col-span-xs="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-9,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-9 {
    grid-column: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([col-start-xs="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-9,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-9 {
    grid-column-start: 9;
  }
  :host([enable-container]) > ::slotted([col-end-xs="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-9,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-9 {
    grid-column-end: 9;
  }
  :host([enable-container]) > ::slotted([col-span-xs="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-10,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-10 {
    grid-column: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([col-start-xs="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-10,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-10 {
    grid-column-start: 10;
  }
  :host([enable-container]) > ::slotted([col-end-xs="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-10,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-10 {
    grid-column-end: 10;
  }
  :host([enable-container]) > ::slotted([col-span-xs="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-11,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-11 {
    grid-column: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([col-start-xs="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-11,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-11 {
    grid-column-start: 11;
  }
  :host([enable-container]) > ::slotted([col-end-xs="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-11,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-11 {
    grid-column-end: 11;
  }
  :host([enable-container]) > ::slotted([col-span-xs="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-12,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-12 {
    grid-column: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([col-start-xs="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-12,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-12 {
    grid-column-start: 12;
  }
  :host([enable-container]) > ::slotted([col-end-xs="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-12,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-12 {
    grid-column-end: 12;
  }
  :host([enable-container]) > ::slotted([col-span-xs="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-13,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-13 {
    grid-column: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([col-start-xs="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-13,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-13 {
    grid-column-start: 13;
  }
  :host([enable-container]) > ::slotted([col-end-xs="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-13,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-13 {
    grid-column-end: 13;
  }
  :host([enable-container]) > ::slotted([col-span-xs="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-14,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-14 {
    grid-column: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([col-start-xs="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-14,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-14 {
    grid-column-start: 14;
  }
  :host([enable-container]) > ::slotted([col-end-xs="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-14,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-14 {
    grid-column-end: 14;
  }
  :host([enable-container]) > ::slotted([col-span-xs="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-15,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-15 {
    grid-column: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([col-start-xs="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-15,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-15 {
    grid-column-start: 15;
  }
  :host([enable-container]) > ::slotted([col-end-xs="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-15,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-15 {
    grid-column-end: 15;
  }
  :host([enable-container]) > ::slotted([col-span-xs="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-16,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-16 {
    grid-column: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([col-start-xs="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-16,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-16 {
    grid-column-start: 16;
  }
  :host([enable-container]) > ::slotted([col-end-xs="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-16,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-16 {
    grid-column-end: 16;
  }
  :host([enable-container]) > ::slotted([col-span-xs="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-17,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-17 {
    grid-column: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([col-start-xs="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-17,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-17 {
    grid-column-start: 17;
  }
  :host([enable-container]) > ::slotted([col-end-xs="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-17,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-17 {
    grid-column-end: 17;
  }
  :host([enable-container]) > ::slotted([col-span-xs="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-18,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-18 {
    grid-column: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([col-start-xs="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-18,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-18 {
    grid-column-start: 18;
  }
  :host([enable-container]) > ::slotted([col-end-xs="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-18,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-18 {
    grid-column-end: 18;
  }
  :host([enable-container]) > ::slotted([col-span-xs="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-19,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-19 {
    grid-column: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([col-start-xs="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-19,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-19 {
    grid-column-start: 19;
  }
  :host([enable-container]) > ::slotted([col-end-xs="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-19,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-19 {
    grid-column-end: 19;
  }
  :host([enable-container]) > ::slotted([col-span-xs="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-20,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-20 {
    grid-column: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([col-start-xs="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-20,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-20 {
    grid-column-start: 20;
  }
  :host([enable-container]) > ::slotted([col-end-xs="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-20,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-20 {
    grid-column-end: 20;
  }
  :host([enable-container]) > ::slotted([col-span-xs="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-21,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-21 {
    grid-column: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([col-start-xs="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-21,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-21 {
    grid-column-start: 21;
  }
  :host([enable-container]) > ::slotted([col-end-xs="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-21,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-21 {
    grid-column-end: 21;
  }
  :host([enable-container]) > ::slotted([col-span-xs="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-22,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-22 {
    grid-column: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([col-start-xs="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-22,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-22 {
    grid-column-start: 22;
  }
  :host([enable-container]) > ::slotted([col-end-xs="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-22,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-22 {
    grid-column-end: 22;
  }
  :host([enable-container]) > ::slotted([col-span-xs="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-23,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-23 {
    grid-column: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([col-start-xs="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-23,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-23 {
    grid-column-start: 23;
  }
  :host([enable-container]) > ::slotted([col-end-xs="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-23,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-23 {
    grid-column-end: 23;
  }
  :host([enable-container]) > ::slotted([col-span-xs="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-24,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-24 {
    grid-column: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([col-start-xs="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-24,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-24 {
    grid-column-start: 24;
  }
  :host([enable-container]) > ::slotted([col-end-xs="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-24,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-24 {
    grid-column-end: 24;
  }
  :host([enable-container])[rows-xs="1"], :host([enable-container]).ids-layout-grid-rows-xs-1,
  .ids-layout-grid[enable-container][rows-xs="1"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-1,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-1 {
    grid-row: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([order-xs="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-1 {
    order: 1;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="2"], :host([enable-container]).ids-layout-grid-rows-xs-2,
  .ids-layout-grid[enable-container][rows-xs="2"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-2,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-2 {
    grid-row: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([order-xs="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-2,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-2 {
    order: 2;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="3"], :host([enable-container]).ids-layout-grid-rows-xs-3,
  .ids-layout-grid[enable-container][rows-xs="3"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-3,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-3 {
    grid-row: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([order-xs="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-3,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-3 {
    order: 3;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="4"], :host([enable-container]).ids-layout-grid-rows-xs-4,
  .ids-layout-grid[enable-container][rows-xs="4"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-4,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-4 {
    grid-row: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([order-xs="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-4,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-4 {
    order: 4;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="5"], :host([enable-container]).ids-layout-grid-rows-xs-5,
  .ids-layout-grid[enable-container][rows-xs="5"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-5,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-5 {
    grid-row: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([order-xs="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-5,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-5 {
    order: 5;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="6"], :host([enable-container]).ids-layout-grid-rows-xs-6,
  .ids-layout-grid[enable-container][rows-xs="6"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-6,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-6 {
    grid-row: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([order-xs="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-6,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-6 {
    order: 6;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="7"], :host([enable-container]).ids-layout-grid-rows-xs-7,
  .ids-layout-grid[enable-container][rows-xs="7"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-7,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-7 {
    grid-row: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([order-xs="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-7,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-7 {
    order: 7;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="8"], :host([enable-container]).ids-layout-grid-rows-xs-8,
  .ids-layout-grid[enable-container][rows-xs="8"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-8,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-8 {
    grid-row: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([order-xs="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-8,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-8 {
    order: 8;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="9"], :host([enable-container]).ids-layout-grid-rows-xs-9,
  .ids-layout-grid[enable-container][rows-xs="9"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-9,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-9 {
    grid-row: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([order-xs="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-9,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-9 {
    order: 9;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="10"], :host([enable-container]).ids-layout-grid-rows-xs-10,
  .ids-layout-grid[enable-container][rows-xs="10"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-10,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-10 {
    grid-row: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([order-xs="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-10,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-10 {
    order: 10;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="11"], :host([enable-container]).ids-layout-grid-rows-xs-11,
  .ids-layout-grid[enable-container][rows-xs="11"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-11,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-11 {
    grid-row: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([order-xs="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-11,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-11 {
    order: 11;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="12"], :host([enable-container]).ids-layout-grid-rows-xs-12,
  .ids-layout-grid[enable-container][rows-xs="12"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-12,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-12 {
    grid-row: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([order-xs="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-12,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-12 {
    order: 12;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="13"], :host([enable-container]).ids-layout-grid-rows-xs-13,
  .ids-layout-grid[enable-container][rows-xs="13"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-13,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-13 {
    grid-row: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([order-xs="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-13,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-13 {
    order: 13;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="14"], :host([enable-container]).ids-layout-grid-rows-xs-14,
  .ids-layout-grid[enable-container][rows-xs="14"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-14,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-14 {
    grid-row: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([order-xs="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-14,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-14 {
    order: 14;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="15"], :host([enable-container]).ids-layout-grid-rows-xs-15,
  .ids-layout-grid[enable-container][rows-xs="15"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-15,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-15 {
    grid-row: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([order-xs="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-15,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-15 {
    order: 15;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="16"], :host([enable-container]).ids-layout-grid-rows-xs-16,
  .ids-layout-grid[enable-container][rows-xs="16"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-16,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-16 {
    grid-row: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([order-xs="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-16,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-16 {
    order: 16;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="17"], :host([enable-container]).ids-layout-grid-rows-xs-17,
  .ids-layout-grid[enable-container][rows-xs="17"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-17,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-17 {
    grid-row: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([order-xs="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-17,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-17 {
    order: 17;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="18"], :host([enable-container]).ids-layout-grid-rows-xs-18,
  .ids-layout-grid[enable-container][rows-xs="18"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-18,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-18 {
    grid-row: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([order-xs="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-18,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-18 {
    order: 18;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="19"], :host([enable-container]).ids-layout-grid-rows-xs-19,
  .ids-layout-grid[enable-container][rows-xs="19"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-19,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-19 {
    grid-row: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([order-xs="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-19,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-19 {
    order: 19;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="20"], :host([enable-container]).ids-layout-grid-rows-xs-20,
  .ids-layout-grid[enable-container][rows-xs="20"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-20,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-20 {
    grid-row: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([order-xs="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-20,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-20 {
    order: 20;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="21"], :host([enable-container]).ids-layout-grid-rows-xs-21,
  .ids-layout-grid[enable-container][rows-xs="21"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-21,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-21 {
    grid-row: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([order-xs="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-21,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-21 {
    order: 21;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="22"], :host([enable-container]).ids-layout-grid-rows-xs-22,
  .ids-layout-grid[enable-container][rows-xs="22"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-22,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-22 {
    grid-row: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([order-xs="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-22,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-22 {
    order: 22;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="23"], :host([enable-container]).ids-layout-grid-rows-xs-23,
  .ids-layout-grid[enable-container][rows-xs="23"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-23,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-23 {
    grid-row: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([order-xs="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-23,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-23 {
    order: 23;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="24"], :host([enable-container]).ids-layout-grid-rows-xs-24,
  .ids-layout-grid[enable-container][rows-xs="24"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-24,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-24 {
    grid-row: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([order-xs="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-24,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-24 {
    order: 24;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="25"], :host([enable-container]).ids-layout-grid-rows-xs-25,
  .ids-layout-grid[enable-container][rows-xs="25"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-25,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-25 {
    grid-row: span 25/span 25;
  }
  :host([enable-container]) > ::slotted([order-xs="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-25,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-25 {
    order: 25;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="26"], :host([enable-container]).ids-layout-grid-rows-xs-26,
  .ids-layout-grid[enable-container][rows-xs="26"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-26,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-26 {
    grid-row: span 26/span 26;
  }
  :host([enable-container]) > ::slotted([order-xs="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-26,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-26 {
    order: 26;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="27"], :host([enable-container]).ids-layout-grid-rows-xs-27,
  .ids-layout-grid[enable-container][rows-xs="27"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-27,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-27 {
    grid-row: span 27/span 27;
  }
  :host([enable-container]) > ::slotted([order-xs="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-27,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-27 {
    order: 27;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="28"], :host([enable-container]).ids-layout-grid-rows-xs-28,
  .ids-layout-grid[enable-container][rows-xs="28"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-28,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-28 {
    grid-row: span 28/span 28;
  }
  :host([enable-container]) > ::slotted([order-xs="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-28,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-28 {
    order: 28;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="29"], :host([enable-container]).ids-layout-grid-rows-xs-29,
  .ids-layout-grid[enable-container][rows-xs="29"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-29,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-29 {
    grid-row: span 29/span 29;
  }
  :host([enable-container]) > ::slotted([order-xs="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-29,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-29 {
    order: 29;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="30"], :host([enable-container]).ids-layout-grid-rows-xs-30,
  .ids-layout-grid[enable-container][rows-xs="30"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-30,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-30 {
    grid-row: span 30/span 30;
  }
  :host([enable-container]) > ::slotted([order-xs="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-30,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-30 {
    order: 30;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="31"], :host([enable-container]).ids-layout-grid-rows-xs-31,
  .ids-layout-grid[enable-container][rows-xs="31"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-31,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-31 {
    grid-row: span 31/span 31;
  }
  :host([enable-container]) > ::slotted([order-xs="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-31,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-31 {
    order: 31;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="32"], :host([enable-container]).ids-layout-grid-rows-xs-32,
  .ids-layout-grid[enable-container][rows-xs="32"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-32,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-32 {
    grid-row: span 32/span 32;
  }
  :host([enable-container]) > ::slotted([order-xs="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-32,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-32 {
    order: 32;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="33"], :host([enable-container]).ids-layout-grid-rows-xs-33,
  .ids-layout-grid[enable-container][rows-xs="33"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-33,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-33 {
    grid-row: span 33/span 33;
  }
  :host([enable-container]) > ::slotted([order-xs="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-33,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-33 {
    order: 33;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="34"], :host([enable-container]).ids-layout-grid-rows-xs-34,
  .ids-layout-grid[enable-container][rows-xs="34"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-34,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-34 {
    grid-row: span 34/span 34;
  }
  :host([enable-container]) > ::slotted([order-xs="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-34,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-34 {
    order: 34;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="35"], :host([enable-container]).ids-layout-grid-rows-xs-35,
  .ids-layout-grid[enable-container][rows-xs="35"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-35,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-35 {
    grid-row: span 35/span 35;
  }
  :host([enable-container]) > ::slotted([order-xs="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-35,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-35 {
    order: 35;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="36"], :host([enable-container]).ids-layout-grid-rows-xs-36,
  .ids-layout-grid[enable-container][rows-xs="36"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-36,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-36 {
    grid-row: span 36/span 36;
  }
  :host([enable-container]) > ::slotted([order-xs="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-36,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-36 {
    order: 36;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="37"], :host([enable-container]).ids-layout-grid-rows-xs-37,
  .ids-layout-grid[enable-container][rows-xs="37"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-37,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-37 {
    grid-row: span 37/span 37;
  }
  :host([enable-container]) > ::slotted([order-xs="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-37,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-37 {
    order: 37;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="38"], :host([enable-container]).ids-layout-grid-rows-xs-38,
  .ids-layout-grid[enable-container][rows-xs="38"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-38,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-38 {
    grid-row: span 38/span 38;
  }
  :host([enable-container]) > ::slotted([order-xs="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-38,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-38 {
    order: 38;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="39"], :host([enable-container]).ids-layout-grid-rows-xs-39,
  .ids-layout-grid[enable-container][rows-xs="39"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-39,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-39 {
    grid-row: span 39/span 39;
  }
  :host([enable-container]) > ::slotted([order-xs="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-39,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-39 {
    order: 39;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="40"], :host([enable-container]).ids-layout-grid-rows-xs-40,
  .ids-layout-grid[enable-container][rows-xs="40"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-40,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-40 {
    grid-row: span 40/span 40;
  }
  :host([enable-container]) > ::slotted([order-xs="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-40,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-40 {
    order: 40;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="41"], :host([enable-container]).ids-layout-grid-rows-xs-41,
  .ids-layout-grid[enable-container][rows-xs="41"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-41,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-41 {
    grid-row: span 41/span 41;
  }
  :host([enable-container]) > ::slotted([order-xs="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-41,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-41 {
    order: 41;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="42"], :host([enable-container]).ids-layout-grid-rows-xs-42,
  .ids-layout-grid[enable-container][rows-xs="42"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-42,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-42 {
    grid-row: span 42/span 42;
  }
  :host([enable-container]) > ::slotted([order-xs="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-42,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-42 {
    order: 42;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="43"], :host([enable-container]).ids-layout-grid-rows-xs-43,
  .ids-layout-grid[enable-container][rows-xs="43"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-43,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-43 {
    grid-row: span 43/span 43;
  }
  :host([enable-container]) > ::slotted([order-xs="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-43,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-43 {
    order: 43;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="44"], :host([enable-container]).ids-layout-grid-rows-xs-44,
  .ids-layout-grid[enable-container][rows-xs="44"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-44,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-44 {
    grid-row: span 44/span 44;
  }
  :host([enable-container]) > ::slotted([order-xs="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-44,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-44 {
    order: 44;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="45"], :host([enable-container]).ids-layout-grid-rows-xs-45,
  .ids-layout-grid[enable-container][rows-xs="45"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-45,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-45 {
    grid-row: span 45/span 45;
  }
  :host([enable-container]) > ::slotted([order-xs="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-45,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-45 {
    order: 45;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="46"], :host([enable-container]).ids-layout-grid-rows-xs-46,
  .ids-layout-grid[enable-container][rows-xs="46"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-46,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-46 {
    grid-row: span 46/span 46;
  }
  :host([enable-container]) > ::slotted([order-xs="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-46,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-46 {
    order: 46;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="47"], :host([enable-container]).ids-layout-grid-rows-xs-47,
  .ids-layout-grid[enable-container][rows-xs="47"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-47,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-47 {
    grid-row: span 47/span 47;
  }
  :host([enable-container]) > ::slotted([order-xs="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-47,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-47 {
    order: 47;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="48"], :host([enable-container]).ids-layout-grid-rows-xs-48,
  .ids-layout-grid[enable-container][rows-xs="48"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-48,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-48 {
    grid-row: span 48/span 48;
  }
  :host([enable-container]) > ::slotted([order-xs="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-48,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-48 {
    order: 48;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="49"], :host([enable-container]).ids-layout-grid-rows-xs-49,
  .ids-layout-grid[enable-container][rows-xs="49"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-49,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-49 {
    grid-row: span 49/span 49;
  }
  :host([enable-container]) > ::slotted([order-xs="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-49,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-49 {
    order: 49;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="50"], :host([enable-container]).ids-layout-grid-rows-xs-50,
  .ids-layout-grid[enable-container][rows-xs="50"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-50,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-50 {
    grid-row: span 50/span 50;
  }
  :host([enable-container]) > ::slotted([order-xs="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-50,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-50 {
    order: 50;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container]) > ::slotted([hide=xs]),
  .ids-layout-grid[enable-container] > ::slotted([hide=xs]) {
    display: block;
  }
}
@container (min-width: 600px) {
  :host([enable-container]) > ::slotted([col-span-sm="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-1,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-1 {
    grid-column: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([col-start-sm="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-1,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-1 {
    grid-column-start: 1;
  }
  :host([enable-container]) > ::slotted([col-end-sm="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-1,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-1 {
    grid-column-end: 1;
  }
  :host([enable-container]) > ::slotted([col-span-sm="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-2,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-2 {
    grid-column: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([col-start-sm="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-2,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-2 {
    grid-column-start: 2;
  }
  :host([enable-container]) > ::slotted([col-end-sm="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-2,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-2 {
    grid-column-end: 2;
  }
  :host([enable-container]) > ::slotted([col-span-sm="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-3,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-3 {
    grid-column: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([col-start-sm="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-3,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-3 {
    grid-column-start: 3;
  }
  :host([enable-container]) > ::slotted([col-end-sm="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-3,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-3 {
    grid-column-end: 3;
  }
  :host([enable-container]) > ::slotted([col-span-sm="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-4,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-4 {
    grid-column: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([col-start-sm="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-4,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-4 {
    grid-column-start: 4;
  }
  :host([enable-container]) > ::slotted([col-end-sm="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-4,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-4 {
    grid-column-end: 4;
  }
  :host([enable-container]) > ::slotted([col-span-sm="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-5,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-5 {
    grid-column: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([col-start-sm="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-5,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-5 {
    grid-column-start: 5;
  }
  :host([enable-container]) > ::slotted([col-end-sm="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-5,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-5 {
    grid-column-end: 5;
  }
  :host([enable-container]) > ::slotted([col-span-sm="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-6,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-6 {
    grid-column: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([col-start-sm="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-6,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-6 {
    grid-column-start: 6;
  }
  :host([enable-container]) > ::slotted([col-end-sm="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-6,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-6 {
    grid-column-end: 6;
  }
  :host([enable-container]) > ::slotted([col-span-sm="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-7,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-7 {
    grid-column: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([col-start-sm="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-7,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-7 {
    grid-column-start: 7;
  }
  :host([enable-container]) > ::slotted([col-end-sm="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-7,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-7 {
    grid-column-end: 7;
  }
  :host([enable-container]) > ::slotted([col-span-sm="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-8,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-8 {
    grid-column: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([col-start-sm="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-8,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-8 {
    grid-column-start: 8;
  }
  :host([enable-container]) > ::slotted([col-end-sm="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-8,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-8 {
    grid-column-end: 8;
  }
  :host([enable-container]) > ::slotted([col-span-sm="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-9,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-9 {
    grid-column: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([col-start-sm="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-9,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-9 {
    grid-column-start: 9;
  }
  :host([enable-container]) > ::slotted([col-end-sm="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-9,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-9 {
    grid-column-end: 9;
  }
  :host([enable-container]) > ::slotted([col-span-sm="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-10,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-10 {
    grid-column: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([col-start-sm="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-10,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-10 {
    grid-column-start: 10;
  }
  :host([enable-container]) > ::slotted([col-end-sm="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-10,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-10 {
    grid-column-end: 10;
  }
  :host([enable-container]) > ::slotted([col-span-sm="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-11,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-11 {
    grid-column: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([col-start-sm="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-11,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-11 {
    grid-column-start: 11;
  }
  :host([enable-container]) > ::slotted([col-end-sm="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-11,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-11 {
    grid-column-end: 11;
  }
  :host([enable-container]) > ::slotted([col-span-sm="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-12,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-12 {
    grid-column: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([col-start-sm="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-12,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-12 {
    grid-column-start: 12;
  }
  :host([enable-container]) > ::slotted([col-end-sm="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-12,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-12 {
    grid-column-end: 12;
  }
  :host([enable-container]) > ::slotted([col-span-sm="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-13,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-13 {
    grid-column: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([col-start-sm="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-13,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-13 {
    grid-column-start: 13;
  }
  :host([enable-container]) > ::slotted([col-end-sm="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-13,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-13 {
    grid-column-end: 13;
  }
  :host([enable-container]) > ::slotted([col-span-sm="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-14,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-14 {
    grid-column: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([col-start-sm="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-14,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-14 {
    grid-column-start: 14;
  }
  :host([enable-container]) > ::slotted([col-end-sm="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-14,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-14 {
    grid-column-end: 14;
  }
  :host([enable-container]) > ::slotted([col-span-sm="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-15,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-15 {
    grid-column: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([col-start-sm="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-15,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-15 {
    grid-column-start: 15;
  }
  :host([enable-container]) > ::slotted([col-end-sm="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-15,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-15 {
    grid-column-end: 15;
  }
  :host([enable-container]) > ::slotted([col-span-sm="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-16,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-16 {
    grid-column: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([col-start-sm="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-16,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-16 {
    grid-column-start: 16;
  }
  :host([enable-container]) > ::slotted([col-end-sm="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-16,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-16 {
    grid-column-end: 16;
  }
  :host([enable-container]) > ::slotted([col-span-sm="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-17,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-17 {
    grid-column: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([col-start-sm="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-17,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-17 {
    grid-column-start: 17;
  }
  :host([enable-container]) > ::slotted([col-end-sm="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-17,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-17 {
    grid-column-end: 17;
  }
  :host([enable-container]) > ::slotted([col-span-sm="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-18,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-18 {
    grid-column: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([col-start-sm="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-18,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-18 {
    grid-column-start: 18;
  }
  :host([enable-container]) > ::slotted([col-end-sm="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-18,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-18 {
    grid-column-end: 18;
  }
  :host([enable-container]) > ::slotted([col-span-sm="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-19,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-19 {
    grid-column: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([col-start-sm="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-19,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-19 {
    grid-column-start: 19;
  }
  :host([enable-container]) > ::slotted([col-end-sm="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-19,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-19 {
    grid-column-end: 19;
  }
  :host([enable-container]) > ::slotted([col-span-sm="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-20,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-20 {
    grid-column: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([col-start-sm="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-20,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-20 {
    grid-column-start: 20;
  }
  :host([enable-container]) > ::slotted([col-end-sm="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-20,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-20 {
    grid-column-end: 20;
  }
  :host([enable-container]) > ::slotted([col-span-sm="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-21,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-21 {
    grid-column: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([col-start-sm="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-21,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-21 {
    grid-column-start: 21;
  }
  :host([enable-container]) > ::slotted([col-end-sm="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-21,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-21 {
    grid-column-end: 21;
  }
  :host([enable-container]) > ::slotted([col-span-sm="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-22,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-22 {
    grid-column: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([col-start-sm="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-22,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-22 {
    grid-column-start: 22;
  }
  :host([enable-container]) > ::slotted([col-end-sm="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-22,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-22 {
    grid-column-end: 22;
  }
  :host([enable-container]) > ::slotted([col-span-sm="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-23,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-23 {
    grid-column: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([col-start-sm="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-23,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-23 {
    grid-column-start: 23;
  }
  :host([enable-container]) > ::slotted([col-end-sm="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-23,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-23 {
    grid-column-end: 23;
  }
  :host([enable-container]) > ::slotted([col-span-sm="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-24,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-24 {
    grid-column: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([col-start-sm="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-24,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-24 {
    grid-column-start: 24;
  }
  :host([enable-container]) > ::slotted([col-end-sm="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-24,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-24 {
    grid-column-end: 24;
  }
  :host([enable-container])[rows-sm="1"], :host([enable-container]).ids-layout-grid-rows-sm-1,
  .ids-layout-grid[enable-container][rows-sm="1"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-1,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-1 {
    grid-row: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([order-sm="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-1 {
    order: 1;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="2"], :host([enable-container]).ids-layout-grid-rows-sm-2,
  .ids-layout-grid[enable-container][rows-sm="2"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-2,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-2 {
    grid-row: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([order-sm="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-2,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-2 {
    order: 2;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="3"], :host([enable-container]).ids-layout-grid-rows-sm-3,
  .ids-layout-grid[enable-container][rows-sm="3"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-3,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-3 {
    grid-row: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([order-sm="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-3,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-3 {
    order: 3;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="4"], :host([enable-container]).ids-layout-grid-rows-sm-4,
  .ids-layout-grid[enable-container][rows-sm="4"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-4,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-4 {
    grid-row: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([order-sm="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-4,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-4 {
    order: 4;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="5"], :host([enable-container]).ids-layout-grid-rows-sm-5,
  .ids-layout-grid[enable-container][rows-sm="5"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-5,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-5 {
    grid-row: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([order-sm="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-5,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-5 {
    order: 5;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="6"], :host([enable-container]).ids-layout-grid-rows-sm-6,
  .ids-layout-grid[enable-container][rows-sm="6"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-6,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-6 {
    grid-row: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([order-sm="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-6,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-6 {
    order: 6;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="7"], :host([enable-container]).ids-layout-grid-rows-sm-7,
  .ids-layout-grid[enable-container][rows-sm="7"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-7,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-7 {
    grid-row: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([order-sm="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-7,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-7 {
    order: 7;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="8"], :host([enable-container]).ids-layout-grid-rows-sm-8,
  .ids-layout-grid[enable-container][rows-sm="8"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-8,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-8 {
    grid-row: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([order-sm="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-8,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-8 {
    order: 8;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="9"], :host([enable-container]).ids-layout-grid-rows-sm-9,
  .ids-layout-grid[enable-container][rows-sm="9"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-9,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-9 {
    grid-row: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([order-sm="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-9,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-9 {
    order: 9;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="10"], :host([enable-container]).ids-layout-grid-rows-sm-10,
  .ids-layout-grid[enable-container][rows-sm="10"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-10,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-10 {
    grid-row: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([order-sm="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-10,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-10 {
    order: 10;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="11"], :host([enable-container]).ids-layout-grid-rows-sm-11,
  .ids-layout-grid[enable-container][rows-sm="11"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-11,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-11 {
    grid-row: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([order-sm="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-11,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-11 {
    order: 11;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="12"], :host([enable-container]).ids-layout-grid-rows-sm-12,
  .ids-layout-grid[enable-container][rows-sm="12"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-12,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-12 {
    grid-row: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([order-sm="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-12,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-12 {
    order: 12;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="13"], :host([enable-container]).ids-layout-grid-rows-sm-13,
  .ids-layout-grid[enable-container][rows-sm="13"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-13,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-13 {
    grid-row: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([order-sm="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-13,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-13 {
    order: 13;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="14"], :host([enable-container]).ids-layout-grid-rows-sm-14,
  .ids-layout-grid[enable-container][rows-sm="14"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-14,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-14 {
    grid-row: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([order-sm="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-14,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-14 {
    order: 14;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="15"], :host([enable-container]).ids-layout-grid-rows-sm-15,
  .ids-layout-grid[enable-container][rows-sm="15"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-15,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-15 {
    grid-row: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([order-sm="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-15,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-15 {
    order: 15;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="16"], :host([enable-container]).ids-layout-grid-rows-sm-16,
  .ids-layout-grid[enable-container][rows-sm="16"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-16,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-16 {
    grid-row: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([order-sm="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-16,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-16 {
    order: 16;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="17"], :host([enable-container]).ids-layout-grid-rows-sm-17,
  .ids-layout-grid[enable-container][rows-sm="17"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-17,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-17 {
    grid-row: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([order-sm="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-17,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-17 {
    order: 17;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="18"], :host([enable-container]).ids-layout-grid-rows-sm-18,
  .ids-layout-grid[enable-container][rows-sm="18"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-18,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-18 {
    grid-row: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([order-sm="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-18,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-18 {
    order: 18;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="19"], :host([enable-container]).ids-layout-grid-rows-sm-19,
  .ids-layout-grid[enable-container][rows-sm="19"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-19,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-19 {
    grid-row: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([order-sm="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-19,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-19 {
    order: 19;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="20"], :host([enable-container]).ids-layout-grid-rows-sm-20,
  .ids-layout-grid[enable-container][rows-sm="20"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-20,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-20 {
    grid-row: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([order-sm="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-20,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-20 {
    order: 20;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="21"], :host([enable-container]).ids-layout-grid-rows-sm-21,
  .ids-layout-grid[enable-container][rows-sm="21"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-21,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-21 {
    grid-row: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([order-sm="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-21,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-21 {
    order: 21;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="22"], :host([enable-container]).ids-layout-grid-rows-sm-22,
  .ids-layout-grid[enable-container][rows-sm="22"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-22,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-22 {
    grid-row: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([order-sm="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-22,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-22 {
    order: 22;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="23"], :host([enable-container]).ids-layout-grid-rows-sm-23,
  .ids-layout-grid[enable-container][rows-sm="23"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-23,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-23 {
    grid-row: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([order-sm="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-23,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-23 {
    order: 23;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="24"], :host([enable-container]).ids-layout-grid-rows-sm-24,
  .ids-layout-grid[enable-container][rows-sm="24"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-24,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-24 {
    grid-row: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([order-sm="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-24,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-24 {
    order: 24;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="25"], :host([enable-container]).ids-layout-grid-rows-sm-25,
  .ids-layout-grid[enable-container][rows-sm="25"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-25,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-25 {
    grid-row: span 25/span 25;
  }
  :host([enable-container]) > ::slotted([order-sm="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-25,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-25 {
    order: 25;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="26"], :host([enable-container]).ids-layout-grid-rows-sm-26,
  .ids-layout-grid[enable-container][rows-sm="26"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-26,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-26 {
    grid-row: span 26/span 26;
  }
  :host([enable-container]) > ::slotted([order-sm="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-26,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-26 {
    order: 26;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="27"], :host([enable-container]).ids-layout-grid-rows-sm-27,
  .ids-layout-grid[enable-container][rows-sm="27"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-27,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-27 {
    grid-row: span 27/span 27;
  }
  :host([enable-container]) > ::slotted([order-sm="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-27,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-27 {
    order: 27;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="28"], :host([enable-container]).ids-layout-grid-rows-sm-28,
  .ids-layout-grid[enable-container][rows-sm="28"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-28,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-28 {
    grid-row: span 28/span 28;
  }
  :host([enable-container]) > ::slotted([order-sm="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-28,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-28 {
    order: 28;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="29"], :host([enable-container]).ids-layout-grid-rows-sm-29,
  .ids-layout-grid[enable-container][rows-sm="29"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-29,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-29 {
    grid-row: span 29/span 29;
  }
  :host([enable-container]) > ::slotted([order-sm="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-29,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-29 {
    order: 29;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="30"], :host([enable-container]).ids-layout-grid-rows-sm-30,
  .ids-layout-grid[enable-container][rows-sm="30"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-30,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-30 {
    grid-row: span 30/span 30;
  }
  :host([enable-container]) > ::slotted([order-sm="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-30,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-30 {
    order: 30;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="31"], :host([enable-container]).ids-layout-grid-rows-sm-31,
  .ids-layout-grid[enable-container][rows-sm="31"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-31,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-31 {
    grid-row: span 31/span 31;
  }
  :host([enable-container]) > ::slotted([order-sm="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-31,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-31 {
    order: 31;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="32"], :host([enable-container]).ids-layout-grid-rows-sm-32,
  .ids-layout-grid[enable-container][rows-sm="32"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-32,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-32 {
    grid-row: span 32/span 32;
  }
  :host([enable-container]) > ::slotted([order-sm="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-32,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-32 {
    order: 32;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="33"], :host([enable-container]).ids-layout-grid-rows-sm-33,
  .ids-layout-grid[enable-container][rows-sm="33"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-33,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-33 {
    grid-row: span 33/span 33;
  }
  :host([enable-container]) > ::slotted([order-sm="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-33,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-33 {
    order: 33;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="34"], :host([enable-container]).ids-layout-grid-rows-sm-34,
  .ids-layout-grid[enable-container][rows-sm="34"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-34,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-34 {
    grid-row: span 34/span 34;
  }
  :host([enable-container]) > ::slotted([order-sm="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-34,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-34 {
    order: 34;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="35"], :host([enable-container]).ids-layout-grid-rows-sm-35,
  .ids-layout-grid[enable-container][rows-sm="35"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-35,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-35 {
    grid-row: span 35/span 35;
  }
  :host([enable-container]) > ::slotted([order-sm="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-35,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-35 {
    order: 35;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="36"], :host([enable-container]).ids-layout-grid-rows-sm-36,
  .ids-layout-grid[enable-container][rows-sm="36"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-36,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-36 {
    grid-row: span 36/span 36;
  }
  :host([enable-container]) > ::slotted([order-sm="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-36,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-36 {
    order: 36;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="37"], :host([enable-container]).ids-layout-grid-rows-sm-37,
  .ids-layout-grid[enable-container][rows-sm="37"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-37,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-37 {
    grid-row: span 37/span 37;
  }
  :host([enable-container]) > ::slotted([order-sm="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-37,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-37 {
    order: 37;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="38"], :host([enable-container]).ids-layout-grid-rows-sm-38,
  .ids-layout-grid[enable-container][rows-sm="38"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-38,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-38 {
    grid-row: span 38/span 38;
  }
  :host([enable-container]) > ::slotted([order-sm="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-38,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-38 {
    order: 38;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="39"], :host([enable-container]).ids-layout-grid-rows-sm-39,
  .ids-layout-grid[enable-container][rows-sm="39"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-39,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-39 {
    grid-row: span 39/span 39;
  }
  :host([enable-container]) > ::slotted([order-sm="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-39,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-39 {
    order: 39;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="40"], :host([enable-container]).ids-layout-grid-rows-sm-40,
  .ids-layout-grid[enable-container][rows-sm="40"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-40,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-40 {
    grid-row: span 40/span 40;
  }
  :host([enable-container]) > ::slotted([order-sm="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-40,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-40 {
    order: 40;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="41"], :host([enable-container]).ids-layout-grid-rows-sm-41,
  .ids-layout-grid[enable-container][rows-sm="41"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-41,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-41 {
    grid-row: span 41/span 41;
  }
  :host([enable-container]) > ::slotted([order-sm="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-41,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-41 {
    order: 41;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="42"], :host([enable-container]).ids-layout-grid-rows-sm-42,
  .ids-layout-grid[enable-container][rows-sm="42"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-42,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-42 {
    grid-row: span 42/span 42;
  }
  :host([enable-container]) > ::slotted([order-sm="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-42,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-42 {
    order: 42;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="43"], :host([enable-container]).ids-layout-grid-rows-sm-43,
  .ids-layout-grid[enable-container][rows-sm="43"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-43,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-43 {
    grid-row: span 43/span 43;
  }
  :host([enable-container]) > ::slotted([order-sm="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-43,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-43 {
    order: 43;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="44"], :host([enable-container]).ids-layout-grid-rows-sm-44,
  .ids-layout-grid[enable-container][rows-sm="44"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-44,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-44 {
    grid-row: span 44/span 44;
  }
  :host([enable-container]) > ::slotted([order-sm="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-44,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-44 {
    order: 44;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="45"], :host([enable-container]).ids-layout-grid-rows-sm-45,
  .ids-layout-grid[enable-container][rows-sm="45"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-45,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-45 {
    grid-row: span 45/span 45;
  }
  :host([enable-container]) > ::slotted([order-sm="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-45,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-45 {
    order: 45;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="46"], :host([enable-container]).ids-layout-grid-rows-sm-46,
  .ids-layout-grid[enable-container][rows-sm="46"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-46,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-46 {
    grid-row: span 46/span 46;
  }
  :host([enable-container]) > ::slotted([order-sm="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-46,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-46 {
    order: 46;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="47"], :host([enable-container]).ids-layout-grid-rows-sm-47,
  .ids-layout-grid[enable-container][rows-sm="47"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-47,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-47 {
    grid-row: span 47/span 47;
  }
  :host([enable-container]) > ::slotted([order-sm="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-47,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-47 {
    order: 47;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="48"], :host([enable-container]).ids-layout-grid-rows-sm-48,
  .ids-layout-grid[enable-container][rows-sm="48"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-48,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-48 {
    grid-row: span 48/span 48;
  }
  :host([enable-container]) > ::slotted([order-sm="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-48,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-48 {
    order: 48;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="49"], :host([enable-container]).ids-layout-grid-rows-sm-49,
  .ids-layout-grid[enable-container][rows-sm="49"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-49,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-49 {
    grid-row: span 49/span 49;
  }
  :host([enable-container]) > ::slotted([order-sm="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-49,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-49 {
    order: 49;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="50"], :host([enable-container]).ids-layout-grid-rows-sm-50,
  .ids-layout-grid[enable-container][rows-sm="50"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-50,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-50 {
    grid-row: span 50/span 50;
  }
  :host([enable-container]) > ::slotted([order-sm="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-50,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-50 {
    order: 50;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container]) > ::slotted([hide=sm]),
  .ids-layout-grid[enable-container] > ::slotted([hide=sm]) {
    display: block;
  }
}
@container (min-width: 840px) {
  :host([enable-container]) > ::slotted([col-span-md="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-1,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-1 {
    grid-column: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([col-start-md="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-1,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-1 {
    grid-column-start: 1;
  }
  :host([enable-container]) > ::slotted([col-end-md="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-1,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-1 {
    grid-column-end: 1;
  }
  :host([enable-container]) > ::slotted([col-span-md="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-2,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-2 {
    grid-column: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([col-start-md="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-2,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-2 {
    grid-column-start: 2;
  }
  :host([enable-container]) > ::slotted([col-end-md="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-2,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-2 {
    grid-column-end: 2;
  }
  :host([enable-container]) > ::slotted([col-span-md="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-3,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-3 {
    grid-column: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([col-start-md="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-3,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-3 {
    grid-column-start: 3;
  }
  :host([enable-container]) > ::slotted([col-end-md="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-3,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-3 {
    grid-column-end: 3;
  }
  :host([enable-container]) > ::slotted([col-span-md="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-4,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-4 {
    grid-column: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([col-start-md="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-4,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-4 {
    grid-column-start: 4;
  }
  :host([enable-container]) > ::slotted([col-end-md="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-4,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-4 {
    grid-column-end: 4;
  }
  :host([enable-container]) > ::slotted([col-span-md="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-5,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-5 {
    grid-column: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([col-start-md="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-5,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-5 {
    grid-column-start: 5;
  }
  :host([enable-container]) > ::slotted([col-end-md="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-5,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-5 {
    grid-column-end: 5;
  }
  :host([enable-container]) > ::slotted([col-span-md="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-6,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-6 {
    grid-column: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([col-start-md="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-6,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-6 {
    grid-column-start: 6;
  }
  :host([enable-container]) > ::slotted([col-end-md="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-6,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-6 {
    grid-column-end: 6;
  }
  :host([enable-container]) > ::slotted([col-span-md="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-7,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-7 {
    grid-column: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([col-start-md="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-7,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-7 {
    grid-column-start: 7;
  }
  :host([enable-container]) > ::slotted([col-end-md="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-7,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-7 {
    grid-column-end: 7;
  }
  :host([enable-container]) > ::slotted([col-span-md="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-8,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-8 {
    grid-column: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([col-start-md="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-8,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-8 {
    grid-column-start: 8;
  }
  :host([enable-container]) > ::slotted([col-end-md="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-8,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-8 {
    grid-column-end: 8;
  }
  :host([enable-container]) > ::slotted([col-span-md="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-9,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-9 {
    grid-column: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([col-start-md="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-9,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-9 {
    grid-column-start: 9;
  }
  :host([enable-container]) > ::slotted([col-end-md="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-9,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-9 {
    grid-column-end: 9;
  }
  :host([enable-container]) > ::slotted([col-span-md="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-10,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-10 {
    grid-column: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([col-start-md="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-10,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-10 {
    grid-column-start: 10;
  }
  :host([enable-container]) > ::slotted([col-end-md="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-10,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-10 {
    grid-column-end: 10;
  }
  :host([enable-container]) > ::slotted([col-span-md="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-11,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-11 {
    grid-column: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([col-start-md="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-11,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-11 {
    grid-column-start: 11;
  }
  :host([enable-container]) > ::slotted([col-end-md="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-11,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-11 {
    grid-column-end: 11;
  }
  :host([enable-container]) > ::slotted([col-span-md="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-12,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-12 {
    grid-column: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([col-start-md="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-12,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-12 {
    grid-column-start: 12;
  }
  :host([enable-container]) > ::slotted([col-end-md="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-12,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-12 {
    grid-column-end: 12;
  }
  :host([enable-container]) > ::slotted([col-span-md="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-13,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-13 {
    grid-column: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([col-start-md="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-13,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-13 {
    grid-column-start: 13;
  }
  :host([enable-container]) > ::slotted([col-end-md="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-13,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-13 {
    grid-column-end: 13;
  }
  :host([enable-container]) > ::slotted([col-span-md="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-14,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-14 {
    grid-column: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([col-start-md="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-14,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-14 {
    grid-column-start: 14;
  }
  :host([enable-container]) > ::slotted([col-end-md="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-14,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-14 {
    grid-column-end: 14;
  }
  :host([enable-container]) > ::slotted([col-span-md="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-15,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-15 {
    grid-column: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([col-start-md="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-15,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-15 {
    grid-column-start: 15;
  }
  :host([enable-container]) > ::slotted([col-end-md="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-15,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-15 {
    grid-column-end: 15;
  }
  :host([enable-container]) > ::slotted([col-span-md="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-16,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-16 {
    grid-column: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([col-start-md="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-16,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-16 {
    grid-column-start: 16;
  }
  :host([enable-container]) > ::slotted([col-end-md="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-16,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-16 {
    grid-column-end: 16;
  }
  :host([enable-container]) > ::slotted([col-span-md="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-17,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-17 {
    grid-column: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([col-start-md="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-17,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-17 {
    grid-column-start: 17;
  }
  :host([enable-container]) > ::slotted([col-end-md="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-17,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-17 {
    grid-column-end: 17;
  }
  :host([enable-container]) > ::slotted([col-span-md="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-18,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-18 {
    grid-column: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([col-start-md="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-18,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-18 {
    grid-column-start: 18;
  }
  :host([enable-container]) > ::slotted([col-end-md="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-18,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-18 {
    grid-column-end: 18;
  }
  :host([enable-container]) > ::slotted([col-span-md="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-19,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-19 {
    grid-column: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([col-start-md="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-19,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-19 {
    grid-column-start: 19;
  }
  :host([enable-container]) > ::slotted([col-end-md="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-19,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-19 {
    grid-column-end: 19;
  }
  :host([enable-container]) > ::slotted([col-span-md="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-20,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-20 {
    grid-column: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([col-start-md="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-20,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-20 {
    grid-column-start: 20;
  }
  :host([enable-container]) > ::slotted([col-end-md="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-20,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-20 {
    grid-column-end: 20;
  }
  :host([enable-container]) > ::slotted([col-span-md="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-21,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-21 {
    grid-column: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([col-start-md="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-21,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-21 {
    grid-column-start: 21;
  }
  :host([enable-container]) > ::slotted([col-end-md="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-21,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-21 {
    grid-column-end: 21;
  }
  :host([enable-container]) > ::slotted([col-span-md="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-22,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-22 {
    grid-column: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([col-start-md="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-22,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-22 {
    grid-column-start: 22;
  }
  :host([enable-container]) > ::slotted([col-end-md="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-22,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-22 {
    grid-column-end: 22;
  }
  :host([enable-container]) > ::slotted([col-span-md="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-23,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-23 {
    grid-column: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([col-start-md="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-23,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-23 {
    grid-column-start: 23;
  }
  :host([enable-container]) > ::slotted([col-end-md="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-23,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-23 {
    grid-column-end: 23;
  }
  :host([enable-container]) > ::slotted([col-span-md="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-24,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-24 {
    grid-column: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([col-start-md="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-24,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-24 {
    grid-column-start: 24;
  }
  :host([enable-container]) > ::slotted([col-end-md="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-24,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-24 {
    grid-column-end: 24;
  }
  :host([enable-container])[rows-md="1"], :host([enable-container]).ids-layout-grid-rows-md-1,
  .ids-layout-grid[enable-container][rows-md="1"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-1,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-1 {
    grid-row: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([order-md="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-1 {
    order: 1;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="2"], :host([enable-container]).ids-layout-grid-rows-md-2,
  .ids-layout-grid[enable-container][rows-md="2"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-2,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-2 {
    grid-row: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([order-md="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-2,
  .ids-layout-grid[enable-container] > ::slotted([order-md="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-2 {
    order: 2;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="3"], :host([enable-container]).ids-layout-grid-rows-md-3,
  .ids-layout-grid[enable-container][rows-md="3"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-3,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-3 {
    grid-row: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([order-md="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-3,
  .ids-layout-grid[enable-container] > ::slotted([order-md="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-3 {
    order: 3;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="4"], :host([enable-container]).ids-layout-grid-rows-md-4,
  .ids-layout-grid[enable-container][rows-md="4"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-4,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-4 {
    grid-row: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([order-md="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-4,
  .ids-layout-grid[enable-container] > ::slotted([order-md="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-4 {
    order: 4;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="5"], :host([enable-container]).ids-layout-grid-rows-md-5,
  .ids-layout-grid[enable-container][rows-md="5"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-5,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-5 {
    grid-row: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([order-md="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-5,
  .ids-layout-grid[enable-container] > ::slotted([order-md="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-5 {
    order: 5;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="6"], :host([enable-container]).ids-layout-grid-rows-md-6,
  .ids-layout-grid[enable-container][rows-md="6"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-6,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-6 {
    grid-row: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([order-md="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-6,
  .ids-layout-grid[enable-container] > ::slotted([order-md="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-6 {
    order: 6;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="7"], :host([enable-container]).ids-layout-grid-rows-md-7,
  .ids-layout-grid[enable-container][rows-md="7"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-7,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-7 {
    grid-row: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([order-md="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-7,
  .ids-layout-grid[enable-container] > ::slotted([order-md="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-7 {
    order: 7;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="8"], :host([enable-container]).ids-layout-grid-rows-md-8,
  .ids-layout-grid[enable-container][rows-md="8"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-8,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-8 {
    grid-row: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([order-md="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-8,
  .ids-layout-grid[enable-container] > ::slotted([order-md="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-8 {
    order: 8;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="9"], :host([enable-container]).ids-layout-grid-rows-md-9,
  .ids-layout-grid[enable-container][rows-md="9"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-9,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-9 {
    grid-row: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([order-md="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-9,
  .ids-layout-grid[enable-container] > ::slotted([order-md="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-9 {
    order: 9;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="10"], :host([enable-container]).ids-layout-grid-rows-md-10,
  .ids-layout-grid[enable-container][rows-md="10"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-10,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-10 {
    grid-row: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([order-md="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-10,
  .ids-layout-grid[enable-container] > ::slotted([order-md="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-10 {
    order: 10;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="11"], :host([enable-container]).ids-layout-grid-rows-md-11,
  .ids-layout-grid[enable-container][rows-md="11"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-11,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-11 {
    grid-row: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([order-md="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-11,
  .ids-layout-grid[enable-container] > ::slotted([order-md="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-11 {
    order: 11;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="12"], :host([enable-container]).ids-layout-grid-rows-md-12,
  .ids-layout-grid[enable-container][rows-md="12"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-12,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-12 {
    grid-row: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([order-md="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-12,
  .ids-layout-grid[enable-container] > ::slotted([order-md="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-12 {
    order: 12;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="13"], :host([enable-container]).ids-layout-grid-rows-md-13,
  .ids-layout-grid[enable-container][rows-md="13"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-13,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-13 {
    grid-row: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([order-md="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-13,
  .ids-layout-grid[enable-container] > ::slotted([order-md="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-13 {
    order: 13;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="14"], :host([enable-container]).ids-layout-grid-rows-md-14,
  .ids-layout-grid[enable-container][rows-md="14"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-14,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-14 {
    grid-row: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([order-md="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-14,
  .ids-layout-grid[enable-container] > ::slotted([order-md="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-14 {
    order: 14;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="15"], :host([enable-container]).ids-layout-grid-rows-md-15,
  .ids-layout-grid[enable-container][rows-md="15"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-15,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-15 {
    grid-row: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([order-md="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-15,
  .ids-layout-grid[enable-container] > ::slotted([order-md="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-15 {
    order: 15;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="16"], :host([enable-container]).ids-layout-grid-rows-md-16,
  .ids-layout-grid[enable-container][rows-md="16"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-16,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-16 {
    grid-row: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([order-md="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-16,
  .ids-layout-grid[enable-container] > ::slotted([order-md="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-16 {
    order: 16;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="17"], :host([enable-container]).ids-layout-grid-rows-md-17,
  .ids-layout-grid[enable-container][rows-md="17"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-17,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-17 {
    grid-row: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([order-md="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-17,
  .ids-layout-grid[enable-container] > ::slotted([order-md="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-17 {
    order: 17;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="18"], :host([enable-container]).ids-layout-grid-rows-md-18,
  .ids-layout-grid[enable-container][rows-md="18"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-18,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-18 {
    grid-row: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([order-md="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-18,
  .ids-layout-grid[enable-container] > ::slotted([order-md="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-18 {
    order: 18;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="19"], :host([enable-container]).ids-layout-grid-rows-md-19,
  .ids-layout-grid[enable-container][rows-md="19"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-19,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-19 {
    grid-row: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([order-md="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-19,
  .ids-layout-grid[enable-container] > ::slotted([order-md="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-19 {
    order: 19;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="20"], :host([enable-container]).ids-layout-grid-rows-md-20,
  .ids-layout-grid[enable-container][rows-md="20"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-20,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-20 {
    grid-row: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([order-md="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-20,
  .ids-layout-grid[enable-container] > ::slotted([order-md="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-20 {
    order: 20;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="21"], :host([enable-container]).ids-layout-grid-rows-md-21,
  .ids-layout-grid[enable-container][rows-md="21"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-21,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-21 {
    grid-row: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([order-md="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-21,
  .ids-layout-grid[enable-container] > ::slotted([order-md="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-21 {
    order: 21;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="22"], :host([enable-container]).ids-layout-grid-rows-md-22,
  .ids-layout-grid[enable-container][rows-md="22"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-22,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-22 {
    grid-row: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([order-md="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-22,
  .ids-layout-grid[enable-container] > ::slotted([order-md="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-22 {
    order: 22;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="23"], :host([enable-container]).ids-layout-grid-rows-md-23,
  .ids-layout-grid[enable-container][rows-md="23"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-23,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-23 {
    grid-row: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([order-md="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-23,
  .ids-layout-grid[enable-container] > ::slotted([order-md="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-23 {
    order: 23;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="24"], :host([enable-container]).ids-layout-grid-rows-md-24,
  .ids-layout-grid[enable-container][rows-md="24"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-24,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-24 {
    grid-row: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([order-md="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-24,
  .ids-layout-grid[enable-container] > ::slotted([order-md="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-24 {
    order: 24;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="25"], :host([enable-container]).ids-layout-grid-rows-md-25,
  .ids-layout-grid[enable-container][rows-md="25"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-25,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-25 {
    grid-row: span 25/span 25;
  }
  :host([enable-container]) > ::slotted([order-md="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-25,
  .ids-layout-grid[enable-container] > ::slotted([order-md="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-25 {
    order: 25;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="26"], :host([enable-container]).ids-layout-grid-rows-md-26,
  .ids-layout-grid[enable-container][rows-md="26"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-26,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-26 {
    grid-row: span 26/span 26;
  }
  :host([enable-container]) > ::slotted([order-md="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-26,
  .ids-layout-grid[enable-container] > ::slotted([order-md="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-26 {
    order: 26;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="27"], :host([enable-container]).ids-layout-grid-rows-md-27,
  .ids-layout-grid[enable-container][rows-md="27"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-27,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-27 {
    grid-row: span 27/span 27;
  }
  :host([enable-container]) > ::slotted([order-md="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-27,
  .ids-layout-grid[enable-container] > ::slotted([order-md="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-27 {
    order: 27;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="28"], :host([enable-container]).ids-layout-grid-rows-md-28,
  .ids-layout-grid[enable-container][rows-md="28"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-28,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-28 {
    grid-row: span 28/span 28;
  }
  :host([enable-container]) > ::slotted([order-md="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-28,
  .ids-layout-grid[enable-container] > ::slotted([order-md="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-28 {
    order: 28;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="29"], :host([enable-container]).ids-layout-grid-rows-md-29,
  .ids-layout-grid[enable-container][rows-md="29"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-29,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-29 {
    grid-row: span 29/span 29;
  }
  :host([enable-container]) > ::slotted([order-md="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-29,
  .ids-layout-grid[enable-container] > ::slotted([order-md="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-29 {
    order: 29;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="30"], :host([enable-container]).ids-layout-grid-rows-md-30,
  .ids-layout-grid[enable-container][rows-md="30"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-30,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-30 {
    grid-row: span 30/span 30;
  }
  :host([enable-container]) > ::slotted([order-md="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-30,
  .ids-layout-grid[enable-container] > ::slotted([order-md="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-30 {
    order: 30;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="31"], :host([enable-container]).ids-layout-grid-rows-md-31,
  .ids-layout-grid[enable-container][rows-md="31"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-31,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-31 {
    grid-row: span 31/span 31;
  }
  :host([enable-container]) > ::slotted([order-md="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-31,
  .ids-layout-grid[enable-container] > ::slotted([order-md="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-31 {
    order: 31;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="32"], :host([enable-container]).ids-layout-grid-rows-md-32,
  .ids-layout-grid[enable-container][rows-md="32"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-32,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-32 {
    grid-row: span 32/span 32;
  }
  :host([enable-container]) > ::slotted([order-md="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-32,
  .ids-layout-grid[enable-container] > ::slotted([order-md="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-32 {
    order: 32;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="33"], :host([enable-container]).ids-layout-grid-rows-md-33,
  .ids-layout-grid[enable-container][rows-md="33"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-33,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-33 {
    grid-row: span 33/span 33;
  }
  :host([enable-container]) > ::slotted([order-md="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-33,
  .ids-layout-grid[enable-container] > ::slotted([order-md="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-33 {
    order: 33;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="34"], :host([enable-container]).ids-layout-grid-rows-md-34,
  .ids-layout-grid[enable-container][rows-md="34"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-34,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-34 {
    grid-row: span 34/span 34;
  }
  :host([enable-container]) > ::slotted([order-md="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-34,
  .ids-layout-grid[enable-container] > ::slotted([order-md="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-34 {
    order: 34;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="35"], :host([enable-container]).ids-layout-grid-rows-md-35,
  .ids-layout-grid[enable-container][rows-md="35"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-35,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-35 {
    grid-row: span 35/span 35;
  }
  :host([enable-container]) > ::slotted([order-md="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-35,
  .ids-layout-grid[enable-container] > ::slotted([order-md="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-35 {
    order: 35;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="36"], :host([enable-container]).ids-layout-grid-rows-md-36,
  .ids-layout-grid[enable-container][rows-md="36"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-36,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-36 {
    grid-row: span 36/span 36;
  }
  :host([enable-container]) > ::slotted([order-md="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-36,
  .ids-layout-grid[enable-container] > ::slotted([order-md="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-36 {
    order: 36;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="37"], :host([enable-container]).ids-layout-grid-rows-md-37,
  .ids-layout-grid[enable-container][rows-md="37"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-37,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-37 {
    grid-row: span 37/span 37;
  }
  :host([enable-container]) > ::slotted([order-md="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-37,
  .ids-layout-grid[enable-container] > ::slotted([order-md="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-37 {
    order: 37;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="38"], :host([enable-container]).ids-layout-grid-rows-md-38,
  .ids-layout-grid[enable-container][rows-md="38"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-38,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-38 {
    grid-row: span 38/span 38;
  }
  :host([enable-container]) > ::slotted([order-md="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-38,
  .ids-layout-grid[enable-container] > ::slotted([order-md="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-38 {
    order: 38;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="39"], :host([enable-container]).ids-layout-grid-rows-md-39,
  .ids-layout-grid[enable-container][rows-md="39"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-39,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-39 {
    grid-row: span 39/span 39;
  }
  :host([enable-container]) > ::slotted([order-md="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-39,
  .ids-layout-grid[enable-container] > ::slotted([order-md="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-39 {
    order: 39;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="40"], :host([enable-container]).ids-layout-grid-rows-md-40,
  .ids-layout-grid[enable-container][rows-md="40"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-40,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-40 {
    grid-row: span 40/span 40;
  }
  :host([enable-container]) > ::slotted([order-md="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-40,
  .ids-layout-grid[enable-container] > ::slotted([order-md="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-40 {
    order: 40;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="41"], :host([enable-container]).ids-layout-grid-rows-md-41,
  .ids-layout-grid[enable-container][rows-md="41"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-41,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-41 {
    grid-row: span 41/span 41;
  }
  :host([enable-container]) > ::slotted([order-md="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-41,
  .ids-layout-grid[enable-container] > ::slotted([order-md="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-41 {
    order: 41;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="42"], :host([enable-container]).ids-layout-grid-rows-md-42,
  .ids-layout-grid[enable-container][rows-md="42"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-42,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-42 {
    grid-row: span 42/span 42;
  }
  :host([enable-container]) > ::slotted([order-md="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-42,
  .ids-layout-grid[enable-container] > ::slotted([order-md="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-42 {
    order: 42;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="43"], :host([enable-container]).ids-layout-grid-rows-md-43,
  .ids-layout-grid[enable-container][rows-md="43"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-43,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-43 {
    grid-row: span 43/span 43;
  }
  :host([enable-container]) > ::slotted([order-md="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-43,
  .ids-layout-grid[enable-container] > ::slotted([order-md="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-43 {
    order: 43;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="44"], :host([enable-container]).ids-layout-grid-rows-md-44,
  .ids-layout-grid[enable-container][rows-md="44"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-44,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-44 {
    grid-row: span 44/span 44;
  }
  :host([enable-container]) > ::slotted([order-md="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-44,
  .ids-layout-grid[enable-container] > ::slotted([order-md="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-44 {
    order: 44;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="45"], :host([enable-container]).ids-layout-grid-rows-md-45,
  .ids-layout-grid[enable-container][rows-md="45"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-45,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-45 {
    grid-row: span 45/span 45;
  }
  :host([enable-container]) > ::slotted([order-md="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-45,
  .ids-layout-grid[enable-container] > ::slotted([order-md="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-45 {
    order: 45;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="46"], :host([enable-container]).ids-layout-grid-rows-md-46,
  .ids-layout-grid[enable-container][rows-md="46"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-46,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-46 {
    grid-row: span 46/span 46;
  }
  :host([enable-container]) > ::slotted([order-md="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-46,
  .ids-layout-grid[enable-container] > ::slotted([order-md="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-46 {
    order: 46;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="47"], :host([enable-container]).ids-layout-grid-rows-md-47,
  .ids-layout-grid[enable-container][rows-md="47"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-47,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-47 {
    grid-row: span 47/span 47;
  }
  :host([enable-container]) > ::slotted([order-md="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-47,
  .ids-layout-grid[enable-container] > ::slotted([order-md="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-47 {
    order: 47;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="48"], :host([enable-container]).ids-layout-grid-rows-md-48,
  .ids-layout-grid[enable-container][rows-md="48"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-48,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-48 {
    grid-row: span 48/span 48;
  }
  :host([enable-container]) > ::slotted([order-md="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-48,
  .ids-layout-grid[enable-container] > ::slotted([order-md="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-48 {
    order: 48;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="49"], :host([enable-container]).ids-layout-grid-rows-md-49,
  .ids-layout-grid[enable-container][rows-md="49"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-49,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-49 {
    grid-row: span 49/span 49;
  }
  :host([enable-container]) > ::slotted([order-md="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-49,
  .ids-layout-grid[enable-container] > ::slotted([order-md="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-49 {
    order: 49;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="50"], :host([enable-container]).ids-layout-grid-rows-md-50,
  .ids-layout-grid[enable-container][rows-md="50"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-50,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-50 {
    grid-row: span 50/span 50;
  }
  :host([enable-container]) > ::slotted([order-md="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-50,
  .ids-layout-grid[enable-container] > ::slotted([order-md="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-50 {
    order: 50;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container]) > ::slotted([hide=md]),
  .ids-layout-grid[enable-container] > ::slotted([hide=md]) {
    display: block;
  }
}
@container (min-width: 1024px) {
  :host([enable-container]) > ::slotted([col-span-lg="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-1,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-1 {
    grid-column: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([col-start-lg="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-1,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-1 {
    grid-column-start: 1;
  }
  :host([enable-container]) > ::slotted([col-end-lg="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-1,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-1 {
    grid-column-end: 1;
  }
  :host([enable-container]) > ::slotted([col-span-lg="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-2,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-2 {
    grid-column: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([col-start-lg="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-2,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-2 {
    grid-column-start: 2;
  }
  :host([enable-container]) > ::slotted([col-end-lg="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-2,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-2 {
    grid-column-end: 2;
  }
  :host([enable-container]) > ::slotted([col-span-lg="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-3,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-3 {
    grid-column: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([col-start-lg="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-3,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-3 {
    grid-column-start: 3;
  }
  :host([enable-container]) > ::slotted([col-end-lg="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-3,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-3 {
    grid-column-end: 3;
  }
  :host([enable-container]) > ::slotted([col-span-lg="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-4,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-4 {
    grid-column: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([col-start-lg="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-4,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-4 {
    grid-column-start: 4;
  }
  :host([enable-container]) > ::slotted([col-end-lg="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-4,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-4 {
    grid-column-end: 4;
  }
  :host([enable-container]) > ::slotted([col-span-lg="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-5,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-5 {
    grid-column: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([col-start-lg="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-5,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-5 {
    grid-column-start: 5;
  }
  :host([enable-container]) > ::slotted([col-end-lg="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-5,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-5 {
    grid-column-end: 5;
  }
  :host([enable-container]) > ::slotted([col-span-lg="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-6,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-6 {
    grid-column: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([col-start-lg="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-6,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-6 {
    grid-column-start: 6;
  }
  :host([enable-container]) > ::slotted([col-end-lg="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-6,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-6 {
    grid-column-end: 6;
  }
  :host([enable-container]) > ::slotted([col-span-lg="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-7,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-7 {
    grid-column: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([col-start-lg="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-7,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-7 {
    grid-column-start: 7;
  }
  :host([enable-container]) > ::slotted([col-end-lg="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-7,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-7 {
    grid-column-end: 7;
  }
  :host([enable-container]) > ::slotted([col-span-lg="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-8,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-8 {
    grid-column: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([col-start-lg="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-8,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-8 {
    grid-column-start: 8;
  }
  :host([enable-container]) > ::slotted([col-end-lg="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-8,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-8 {
    grid-column-end: 8;
  }
  :host([enable-container]) > ::slotted([col-span-lg="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-9,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-9 {
    grid-column: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([col-start-lg="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-9,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-9 {
    grid-column-start: 9;
  }
  :host([enable-container]) > ::slotted([col-end-lg="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-9,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-9 {
    grid-column-end: 9;
  }
  :host([enable-container]) > ::slotted([col-span-lg="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-10,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-10 {
    grid-column: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([col-start-lg="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-10,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-10 {
    grid-column-start: 10;
  }
  :host([enable-container]) > ::slotted([col-end-lg="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-10,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-10 {
    grid-column-end: 10;
  }
  :host([enable-container]) > ::slotted([col-span-lg="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-11,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-11 {
    grid-column: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([col-start-lg="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-11,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-11 {
    grid-column-start: 11;
  }
  :host([enable-container]) > ::slotted([col-end-lg="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-11,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-11 {
    grid-column-end: 11;
  }
  :host([enable-container]) > ::slotted([col-span-lg="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-12,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-12 {
    grid-column: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([col-start-lg="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-12,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-12 {
    grid-column-start: 12;
  }
  :host([enable-container]) > ::slotted([col-end-lg="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-12,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-12 {
    grid-column-end: 12;
  }
  :host([enable-container]) > ::slotted([col-span-lg="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-13,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-13 {
    grid-column: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([col-start-lg="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-13,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-13 {
    grid-column-start: 13;
  }
  :host([enable-container]) > ::slotted([col-end-lg="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-13,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-13 {
    grid-column-end: 13;
  }
  :host([enable-container]) > ::slotted([col-span-lg="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-14,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-14 {
    grid-column: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([col-start-lg="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-14,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-14 {
    grid-column-start: 14;
  }
  :host([enable-container]) > ::slotted([col-end-lg="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-14,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-14 {
    grid-column-end: 14;
  }
  :host([enable-container]) > ::slotted([col-span-lg="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-15,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-15 {
    grid-column: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([col-start-lg="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-15,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-15 {
    grid-column-start: 15;
  }
  :host([enable-container]) > ::slotted([col-end-lg="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-15,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-15 {
    grid-column-end: 15;
  }
  :host([enable-container]) > ::slotted([col-span-lg="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-16,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-16 {
    grid-column: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([col-start-lg="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-16,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-16 {
    grid-column-start: 16;
  }
  :host([enable-container]) > ::slotted([col-end-lg="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-16,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-16 {
    grid-column-end: 16;
  }
  :host([enable-container]) > ::slotted([col-span-lg="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-17,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-17 {
    grid-column: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([col-start-lg="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-17,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-17 {
    grid-column-start: 17;
  }
  :host([enable-container]) > ::slotted([col-end-lg="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-17,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-17 {
    grid-column-end: 17;
  }
  :host([enable-container]) > ::slotted([col-span-lg="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-18,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-18 {
    grid-column: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([col-start-lg="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-18,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-18 {
    grid-column-start: 18;
  }
  :host([enable-container]) > ::slotted([col-end-lg="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-18,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-18 {
    grid-column-end: 18;
  }
  :host([enable-container]) > ::slotted([col-span-lg="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-19,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-19 {
    grid-column: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([col-start-lg="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-19,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-19 {
    grid-column-start: 19;
  }
  :host([enable-container]) > ::slotted([col-end-lg="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-19,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-19 {
    grid-column-end: 19;
  }
  :host([enable-container]) > ::slotted([col-span-lg="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-20,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-20 {
    grid-column: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([col-start-lg="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-20,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-20 {
    grid-column-start: 20;
  }
  :host([enable-container]) > ::slotted([col-end-lg="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-20,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-20 {
    grid-column-end: 20;
  }
  :host([enable-container]) > ::slotted([col-span-lg="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-21,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-21 {
    grid-column: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([col-start-lg="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-21,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-21 {
    grid-column-start: 21;
  }
  :host([enable-container]) > ::slotted([col-end-lg="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-21,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-21 {
    grid-column-end: 21;
  }
  :host([enable-container]) > ::slotted([col-span-lg="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-22,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-22 {
    grid-column: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([col-start-lg="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-22,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-22 {
    grid-column-start: 22;
  }
  :host([enable-container]) > ::slotted([col-end-lg="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-22,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-22 {
    grid-column-end: 22;
  }
  :host([enable-container]) > ::slotted([col-span-lg="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-23,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-23 {
    grid-column: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([col-start-lg="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-23,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-23 {
    grid-column-start: 23;
  }
  :host([enable-container]) > ::slotted([col-end-lg="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-23,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-23 {
    grid-column-end: 23;
  }
  :host([enable-container]) > ::slotted([col-span-lg="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-24,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-24 {
    grid-column: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([col-start-lg="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-24,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-24 {
    grid-column-start: 24;
  }
  :host([enable-container]) > ::slotted([col-end-lg="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-24,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-24 {
    grid-column-end: 24;
  }
  :host([enable-container])[rows-lg="1"], :host([enable-container]).ids-layout-grid-rows-lg-1,
  .ids-layout-grid[enable-container][rows-lg="1"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-1,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-1 {
    grid-row: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([order-lg="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-1 {
    order: 1;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="2"], :host([enable-container]).ids-layout-grid-rows-lg-2,
  .ids-layout-grid[enable-container][rows-lg="2"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-2,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-2 {
    grid-row: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([order-lg="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-2,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-2 {
    order: 2;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="3"], :host([enable-container]).ids-layout-grid-rows-lg-3,
  .ids-layout-grid[enable-container][rows-lg="3"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-3,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-3 {
    grid-row: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([order-lg="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-3,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-3 {
    order: 3;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="4"], :host([enable-container]).ids-layout-grid-rows-lg-4,
  .ids-layout-grid[enable-container][rows-lg="4"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-4,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-4 {
    grid-row: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([order-lg="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-4,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-4 {
    order: 4;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="5"], :host([enable-container]).ids-layout-grid-rows-lg-5,
  .ids-layout-grid[enable-container][rows-lg="5"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-5,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-5 {
    grid-row: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([order-lg="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-5,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-5 {
    order: 5;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="6"], :host([enable-container]).ids-layout-grid-rows-lg-6,
  .ids-layout-grid[enable-container][rows-lg="6"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-6,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-6 {
    grid-row: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([order-lg="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-6,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-6 {
    order: 6;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="7"], :host([enable-container]).ids-layout-grid-rows-lg-7,
  .ids-layout-grid[enable-container][rows-lg="7"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-7,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-7 {
    grid-row: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([order-lg="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-7,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-7 {
    order: 7;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="8"], :host([enable-container]).ids-layout-grid-rows-lg-8,
  .ids-layout-grid[enable-container][rows-lg="8"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-8,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-8 {
    grid-row: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([order-lg="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-8,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-8 {
    order: 8;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="9"], :host([enable-container]).ids-layout-grid-rows-lg-9,
  .ids-layout-grid[enable-container][rows-lg="9"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-9,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-9 {
    grid-row: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([order-lg="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-9,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-9 {
    order: 9;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="10"], :host([enable-container]).ids-layout-grid-rows-lg-10,
  .ids-layout-grid[enable-container][rows-lg="10"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-10,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-10 {
    grid-row: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([order-lg="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-10,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-10 {
    order: 10;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="11"], :host([enable-container]).ids-layout-grid-rows-lg-11,
  .ids-layout-grid[enable-container][rows-lg="11"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-11,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-11 {
    grid-row: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([order-lg="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-11,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-11 {
    order: 11;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="12"], :host([enable-container]).ids-layout-grid-rows-lg-12,
  .ids-layout-grid[enable-container][rows-lg="12"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-12,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-12 {
    grid-row: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([order-lg="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-12,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-12 {
    order: 12;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="13"], :host([enable-container]).ids-layout-grid-rows-lg-13,
  .ids-layout-grid[enable-container][rows-lg="13"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-13,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-13 {
    grid-row: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([order-lg="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-13,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-13 {
    order: 13;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="14"], :host([enable-container]).ids-layout-grid-rows-lg-14,
  .ids-layout-grid[enable-container][rows-lg="14"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-14,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-14 {
    grid-row: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([order-lg="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-14,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-14 {
    order: 14;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="15"], :host([enable-container]).ids-layout-grid-rows-lg-15,
  .ids-layout-grid[enable-container][rows-lg="15"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-15,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-15 {
    grid-row: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([order-lg="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-15,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-15 {
    order: 15;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="16"], :host([enable-container]).ids-layout-grid-rows-lg-16,
  .ids-layout-grid[enable-container][rows-lg="16"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-16,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-16 {
    grid-row: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([order-lg="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-16,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-16 {
    order: 16;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="17"], :host([enable-container]).ids-layout-grid-rows-lg-17,
  .ids-layout-grid[enable-container][rows-lg="17"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-17,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-17 {
    grid-row: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([order-lg="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-17,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-17 {
    order: 17;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="18"], :host([enable-container]).ids-layout-grid-rows-lg-18,
  .ids-layout-grid[enable-container][rows-lg="18"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-18,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-18 {
    grid-row: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([order-lg="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-18,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-18 {
    order: 18;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="19"], :host([enable-container]).ids-layout-grid-rows-lg-19,
  .ids-layout-grid[enable-container][rows-lg="19"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-19,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-19 {
    grid-row: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([order-lg="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-19,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-19 {
    order: 19;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="20"], :host([enable-container]).ids-layout-grid-rows-lg-20,
  .ids-layout-grid[enable-container][rows-lg="20"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-20,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-20 {
    grid-row: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([order-lg="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-20,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-20 {
    order: 20;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="21"], :host([enable-container]).ids-layout-grid-rows-lg-21,
  .ids-layout-grid[enable-container][rows-lg="21"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-21,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-21 {
    grid-row: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([order-lg="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-21,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-21 {
    order: 21;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="22"], :host([enable-container]).ids-layout-grid-rows-lg-22,
  .ids-layout-grid[enable-container][rows-lg="22"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-22,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-22 {
    grid-row: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([order-lg="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-22,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-22 {
    order: 22;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="23"], :host([enable-container]).ids-layout-grid-rows-lg-23,
  .ids-layout-grid[enable-container][rows-lg="23"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-23,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-23 {
    grid-row: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([order-lg="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-23,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-23 {
    order: 23;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="24"], :host([enable-container]).ids-layout-grid-rows-lg-24,
  .ids-layout-grid[enable-container][rows-lg="24"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-24,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-24 {
    grid-row: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([order-lg="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-24,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-24 {
    order: 24;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="25"], :host([enable-container]).ids-layout-grid-rows-lg-25,
  .ids-layout-grid[enable-container][rows-lg="25"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-25,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-25 {
    grid-row: span 25/span 25;
  }
  :host([enable-container]) > ::slotted([order-lg="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-25,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-25 {
    order: 25;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="26"], :host([enable-container]).ids-layout-grid-rows-lg-26,
  .ids-layout-grid[enable-container][rows-lg="26"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-26,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-26 {
    grid-row: span 26/span 26;
  }
  :host([enable-container]) > ::slotted([order-lg="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-26,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-26 {
    order: 26;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="27"], :host([enable-container]).ids-layout-grid-rows-lg-27,
  .ids-layout-grid[enable-container][rows-lg="27"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-27,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-27 {
    grid-row: span 27/span 27;
  }
  :host([enable-container]) > ::slotted([order-lg="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-27,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-27 {
    order: 27;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="28"], :host([enable-container]).ids-layout-grid-rows-lg-28,
  .ids-layout-grid[enable-container][rows-lg="28"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-28,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-28 {
    grid-row: span 28/span 28;
  }
  :host([enable-container]) > ::slotted([order-lg="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-28,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-28 {
    order: 28;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="29"], :host([enable-container]).ids-layout-grid-rows-lg-29,
  .ids-layout-grid[enable-container][rows-lg="29"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-29,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-29 {
    grid-row: span 29/span 29;
  }
  :host([enable-container]) > ::slotted([order-lg="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-29,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-29 {
    order: 29;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="30"], :host([enable-container]).ids-layout-grid-rows-lg-30,
  .ids-layout-grid[enable-container][rows-lg="30"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-30,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-30 {
    grid-row: span 30/span 30;
  }
  :host([enable-container]) > ::slotted([order-lg="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-30,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-30 {
    order: 30;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="31"], :host([enable-container]).ids-layout-grid-rows-lg-31,
  .ids-layout-grid[enable-container][rows-lg="31"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-31,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-31 {
    grid-row: span 31/span 31;
  }
  :host([enable-container]) > ::slotted([order-lg="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-31,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-31 {
    order: 31;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="32"], :host([enable-container]).ids-layout-grid-rows-lg-32,
  .ids-layout-grid[enable-container][rows-lg="32"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-32,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-32 {
    grid-row: span 32/span 32;
  }
  :host([enable-container]) > ::slotted([order-lg="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-32,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-32 {
    order: 32;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="33"], :host([enable-container]).ids-layout-grid-rows-lg-33,
  .ids-layout-grid[enable-container][rows-lg="33"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-33,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-33 {
    grid-row: span 33/span 33;
  }
  :host([enable-container]) > ::slotted([order-lg="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-33,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-33 {
    order: 33;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="34"], :host([enable-container]).ids-layout-grid-rows-lg-34,
  .ids-layout-grid[enable-container][rows-lg="34"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-34,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-34 {
    grid-row: span 34/span 34;
  }
  :host([enable-container]) > ::slotted([order-lg="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-34,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-34 {
    order: 34;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="35"], :host([enable-container]).ids-layout-grid-rows-lg-35,
  .ids-layout-grid[enable-container][rows-lg="35"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-35,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-35 {
    grid-row: span 35/span 35;
  }
  :host([enable-container]) > ::slotted([order-lg="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-35,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-35 {
    order: 35;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="36"], :host([enable-container]).ids-layout-grid-rows-lg-36,
  .ids-layout-grid[enable-container][rows-lg="36"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-36,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-36 {
    grid-row: span 36/span 36;
  }
  :host([enable-container]) > ::slotted([order-lg="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-36,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-36 {
    order: 36;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="37"], :host([enable-container]).ids-layout-grid-rows-lg-37,
  .ids-layout-grid[enable-container][rows-lg="37"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-37,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-37 {
    grid-row: span 37/span 37;
  }
  :host([enable-container]) > ::slotted([order-lg="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-37,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-37 {
    order: 37;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="38"], :host([enable-container]).ids-layout-grid-rows-lg-38,
  .ids-layout-grid[enable-container][rows-lg="38"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-38,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-38 {
    grid-row: span 38/span 38;
  }
  :host([enable-container]) > ::slotted([order-lg="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-38,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-38 {
    order: 38;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="39"], :host([enable-container]).ids-layout-grid-rows-lg-39,
  .ids-layout-grid[enable-container][rows-lg="39"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-39,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-39 {
    grid-row: span 39/span 39;
  }
  :host([enable-container]) > ::slotted([order-lg="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-39,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-39 {
    order: 39;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="40"], :host([enable-container]).ids-layout-grid-rows-lg-40,
  .ids-layout-grid[enable-container][rows-lg="40"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-40,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-40 {
    grid-row: span 40/span 40;
  }
  :host([enable-container]) > ::slotted([order-lg="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-40,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-40 {
    order: 40;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="41"], :host([enable-container]).ids-layout-grid-rows-lg-41,
  .ids-layout-grid[enable-container][rows-lg="41"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-41,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-41 {
    grid-row: span 41/span 41;
  }
  :host([enable-container]) > ::slotted([order-lg="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-41,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-41 {
    order: 41;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="42"], :host([enable-container]).ids-layout-grid-rows-lg-42,
  .ids-layout-grid[enable-container][rows-lg="42"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-42,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-42 {
    grid-row: span 42/span 42;
  }
  :host([enable-container]) > ::slotted([order-lg="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-42,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-42 {
    order: 42;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="43"], :host([enable-container]).ids-layout-grid-rows-lg-43,
  .ids-layout-grid[enable-container][rows-lg="43"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-43,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-43 {
    grid-row: span 43/span 43;
  }
  :host([enable-container]) > ::slotted([order-lg="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-43,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-43 {
    order: 43;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="44"], :host([enable-container]).ids-layout-grid-rows-lg-44,
  .ids-layout-grid[enable-container][rows-lg="44"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-44,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-44 {
    grid-row: span 44/span 44;
  }
  :host([enable-container]) > ::slotted([order-lg="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-44,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-44 {
    order: 44;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="45"], :host([enable-container]).ids-layout-grid-rows-lg-45,
  .ids-layout-grid[enable-container][rows-lg="45"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-45,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-45 {
    grid-row: span 45/span 45;
  }
  :host([enable-container]) > ::slotted([order-lg="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-45,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-45 {
    order: 45;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="46"], :host([enable-container]).ids-layout-grid-rows-lg-46,
  .ids-layout-grid[enable-container][rows-lg="46"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-46,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-46 {
    grid-row: span 46/span 46;
  }
  :host([enable-container]) > ::slotted([order-lg="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-46,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-46 {
    order: 46;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="47"], :host([enable-container]).ids-layout-grid-rows-lg-47,
  .ids-layout-grid[enable-container][rows-lg="47"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-47,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-47 {
    grid-row: span 47/span 47;
  }
  :host([enable-container]) > ::slotted([order-lg="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-47,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-47 {
    order: 47;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="48"], :host([enable-container]).ids-layout-grid-rows-lg-48,
  .ids-layout-grid[enable-container][rows-lg="48"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-48,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-48 {
    grid-row: span 48/span 48;
  }
  :host([enable-container]) > ::slotted([order-lg="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-48,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-48 {
    order: 48;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="49"], :host([enable-container]).ids-layout-grid-rows-lg-49,
  .ids-layout-grid[enable-container][rows-lg="49"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-49,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-49 {
    grid-row: span 49/span 49;
  }
  :host([enable-container]) > ::slotted([order-lg="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-49,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-49 {
    order: 49;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="50"], :host([enable-container]).ids-layout-grid-rows-lg-50,
  .ids-layout-grid[enable-container][rows-lg="50"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-50,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-50 {
    grid-row: span 50/span 50;
  }
  :host([enable-container]) > ::slotted([order-lg="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-50,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-50 {
    order: 50;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container]) > ::slotted([hide=lg]),
  .ids-layout-grid[enable-container] > ::slotted([hide=lg]) {
    display: block;
  }
}
@container (min-width: 1280px) {
  :host([enable-container]) > ::slotted([col-span-xl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-1,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-1 {
    grid-column: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([col-start-xl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-1,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-1 {
    grid-column-start: 1;
  }
  :host([enable-container]) > ::slotted([col-end-xl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-1,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-1 {
    grid-column-end: 1;
  }
  :host([enable-container]) > ::slotted([col-span-xl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-2,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-2 {
    grid-column: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([col-start-xl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-2,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-2 {
    grid-column-start: 2;
  }
  :host([enable-container]) > ::slotted([col-end-xl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-2,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-2 {
    grid-column-end: 2;
  }
  :host([enable-container]) > ::slotted([col-span-xl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-3,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-3 {
    grid-column: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([col-start-xl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-3,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-3 {
    grid-column-start: 3;
  }
  :host([enable-container]) > ::slotted([col-end-xl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-3,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-3 {
    grid-column-end: 3;
  }
  :host([enable-container]) > ::slotted([col-span-xl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-4,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-4 {
    grid-column: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([col-start-xl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-4,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-4 {
    grid-column-start: 4;
  }
  :host([enable-container]) > ::slotted([col-end-xl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-4,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-4 {
    grid-column-end: 4;
  }
  :host([enable-container]) > ::slotted([col-span-xl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-5,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-5 {
    grid-column: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([col-start-xl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-5,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-5 {
    grid-column-start: 5;
  }
  :host([enable-container]) > ::slotted([col-end-xl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-5,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-5 {
    grid-column-end: 5;
  }
  :host([enable-container]) > ::slotted([col-span-xl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-6,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-6 {
    grid-column: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([col-start-xl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-6,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-6 {
    grid-column-start: 6;
  }
  :host([enable-container]) > ::slotted([col-end-xl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-6,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-6 {
    grid-column-end: 6;
  }
  :host([enable-container]) > ::slotted([col-span-xl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-7,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-7 {
    grid-column: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([col-start-xl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-7,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-7 {
    grid-column-start: 7;
  }
  :host([enable-container]) > ::slotted([col-end-xl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-7,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-7 {
    grid-column-end: 7;
  }
  :host([enable-container]) > ::slotted([col-span-xl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-8,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-8 {
    grid-column: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([col-start-xl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-8,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-8 {
    grid-column-start: 8;
  }
  :host([enable-container]) > ::slotted([col-end-xl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-8,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-8 {
    grid-column-end: 8;
  }
  :host([enable-container]) > ::slotted([col-span-xl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-9,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-9 {
    grid-column: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([col-start-xl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-9,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-9 {
    grid-column-start: 9;
  }
  :host([enable-container]) > ::slotted([col-end-xl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-9,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-9 {
    grid-column-end: 9;
  }
  :host([enable-container]) > ::slotted([col-span-xl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-10,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-10 {
    grid-column: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([col-start-xl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-10,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-10 {
    grid-column-start: 10;
  }
  :host([enable-container]) > ::slotted([col-end-xl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-10,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-10 {
    grid-column-end: 10;
  }
  :host([enable-container]) > ::slotted([col-span-xl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-11,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-11 {
    grid-column: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([col-start-xl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-11,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-11 {
    grid-column-start: 11;
  }
  :host([enable-container]) > ::slotted([col-end-xl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-11,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-11 {
    grid-column-end: 11;
  }
  :host([enable-container]) > ::slotted([col-span-xl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-12,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-12 {
    grid-column: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([col-start-xl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-12,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-12 {
    grid-column-start: 12;
  }
  :host([enable-container]) > ::slotted([col-end-xl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-12,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-12 {
    grid-column-end: 12;
  }
  :host([enable-container]) > ::slotted([col-span-xl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-13,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-13 {
    grid-column: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([col-start-xl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-13,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-13 {
    grid-column-start: 13;
  }
  :host([enable-container]) > ::slotted([col-end-xl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-13,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-13 {
    grid-column-end: 13;
  }
  :host([enable-container]) > ::slotted([col-span-xl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-14,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-14 {
    grid-column: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([col-start-xl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-14,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-14 {
    grid-column-start: 14;
  }
  :host([enable-container]) > ::slotted([col-end-xl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-14,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-14 {
    grid-column-end: 14;
  }
  :host([enable-container]) > ::slotted([col-span-xl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-15,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-15 {
    grid-column: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([col-start-xl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-15,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-15 {
    grid-column-start: 15;
  }
  :host([enable-container]) > ::slotted([col-end-xl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-15,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-15 {
    grid-column-end: 15;
  }
  :host([enable-container]) > ::slotted([col-span-xl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-16,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-16 {
    grid-column: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([col-start-xl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-16,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-16 {
    grid-column-start: 16;
  }
  :host([enable-container]) > ::slotted([col-end-xl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-16,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-16 {
    grid-column-end: 16;
  }
  :host([enable-container]) > ::slotted([col-span-xl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-17,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-17 {
    grid-column: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([col-start-xl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-17,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-17 {
    grid-column-start: 17;
  }
  :host([enable-container]) > ::slotted([col-end-xl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-17,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-17 {
    grid-column-end: 17;
  }
  :host([enable-container]) > ::slotted([col-span-xl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-18,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-18 {
    grid-column: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([col-start-xl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-18,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-18 {
    grid-column-start: 18;
  }
  :host([enable-container]) > ::slotted([col-end-xl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-18,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-18 {
    grid-column-end: 18;
  }
  :host([enable-container]) > ::slotted([col-span-xl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-19,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-19 {
    grid-column: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([col-start-xl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-19,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-19 {
    grid-column-start: 19;
  }
  :host([enable-container]) > ::slotted([col-end-xl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-19,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-19 {
    grid-column-end: 19;
  }
  :host([enable-container]) > ::slotted([col-span-xl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-20,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-20 {
    grid-column: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([col-start-xl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-20,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-20 {
    grid-column-start: 20;
  }
  :host([enable-container]) > ::slotted([col-end-xl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-20,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-20 {
    grid-column-end: 20;
  }
  :host([enable-container]) > ::slotted([col-span-xl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-21,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-21 {
    grid-column: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([col-start-xl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-21,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-21 {
    grid-column-start: 21;
  }
  :host([enable-container]) > ::slotted([col-end-xl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-21,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-21 {
    grid-column-end: 21;
  }
  :host([enable-container]) > ::slotted([col-span-xl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-22,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-22 {
    grid-column: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([col-start-xl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-22,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-22 {
    grid-column-start: 22;
  }
  :host([enable-container]) > ::slotted([col-end-xl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-22,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-22 {
    grid-column-end: 22;
  }
  :host([enable-container]) > ::slotted([col-span-xl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-23,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-23 {
    grid-column: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([col-start-xl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-23,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-23 {
    grid-column-start: 23;
  }
  :host([enable-container]) > ::slotted([col-end-xl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-23,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-23 {
    grid-column-end: 23;
  }
  :host([enable-container]) > ::slotted([col-span-xl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-24,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-24 {
    grid-column: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([col-start-xl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-24,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-24 {
    grid-column-start: 24;
  }
  :host([enable-container]) > ::slotted([col-end-xl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-24,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-24 {
    grid-column-end: 24;
  }
  :host([enable-container])[rows-xl="1"], :host([enable-container]).ids-layout-grid-rows-xl-1,
  .ids-layout-grid[enable-container][rows-xl="1"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-1,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-1 {
    grid-row: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([order-xl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-1 {
    order: 1;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="2"], :host([enable-container]).ids-layout-grid-rows-xl-2,
  .ids-layout-grid[enable-container][rows-xl="2"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-2,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-2 {
    grid-row: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([order-xl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-2,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-2 {
    order: 2;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="3"], :host([enable-container]).ids-layout-grid-rows-xl-3,
  .ids-layout-grid[enable-container][rows-xl="3"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-3,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-3 {
    grid-row: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([order-xl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-3,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-3 {
    order: 3;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="4"], :host([enable-container]).ids-layout-grid-rows-xl-4,
  .ids-layout-grid[enable-container][rows-xl="4"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-4,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-4 {
    grid-row: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([order-xl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-4,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-4 {
    order: 4;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="5"], :host([enable-container]).ids-layout-grid-rows-xl-5,
  .ids-layout-grid[enable-container][rows-xl="5"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-5,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-5 {
    grid-row: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([order-xl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-5,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-5 {
    order: 5;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="6"], :host([enable-container]).ids-layout-grid-rows-xl-6,
  .ids-layout-grid[enable-container][rows-xl="6"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-6,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-6 {
    grid-row: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([order-xl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-6,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-6 {
    order: 6;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="7"], :host([enable-container]).ids-layout-grid-rows-xl-7,
  .ids-layout-grid[enable-container][rows-xl="7"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-7,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-7 {
    grid-row: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([order-xl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-7,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-7 {
    order: 7;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="8"], :host([enable-container]).ids-layout-grid-rows-xl-8,
  .ids-layout-grid[enable-container][rows-xl="8"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-8,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-8 {
    grid-row: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([order-xl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-8,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-8 {
    order: 8;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="9"], :host([enable-container]).ids-layout-grid-rows-xl-9,
  .ids-layout-grid[enable-container][rows-xl="9"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-9,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-9 {
    grid-row: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([order-xl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-9,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-9 {
    order: 9;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="10"], :host([enable-container]).ids-layout-grid-rows-xl-10,
  .ids-layout-grid[enable-container][rows-xl="10"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-10,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-10 {
    grid-row: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([order-xl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-10,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-10 {
    order: 10;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="11"], :host([enable-container]).ids-layout-grid-rows-xl-11,
  .ids-layout-grid[enable-container][rows-xl="11"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-11,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-11 {
    grid-row: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([order-xl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-11,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-11 {
    order: 11;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="12"], :host([enable-container]).ids-layout-grid-rows-xl-12,
  .ids-layout-grid[enable-container][rows-xl="12"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-12,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-12 {
    grid-row: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([order-xl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-12,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-12 {
    order: 12;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="13"], :host([enable-container]).ids-layout-grid-rows-xl-13,
  .ids-layout-grid[enable-container][rows-xl="13"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-13,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-13 {
    grid-row: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([order-xl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-13,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-13 {
    order: 13;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="14"], :host([enable-container]).ids-layout-grid-rows-xl-14,
  .ids-layout-grid[enable-container][rows-xl="14"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-14,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-14 {
    grid-row: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([order-xl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-14,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-14 {
    order: 14;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="15"], :host([enable-container]).ids-layout-grid-rows-xl-15,
  .ids-layout-grid[enable-container][rows-xl="15"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-15,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-15 {
    grid-row: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([order-xl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-15,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-15 {
    order: 15;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="16"], :host([enable-container]).ids-layout-grid-rows-xl-16,
  .ids-layout-grid[enable-container][rows-xl="16"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-16,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-16 {
    grid-row: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([order-xl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-16,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-16 {
    order: 16;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="17"], :host([enable-container]).ids-layout-grid-rows-xl-17,
  .ids-layout-grid[enable-container][rows-xl="17"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-17,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-17 {
    grid-row: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([order-xl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-17,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-17 {
    order: 17;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="18"], :host([enable-container]).ids-layout-grid-rows-xl-18,
  .ids-layout-grid[enable-container][rows-xl="18"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-18,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-18 {
    grid-row: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([order-xl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-18,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-18 {
    order: 18;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="19"], :host([enable-container]).ids-layout-grid-rows-xl-19,
  .ids-layout-grid[enable-container][rows-xl="19"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-19,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-19 {
    grid-row: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([order-xl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-19,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-19 {
    order: 19;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="20"], :host([enable-container]).ids-layout-grid-rows-xl-20,
  .ids-layout-grid[enable-container][rows-xl="20"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-20,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-20 {
    grid-row: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([order-xl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-20,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-20 {
    order: 20;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="21"], :host([enable-container]).ids-layout-grid-rows-xl-21,
  .ids-layout-grid[enable-container][rows-xl="21"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-21,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-21 {
    grid-row: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([order-xl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-21,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-21 {
    order: 21;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="22"], :host([enable-container]).ids-layout-grid-rows-xl-22,
  .ids-layout-grid[enable-container][rows-xl="22"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-22,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-22 {
    grid-row: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([order-xl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-22,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-22 {
    order: 22;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="23"], :host([enable-container]).ids-layout-grid-rows-xl-23,
  .ids-layout-grid[enable-container][rows-xl="23"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-23,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-23 {
    grid-row: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([order-xl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-23,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-23 {
    order: 23;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="24"], :host([enable-container]).ids-layout-grid-rows-xl-24,
  .ids-layout-grid[enable-container][rows-xl="24"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-24,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-24 {
    grid-row: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([order-xl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-24,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-24 {
    order: 24;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="25"], :host([enable-container]).ids-layout-grid-rows-xl-25,
  .ids-layout-grid[enable-container][rows-xl="25"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-25,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-25 {
    grid-row: span 25/span 25;
  }
  :host([enable-container]) > ::slotted([order-xl="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-25,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-25 {
    order: 25;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="26"], :host([enable-container]).ids-layout-grid-rows-xl-26,
  .ids-layout-grid[enable-container][rows-xl="26"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-26,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-26 {
    grid-row: span 26/span 26;
  }
  :host([enable-container]) > ::slotted([order-xl="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-26,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-26 {
    order: 26;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="27"], :host([enable-container]).ids-layout-grid-rows-xl-27,
  .ids-layout-grid[enable-container][rows-xl="27"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-27,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-27 {
    grid-row: span 27/span 27;
  }
  :host([enable-container]) > ::slotted([order-xl="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-27,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-27 {
    order: 27;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="28"], :host([enable-container]).ids-layout-grid-rows-xl-28,
  .ids-layout-grid[enable-container][rows-xl="28"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-28,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-28 {
    grid-row: span 28/span 28;
  }
  :host([enable-container]) > ::slotted([order-xl="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-28,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-28 {
    order: 28;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="29"], :host([enable-container]).ids-layout-grid-rows-xl-29,
  .ids-layout-grid[enable-container][rows-xl="29"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-29,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-29 {
    grid-row: span 29/span 29;
  }
  :host([enable-container]) > ::slotted([order-xl="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-29,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-29 {
    order: 29;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="30"], :host([enable-container]).ids-layout-grid-rows-xl-30,
  .ids-layout-grid[enable-container][rows-xl="30"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-30,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-30 {
    grid-row: span 30/span 30;
  }
  :host([enable-container]) > ::slotted([order-xl="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-30,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-30 {
    order: 30;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="31"], :host([enable-container]).ids-layout-grid-rows-xl-31,
  .ids-layout-grid[enable-container][rows-xl="31"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-31,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-31 {
    grid-row: span 31/span 31;
  }
  :host([enable-container]) > ::slotted([order-xl="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-31,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-31 {
    order: 31;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="32"], :host([enable-container]).ids-layout-grid-rows-xl-32,
  .ids-layout-grid[enable-container][rows-xl="32"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-32,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-32 {
    grid-row: span 32/span 32;
  }
  :host([enable-container]) > ::slotted([order-xl="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-32,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-32 {
    order: 32;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="33"], :host([enable-container]).ids-layout-grid-rows-xl-33,
  .ids-layout-grid[enable-container][rows-xl="33"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-33,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-33 {
    grid-row: span 33/span 33;
  }
  :host([enable-container]) > ::slotted([order-xl="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-33,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-33 {
    order: 33;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="34"], :host([enable-container]).ids-layout-grid-rows-xl-34,
  .ids-layout-grid[enable-container][rows-xl="34"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-34,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-34 {
    grid-row: span 34/span 34;
  }
  :host([enable-container]) > ::slotted([order-xl="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-34,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-34 {
    order: 34;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="35"], :host([enable-container]).ids-layout-grid-rows-xl-35,
  .ids-layout-grid[enable-container][rows-xl="35"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-35,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-35 {
    grid-row: span 35/span 35;
  }
  :host([enable-container]) > ::slotted([order-xl="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-35,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-35 {
    order: 35;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="36"], :host([enable-container]).ids-layout-grid-rows-xl-36,
  .ids-layout-grid[enable-container][rows-xl="36"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-36,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-36 {
    grid-row: span 36/span 36;
  }
  :host([enable-container]) > ::slotted([order-xl="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-36,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-36 {
    order: 36;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="37"], :host([enable-container]).ids-layout-grid-rows-xl-37,
  .ids-layout-grid[enable-container][rows-xl="37"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-37,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-37 {
    grid-row: span 37/span 37;
  }
  :host([enable-container]) > ::slotted([order-xl="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-37,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-37 {
    order: 37;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="38"], :host([enable-container]).ids-layout-grid-rows-xl-38,
  .ids-layout-grid[enable-container][rows-xl="38"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-38,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-38 {
    grid-row: span 38/span 38;
  }
  :host([enable-container]) > ::slotted([order-xl="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-38,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-38 {
    order: 38;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="39"], :host([enable-container]).ids-layout-grid-rows-xl-39,
  .ids-layout-grid[enable-container][rows-xl="39"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-39,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-39 {
    grid-row: span 39/span 39;
  }
  :host([enable-container]) > ::slotted([order-xl="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-39,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-39 {
    order: 39;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="40"], :host([enable-container]).ids-layout-grid-rows-xl-40,
  .ids-layout-grid[enable-container][rows-xl="40"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-40,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-40 {
    grid-row: span 40/span 40;
  }
  :host([enable-container]) > ::slotted([order-xl="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-40,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-40 {
    order: 40;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="41"], :host([enable-container]).ids-layout-grid-rows-xl-41,
  .ids-layout-grid[enable-container][rows-xl="41"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-41,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-41 {
    grid-row: span 41/span 41;
  }
  :host([enable-container]) > ::slotted([order-xl="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-41,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-41 {
    order: 41;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="42"], :host([enable-container]).ids-layout-grid-rows-xl-42,
  .ids-layout-grid[enable-container][rows-xl="42"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-42,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-42 {
    grid-row: span 42/span 42;
  }
  :host([enable-container]) > ::slotted([order-xl="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-42,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-42 {
    order: 42;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="43"], :host([enable-container]).ids-layout-grid-rows-xl-43,
  .ids-layout-grid[enable-container][rows-xl="43"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-43,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-43 {
    grid-row: span 43/span 43;
  }
  :host([enable-container]) > ::slotted([order-xl="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-43,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-43 {
    order: 43;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="44"], :host([enable-container]).ids-layout-grid-rows-xl-44,
  .ids-layout-grid[enable-container][rows-xl="44"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-44,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-44 {
    grid-row: span 44/span 44;
  }
  :host([enable-container]) > ::slotted([order-xl="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-44,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-44 {
    order: 44;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="45"], :host([enable-container]).ids-layout-grid-rows-xl-45,
  .ids-layout-grid[enable-container][rows-xl="45"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-45,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-45 {
    grid-row: span 45/span 45;
  }
  :host([enable-container]) > ::slotted([order-xl="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-45,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-45 {
    order: 45;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="46"], :host([enable-container]).ids-layout-grid-rows-xl-46,
  .ids-layout-grid[enable-container][rows-xl="46"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-46,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-46 {
    grid-row: span 46/span 46;
  }
  :host([enable-container]) > ::slotted([order-xl="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-46,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-46 {
    order: 46;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="47"], :host([enable-container]).ids-layout-grid-rows-xl-47,
  .ids-layout-grid[enable-container][rows-xl="47"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-47,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-47 {
    grid-row: span 47/span 47;
  }
  :host([enable-container]) > ::slotted([order-xl="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-47,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-47 {
    order: 47;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="48"], :host([enable-container]).ids-layout-grid-rows-xl-48,
  .ids-layout-grid[enable-container][rows-xl="48"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-48,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-48 {
    grid-row: span 48/span 48;
  }
  :host([enable-container]) > ::slotted([order-xl="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-48,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-48 {
    order: 48;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="49"], :host([enable-container]).ids-layout-grid-rows-xl-49,
  .ids-layout-grid[enable-container][rows-xl="49"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-49,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-49 {
    grid-row: span 49/span 49;
  }
  :host([enable-container]) > ::slotted([order-xl="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-49,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-49 {
    order: 49;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="50"], :host([enable-container]).ids-layout-grid-rows-xl-50,
  .ids-layout-grid[enable-container][rows-xl="50"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-50,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-50 {
    grid-row: span 50/span 50;
  }
  :host([enable-container]) > ::slotted([order-xl="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-50,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-50 {
    order: 50;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container]) > ::slotted([hide=xl]),
  .ids-layout-grid[enable-container] > ::slotted([hide=xl]) {
    display: block;
  }
}
@container (min-width: 1440px) {
  :host([enable-container]) > ::slotted([col-span-xxl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-1,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-1 {
    grid-column: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-1,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-1 {
    grid-column-start: 1;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-1,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-1 {
    grid-column-end: 1;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-2,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-2 {
    grid-column: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-2,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-2 {
    grid-column-start: 2;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-2,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-2 {
    grid-column-end: 2;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-3,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-3 {
    grid-column: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-3,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-3 {
    grid-column-start: 3;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-3,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-3 {
    grid-column-end: 3;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-4,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-4 {
    grid-column: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-4,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-4 {
    grid-column-start: 4;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-4,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-4 {
    grid-column-end: 4;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-5,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-5 {
    grid-column: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-5,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-5 {
    grid-column-start: 5;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-5,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-5 {
    grid-column-end: 5;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-6,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-6 {
    grid-column: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-6,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-6 {
    grid-column-start: 6;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-6,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-6 {
    grid-column-end: 6;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-7,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-7 {
    grid-column: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-7,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-7 {
    grid-column-start: 7;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-7,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-7 {
    grid-column-end: 7;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-8,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-8 {
    grid-column: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-8,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-8 {
    grid-column-start: 8;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-8,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-8 {
    grid-column-end: 8;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-9,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-9 {
    grid-column: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-9,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-9 {
    grid-column-start: 9;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-9,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-9 {
    grid-column-end: 9;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-10,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-10 {
    grid-column: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-10,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-10 {
    grid-column-start: 10;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-10,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-10 {
    grid-column-end: 10;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-11,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-11 {
    grid-column: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-11,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-11 {
    grid-column-start: 11;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-11,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-11 {
    grid-column-end: 11;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-12,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-12 {
    grid-column: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-12,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-12 {
    grid-column-start: 12;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-12,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-12 {
    grid-column-end: 12;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-13,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-13 {
    grid-column: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-13,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-13 {
    grid-column-start: 13;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-13,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-13 {
    grid-column-end: 13;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-14,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-14 {
    grid-column: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-14,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-14 {
    grid-column-start: 14;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-14,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-14 {
    grid-column-end: 14;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-15,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-15 {
    grid-column: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-15,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-15 {
    grid-column-start: 15;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-15,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-15 {
    grid-column-end: 15;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-16,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-16 {
    grid-column: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-16,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-16 {
    grid-column-start: 16;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-16,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-16 {
    grid-column-end: 16;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-17,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-17 {
    grid-column: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-17,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-17 {
    grid-column-start: 17;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-17,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-17 {
    grid-column-end: 17;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-18,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-18 {
    grid-column: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-18,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-18 {
    grid-column-start: 18;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-18,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-18 {
    grid-column-end: 18;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-19,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-19 {
    grid-column: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-19,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-19 {
    grid-column-start: 19;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-19,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-19 {
    grid-column-end: 19;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-20,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-20 {
    grid-column: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-20,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-20 {
    grid-column-start: 20;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-20,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-20 {
    grid-column-end: 20;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-21,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-21 {
    grid-column: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-21,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-21 {
    grid-column-start: 21;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-21,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-21 {
    grid-column-end: 21;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-22,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-22 {
    grid-column: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-22,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-22 {
    grid-column-start: 22;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-22,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-22 {
    grid-column-end: 22;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-23,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-23 {
    grid-column: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-23,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-23 {
    grid-column-start: 23;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-23,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-23 {
    grid-column-end: 23;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-24,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-24 {
    grid-column: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-24,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-24 {
    grid-column-start: 24;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-24,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-24 {
    grid-column-end: 24;
  }
  :host([enable-container])[rows-xxl="1"], :host([enable-container]).ids-layout-grid-rows-xxl-1,
  .ids-layout-grid[enable-container][rows-xxl="1"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-1,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-1 {
    grid-row: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([order-xxl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-1 {
    order: 1;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="2"], :host([enable-container]).ids-layout-grid-rows-xxl-2,
  .ids-layout-grid[enable-container][rows-xxl="2"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-2,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-2 {
    grid-row: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([order-xxl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-2,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-2 {
    order: 2;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="3"], :host([enable-container]).ids-layout-grid-rows-xxl-3,
  .ids-layout-grid[enable-container][rows-xxl="3"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-3,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-3 {
    grid-row: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([order-xxl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-3,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-3 {
    order: 3;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="4"], :host([enable-container]).ids-layout-grid-rows-xxl-4,
  .ids-layout-grid[enable-container][rows-xxl="4"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-4,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-4 {
    grid-row: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([order-xxl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-4,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-4 {
    order: 4;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="5"], :host([enable-container]).ids-layout-grid-rows-xxl-5,
  .ids-layout-grid[enable-container][rows-xxl="5"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-5,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-5 {
    grid-row: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([order-xxl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-5,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-5 {
    order: 5;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="6"], :host([enable-container]).ids-layout-grid-rows-xxl-6,
  .ids-layout-grid[enable-container][rows-xxl="6"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-6,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-6 {
    grid-row: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([order-xxl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-6,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-6 {
    order: 6;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="7"], :host([enable-container]).ids-layout-grid-rows-xxl-7,
  .ids-layout-grid[enable-container][rows-xxl="7"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-7,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-7 {
    grid-row: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([order-xxl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-7,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-7 {
    order: 7;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="8"], :host([enable-container]).ids-layout-grid-rows-xxl-8,
  .ids-layout-grid[enable-container][rows-xxl="8"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-8,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-8 {
    grid-row: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([order-xxl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-8,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-8 {
    order: 8;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="9"], :host([enable-container]).ids-layout-grid-rows-xxl-9,
  .ids-layout-grid[enable-container][rows-xxl="9"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-9,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-9 {
    grid-row: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([order-xxl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-9,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-9 {
    order: 9;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="10"], :host([enable-container]).ids-layout-grid-rows-xxl-10,
  .ids-layout-grid[enable-container][rows-xxl="10"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-10,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-10 {
    grid-row: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([order-xxl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-10,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-10 {
    order: 10;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="11"], :host([enable-container]).ids-layout-grid-rows-xxl-11,
  .ids-layout-grid[enable-container][rows-xxl="11"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-11,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-11 {
    grid-row: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([order-xxl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-11,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-11 {
    order: 11;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="12"], :host([enable-container]).ids-layout-grid-rows-xxl-12,
  .ids-layout-grid[enable-container][rows-xxl="12"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-12,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-12 {
    grid-row: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([order-xxl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-12,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-12 {
    order: 12;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="13"], :host([enable-container]).ids-layout-grid-rows-xxl-13,
  .ids-layout-grid[enable-container][rows-xxl="13"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-13,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-13 {
    grid-row: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([order-xxl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-13,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-13 {
    order: 13;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="14"], :host([enable-container]).ids-layout-grid-rows-xxl-14,
  .ids-layout-grid[enable-container][rows-xxl="14"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-14,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-14 {
    grid-row: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([order-xxl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-14,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-14 {
    order: 14;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="15"], :host([enable-container]).ids-layout-grid-rows-xxl-15,
  .ids-layout-grid[enable-container][rows-xxl="15"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-15,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-15 {
    grid-row: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([order-xxl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-15,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-15 {
    order: 15;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="16"], :host([enable-container]).ids-layout-grid-rows-xxl-16,
  .ids-layout-grid[enable-container][rows-xxl="16"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-16,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-16 {
    grid-row: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([order-xxl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-16,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-16 {
    order: 16;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="17"], :host([enable-container]).ids-layout-grid-rows-xxl-17,
  .ids-layout-grid[enable-container][rows-xxl="17"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-17,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-17 {
    grid-row: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([order-xxl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-17,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-17 {
    order: 17;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="18"], :host([enable-container]).ids-layout-grid-rows-xxl-18,
  .ids-layout-grid[enable-container][rows-xxl="18"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-18,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-18 {
    grid-row: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([order-xxl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-18,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-18 {
    order: 18;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="19"], :host([enable-container]).ids-layout-grid-rows-xxl-19,
  .ids-layout-grid[enable-container][rows-xxl="19"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-19,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-19 {
    grid-row: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([order-xxl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-19,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-19 {
    order: 19;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="20"], :host([enable-container]).ids-layout-grid-rows-xxl-20,
  .ids-layout-grid[enable-container][rows-xxl="20"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-20,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-20 {
    grid-row: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([order-xxl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-20,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-20 {
    order: 20;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="21"], :host([enable-container]).ids-layout-grid-rows-xxl-21,
  .ids-layout-grid[enable-container][rows-xxl="21"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-21,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-21 {
    grid-row: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([order-xxl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-21,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-21 {
    order: 21;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="22"], :host([enable-container]).ids-layout-grid-rows-xxl-22,
  .ids-layout-grid[enable-container][rows-xxl="22"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-22,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-22 {
    grid-row: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([order-xxl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-22,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-22 {
    order: 22;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="23"], :host([enable-container]).ids-layout-grid-rows-xxl-23,
  .ids-layout-grid[enable-container][rows-xxl="23"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-23,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-23 {
    grid-row: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([order-xxl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-23,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-23 {
    order: 23;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="24"], :host([enable-container]).ids-layout-grid-rows-xxl-24,
  .ids-layout-grid[enable-container][rows-xxl="24"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-24,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-24 {
    grid-row: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([order-xxl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-24,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-24 {
    order: 24;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="25"], :host([enable-container]).ids-layout-grid-rows-xxl-25,
  .ids-layout-grid[enable-container][rows-xxl="25"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-25,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-25 {
    grid-row: span 25/span 25;
  }
  :host([enable-container]) > ::slotted([order-xxl="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-25,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-25 {
    order: 25;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="26"], :host([enable-container]).ids-layout-grid-rows-xxl-26,
  .ids-layout-grid[enable-container][rows-xxl="26"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-26,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-26 {
    grid-row: span 26/span 26;
  }
  :host([enable-container]) > ::slotted([order-xxl="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-26,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-26 {
    order: 26;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="27"], :host([enable-container]).ids-layout-grid-rows-xxl-27,
  .ids-layout-grid[enable-container][rows-xxl="27"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-27,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-27 {
    grid-row: span 27/span 27;
  }
  :host([enable-container]) > ::slotted([order-xxl="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-27,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-27 {
    order: 27;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="28"], :host([enable-container]).ids-layout-grid-rows-xxl-28,
  .ids-layout-grid[enable-container][rows-xxl="28"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-28,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-28 {
    grid-row: span 28/span 28;
  }
  :host([enable-container]) > ::slotted([order-xxl="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-28,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-28 {
    order: 28;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="29"], :host([enable-container]).ids-layout-grid-rows-xxl-29,
  .ids-layout-grid[enable-container][rows-xxl="29"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-29,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-29 {
    grid-row: span 29/span 29;
  }
  :host([enable-container]) > ::slotted([order-xxl="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-29,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-29 {
    order: 29;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="30"], :host([enable-container]).ids-layout-grid-rows-xxl-30,
  .ids-layout-grid[enable-container][rows-xxl="30"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-30,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-30 {
    grid-row: span 30/span 30;
  }
  :host([enable-container]) > ::slotted([order-xxl="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-30,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-30 {
    order: 30;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="31"], :host([enable-container]).ids-layout-grid-rows-xxl-31,
  .ids-layout-grid[enable-container][rows-xxl="31"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-31,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-31 {
    grid-row: span 31/span 31;
  }
  :host([enable-container]) > ::slotted([order-xxl="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-31,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-31 {
    order: 31;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="32"], :host([enable-container]).ids-layout-grid-rows-xxl-32,
  .ids-layout-grid[enable-container][rows-xxl="32"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-32,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-32 {
    grid-row: span 32/span 32;
  }
  :host([enable-container]) > ::slotted([order-xxl="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-32,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-32 {
    order: 32;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="33"], :host([enable-container]).ids-layout-grid-rows-xxl-33,
  .ids-layout-grid[enable-container][rows-xxl="33"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-33,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-33 {
    grid-row: span 33/span 33;
  }
  :host([enable-container]) > ::slotted([order-xxl="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-33,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-33 {
    order: 33;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="34"], :host([enable-container]).ids-layout-grid-rows-xxl-34,
  .ids-layout-grid[enable-container][rows-xxl="34"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-34,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-34 {
    grid-row: span 34/span 34;
  }
  :host([enable-container]) > ::slotted([order-xxl="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-34,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-34 {
    order: 34;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="35"], :host([enable-container]).ids-layout-grid-rows-xxl-35,
  .ids-layout-grid[enable-container][rows-xxl="35"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-35,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-35 {
    grid-row: span 35/span 35;
  }
  :host([enable-container]) > ::slotted([order-xxl="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-35,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-35 {
    order: 35;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="36"], :host([enable-container]).ids-layout-grid-rows-xxl-36,
  .ids-layout-grid[enable-container][rows-xxl="36"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-36,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-36 {
    grid-row: span 36/span 36;
  }
  :host([enable-container]) > ::slotted([order-xxl="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-36,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-36 {
    order: 36;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="37"], :host([enable-container]).ids-layout-grid-rows-xxl-37,
  .ids-layout-grid[enable-container][rows-xxl="37"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-37,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-37 {
    grid-row: span 37/span 37;
  }
  :host([enable-container]) > ::slotted([order-xxl="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-37,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-37 {
    order: 37;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="38"], :host([enable-container]).ids-layout-grid-rows-xxl-38,
  .ids-layout-grid[enable-container][rows-xxl="38"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-38,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-38 {
    grid-row: span 38/span 38;
  }
  :host([enable-container]) > ::slotted([order-xxl="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-38,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-38 {
    order: 38;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="39"], :host([enable-container]).ids-layout-grid-rows-xxl-39,
  .ids-layout-grid[enable-container][rows-xxl="39"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-39,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-39 {
    grid-row: span 39/span 39;
  }
  :host([enable-container]) > ::slotted([order-xxl="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-39,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-39 {
    order: 39;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="40"], :host([enable-container]).ids-layout-grid-rows-xxl-40,
  .ids-layout-grid[enable-container][rows-xxl="40"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-40,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-40 {
    grid-row: span 40/span 40;
  }
  :host([enable-container]) > ::slotted([order-xxl="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-40,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-40 {
    order: 40;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="41"], :host([enable-container]).ids-layout-grid-rows-xxl-41,
  .ids-layout-grid[enable-container][rows-xxl="41"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-41,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-41 {
    grid-row: span 41/span 41;
  }
  :host([enable-container]) > ::slotted([order-xxl="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-41,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-41 {
    order: 41;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="42"], :host([enable-container]).ids-layout-grid-rows-xxl-42,
  .ids-layout-grid[enable-container][rows-xxl="42"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-42,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-42 {
    grid-row: span 42/span 42;
  }
  :host([enable-container]) > ::slotted([order-xxl="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-42,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-42 {
    order: 42;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="43"], :host([enable-container]).ids-layout-grid-rows-xxl-43,
  .ids-layout-grid[enable-container][rows-xxl="43"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-43,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-43 {
    grid-row: span 43/span 43;
  }
  :host([enable-container]) > ::slotted([order-xxl="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-43,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-43 {
    order: 43;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="44"], :host([enable-container]).ids-layout-grid-rows-xxl-44,
  .ids-layout-grid[enable-container][rows-xxl="44"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-44,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-44 {
    grid-row: span 44/span 44;
  }
  :host([enable-container]) > ::slotted([order-xxl="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-44,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-44 {
    order: 44;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="45"], :host([enable-container]).ids-layout-grid-rows-xxl-45,
  .ids-layout-grid[enable-container][rows-xxl="45"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-45,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-45 {
    grid-row: span 45/span 45;
  }
  :host([enable-container]) > ::slotted([order-xxl="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-45,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-45 {
    order: 45;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="46"], :host([enable-container]).ids-layout-grid-rows-xxl-46,
  .ids-layout-grid[enable-container][rows-xxl="46"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-46,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-46 {
    grid-row: span 46/span 46;
  }
  :host([enable-container]) > ::slotted([order-xxl="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-46,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-46 {
    order: 46;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="47"], :host([enable-container]).ids-layout-grid-rows-xxl-47,
  .ids-layout-grid[enable-container][rows-xxl="47"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-47,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-47 {
    grid-row: span 47/span 47;
  }
  :host([enable-container]) > ::slotted([order-xxl="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-47,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-47 {
    order: 47;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="48"], :host([enable-container]).ids-layout-grid-rows-xxl-48,
  .ids-layout-grid[enable-container][rows-xxl="48"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-48,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-48 {
    grid-row: span 48/span 48;
  }
  :host([enable-container]) > ::slotted([order-xxl="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-48,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-48 {
    order: 48;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="49"], :host([enable-container]).ids-layout-grid-rows-xxl-49,
  .ids-layout-grid[enable-container][rows-xxl="49"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-49,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-49 {
    grid-row: span 49/span 49;
  }
  :host([enable-container]) > ::slotted([order-xxl="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-49,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-49 {
    order: 49;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="50"], :host([enable-container]).ids-layout-grid-rows-xxl-50,
  .ids-layout-grid[enable-container][rows-xxl="50"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-50,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-50 {
    grid-row: span 50/span 50;
  }
  :host([enable-container]) > ::slotted([order-xxl="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-50,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-50 {
    order: 50;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container]) > ::slotted([hide=xxl]),
  .ids-layout-grid[enable-container] > ::slotted([hide=xxl]) {
    display: block;
  }
}

/* Grid Gaps */
:host([gap=none]),
.ids-layout-grid.ids-layout-grid-gap-none {
  grid-gap: 0;
}

:host([gap=sm]),
.ids-layout-grid.ids-layout-grid-gap-sm {
  grid-gap: 8px;
}

:host([gap=md]),
.ids-layout-grid.ids-layout-grid-gap-md {
  grid-gap: 24px;
}

:host([gap=lg]),
.ids-layout-grid.ids-layout-grid-gap-lg {
  grid-gap: 32px;
}

:host([gap=xl]),
.ids-layout-grid.ids-layout-grid-gap-xl {
  grid-gap: 40px;
}

/* Grid Margins */
:host([margin=xs]),
.ids-layout-grid.ids-layout-grid-margin-xs {
  margin: 8px;
}

:host([margin=sm]),
.ids-layout-grid.ids-layout-grid-margin-sm {
  margin: 16px;
}

:host([margin=md]),
.ids-layout-grid.ids-layout-grid-margin-md {
  margin: 24px;
}

:host([margin=lg]),
.ids-layout-grid.ids-layout-grid-margin-lg {
  margin: 32px;
}

:host([margin=xl]),
.ids-layout-grid.ids-layout-grid-margin-xl {
  margin: 40px;
}

:host([margin=auto]),
.ids-layout-grid.ids-layout-grid-margin-auto {
  margin: auto;
}

/* Grid Margin Y */
:host([margin-y=xs]),
.ids-layout-grid.ids-layout-grid-margin-y-xs {
  margin-block: 8px;
}

:host([margin-y=sm]),
.ids-layout-grid.ids-layout-grid-margin-y-sm {
  margin-block: 16px;
}

:host([margin-y=md]),
.ids-layout-grid.ids-layout-grid-margin-y-md {
  margin-block: 24px;
}

:host([margin-y=lg]),
.ids-layout-grid.ids-layout-grid-margin-y-lg {
  margin-block: 32px;
}

:host([margin-y=xl]),
.ids-layout-grid.ids-layout-grid-margin-y-xl {
  margin-block: 40px;
}

/* Grid Max Width */
:host([max-width=xs]),
.ids-layout-grid.ids-layout-grid-max-width-xs {
  max-width: 320px;
}

:host([max-width=sm]),
.ids-layout-grid.ids-layout-grid-max-width-sm {
  max-width: 600px;
}

:host([max-width=md]),
.ids-layout-grid.ids-layout-grid-max-width-md {
  max-width: 840px;
}

:host([max-width=lg]),
.ids-layout-grid.ids-layout-grid-max-width-lg {
  max-width: 1024px;
}

:host([max-width=xl]),
.ids-layout-grid.ids-layout-grid-max-width-xl {
  max-width: 1280px;
}

:host([max-width=xxl]),
.ids-layout-grid.ids-layout-grid-max-width-xxl {
  max-width: 1440px;
}

:host([max-width\$=px]) {
  max-width: var(--max-width);
}

/* Grid Padding */
:host([padding=xs]),
::slotted([padding=xs]),
.ids-layout-grid.ids-layout-grid-padding-xs {
  padding: 8px;
}

:host([padding=sm]),
::slotted([padding=sm]),
.ids-layout-grid.ids-layout-grid-padding-sm {
  padding: 16px;
}

:host([padding=md]),
::slotted([padding=md]),
.ids-layout-grid.ids-layout-grid-padding-md {
  padding: 24px;
}

:host([padding=lg]),
::slotted([padding=lg]),
.ids-layout-grid.ids-layout-grid-padding-lg {
  padding: 32px;
}

:host([padding=xl]),
::slotted([padding=xl]),
.ids-layout-grid.ids-layout-grid-padding-xl {
  padding: 40px;
}

/* Grid Padding X */
:host([padding-x=xs]),
.ids-layout-grid.ids-layout-grid-padding-x-xs {
  padding-inline: 8px;
}

:host([padding-x=sm]),
.ids-layout-grid.ids-layout-grid-padding-x-sm {
  padding-inline: 16px;
}

:host([padding-x=md]),
.ids-layout-grid.ids-layout-grid-padding-x-md {
  padding-inline: 24px;
}

:host([padding-x=lg]),
.ids-layout-grid.ids-layout-grid-padding-x-lg {
  padding-inline: 32px;
}

:host([padding-x=xl]),
.ids-layout-grid.ids-layout-grid-padding-x-xl {
  padding-inline: 40px;
}

/* Grid Padding Y */
:host([padding-y=xs]),
.ids-layout-grid.ids-layout-grid-padding-y-xs {
  padding-block: 8px;
}

:host([padding-y=xxs]),
.ids-layout-grid.ids-layout-grid-padding-y-xxs {
  padding-block: 4px;
}

:host([padding-y=sm]),
.ids-layout-grid.ids-layout-grid-padding-y-sm {
  padding-block: 16px;
}

:host([padding-y=md]),
.ids-layout-grid.ids-layout-grid-padding-y-md {
  padding-block: 24px;
}

:host([padding-y=lg]),
.ids-layout-grid.ids-layout-grid-padding-y-lg {
  padding-block: 32px;
}

:host([padding-y=xl]),
.ids-layout-grid.ids-layout-grid-padding-y-xl {
  padding-block: 40px;
}

/* Grid - Auto Fit/Fill */
:host([auto-fit]),
.ids-layout-grid-auto-fit {
  width: 100%;
  grid-template-columns: repeat(auto-fit, minmax(var(--min-col-width), var(--max-col-width)));
}

:host([auto-fill]),
.ids-layout-grid-auto-fill {
  width: 100%;
  grid-template-columns: repeat(auto-fill, minmax(var(--min-col-width), var(--max-col-width)));
}

/* Grid - Auto Columns - TODO - Add settings for grid-auto-columns */
:host(.ids-layout-grid-cols-auto),
.ids-layout-grid-cols-auto {
  grid-auto-columns: auto;
}

:host(.ids-layout-grid-cols-min),
.ids-layout-grid-cols-min {
  grid-auto-columns: min-content;
}

:host(.ids-layout-grid-cols-max),
.ids-layout-grid-cols-max {
  grid-auto-columns: max-content;
}

:host(.ids-layout-grid-cols-fr),
.ids-layout-grid-cols-fr {
  grid-auto-columns: minmax(0, 1fr);
}

/* Grid Flow */
:host([flow=row]),
.ids-layout-grid-flow-row {
  grid-auto-flow: row;
}

:host([flow=column]),
.ids-layout-grid-flow-col {
  grid-auto-flow: column;
}

:host([flow=dense]),
.ids-layout-grid-flow-dense {
  grid-auto-flow: dense;
}

:host([flow=row-dense]),
.ids-layout-grid-flow-row-dense {
  grid-auto-flow: row dense;
}

:host([flow=column-dense]),
.ids-layout-grid-flow-col-dense {
  grid-auto-flow: column dense;
}

/* Grid - Auto Rows - TODO - Add settings for grid-auto-rows */
:host(.ids-layout-grid-auto-rows-auto),
.ids-layout-grid-auto-rows-auto {
  grid-auto-rows: auto;
}

:host(.ids-layout-grid-auto-rows-min),
.ids-layout-grid-auto-rows-min {
  grid-auto-rows: min-content;
}

:host(.ids-layout-grid-auto-rows-max),
.ids-layout-grid-auto-rows-max {
  grid-auto-rows: max-content;
}

:host(.ids-layout-grid-auto-rows-fr),
.ids-layout-grid-auto-rows-fr {
  grid-auto-rows: minmax(0, 1fr);
}

:host([row-height]),
.ids-layout-grid-auto-row-height {
  grid-auto-rows: var(--grid-auto-row-height);
}

/* Grid - Template Rows */
:host([template-rows]),
.ids-layout-grid-template-rows {
  grid-template-rows: var(--grid-template-rows);
}

/** Align items */
:host([align-items=start]),
.ids-layout-grid-align-items-start {
  align-items: start;
}

:host([align-items=end]),
.ids-layout-grid-align-items-end {
  align-items: end;
}

:host([align-items=center]),
.ids-layout-grid-align-items-center {
  align-items: center;
}

:host([align-items=stretch]),
.ids-layout-grid-align-items-stretch {
  align-items: stretch;
}

/* Justify Content and Align Content */
:host([justify-content=start]),
.ids-layout-grid-justify-start {
  justify-content: start;
}

:host([align-content=start]),
.ids-layout-grid-align-start {
  align-content: start;
}

::slotted([justify-content=start]),
.ids-layout-grid > .ids-layout-grid-justify-start {
  display: grid;
  justify-content: start;
}

::slotted([align-content=start]),
.ids-layout-grid > .ids-layout-grid-align-start {
  display: grid;
  align-content: start;
}

:host([justify-content=center]),
.ids-layout-grid-justify-center {
  justify-content: center;
}

:host([align-content=center]),
.ids-layout-grid-align-center {
  align-content: center;
}

::slotted([justify-content=center]),
.ids-layout-grid > .ids-layout-grid-justify-center {
  display: grid;
  justify-content: center;
}

::slotted([align-content=center]),
.ids-layout-grid > .ids-layout-grid-align-center {
  display: grid;
  align-content: center;
}

:host([justify-content=space-between]),
.ids-layout-grid-justify-space-between {
  justify-content: space-between;
}

:host([align-content=space-between]),
.ids-layout-grid-align-space-between {
  align-content: space-between;
}

::slotted([justify-content=space-between]),
.ids-layout-grid > .ids-layout-grid-justify-space-between {
  display: grid;
  justify-content: space-between;
}

::slotted([align-content=space-between]),
.ids-layout-grid > .ids-layout-grid-align-space-between {
  display: grid;
  align-content: space-between;
}

:host([justify-content=space-around]),
.ids-layout-grid-justify-space-around {
  justify-content: space-around;
}

:host([align-content=space-around]),
.ids-layout-grid-align-space-around {
  align-content: space-around;
}

::slotted([justify-content=space-around]),
.ids-layout-grid > .ids-layout-grid-justify-space-around {
  display: grid;
  justify-content: space-around;
}

::slotted([align-content=space-around]),
.ids-layout-grid > .ids-layout-grid-align-space-around {
  display: grid;
  align-content: space-around;
}

:host([justify-content=space-evenly]),
.ids-layout-grid-justify-space-evenly {
  justify-content: space-evenly;
}

:host([align-content=space-evenly]),
.ids-layout-grid-align-space-evenly {
  align-content: space-evenly;
}

::slotted([justify-content=space-evenly]),
.ids-layout-grid > .ids-layout-grid-justify-space-evenly {
  display: grid;
  justify-content: space-evenly;
}

::slotted([align-content=space-evenly]),
.ids-layout-grid > .ids-layout-grid-align-space-evenly {
  display: grid;
  align-content: space-evenly;
}

:host([justify-content=end]),
.ids-layout-grid-justify-end {
  justify-content: end;
}

:host([align-content=end]),
.ids-layout-grid-align-end {
  align-content: end;
}

::slotted([justify-content=end]),
.ids-layout-grid > .ids-layout-grid-justify-end {
  display: grid;
  justify-content: end;
}

::slotted([align-content=end]),
.ids-layout-grid > .ids-layout-grid-align-end {
  display: grid;
  align-content: end;
}

/* Grid Col/Row Span All and Sticky */
::slotted([col-span=all]),
.ids-layout-grid > .ids-layout-grid-col-span-all {
  grid-column: 1/-1;
}

::slotted([row-span=all]),
.ids-layout-grid > .ids-layout-grid-row-span-all {
  grid-row: 1/-1;
}

::slotted([sticky]),
.ids-layout-grid > .ids-layout-grid-sticky {
  position: sticky;
  top: var(--sticky-position);
}

/* Hide Cell on Breakpoints */
:host > ::slotted([hide=xs]) {
  display: none;
}

:host > ::slotted([hide=sm]) {
  display: none;
}

:host > ::slotted([hide=md]) {
  display: none;
}

:host > ::slotted([hide=lg]) {
  display: none;
}

:host > ::slotted([hide=xl]) {
  display: none;
}

:host > ::slotted([hide=xxl]) {
  display: none;
}

:host > ::slotted([hide=always]) {
  display: none;
}

:host([row-gap=none]),
::slotted([row-gap=none]),
.ids-layout-grid.ids-layout-grid-row-gap-none {
  row-gap: 0;
}

:host([row-gap=xs]),
::slotted([row-gap=xs]),
.ids-layout-grid.ids-layout-grid-row-gap-xs {
  row-gap: 8px;
}

:host([row-gap=sm]),
::slotted([row-gap=sm]),
.ids-layout-grid.ids-layout-grid-row-gap-sm {
  row-gap: 16px;
}

:host([row-gap=md]),
::slotted([row-gap=md]),
.ids-layout-grid.ids-layout-grid-row-gap-md {
  row-gap: 24px;
}

:host([row-gap=lg]),
::slotted([row-gap=lg]),
.ids-layout-grid.ids-layout-grid-row-gap-lg {
  row-gap: 32px;
}

:host([row-gap=xl]),
::slotted([row-gap=xl]),
.ids-layout-grid.ids-layout-grid-row-gap-xl {
  row-gap: 40px;
}

:host([col-gap=none]),
::slotted([col-gap=none]),
.ids-layout-grid.ids-layout-grid-col-gap-none {
  column-gap: 0;
}

:host([col-gap=xs]),
::slotted([col-gap=xs]),
.ids-layout-grid.ids-layout-grid-col-gap-xs {
  column-gap: 8px;
}

:host([col-gap=sm]),
::slotted([col-gap=sm]),
.ids-layout-grid.ids-layout-grid-col-gap-sm {
  column-gap: 16px;
}

:host([col-gap=md]),
::slotted([col-gap=md]),
.ids-layout-grid.ids-layout-grid-col-gap-md {
  column-gap: 24px;
}

:host([col-gap=lg]),
::slotted([col-gap=lg]),
.ids-layout-grid.ids-layout-grid-col-gap-lg {
  column-gap: 32px;
}

:host([col-gap=xl]),
::slotted([col-gap=xl]),
.ids-layout-grid.ids-layout-grid-col-gap-xl {
  column-gap: 40px;
}

/* Editable */
::slotted([editable]) > ids-button,
.ids-layout-grid > .ids-layout-grid-cell.editable > ids-button {
  position: absolute;
  top: 0;
  right: 0;
}

/* Fill */
::slotted([fill]),
.ids-layout-grid > .ids-layout-grid-cell.fill {
  background-color: var(--grid-fill-color);
  color: var(--grid-text-color);
}

/* Height */
::slotted([height=auto]),
.ids-layout-grid > .ids-layout-grid-height-auto {
  height: auto;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-layout-grid/ids-layout-grid-base.scss","webpack://./src/components/ids-layout-grid/ids-layout-grid.scss","webpack://./src/components/ids-layout-grid/ids-layout-grid-responsive.scss","webpack://./src/themes/mixins/ids-core-mixins.scss"],"names":[],"mappings":"AAAA,mBAAA;AACA;EACE,yBAAA;EACA,0DAAA;EACA,oDAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;ACCF;;ADEA,mBAAA;AA2BA,kCAAA;AACA;;EAEE,aAAA;EACA,cAzBS;EA0BT,sBAAA;EACA,sBAAA;ACzBF;;AD4BA,wBAAA;AAEE;;EAEE,WAAA;EACA,oFAAA;AC1BJ;;AD6BE;;EAEE,0BAAA;AC1BJ;;AD6BE;;EAEE,oBAdS;ACZb;;AD6BE;;EAEE,kBAnBS;ACPb;;ADQE;;EAEE,WAAA;EACA,oFAAA;ACLJ;;ADQE;;EAEE,0BAAA;ACLJ;;ADQE;;EAEE,oBAdS;ACSb;;ADQE;;EAEE,kBAnBS;ACcb;;ADbE;;EAEE,WAAA;EACA,oFAAA;ACgBJ;;ADbE;;EAEE,0BAAA;ACgBJ;;ADbE;;EAEE,oBAdS;AC8Bb;;ADbE;;EAEE,kBAnBS;ACmCb;;ADlCE;;EAEE,WAAA;EACA,oFAAA;ACqCJ;;ADlCE;;EAEE,0BAAA;ACqCJ;;ADlCE;;EAEE,oBAdS;ACmDb;;ADlCE;;EAEE,kBAnBS;ACwDb;;ADvDE;;EAEE,WAAA;EACA,oFAAA;AC0DJ;;ADvDE;;EAEE,0BAAA;AC0DJ;;ADvDE;;EAEE,oBAdS;ACwEb;;ADvDE;;EAEE,kBAnBS;AC6Eb;;AD5EE;;EAEE,WAAA;EACA,oFAAA;AC+EJ;;AD5EE;;EAEE,0BAAA;AC+EJ;;AD5EE;;EAEE,oBAdS;AC6Fb;;AD5EE;;EAEE,kBAnBS;ACkGb;;ADjGE;;EAEE,WAAA;EACA,oFAAA;ACoGJ;;ADjGE;;EAEE,0BAAA;ACoGJ;;ADjGE;;EAEE,oBAdS;ACkHb;;ADjGE;;EAEE,kBAnBS;ACuHb;;ADtHE;;EAEE,WAAA;EACA,oFAAA;ACyHJ;;ADtHE;;EAEE,0BAAA;ACyHJ;;ADtHE;;EAEE,oBAdS;ACuIb;;ADtHE;;EAEE,kBAnBS;AC4Ib;;AD3IE;;EAEE,WAAA;EACA,oFAAA;AC8IJ;;AD3IE;;EAEE,0BAAA;AC8IJ;;AD3IE;;EAEE,oBAdS;AC4Jb;;AD3IE;;EAEE,kBAnBS;ACiKb;;ADhKE;;EAEE,WAAA;EACA,qFAAA;ACmKJ;;ADhKE;;EAEE,4BAAA;ACmKJ;;ADhKE;;EAEE,qBAdS;ACiLb;;ADhKE;;EAEE,mBAnBS;ACsLb;;ADrLE;;EAEE,WAAA;EACA,qFAAA;ACwLJ;;ADrLE;;EAEE,4BAAA;ACwLJ;;ADrLE;;EAEE,qBAdS;ACsMb;;ADrLE;;EAEE,mBAnBS;AC2Mb;;AD1ME;;EAEE,WAAA;EACA,qFAAA;AC6MJ;;AD1ME;;EAEE,4BAAA;AC6MJ;;AD1ME;;EAEE,qBAdS;AC2Nb;;AD1ME;;EAEE,mBAnBS;ACgOb;;AD/NE;;EAEE,WAAA;EACA,qFAAA;ACkOJ;;AD/NE;;EAEE,4BAAA;ACkOJ;;AD/NE;;EAEE,qBAdS;ACgPb;;AD/NE;;EAEE,mBAnBS;ACqPb;;ADpPE;;EAEE,WAAA;EACA,qFAAA;ACuPJ;;ADpPE;;EAEE,4BAAA;ACuPJ;;ADpPE;;EAEE,qBAdS;ACqQb;;ADpPE;;EAEE,mBAnBS;AC0Qb;;ADzQE;;EAEE,WAAA;EACA,qFAAA;AC4QJ;;ADzQE;;EAEE,4BAAA;AC4QJ;;ADzQE;;EAEE,qBAdS;AC0Rb;;ADzQE;;EAEE,mBAnBS;AC+Rb;;AD9RE;;EAEE,WAAA;EACA,qFAAA;ACiSJ;;AD9RE;;EAEE,4BAAA;ACiSJ;;AD9RE;;EAEE,qBAdS;AC+Sb;;AD9RE;;EAEE,mBAnBS;ACoTb;;ADnTE;;EAEE,WAAA;EACA,qFAAA;ACsTJ;;ADnTE;;EAEE,4BAAA;ACsTJ;;ADnTE;;EAEE,qBAdS;ACoUb;;ADnTE;;EAEE,mBAnBS;ACyUb;;ADxUE;;EAEE,WAAA;EACA,qFAAA;AC2UJ;;ADxUE;;EAEE,4BAAA;AC2UJ;;ADxUE;;EAEE,qBAdS;ACyVb;;ADxUE;;EAEE,mBAnBS;AC8Vb;;AD7VE;;EAEE,WAAA;EACA,qFAAA;ACgWJ;;AD7VE;;EAEE,4BAAA;ACgWJ;;AD7VE;;EAEE,qBAdS;AC8Wb;;AD7VE;;EAEE,mBAnBS;ACmXb;;ADlXE;;EAEE,WAAA;EACA,qFAAA;ACqXJ;;ADlXE;;EAEE,4BAAA;ACqXJ;;ADlXE;;EAEE,qBAdS;ACmYb;;ADlXE;;EAEE,mBAnBS;ACwYb;;ADvYE;;EAEE,WAAA;EACA,qFAAA;AC0YJ;;ADvYE;;EAEE,4BAAA;AC0YJ;;ADvYE;;EAEE,qBAdS;ACwZb;;ADvYE;;EAEE,mBAnBS;AC6Zb;;AD5ZE;;EAEE,WAAA;EACA,qFAAA;AC+ZJ;;AD5ZE;;EAEE,4BAAA;AC+ZJ;;AD5ZE;;EAEE,qBAdS;AC6ab;;AD5ZE;;EAEE,mBAnBS;ACkbb;;ADjbE;;EAEE,WAAA;EACA,qFAAA;ACobJ;;ADjbE;;EAEE,4BAAA;ACobJ;;ADjbE;;EAEE,qBAdS;ACkcb;;ADjbE;;EAEE,mBAnBS;ACucb;;ADtcE;;EAEE,WAAA;EACA,qFAAA;ACycJ;;ADtcE;;EAEE,4BAAA;ACycJ;;ADtcE;;EAEE,qBAdS;ACudb;;ADtcE;;EAEE,mBAnBS;AC4db;;ADrcA,qBAAA;AAEE;;EAEE,6CAAA;ACucJ;;ADpcE;;EAEE,uBAAA;ACucJ;;ADpcE;;EAEE,QAbS;ACodb;;ADpcE;;EAEE,SAAA;ACucJ;;ADxdE;;EAEE,6CAAA;AC2dJ;;ADxdE;;EAEE,uBAAA;AC2dJ;;ADxdE;;EAEE,QAbS;ACweb;;ADxdE;;EAEE,SAAA;AC2dJ;;AD5eE;;EAEE,6CAAA;AC+eJ;;AD5eE;;EAEE,uBAAA;AC+eJ;;AD5eE;;EAEE,QAbS;AC4fb;;AD5eE;;EAEE,SAAA;AC+eJ;;ADhgBE;;EAEE,6CAAA;ACmgBJ;;ADhgBE;;EAEE,uBAAA;ACmgBJ;;ADhgBE;;EAEE,QAbS;ACghBb;;ADhgBE;;EAEE,SAAA;ACmgBJ;;ADphBE;;EAEE,6CAAA;ACuhBJ;;ADphBE;;EAEE,uBAAA;ACuhBJ;;ADphBE;;EAEE,QAbS;ACoiBb;;ADphBE;;EAEE,SAAA;ACuhBJ;;ADxiBE;;EAEE,6CAAA;AC2iBJ;;ADxiBE;;EAEE,uBAAA;AC2iBJ;;ADxiBE;;EAEE,QAbS;ACwjBb;;ADxiBE;;EAEE,SAAA;AC2iBJ;;AD5jBE;;EAEE,6CAAA;AC+jBJ;;AD5jBE;;EAEE,uBAAA;AC+jBJ;;AD5jBE;;EAEE,QAbS;AC4kBb;;AD5jBE;;EAEE,SAAA;AC+jBJ;;ADhlBE;;EAEE,6CAAA;ACmlBJ;;ADhlBE;;EAEE,uBAAA;ACmlBJ;;ADhlBE;;EAEE,QAbS;ACgmBb;;ADhlBE;;EAEE,SAAA;ACmlBJ;;ADpmBE;;EAEE,6CAAA;ACumBJ;;ADpmBE;;EAEE,uBAAA;ACumBJ;;ADpmBE;;EAEE,QAbS;AConBb;;ADpmBE;;EAEE,SAAA;ACumBJ;;ADxnBE;;EAEE,8CAAA;AC2nBJ;;ADxnBE;;EAEE,yBAAA;AC2nBJ;;ADxnBE;;EAEE,SAbS;ACwoBb;;ADxnBE;;EAEE,SAAA;AC2nBJ;;AD5oBE;;EAEE,8CAAA;AC+oBJ;;AD5oBE;;EAEE,yBAAA;AC+oBJ;;AD5oBE;;EAEE,SAbS;AC4pBb;;AD5oBE;;EAEE,SAAA;AC+oBJ;;ADhqBE;;EAEE,8CAAA;ACmqBJ;;ADhqBE;;EAEE,yBAAA;ACmqBJ;;ADhqBE;;EAEE,SAbS;ACgrBb;;ADhqBE;;EAEE,SAAA;ACmqBJ;;ADprBE;;EAEE,8CAAA;ACurBJ;;ADprBE;;EAEE,yBAAA;ACurBJ;;ADprBE;;EAEE,SAbS;ACosBb;;ADprBE;;EAEE,SAAA;ACurBJ;;ADxsBE;;EAEE,8CAAA;AC2sBJ;;ADxsBE;;EAEE,yBAAA;AC2sBJ;;ADxsBE;;EAEE,SAbS;ACwtBb;;ADxsBE;;EAEE,SAAA;AC2sBJ;;AD5tBE;;EAEE,8CAAA;AC+tBJ;;AD5tBE;;EAEE,yBAAA;AC+tBJ;;AD5tBE;;EAEE,SAbS;AC4uBb;;AD5tBE;;EAEE,SAAA;AC+tBJ;;ADhvBE;;EAEE,8CAAA;ACmvBJ;;ADhvBE;;EAEE,yBAAA;ACmvBJ;;ADhvBE;;EAEE,SAbS;ACgwBb;;ADhvBE;;EAEE,SAAA;ACmvBJ;;ADpwBE;;EAEE,8CAAA;ACuwBJ;;ADpwBE;;EAEE,yBAAA;ACuwBJ;;ADpwBE;;EAEE,SAbS;ACoxBb;;ADpwBE;;EAEE,SAAA;ACuwBJ;;ADxxBE;;EAEE,8CAAA;AC2xBJ;;ADxxBE;;EAEE,yBAAA;AC2xBJ;;ADxxBE;;EAEE,SAbS;ACwyBb;;ADxxBE;;EAEE,SAAA;AC2xBJ;;AD5yBE;;EAEE,8CAAA;AC+yBJ;;AD5yBE;;EAEE,yBAAA;AC+yBJ;;AD5yBE;;EAEE,SAbS;AC4zBb;;AD5yBE;;EAEE,SAAA;AC+yBJ;;ADh0BE;;EAEE,8CAAA;ACm0BJ;;ADh0BE;;EAEE,yBAAA;ACm0BJ;;ADh0BE;;EAEE,SAbS;ACg1Bb;;ADh0BE;;EAEE,SAAA;ACm0BJ;;ADp1BE;;EAEE,8CAAA;ACu1BJ;;ADp1BE;;EAEE,yBAAA;ACu1BJ;;ADp1BE;;EAEE,SAbS;ACo2Bb;;ADp1BE;;EAEE,SAAA;ACu1BJ;;ADx2BE;;EAEE,8CAAA;AC22BJ;;ADx2BE;;EAEE,yBAAA;AC22BJ;;ADx2BE;;EAEE,SAbS;ACw3Bb;;ADx2BE;;EAEE,SAAA;AC22BJ;;AD53BE;;EAEE,8CAAA;AC+3BJ;;AD53BE;;EAEE,yBAAA;AC+3BJ;;AD53BE;;EAEE,SAbS;AC44Bb;;AD53BE;;EAEE,SAAA;AC+3BJ;;ADh5BE;;EAEE,8CAAA;ACm5BJ;;ADh5BE;;EAEE,yBAAA;ACm5BJ;;ADh5BE;;EAEE,SAbS;ACg6Bb;;ADh5BE;;EAEE,SAAA;ACm5BJ;;ADp6BE;;EAEE,8CAAA;ACu6BJ;;ADp6BE;;EAEE,yBAAA;ACu6BJ;;ADp6BE;;EAEE,SAbS;ACo7Bb;;ADp6BE;;EAEE,SAAA;ACu6BJ;;ADx7BE;;EAEE,8CAAA;AC27BJ;;ADx7BE;;EAEE,yBAAA;AC27BJ;;ADx7BE;;EAEE,SAbS;ACw8Bb;;ADx7BE;;EAEE,SAAA;AC27BJ;;AD58BE;;EAEE,8CAAA;AC+8BJ;;AD58BE;;EAEE,yBAAA;AC+8BJ;;AD58BE;;EAEE,SAbS;AC49Bb;;AD58BE;;EAEE,SAAA;AC+8BJ;;ADh+BE;;EAEE,8CAAA;ACm+BJ;;ADh+BE;;EAEE,yBAAA;ACm+BJ;;ADh+BE;;EAEE,SAbS;ACg/Bb;;ADh+BE;;EAEE,SAAA;ACm+BJ;;ADp/BE;;EAEE,8CAAA;ACu/BJ;;ADp/BE;;EAEE,yBAAA;ACu/BJ;;ADp/BE;;EAEE,SAbS;ACogCb;;ADp/BE;;EAEE,SAAA;ACu/BJ;;ADxgCE;;EAEE,8CAAA;AC2gCJ;;ADxgCE;;EAEE,yBAAA;AC2gCJ;;ADxgCE;;EAEE,SAbS;ACwhCb;;ADxgCE;;EAEE,SAAA;AC2gCJ;;AD5hCE;;EAEE,8CAAA;AC+hCJ;;AD5hCE;;EAEE,yBAAA;AC+hCJ;;AD5hCE;;EAEE,SAbS;AC4iCb;;AD5hCE;;EAEE,SAAA;AC+hCJ;;ADhjCE;;EAEE,8CAAA;ACmjCJ;;ADhjCE;;EAEE,yBAAA;ACmjCJ;;ADhjCE;;EAEE,SAbS;ACgkCb;;ADhjCE;;EAEE,SAAA;ACmjCJ;;ADpkCE;;EAEE,8CAAA;ACukCJ;;ADpkCE;;EAEE,yBAAA;ACukCJ;;ADpkCE;;EAEE,SAbS;AColCb;;ADpkCE;;EAEE,SAAA;ACukCJ;;ADxlCE;;EAEE,8CAAA;AC2lCJ;;ADxlCE;;EAEE,yBAAA;AC2lCJ;;ADxlCE;;EAEE,SAbS;ACwmCb;;ADxlCE;;EAEE,SAAA;AC2lCJ;;AD5mCE;;EAEE,8CAAA;AC+mCJ;;AD5mCE;;EAEE,yBAAA;AC+mCJ;;AD5mCE;;EAEE,SAbS;AC4nCb;;AD5mCE;;EAEE,SAAA;AC+mCJ;;ADhoCE;;EAEE,8CAAA;ACmoCJ;;ADhoCE;;EAEE,yBAAA;ACmoCJ;;ADhoCE;;EAEE,SAbS;ACgpCb;;ADhoCE;;EAEE,SAAA;ACmoCJ;;ADppCE;;EAEE,8CAAA;ACupCJ;;ADppCE;;EAEE,yBAAA;ACupCJ;;ADppCE;;EAEE,SAbS;ACoqCb;;ADppCE;;EAEE,SAAA;ACupCJ;;ADxqCE;;EAEE,8CAAA;AC2qCJ;;ADxqCE;;EAEE,yBAAA;AC2qCJ;;ADxqCE;;EAEE,SAbS;ACwrCb;;ADxqCE;;EAEE,SAAA;AC2qCJ;;AD5rCE;;EAEE,8CAAA;AC+rCJ;;AD5rCE;;EAEE,yBAAA;AC+rCJ;;AD5rCE;;EAEE,SAbS;AC4sCb;;AD5rCE;;EAEE,SAAA;AC+rCJ;;ADhtCE;;EAEE,8CAAA;ACmtCJ;;ADhtCE;;EAEE,yBAAA;ACmtCJ;;ADhtCE;;EAEE,SAbS;ACguCb;;ADhtCE;;EAEE,SAAA;ACmtCJ;;ADpuCE;;EAEE,8CAAA;ACuuCJ;;ADpuCE;;EAEE,yBAAA;ACuuCJ;;ADpuCE;;EAEE,SAbS;ACovCb;;ADpuCE;;EAEE,SAAA;ACuuCJ;;ADxvCE;;EAEE,8CAAA;AC2vCJ;;ADxvCE;;EAEE,yBAAA;AC2vCJ;;ADxvCE;;EAEE,SAbS;ACwwCb;;ADxvCE;;EAEE,SAAA;AC2vCJ;;AD5wCE;;EAEE,8CAAA;AC+wCJ;;AD5wCE;;EAEE,yBAAA;AC+wCJ;;AD5wCE;;EAEE,SAbS;AC4xCb;;AD5wCE;;EAEE,SAAA;AC+wCJ;;ADhyCE;;EAEE,8CAAA;ACmyCJ;;ADhyCE;;EAEE,yBAAA;ACmyCJ;;ADhyCE;;EAEE,SAbS;ACgzCb;;ADhyCE;;EAEE,SAAA;ACmyCJ;;ADpzCE;;EAEE,8CAAA;ACuzCJ;;ADpzCE;;EAEE,yBAAA;ACuzCJ;;ADpzCE;;EAEE,SAbS;ACo0Cb;;ADpzCE;;EAEE,SAAA;ACuzCJ;;ADx0CE;;EAEE,8CAAA;AC20CJ;;ADx0CE;;EAEE,yBAAA;AC20CJ;;ADx0CE;;EAEE,SAbS;ACw1Cb;;ADx0CE;;EAEE,SAAA;AC20CJ;;AD51CE;;EAEE,8CAAA;AC+1CJ;;AD51CE;;EAEE,yBAAA;AC+1CJ;;AD51CE;;EAEE,SAbS;AC42Cb;;AD51CE;;EAEE,SAAA;AC+1CJ;;ADh3CE;;EAEE,8CAAA;ACm3CJ;;ADh3CE;;EAEE,yBAAA;ACm3CJ;;ADh3CE;;EAEE,SAbS;ACg4Cb;;ADh3CE;;EAEE,SAAA;ACm3CJ;;ADp4CE;;EAEE,8CAAA;ACu4CJ;;ADp4CE;;EAEE,yBAAA;ACu4CJ;;ADp4CE;;EAEE,SAbS;ACo5Cb;;ADp4CE;;EAEE,SAAA;ACu4CJ;;ADx5CE;;EAEE,8CAAA;AC25CJ;;ADx5CE;;EAEE,yBAAA;AC25CJ;;ADx5CE;;EAEE,SAbS;ACw6Cb;;ADx5CE;;EAEE,SAAA;AC25CJ;;ACp9CE;EAEI;;IAEE,WAAA;IACA,oFAAA;EDs9CN;ECz9CI;;IAEE,WAAA;IACA,oFAAA;ED29CN;EC99CI;;IAEE,WAAA;IACA,oFAAA;EDg+CN;ECn+CI;;IAEE,WAAA;IACA,oFAAA;EDq+CN;ECx+CI;;IAEE,WAAA;IACA,oFAAA;ED0+CN;EC7+CI;;IAEE,WAAA;IACA,oFAAA;ED++CN;ECl/CI;;IAEE,WAAA;IACA,oFAAA;EDo/CN;ECv/CI;;IAEE,WAAA;IACA,oFAAA;EDy/CN;EC5/CI;;IAEE,WAAA;IACA,oFAAA;ED8/CN;ECjgDI;;IAEE,WAAA;IACA,qFAAA;EDmgDN;ECtgDI;;IAEE,WAAA;IACA,qFAAA;EDwgDN;EC3gDI;;IAEE,WAAA;IACA,qFAAA;ED6gDN;EChhDI;;IAEE,WAAA;IACA,qFAAA;EDkhDN;ECrhDI;;IAEE,WAAA;IACA,qFAAA;EDuhDN;EC1hDI;;IAEE,WAAA;IACA,qFAAA;ED4hDN;EC/hDI;;IAEE,WAAA;IACA,qFAAA;EDiiDN;ECpiDI;;IAEE,WAAA;IACA,qFAAA;EDsiDN;ECziDI;;IAEE,WAAA;IACA,qFAAA;ED2iDN;EC9iDI;;IAEE,WAAA;IACA,qFAAA;EDgjDN;ECnjDI;;IAEE,WAAA;IACA,qFAAA;EDqjDN;ECxjDI;;IAEE,WAAA;IACA,qFAAA;ED0jDN;EC7jDI;;IAEE,WAAA;IACA,qFAAA;ED+jDN;EClkDI;;IAEE,WAAA;IACA,qFAAA;EDokDN;ECvkDI;;IAEE,WAAA;IACA,qFAAA;EDykDN;ECrkDE;;IAEE,mBAAA;EDukDJ;ECrkDE;;IAEE,sBAAA;EDukDJ;ECrkDE;;IAEE,qBAAA;EDukDJ;ECrkDE;;IAEE,yBAAA;EDukDJ;ECrkDE;;IAEE,4BAAA;EDukDJ;AACF;ACnmDE;EAEI;;IAEE,WAAA;IACA,oFAAA;EDomDN;ECvmDI;;IAEE,WAAA;IACA,oFAAA;EDymDN;EC5mDI;;IAEE,WAAA;IACA,oFAAA;ED8mDN;ECjnDI;;IAEE,WAAA;IACA,oFAAA;EDmnDN;ECtnDI;;IAEE,WAAA;IACA,oFAAA;EDwnDN;EC3nDI;;IAEE,WAAA;IACA,oFAAA;ED6nDN;EChoDI;;IAEE,WAAA;IACA,oFAAA;EDkoDN;ECroDI;;IAEE,WAAA;IACA,oFAAA;EDuoDN;EC1oDI;;IAEE,WAAA;IACA,oFAAA;ED4oDN;EC/oDI;;IAEE,WAAA;IACA,qFAAA;EDipDN;ECppDI;;IAEE,WAAA;IACA,qFAAA;EDspDN;ECzpDI;;IAEE,WAAA;IACA,qFAAA;ED2pDN;EC9pDI;;IAEE,WAAA;IACA,qFAAA;EDgqDN;ECnqDI;;IAEE,WAAA;IACA,qFAAA;EDqqDN;ECxqDI;;IAEE,WAAA;IACA,qFAAA;ED0qDN;EC7qDI;;IAEE,WAAA;IACA,qFAAA;ED+qDN;EClrDI;;IAEE,WAAA;IACA,qFAAA;EDorDN;ECvrDI;;IAEE,WAAA;IACA,qFAAA;EDyrDN;EC5rDI;;IAEE,WAAA;IACA,qFAAA;ED8rDN;ECjsDI;;IAEE,WAAA;IACA,qFAAA;EDmsDN;ECtsDI;;IAEE,WAAA;IACA,qFAAA;EDwsDN;EC3sDI;;IAEE,WAAA;IACA,qFAAA;ED6sDN;EChtDI;;IAEE,WAAA;IACA,qFAAA;EDktDN;ECrtDI;;IAEE,WAAA;IACA,qFAAA;EDutDN;ECntDE;;IAEE,mBAAA;EDqtDJ;ECntDE;;IAEE,sBAAA;EDqtDJ;ECntDE;;IAEE,qBAAA;EDqtDJ;ECntDE;;IAEE,yBAAA;EDqtDJ;ECntDE;;IAEE,4BAAA;EDqtDJ;AACF;ACjvDE;EAEI;;IAEE,WAAA;IACA,oFAAA;EDkvDN;ECrvDI;;IAEE,WAAA;IACA,oFAAA;EDuvDN;EC1vDI;;IAEE,WAAA;IACA,oFAAA;ED4vDN;EC/vDI;;IAEE,WAAA;IACA,oFAAA;EDiwDN;ECpwDI;;IAEE,WAAA;IACA,oFAAA;EDswDN;ECzwDI;;IAEE,WAAA;IACA,oFAAA;ED2wDN;EC9wDI;;IAEE,WAAA;IACA,oFAAA;EDgxDN;ECnxDI;;IAEE,WAAA;IACA,oFAAA;EDqxDN;ECxxDI;;IAEE,WAAA;IACA,oFAAA;ED0xDN;EC7xDI;;IAEE,WAAA;IACA,qFAAA;ED+xDN;EClyDI;;IAEE,WAAA;IACA,qFAAA;EDoyDN;ECvyDI;;IAEE,WAAA;IACA,qFAAA;EDyyDN;EC5yDI;;IAEE,WAAA;IACA,qFAAA;ED8yDN;ECjzDI;;IAEE,WAAA;IACA,qFAAA;EDmzDN;ECtzDI;;IAEE,WAAA;IACA,qFAAA;EDwzDN;EC3zDI;;IAEE,WAAA;IACA,qFAAA;ED6zDN;ECh0DI;;IAEE,WAAA;IACA,qFAAA;EDk0DN;ECr0DI;;IAEE,WAAA;IACA,qFAAA;EDu0DN;EC10DI;;IAEE,WAAA;IACA,qFAAA;ED40DN;EC/0DI;;IAEE,WAAA;IACA,qFAAA;EDi1DN;ECp1DI;;IAEE,WAAA;IACA,qFAAA;EDs1DN;ECz1DI;;IAEE,WAAA;IACA,qFAAA;ED21DN;EC91DI;;IAEE,WAAA;IACA,qFAAA;EDg2DN;ECn2DI;;IAEE,WAAA;IACA,qFAAA;EDq2DN;ECj2DE;;IAEE,mBAAA;EDm2DJ;ECj2DE;;IAEE,sBAAA;EDm2DJ;ECj2DE;;IAEE,qBAAA;EDm2DJ;ECj2DE;;IAEE,yBAAA;EDm2DJ;ECj2DE;;IAEE,4BAAA;EDm2DJ;AACF;AC/3DE;EAEI;;IAEE,WAAA;IACA,oFAAA;EDg4DN;ECn4DI;;IAEE,WAAA;IACA,oFAAA;EDq4DN;ECx4DI;;IAEE,WAAA;IACA,oFAAA;ED04DN;EC74DI;;IAEE,WAAA;IACA,oFAAA;ED+4DN;ECl5DI;;IAEE,WAAA;IACA,oFAAA;EDo5DN;ECv5DI;;IAEE,WAAA;IACA,oFAAA;EDy5DN;EC55DI;;IAEE,WAAA;IACA,oFAAA;ED85DN;ECj6DI;;IAEE,WAAA;IACA,oFAAA;EDm6DN;ECt6DI;;IAEE,WAAA;IACA,oFAAA;EDw6DN;EC36DI;;IAEE,WAAA;IACA,qFAAA;ED66DN;ECh7DI;;IAEE,WAAA;IACA,qFAAA;EDk7DN;ECr7DI;;IAEE,WAAA;IACA,qFAAA;EDu7DN;EC17DI;;IAEE,WAAA;IACA,qFAAA;ED47DN;EC/7DI;;IAEE,WAAA;IACA,qFAAA;EDi8DN;ECp8DI;;IAEE,WAAA;IACA,qFAAA;EDs8DN;ECz8DI;;IAEE,WAAA;IACA,qFAAA;ED28DN;EC98DI;;IAEE,WAAA;IACA,qFAAA;EDg9DN;ECn9DI;;IAEE,WAAA;IACA,qFAAA;EDq9DN;ECx9DI;;IAEE,WAAA;IACA,qFAAA;ED09DN;EC79DI;;IAEE,WAAA;IACA,qFAAA;ED+9DN;ECl+DI;;IAEE,WAAA;IACA,qFAAA;EDo+DN;ECv+DI;;IAEE,WAAA;IACA,qFAAA;EDy+DN;EC5+DI;;IAEE,WAAA;IACA,qFAAA;ED8+DN;ECj/DI;;IAEE,WAAA;IACA,qFAAA;EDm/DN;EC/+DE;;IAEE,mBAAA;EDi/DJ;EC/+DE;;IAEE,sBAAA;EDi/DJ;EC/+DE;;IAEE,qBAAA;EDi/DJ;EC/+DE;;IAEE,yBAAA;EDi/DJ;EC/+DE;;IAEE,4BAAA;EDi/DJ;AACF;AC7gEE;EAEI;;IAEE,WAAA;IACA,oFAAA;ED8gEN;ECjhEI;;IAEE,WAAA;IACA,oFAAA;EDmhEN;ECthEI;;IAEE,WAAA;IACA,oFAAA;EDwhEN;EC3hEI;;IAEE,WAAA;IACA,oFAAA;ED6hEN;EChiEI;;IAEE,WAAA;IACA,oFAAA;EDkiEN;ECriEI;;IAEE,WAAA;IACA,oFAAA;EDuiEN;EC1iEI;;IAEE,WAAA;IACA,oFAAA;ED4iEN;EC/iEI;;IAEE,WAAA;IACA,oFAAA;EDijEN;ECpjEI;;IAEE,WAAA;IACA,oFAAA;EDsjEN;ECzjEI;;IAEE,WAAA;IACA,qFAAA;ED2jEN;EC9jEI;;IAEE,WAAA;IACA,qFAAA;EDgkEN;ECnkEI;;IAEE,WAAA;IACA,qFAAA;EDqkEN;ECxkEI;;IAEE,WAAA;IACA,qFAAA;ED0kEN;EC7kEI;;IAEE,WAAA;IACA,qFAAA;ED+kEN;ECllEI;;IAEE,WAAA;IACA,qFAAA;EDolEN;ECvlEI;;IAEE,WAAA;IACA,qFAAA;EDylEN;EC5lEI;;IAEE,WAAA;IACA,qFAAA;ED8lEN;ECjmEI;;IAEE,WAAA;IACA,qFAAA;EDmmEN;ECtmEI;;IAEE,WAAA;IACA,qFAAA;EDwmEN;EC3mEI;;IAEE,WAAA;IACA,qFAAA;ED6mEN;EChnEI;;IAEE,WAAA;IACA,qFAAA;EDknEN;ECrnEI;;IAEE,WAAA;IACA,qFAAA;EDunEN;EC1nEI;;IAEE,WAAA;IACA,qFAAA;ED4nEN;EC/nEI;;IAEE,WAAA;IACA,qFAAA;EDioEN;EC7nEE;;IAEE,mBAAA;ED+nEJ;EC7nEE;;IAEE,sBAAA;ED+nEJ;EC7nEE;;IAEE,qBAAA;ED+nEJ;EC7nEE;;IAEE,yBAAA;ED+nEJ;EC7nEE;;IAEE,4BAAA;ED+nEJ;AACF;AC3pEE;EAEI;;IAEE,WAAA;IACA,oFAAA;ED4pEN;EC/pEI;;IAEE,WAAA;IACA,oFAAA;EDiqEN;ECpqEI;;IAEE,WAAA;IACA,oFAAA;EDsqEN;ECzqEI;;IAEE,WAAA;IACA,oFAAA;ED2qEN;EC9qEI;;IAEE,WAAA;IACA,oFAAA;EDgrEN;ECnrEI;;IAEE,WAAA;IACA,oFAAA;EDqrEN;ECxrEI;;IAEE,WAAA;IACA,oFAAA;ED0rEN;EC7rEI;;IAEE,WAAA;IACA,oFAAA;ED+rEN;EClsEI;;IAEE,WAAA;IACA,oFAAA;EDosEN;ECvsEI;;IAEE,WAAA;IACA,qFAAA;EDysEN;EC5sEI;;IAEE,WAAA;IACA,qFAAA;ED8sEN;ECjtEI;;IAEE,WAAA;IACA,qFAAA;EDmtEN;ECttEI;;IAEE,WAAA;IACA,qFAAA;EDwtEN;EC3tEI;;IAEE,WAAA;IACA,qFAAA;ED6tEN;EChuEI;;IAEE,WAAA;IACA,qFAAA;EDkuEN;ECruEI;;IAEE,WAAA;IACA,qFAAA;EDuuEN;EC1uEI;;IAEE,WAAA;IACA,qFAAA;ED4uEN;EC/uEI;;IAEE,WAAA;IACA,qFAAA;EDivEN;ECpvEI;;IAEE,WAAA;IACA,qFAAA;EDsvEN;ECzvEI;;IAEE,WAAA;IACA,qFAAA;ED2vEN;EC9vEI;;IAEE,WAAA;IACA,qFAAA;EDgwEN;ECnwEI;;IAEE,WAAA;IACA,qFAAA;EDqwEN;ECxwEI;;IAEE,WAAA;IACA,qFAAA;ED0wEN;EC7wEI;;IAEE,WAAA;IACA,qFAAA;ED+wEN;EC3wEE;;IAEE,mBAAA;ED6wEJ;EC3wEE;;IAEE,sBAAA;ED6wEJ;EC3wEE;;IAEE,qBAAA;ED6wEJ;EC3wEE;;IAEE,yBAAA;ED6wEJ;EC3wEE;;IAEE,4BAAA;ED6wEJ;AACF;ACxwEE;EAEI;;IAEE,WAAA;IACA,oFAAA;EDywEN;EC5wEI;;IAEE,WAAA;IACA,oFAAA;ED8wEN;ECjxEI;;IAEE,WAAA;IACA,oFAAA;EDmxEN;ECtxEI;;IAEE,WAAA;IACA,oFAAA;EDwxEN;EC3xEI;;IAEE,WAAA;IACA,oFAAA;ED6xEN;EChyEI;;IAEE,WAAA;IACA,oFAAA;EDkyEN;ECryEI;;IAEE,WAAA;IACA,oFAAA;EDuyEN;EC1yEI;;IAEE,WAAA;IACA,oFAAA;ED4yEN;EC/yEI;;IAEE,WAAA;IACA,oFAAA;EDizEN;ECpzEI;;IAEE,WAAA;IACA,qFAAA;EDszEN;ECzzEI;;IAEE,WAAA;IACA,qFAAA;ED2zEN;EC9zEI;;IAEE,WAAA;IACA,qFAAA;EDg0EN;ECn0EI;;IAEE,WAAA;IACA,qFAAA;EDq0EN;ECx0EI;;IAEE,WAAA;IACA,qFAAA;ED00EN;EC70EI;;IAEE,WAAA;IACA,qFAAA;ED+0EN;ECl1EI;;IAEE,WAAA;IACA,qFAAA;EDo1EN;ECv1EI;;IAEE,WAAA;IACA,qFAAA;EDy1EN;EC51EI;;IAEE,WAAA;IACA,qFAAA;ED81EN;ECj2EI;;IAEE,WAAA;IACA,qFAAA;EDm2EN;ECt2EI;;IAEE,WAAA;IACA,qFAAA;EDw2EN;EC32EI;;IAEE,WAAA;IACA,qFAAA;ED62EN;ECh3EI;;IAEE,WAAA;IACA,qFAAA;EDk3EN;ECr3EI;;IAEE,WAAA;IACA,qFAAA;EDu3EN;EC13EI;;IAEE,WAAA;IACA,qFAAA;ED43EN;AACF;ACl4EE;EAEI;;IAEE,WAAA;IACA,oFAAA;EDm4EN;ECt4EI;;IAEE,WAAA;IACA,oFAAA;EDw4EN;EC34EI;;IAEE,WAAA;IACA,oFAAA;ED64EN;ECh5EI;;IAEE,WAAA;IACA,oFAAA;EDk5EN;ECr5EI;;IAEE,WAAA;IACA,oFAAA;EDu5EN;EC15EI;;IAEE,WAAA;IACA,oFAAA;ED45EN;EC/5EI;;IAEE,WAAA;IACA,oFAAA;EDi6EN;ECp6EI;;IAEE,WAAA;IACA,oFAAA;EDs6EN;ECz6EI;;IAEE,WAAA;IACA,oFAAA;ED26EN;EC96EI;;IAEE,WAAA;IACA,qFAAA;EDg7EN;ECn7EI;;IAEE,WAAA;IACA,qFAAA;EDq7EN;ECx7EI;;IAEE,WAAA;IACA,qFAAA;ED07EN;EC77EI;;IAEE,WAAA;IACA,qFAAA;ED+7EN;ECl8EI;;IAEE,WAAA;IACA,qFAAA;EDo8EN;ECv8EI;;IAEE,WAAA;IACA,qFAAA;EDy8EN;EC58EI;;IAEE,WAAA;IACA,qFAAA;ED88EN;ECj9EI;;IAEE,WAAA;IACA,qFAAA;EDm9EN;ECt9EI;;IAEE,WAAA;IACA,qFAAA;EDw9EN;EC39EI;;IAEE,WAAA;IACA,qFAAA;ED69EN;ECh+EI;;IAEE,WAAA;IACA,qFAAA;EDk+EN;ECr+EI;;IAEE,WAAA;IACA,qFAAA;EDu+EN;EC1+EI;;IAEE,WAAA;IACA,qFAAA;ED4+EN;EC/+EI;;IAEE,WAAA;IACA,qFAAA;EDi/EN;ECp/EI;;IAEE,WAAA;IACA,qFAAA;EDs/EN;AACF;AC5/EE;EAEI;;IAEE,WAAA;IACA,oFAAA;ED6/EN;EChgFI;;IAEE,WAAA;IACA,oFAAA;EDkgFN;ECrgFI;;IAEE,WAAA;IACA,oFAAA;EDugFN;EC1gFI;;IAEE,WAAA;IACA,oFAAA;ED4gFN;EC/gFI;;IAEE,WAAA;IACA,oFAAA;EDihFN;ECphFI;;IAEE,WAAA;IACA,oFAAA;EDshFN;ECzhFI;;IAEE,WAAA;IACA,oFAAA;ED2hFN;EC9hFI;;IAEE,WAAA;IACA,oFAAA;EDgiFN;ECniFI;;IAEE,WAAA;IACA,oFAAA;EDqiFN;ECxiFI;;IAEE,WAAA;IACA,qFAAA;ED0iFN;EC7iFI;;IAEE,WAAA;IACA,qFAAA;ED+iFN;ECljFI;;IAEE,WAAA;IACA,qFAAA;EDojFN;ECvjFI;;IAEE,WAAA;IACA,qFAAA;EDyjFN;EC5jFI;;IAEE,WAAA;IACA,qFAAA;ED8jFN;ECjkFI;;IAEE,WAAA;IACA,qFAAA;EDmkFN;ECtkFI;;IAEE,WAAA;IACA,qFAAA;EDwkFN;EC3kFI;;IAEE,WAAA;IACA,qFAAA;ED6kFN;EChlFI;;IAEE,WAAA;IACA,qFAAA;EDklFN;ECrlFI;;IAEE,WAAA;IACA,qFAAA;EDulFN;EC1lFI;;IAEE,WAAA;IACA,qFAAA;ED4lFN;EC/lFI;;IAEE,WAAA;IACA,qFAAA;EDimFN;ECpmFI;;IAEE,WAAA;IACA,qFAAA;EDsmFN;ECzmFI;;IAEE,WAAA;IACA,qFAAA;ED2mFN;EC9mFI;;IAEE,WAAA;IACA,qFAAA;EDgnFN;AACF;ACtnFE;EAEI;;IAEE,WAAA;IACA,oFAAA;EDunFN;EC1nFI;;IAEE,WAAA;IACA,oFAAA;ED4nFN;EC/nFI;;IAEE,WAAA;IACA,oFAAA;EDioFN;ECpoFI;;IAEE,WAAA;IACA,oFAAA;EDsoFN;ECzoFI;;IAEE,WAAA;IACA,oFAAA;ED2oFN;EC9oFI;;IAEE,WAAA;IACA,oFAAA;EDgpFN;ECnpFI;;IAEE,WAAA;IACA,oFAAA;EDqpFN;ECxpFI;;IAEE,WAAA;IACA,oFAAA;ED0pFN;EC7pFI;;IAEE,WAAA;IACA,oFAAA;ED+pFN;EClqFI;;IAEE,WAAA;IACA,qFAAA;EDoqFN;ECvqFI;;IAEE,WAAA;IACA,qFAAA;EDyqFN;EC5qFI;;IAEE,WAAA;IACA,qFAAA;ED8qFN;ECjrFI;;IAEE,WAAA;IACA,qFAAA;EDmrFN;ECtrFI;;IAEE,WAAA;IACA,qFAAA;EDwrFN;EC3rFI;;IAEE,WAAA;IACA,qFAAA;ED6rFN;EChsFI;;IAEE,WAAA;IACA,qFAAA;EDksFN;ECrsFI;;IAEE,WAAA;IACA,qFAAA;EDusFN;EC1sFI;;IAEE,WAAA;IACA,qFAAA;ED4sFN;EC/sFI;;IAEE,WAAA;IACA,qFAAA;EDitFN;ECptFI;;IAEE,WAAA;IACA,qFAAA;EDstFN;ECztFI;;IAEE,WAAA;IACA,qFAAA;ED2tFN;EC9tFI;;IAEE,WAAA;IACA,qFAAA;EDguFN;ECnuFI;;IAEE,WAAA;IACA,qFAAA;EDquFN;ECxuFI;;IAEE,WAAA;IACA,qFAAA;ED0uFN;AACF;AChvFE;EAEI;;IAEE,WAAA;IACA,oFAAA;EDivFN;ECpvFI;;IAEE,WAAA;IACA,oFAAA;EDsvFN;ECzvFI;;IAEE,WAAA;IACA,oFAAA;ED2vFN;EC9vFI;;IAEE,WAAA;IACA,oFAAA;EDgwFN;ECnwFI;;IAEE,WAAA;IACA,oFAAA;EDqwFN;ECxwFI;;IAEE,WAAA;IACA,oFAAA;ED0wFN;EC7wFI;;IAEE,WAAA;IACA,oFAAA;ED+wFN;EClxFI;;IAEE,WAAA;IACA,oFAAA;EDoxFN;ECvxFI;;IAEE,WAAA;IACA,oFAAA;EDyxFN;EC5xFI;;IAEE,WAAA;IACA,qFAAA;ED8xFN;ECjyFI;;IAEE,WAAA;IACA,qFAAA;EDmyFN;ECtyFI;;IAEE,WAAA;IACA,qFAAA;EDwyFN;EC3yFI;;IAEE,WAAA;IACA,qFAAA;ED6yFN;EChzFI;;IAEE,WAAA;IACA,qFAAA;EDkzFN;ECrzFI;;IAEE,WAAA;IACA,qFAAA;EDuzFN;EC1zFI;;IAEE,WAAA;IACA,qFAAA;ED4zFN;EC/zFI;;IAEE,WAAA;IACA,qFAAA;EDi0FN;ECp0FI;;IAEE,WAAA;IACA,qFAAA;EDs0FN;ECz0FI;;IAEE,WAAA;IACA,qFAAA;ED20FN;EC90FI;;IAEE,WAAA;IACA,qFAAA;EDg1FN;ECn1FI;;IAEE,WAAA;IACA,qFAAA;EDq1FN;ECx1FI;;IAEE,WAAA;IACA,qFAAA;ED01FN;EC71FI;;IAEE,WAAA;IACA,qFAAA;ED+1FN;ECl2FI;;IAEE,WAAA;IACA,qFAAA;EDo2FN;AACF;AC12FE;EAEI;;IAEE,WAAA;IACA,oFAAA;ED22FN;EC92FI;;IAEE,WAAA;IACA,oFAAA;EDg3FN;ECn3FI;;IAEE,WAAA;IACA,oFAAA;EDq3FN;ECx3FI;;IAEE,WAAA;IACA,oFAAA;ED03FN;EC73FI;;IAEE,WAAA;IACA,oFAAA;ED+3FN;ECl4FI;;IAEE,WAAA;IACA,oFAAA;EDo4FN;ECv4FI;;IAEE,WAAA;IACA,oFAAA;EDy4FN;EC54FI;;IAEE,WAAA;IACA,oFAAA;ED84FN;ECj5FI;;IAEE,WAAA;IACA,oFAAA;EDm5FN;ECt5FI;;IAEE,WAAA;IACA,qFAAA;EDw5FN;EC35FI;;IAEE,WAAA;IACA,qFAAA;ED65FN;ECh6FI;;IAEE,WAAA;IACA,qFAAA;EDk6FN;ECr6FI;;IAEE,WAAA;IACA,qFAAA;EDu6FN;EC16FI;;IAEE,WAAA;IACA,qFAAA;ED46FN;EC/6FI;;IAEE,WAAA;IACA,qFAAA;EDi7FN;ECp7FI;;IAEE,WAAA;IACA,qFAAA;EDs7FN;ECz7FI;;IAEE,WAAA;IACA,qFAAA;ED27FN;EC97FI;;IAEE,WAAA;IACA,qFAAA;EDg8FN;ECn8FI;;IAEE,WAAA;IACA,qFAAA;EDq8FN;ECx8FI;;IAEE,WAAA;IACA,qFAAA;ED08FN;EC78FI;;IAEE,WAAA;IACA,qFAAA;ED+8FN;ECl9FI;;IAEE,WAAA;IACA,qFAAA;EDo9FN;ECv9FI;;IAEE,WAAA;IACA,qFAAA;EDy9FN;EC59FI;;IAEE,WAAA;IACA,qFAAA;ED89FN;AACF;AAhiGA,iCAAA;ACmFI;EAUA;;;IAEE,0BAAA;EDw8FJ;ECt8FE;;;IAEE,oBAPS;EDg9Fb;ECv8FE;;;IAEE,kBAXS;EDq9Fb;ECp9FE;;;IAEE,0BAAA;EDu9FJ;ECr9FE;;;IAEE,oBAPS;ED+9Fb;ECt9FE;;;IAEE,kBAXS;EDo+Fb;ECn+FE;;;IAEE,0BAAA;EDs+FJ;ECp+FE;;;IAEE,oBAPS;ED8+Fb;ECr+FE;;;IAEE,kBAXS;EDm/Fb;ECl/FE;;;IAEE,0BAAA;EDq/FJ;ECn/FE;;;IAEE,oBAPS;ED6/Fb;ECp/FE;;;IAEE,kBAXS;EDkgGb;ECjgGE;;;IAEE,0BAAA;EDogGJ;EClgGE;;;IAEE,oBAPS;ED4gGb;ECngGE;;;IAEE,kBAXS;EDihGb;EChhGE;;;IAEE,0BAAA;EDmhGJ;ECjhGE;;;IAEE,oBAPS;ED2hGb;EClhGE;;;IAEE,kBAXS;EDgiGb;EC/hGE;;;IAEE,0BAAA;EDkiGJ;EChiGE;;;IAEE,oBAPS;ED0iGb;ECjiGE;;;IAEE,kBAXS;ED+iGb;EC9iGE;;;IAEE,0BAAA;EDijGJ;EC/iGE;;;IAEE,oBAPS;EDyjGb;EChjGE;;;IAEE,kBAXS;ED8jGb;EC7jGE;;;IAEE,0BAAA;EDgkGJ;EC9jGE;;;IAEE,oBAPS;EDwkGb;EC/jGE;;;IAEE,kBAXS;ED6kGb;EC5kGE;;;IAEE,4BAAA;ED+kGJ;EC7kGE;;;IAEE,qBAPS;EDulGb;EC9kGE;;;IAEE,mBAXS;ED4lGb;EC3lGE;;;IAEE,4BAAA;ED8lGJ;EC5lGE;;;IAEE,qBAPS;EDsmGb;EC7lGE;;;IAEE,mBAXS;ED2mGb;EC1mGE;;;IAEE,4BAAA;ED6mGJ;EC3mGE;;;IAEE,qBAPS;EDqnGb;EC5mGE;;;IAEE,mBAXS;ED0nGb;ECznGE;;;IAEE,4BAAA;ED4nGJ;EC1nGE;;;IAEE,qBAPS;EDooGb;EC3nGE;;;IAEE,mBAXS;EDyoGb;ECxoGE;;;IAEE,4BAAA;ED2oGJ;ECzoGE;;;IAEE,qBAPS;EDmpGb;EC1oGE;;;IAEE,mBAXS;EDwpGb;ECvpGE;;;IAEE,4BAAA;ED0pGJ;ECxpGE;;;IAEE,qBAPS;EDkqGb;ECzpGE;;;IAEE,mBAXS;EDuqGb;ECtqGE;;;IAEE,4BAAA;EDyqGJ;ECvqGE;;;IAEE,qBAPS;EDirGb;ECxqGE;;;IAEE,mBAXS;EDsrGb;ECrrGE;;;IAEE,4BAAA;EDwrGJ;ECtrGE;;;IAEE,qBAPS;EDgsGb;ECvrGE;;;IAEE,mBAXS;EDqsGb;ECpsGE;;;IAEE,4BAAA;EDusGJ;ECrsGE;;;IAEE,qBAPS;ED+sGb;ECtsGE;;;IAEE,mBAXS;EDotGb;ECntGE;;;IAEE,4BAAA;EDstGJ;ECptGE;;;IAEE,qBAPS;ED8tGb;ECrtGE;;;IAEE,mBAXS;EDmuGb;ECluGE;;;IAEE,4BAAA;EDquGJ;ECnuGE;;;IAEE,qBAPS;ED6uGb;ECpuGE;;;IAEE,mBAXS;EDkvGb;ECjvGE;;;IAEE,4BAAA;EDovGJ;EClvGE;;;IAEE,qBAPS;ED4vGb;ECnvGE;;;IAEE,mBAXS;EDiwGb;EChwGE;;;IAEE,4BAAA;EDmwGJ;ECjwGE;;;IAEE,qBAPS;ED2wGb;EClwGE;;;IAEE,mBAXS;EDgxGb;EC/wGE;;;IAEE,4BAAA;EDkxGJ;EChxGE;;;IAEE,qBAPS;ED0xGb;ECjxGE;;;IAEE,mBAXS;ED+xGb;EC9xGE;;;IAEE,4BAAA;EDiyGJ;EC/xGE;;;IAEE,qBAPS;EDyyGb;EChyGE;;;IAEE,mBAXS;ED8yGb;ECz4GE;;;IAEE,6CAAA;ED44GJ;EC14GE;;;IAEE,uBAAA;ED64GJ;EC34GE;;;IAEE,QAXS;EDy5Gb;EC54GE;;;IAEE,SAAA;ED+4GJ;EC75GE;;;IAEE,6CAAA;EDg6GJ;EC95GE;;;IAEE,uBAAA;EDi6GJ;EC/5GE;;;IAEE,QAXS;ED66Gb;ECh6GE;;;IAEE,SAAA;EDm6GJ;ECj7GE;;;IAEE,6CAAA;EDo7GJ;ECl7GE;;;IAEE,uBAAA;EDq7GJ;ECn7GE;;;IAEE,QAXS;EDi8Gb;ECp7GE;;;IAEE,SAAA;EDu7GJ;ECr8GE;;;IAEE,6CAAA;EDw8GJ;ECt8GE;;;IAEE,uBAAA;EDy8GJ;ECv8GE;;;IAEE,QAXS;EDq9Gb;ECx8GE;;;IAEE,SAAA;ED28GJ;ECz9GE;;;IAEE,6CAAA;ED49GJ;EC19GE;;;IAEE,uBAAA;ED69GJ;EC39GE;;;IAEE,QAXS;EDy+Gb;EC59GE;;;IAEE,SAAA;ED+9GJ;EC7+GE;;;IAEE,6CAAA;EDg/GJ;EC9+GE;;;IAEE,uBAAA;EDi/GJ;EC/+GE;;;IAEE,QAXS;ED6/Gb;ECh/GE;;;IAEE,SAAA;EDm/GJ;ECjgHE;;;IAEE,6CAAA;EDogHJ;EClgHE;;;IAEE,uBAAA;EDqgHJ;ECngHE;;;IAEE,QAXS;EDihHb;ECpgHE;;;IAEE,SAAA;EDugHJ;ECrhHE;;;IAEE,6CAAA;EDwhHJ;ECthHE;;;IAEE,uBAAA;EDyhHJ;ECvhHE;;;IAEE,QAXS;EDqiHb;ECxhHE;;;IAEE,SAAA;ED2hHJ;ECziHE;;;IAEE,6CAAA;ED4iHJ;EC1iHE;;;IAEE,uBAAA;ED6iHJ;EC3iHE;;;IAEE,QAXS;EDyjHb;EC5iHE;;;IAEE,SAAA;ED+iHJ;EC7jHE;;;IAEE,8CAAA;EDgkHJ;EC9jHE;;;IAEE,yBAAA;EDikHJ;EC/jHE;;;IAEE,SAXS;ED6kHb;EChkHE;;;IAEE,SAAA;EDmkHJ;ECjlHE;;;IAEE,8CAAA;EDolHJ;ECllHE;;;IAEE,yBAAA;EDqlHJ;ECnlHE;;;IAEE,SAXS;EDimHb;ECplHE;;;IAEE,SAAA;EDulHJ;ECrmHE;;;IAEE,8CAAA;EDwmHJ;ECtmHE;;;IAEE,yBAAA;EDymHJ;ECvmHE;;;IAEE,SAXS;EDqnHb;ECxmHE;;;IAEE,SAAA;ED2mHJ;ECznHE;;;IAEE,8CAAA;ED4nHJ;EC1nHE;;;IAEE,yBAAA;ED6nHJ;EC3nHE;;;IAEE,SAXS;EDyoHb;EC5nHE;;;IAEE,SAAA;ED+nHJ;EC7oHE;;;IAEE,8CAAA;EDgpHJ;EC9oHE;;;IAEE,yBAAA;EDipHJ;EC/oHE;;;IAEE,SAXS;ED6pHb;EChpHE;;;IAEE,SAAA;EDmpHJ;ECjqHE;;;IAEE,8CAAA;EDoqHJ;EClqHE;;;IAEE,yBAAA;EDqqHJ;ECnqHE;;;IAEE,SAXS;EDirHb;ECpqHE;;;IAEE,SAAA;EDuqHJ;ECrrHE;;;IAEE,8CAAA;EDwrHJ;ECtrHE;;;IAEE,yBAAA;EDyrHJ;ECvrHE;;;IAEE,SAXS;EDqsHb;ECxrHE;;;IAEE,SAAA;ED2rHJ;ECzsHE;;;IAEE,8CAAA;ED4sHJ;EC1sHE;;;IAEE,yBAAA;ED6sHJ;EC3sHE;;;IAEE,SAXS;EDytHb;EC5sHE;;;IAEE,SAAA;ED+sHJ;EC7tHE;;;IAEE,8CAAA;EDguHJ;EC9tHE;;;IAEE,yBAAA;EDiuHJ;EC/tHE;;;IAEE,SAXS;ED6uHb;EChuHE;;;IAEE,SAAA;EDmuHJ;ECjvHE;;;IAEE,8CAAA;EDovHJ;EClvHE;;;IAEE,yBAAA;EDqvHJ;ECnvHE;;;IAEE,SAXS;EDiwHb;ECpvHE;;;IAEE,SAAA;EDuvHJ;ECrwHE;;;IAEE,8CAAA;EDwwHJ;ECtwHE;;;IAEE,yBAAA;EDywHJ;ECvwHE;;;IAEE,SAXS;EDqxHb;ECxwHE;;;IAEE,SAAA;ED2wHJ;ECzxHE;;;IAEE,8CAAA;ED4xHJ;EC1xHE;;;IAEE,yBAAA;ED6xHJ;EC3xHE;;;IAEE,SAXS;EDyyHb;EC5xHE;;;IAEE,SAAA;ED+xHJ;EC7yHE;;;IAEE,8CAAA;EDgzHJ;EC9yHE;;;IAEE,yBAAA;EDizHJ;EC/yHE;;;IAEE,SAXS;ED6zHb;EChzHE;;;IAEE,SAAA;EDmzHJ;ECj0HE;;;IAEE,8CAAA;EDo0HJ;ECl0HE;;;IAEE,yBAAA;EDq0HJ;ECn0HE;;;IAEE,SAXS;EDi1Hb;ECp0HE;;;IAEE,SAAA;EDu0HJ;ECr1HE;;;IAEE,8CAAA;EDw1HJ;ECt1HE;;;IAEE,yBAAA;EDy1HJ;ECv1HE;;;IAEE,SAXS;EDq2Hb;ECx1HE;;;IAEE,SAAA;ED21HJ;ECz2HE;;;IAEE,8CAAA;ED42HJ;EC12HE;;;IAEE,yBAAA;ED62HJ;EC32HE;;;IAEE,SAXS;EDy3Hb;EC52HE;;;IAEE,SAAA;ED+2HJ;EC73HE;;;IAEE,8CAAA;EDg4HJ;EC93HE;;;IAEE,yBAAA;EDi4HJ;EC/3HE;;;IAEE,SAXS;ED64Hb;ECh4HE;;;IAEE,SAAA;EDm4HJ;ECj5HE;;;IAEE,8CAAA;EDo5HJ;ECl5HE;;;IAEE,yBAAA;EDq5HJ;ECn5HE;;;IAEE,SAXS;EDi6Hb;ECp5HE;;;IAEE,SAAA;EDu5HJ;ECr6HE;;;IAEE,8CAAA;EDw6HJ;ECt6HE;;;IAEE,yBAAA;EDy6HJ;ECv6HE;;;IAEE,SAXS;EDq7Hb;ECx6HE;;;IAEE,SAAA;ED26HJ;ECz7HE;;;IAEE,8CAAA;ED47HJ;EC17HE;;;IAEE,yBAAA;ED67HJ;EC37HE;;;IAEE,SAXS;EDy8Hb;EC57HE;;;IAEE,SAAA;ED+7HJ;EC78HE;;;IAEE,8CAAA;EDg9HJ;EC98HE;;;IAEE,yBAAA;EDi9HJ;EC/8HE;;;IAEE,SAXS;ED69Hb;ECh9HE;;;IAEE,SAAA;EDm9HJ;ECj+HE;;;IAEE,8CAAA;EDo+HJ;ECl+HE;;;IAEE,yBAAA;EDq+HJ;ECn+HE;;;IAEE,SAXS;EDi/Hb;ECp+HE;;;IAEE,SAAA;EDu+HJ;ECr/HE;;;IAEE,8CAAA;EDw/HJ;ECt/HE;;;IAEE,yBAAA;EDy/HJ;ECv/HE;;;IAEE,SAXS;EDqgIb;ECx/HE;;;IAEE,SAAA;ED2/HJ;ECzgIE;;;IAEE,8CAAA;ED4gIJ;EC1gIE;;;IAEE,yBAAA;ED6gIJ;EC3gIE;;;IAEE,SAXS;EDyhIb;EC5gIE;;;IAEE,SAAA;ED+gIJ;EC7hIE;;;IAEE,8CAAA;EDgiIJ;EC9hIE;;;IAEE,yBAAA;EDiiIJ;EC/hIE;;;IAEE,SAXS;ED6iIb;EChiIE;;;IAEE,SAAA;EDmiIJ;ECjjIE;;;IAEE,8CAAA;EDojIJ;ECljIE;;;IAEE,yBAAA;EDqjIJ;ECnjIE;;;IAEE,SAXS;EDikIb;ECpjIE;;;IAEE,SAAA;EDujIJ;ECrkIE;;;IAEE,8CAAA;EDwkIJ;ECtkIE;;;IAEE,yBAAA;EDykIJ;ECvkIE;;;IAEE,SAXS;EDqlIb;ECxkIE;;;IAEE,SAAA;ED2kIJ;ECzlIE;;;IAEE,8CAAA;ED4lIJ;EC1lIE;;;IAEE,yBAAA;ED6lIJ;EC3lIE;;;IAEE,SAXS;EDymIb;EC5lIE;;;IAEE,SAAA;ED+lIJ;EC7mIE;;;IAEE,8CAAA;EDgnIJ;EC9mIE;;;IAEE,yBAAA;EDinIJ;EC/mIE;;;IAEE,SAXS;ED6nIb;EChnIE;;;IAEE,SAAA;EDmnIJ;ECjoIE;;;IAEE,8CAAA;EDooIJ;ECloIE;;;IAEE,yBAAA;EDqoIJ;ECnoIE;;;IAEE,SAXS;EDipIb;ECpoIE;;;IAEE,SAAA;EDuoIJ;ECrpIE;;;IAEE,8CAAA;EDwpIJ;ECtpIE;;;IAEE,yBAAA;EDypIJ;ECvpIE;;;IAEE,SAXS;EDqqIb;ECxpIE;;;IAEE,SAAA;ED2pIJ;ECzqIE;;;IAEE,8CAAA;ED4qIJ;EC1qIE;;;IAEE,yBAAA;ED6qIJ;EC3qIE;;;IAEE,SAXS;EDyrIb;EC5qIE;;;IAEE,SAAA;ED+qIJ;EC7rIE;;;IAEE,8CAAA;EDgsIJ;EC9rIE;;;IAEE,yBAAA;EDisIJ;EC/rIE;;;IAEE,SAXS;ED6sIb;EChsIE;;;IAEE,SAAA;EDmsIJ;ECjtIE;;;IAEE,8CAAA;EDotIJ;ECltIE;;;IAEE,yBAAA;EDqtIJ;ECntIE;;;IAEE,SAXS;EDiuIb;ECptIE;;;IAEE,SAAA;EDutIJ;ECruIE;;;IAEE,8CAAA;EDwuIJ;ECtuIE;;;IAEE,yBAAA;EDyuIJ;ECvuIE;;;IAEE,SAXS;EDqvIb;ECxuIE;;;IAEE,SAAA;ED2uIJ;ECzvIE;;;IAEE,8CAAA;ED4vIJ;EC1vIE;;;IAEE,yBAAA;ED6vIJ;EC3vIE;;;IAEE,SAXS;EDywIb;EC5vIE;;;IAEE,SAAA;ED+vIJ;EC7wIE;;;IAEE,8CAAA;EDgxIJ;EC9wIE;;;IAEE,yBAAA;EDixIJ;EC/wIE;;;IAEE,SAXS;ED6xIb;EChxIE;;;IAEE,SAAA;EDmxIJ;ECjyIE;;;IAEE,8CAAA;EDoyIJ;EClyIE;;;IAEE,yBAAA;EDqyIJ;ECnyIE;;;IAEE,SAXS;EDizIb;ECpyIE;;;IAEE,SAAA;EDuyIJ;ECrzIE;;;IAEE,8CAAA;EDwzIJ;ECtzIE;;;IAEE,yBAAA;EDyzIJ;ECvzIE;;;IAEE,SAXS;EDq0Ib;ECxzIE;;;IAEE,SAAA;ED2zIJ;ECz0IE;;;IAEE,8CAAA;ED40IJ;EC10IE;;;IAEE,yBAAA;ED60IJ;EC30IE;;;IAEE,SAXS;EDy1Ib;EC50IE;;;IAEE,SAAA;ED+0IJ;EC71IE;;;IAEE,8CAAA;EDg2IJ;EC91IE;;;IAEE,yBAAA;EDi2IJ;EC/1IE;;;IAEE,SAXS;ED62Ib;ECh2IE;;;IAEE,SAAA;EDm2IJ;EC71IA;;IACE,cAAA;EDg2IF;AACF;ACpyII;EAUA;;;IAEE,0BAAA;ED8xIJ;EC5xIE;;;IAEE,oBAPS;EDsyIb;EC7xIE;;;IAEE,kBAXS;ED2yIb;EC1yIE;;;IAEE,0BAAA;ED6yIJ;EC3yIE;;;IAEE,oBAPS;EDqzIb;EC5yIE;;;IAEE,kBAXS;ED0zIb;ECzzIE;;;IAEE,0BAAA;ED4zIJ;EC1zIE;;;IAEE,oBAPS;EDo0Ib;EC3zIE;;;IAEE,kBAXS;EDy0Ib;ECx0IE;;;IAEE,0BAAA;ED20IJ;ECz0IE;;;IAEE,oBAPS;EDm1Ib;EC10IE;;;IAEE,kBAXS;EDw1Ib;ECv1IE;;;IAEE,0BAAA;ED01IJ;ECx1IE;;;IAEE,oBAPS;EDk2Ib;ECz1IE;;;IAEE,kBAXS;EDu2Ib;ECt2IE;;;IAEE,0BAAA;EDy2IJ;ECv2IE;;;IAEE,oBAPS;EDi3Ib;ECx2IE;;;IAEE,kBAXS;EDs3Ib;ECr3IE;;;IAEE,0BAAA;EDw3IJ;ECt3IE;;;IAEE,oBAPS;EDg4Ib;ECv3IE;;;IAEE,kBAXS;EDq4Ib;ECp4IE;;;IAEE,0BAAA;EDu4IJ;ECr4IE;;;IAEE,oBAPS;ED+4Ib;ECt4IE;;;IAEE,kBAXS;EDo5Ib;ECn5IE;;;IAEE,0BAAA;EDs5IJ;ECp5IE;;;IAEE,oBAPS;ED85Ib;ECr5IE;;;IAEE,kBAXS;EDm6Ib;ECl6IE;;;IAEE,4BAAA;EDq6IJ;ECn6IE;;;IAEE,qBAPS;ED66Ib;ECp6IE;;;IAEE,mBAXS;EDk7Ib;ECj7IE;;;IAEE,4BAAA;EDo7IJ;ECl7IE;;;IAEE,qBAPS;ED47Ib;ECn7IE;;;IAEE,mBAXS;EDi8Ib;ECh8IE;;;IAEE,4BAAA;EDm8IJ;ECj8IE;;;IAEE,qBAPS;ED28Ib;ECl8IE;;;IAEE,mBAXS;EDg9Ib;EC/8IE;;;IAEE,4BAAA;EDk9IJ;ECh9IE;;;IAEE,qBAPS;ED09Ib;ECj9IE;;;IAEE,mBAXS;ED+9Ib;EC99IE;;;IAEE,4BAAA;EDi+IJ;EC/9IE;;;IAEE,qBAPS;EDy+Ib;ECh+IE;;;IAEE,mBAXS;ED8+Ib;EC7+IE;;;IAEE,4BAAA;EDg/IJ;EC9+IE;;;IAEE,qBAPS;EDw/Ib;EC/+IE;;;IAEE,mBAXS;ED6/Ib;EC5/IE;;;IAEE,4BAAA;ED+/IJ;EC7/IE;;;IAEE,qBAPS;EDugJb;EC9/IE;;;IAEE,mBAXS;ED4gJb;EC3gJE;;;IAEE,4BAAA;ED8gJJ;EC5gJE;;;IAEE,qBAPS;EDshJb;EC7gJE;;;IAEE,mBAXS;ED2hJb;EC1hJE;;;IAEE,4BAAA;ED6hJJ;EC3hJE;;;IAEE,qBAPS;EDqiJb;EC5hJE;;;IAEE,mBAXS;ED0iJb;ECziJE;;;IAEE,4BAAA;ED4iJJ;EC1iJE;;;IAEE,qBAPS;EDojJb;EC3iJE;;;IAEE,mBAXS;EDyjJb;ECxjJE;;;IAEE,4BAAA;ED2jJJ;ECzjJE;;;IAEE,qBAPS;EDmkJb;EC1jJE;;;IAEE,mBAXS;EDwkJb;ECvkJE;;;IAEE,4BAAA;ED0kJJ;ECxkJE;;;IAEE,qBAPS;EDklJb;ECzkJE;;;IAEE,mBAXS;EDulJb;ECtlJE;;;IAEE,4BAAA;EDylJJ;ECvlJE;;;IAEE,qBAPS;EDimJb;ECxlJE;;;IAEE,mBAXS;EDsmJb;ECrmJE;;;IAEE,4BAAA;EDwmJJ;ECtmJE;;;IAEE,qBAPS;EDgnJb;ECvmJE;;;IAEE,mBAXS;EDqnJb;ECpnJE;;;IAEE,4BAAA;EDunJJ;ECrnJE;;;IAEE,qBAPS;ED+nJb;ECtnJE;;;IAEE,mBAXS;EDooJb;EC/tJE;;;IAEE,6CAAA;EDkuJJ;EChuJE;;;IAEE,uBAAA;EDmuJJ;ECjuJE;;;IAEE,QAXS;ED+uJb;ECluJE;;;IAEE,SAAA;EDquJJ;ECnvJE;;;IAEE,6CAAA;EDsvJJ;ECpvJE;;;IAEE,uBAAA;EDuvJJ;ECrvJE;;;IAEE,QAXS;EDmwJb;ECtvJE;;;IAEE,SAAA;EDyvJJ;ECvwJE;;;IAEE,6CAAA;ED0wJJ;ECxwJE;;;IAEE,uBAAA;ED2wJJ;ECzwJE;;;IAEE,QAXS;EDuxJb;EC1wJE;;;IAEE,SAAA;ED6wJJ;EC3xJE;;;IAEE,6CAAA;ED8xJJ;EC5xJE;;;IAEE,uBAAA;ED+xJJ;EC7xJE;;;IAEE,QAXS;ED2yJb;EC9xJE;;;IAEE,SAAA;EDiyJJ;EC/yJE;;;IAEE,6CAAA;EDkzJJ;EChzJE;;;IAEE,uBAAA;EDmzJJ;ECjzJE;;;IAEE,QAXS;ED+zJb;EClzJE;;;IAEE,SAAA;EDqzJJ;ECn0JE;;;IAEE,6CAAA;EDs0JJ;ECp0JE;;;IAEE,uBAAA;EDu0JJ;ECr0JE;;;IAEE,QAXS;EDm1Jb;ECt0JE;;;IAEE,SAAA;EDy0JJ;ECv1JE;;;IAEE,6CAAA;ED01JJ;ECx1JE;;;IAEE,uBAAA;ED21JJ;ECz1JE;;;IAEE,QAXS;EDu2Jb;EC11JE;;;IAEE,SAAA;ED61JJ;EC32JE;;;IAEE,6CAAA;ED82JJ;EC52JE;;;IAEE,uBAAA;ED+2JJ;EC72JE;;;IAEE,QAXS;ED23Jb;EC92JE;;;IAEE,SAAA;EDi3JJ;EC/3JE;;;IAEE,6CAAA;EDk4JJ;ECh4JE;;;IAEE,uBAAA;EDm4JJ;ECj4JE;;;IAEE,QAXS;ED+4Jb;ECl4JE;;;IAEE,SAAA;EDq4JJ;ECn5JE;;;IAEE,8CAAA;EDs5JJ;ECp5JE;;;IAEE,yBAAA;EDu5JJ;ECr5JE;;;IAEE,SAXS;EDm6Jb;ECt5JE;;;IAEE,SAAA;EDy5JJ;ECv6JE;;;IAEE,8CAAA;ED06JJ;ECx6JE;;;IAEE,yBAAA;ED26JJ;ECz6JE;;;IAEE,SAXS;EDu7Jb;EC16JE;;;IAEE,SAAA;ED66JJ;EC37JE;;;IAEE,8CAAA;ED87JJ;EC57JE;;;IAEE,yBAAA;ED+7JJ;EC77JE;;;IAEE,SAXS;ED28Jb;EC97JE;;;IAEE,SAAA;EDi8JJ;EC/8JE;;;IAEE,8CAAA;EDk9JJ;ECh9JE;;;IAEE,yBAAA;EDm9JJ;ECj9JE;;;IAEE,SAXS;ED+9Jb;ECl9JE;;;IAEE,SAAA;EDq9JJ;ECn+JE;;;IAEE,8CAAA;EDs+JJ;ECp+JE;;;IAEE,yBAAA;EDu+JJ;ECr+JE;;;IAEE,SAXS;EDm/Jb;ECt+JE;;;IAEE,SAAA;EDy+JJ;ECv/JE;;;IAEE,8CAAA;ED0/JJ;ECx/JE;;;IAEE,yBAAA;ED2/JJ;ECz/JE;;;IAEE,SAXS;EDugKb;EC1/JE;;;IAEE,SAAA;ED6/JJ;EC3gKE;;;IAEE,8CAAA;ED8gKJ;EC5gKE;;;IAEE,yBAAA;ED+gKJ;EC7gKE;;;IAEE,SAXS;ED2hKb;EC9gKE;;;IAEE,SAAA;EDihKJ;EC/hKE;;;IAEE,8CAAA;EDkiKJ;EChiKE;;;IAEE,yBAAA;EDmiKJ;ECjiKE;;;IAEE,SAXS;ED+iKb;ECliKE;;;IAEE,SAAA;EDqiKJ;ECnjKE;;;IAEE,8CAAA;EDsjKJ;ECpjKE;;;IAEE,yBAAA;EDujKJ;ECrjKE;;;IAEE,SAXS;EDmkKb;ECtjKE;;;IAEE,SAAA;EDyjKJ;ECvkKE;;;IAEE,8CAAA;ED0kKJ;ECxkKE;;;IAEE,yBAAA;ED2kKJ;ECzkKE;;;IAEE,SAXS;EDulKb;EC1kKE;;;IAEE,SAAA;ED6kKJ;EC3lKE;;;IAEE,8CAAA;ED8lKJ;EC5lKE;;;IAEE,yBAAA;ED+lKJ;EC7lKE;;;IAEE,SAXS;ED2mKb;EC9lKE;;;IAEE,SAAA;EDimKJ;EC/mKE;;;IAEE,8CAAA;EDknKJ;EChnKE;;;IAEE,yBAAA;EDmnKJ;ECjnKE;;;IAEE,SAXS;ED+nKb;EClnKE;;;IAEE,SAAA;EDqnKJ;ECnoKE;;;IAEE,8CAAA;EDsoKJ;ECpoKE;;;IAEE,yBAAA;EDuoKJ;ECroKE;;;IAEE,SAXS;EDmpKb;ECtoKE;;;IAEE,SAAA;EDyoKJ;ECvpKE;;;IAEE,8CAAA;ED0pKJ;ECxpKE;;;IAEE,yBAAA;ED2pKJ;ECzpKE;;;IAEE,SAXS;EDuqKb;EC1pKE;;;IAEE,SAAA;ED6pKJ;EC3qKE;;;IAEE,8CAAA;ED8qKJ;EC5qKE;;;IAEE,yBAAA;ED+qKJ;EC7qKE;;;IAEE,SAXS;ED2rKb;EC9qKE;;;IAEE,SAAA;EDirKJ;EC/rKE;;;IAEE,8CAAA;EDksKJ;EChsKE;;;IAEE,yBAAA;EDmsKJ;ECjsKE;;;IAEE,SAXS;ED+sKb;EClsKE;;;IAEE,SAAA;EDqsKJ;ECntKE;;;IAEE,8CAAA;EDstKJ;ECptKE;;;IAEE,yBAAA;EDutKJ;ECrtKE;;;IAEE,SAXS;EDmuKb;ECttKE;;;IAEE,SAAA;EDytKJ;ECvuKE;;;IAEE,8CAAA;ED0uKJ;ECxuKE;;;IAEE,yBAAA;ED2uKJ;ECzuKE;;;IAEE,SAXS;EDuvKb;EC1uKE;;;IAEE,SAAA;ED6uKJ;EC3vKE;;;IAEE,8CAAA;ED8vKJ;EC5vKE;;;IAEE,yBAAA;ED+vKJ;EC7vKE;;;IAEE,SAXS;ED2wKb;EC9vKE;;;IAEE,SAAA;EDiwKJ;EC/wKE;;;IAEE,8CAAA;EDkxKJ;EChxKE;;;IAEE,yBAAA;EDmxKJ;ECjxKE;;;IAEE,SAXS;ED+xKb;EClxKE;;;IAEE,SAAA;EDqxKJ;ECnyKE;;;IAEE,8CAAA;EDsyKJ;ECpyKE;;;IAEE,yBAAA;EDuyKJ;ECryKE;;;IAEE,SAXS;EDmzKb;ECtyKE;;;IAEE,SAAA;EDyyKJ;ECvzKE;;;IAEE,8CAAA;ED0zKJ;ECxzKE;;;IAEE,yBAAA;ED2zKJ;ECzzKE;;;IAEE,SAXS;EDu0Kb;EC1zKE;;;IAEE,SAAA;ED6zKJ;EC30KE;;;IAEE,8CAAA;ED80KJ;EC50KE;;;IAEE,yBAAA;ED+0KJ;EC70KE;;;IAEE,SAXS;ED21Kb;EC90KE;;;IAEE,SAAA;EDi1KJ;EC/1KE;;;IAEE,8CAAA;EDk2KJ;ECh2KE;;;IAEE,yBAAA;EDm2KJ;ECj2KE;;;IAEE,SAXS;ED+2Kb;ECl2KE;;;IAEE,SAAA;EDq2KJ;ECn3KE;;;IAEE,8CAAA;EDs3KJ;ECp3KE;;;IAEE,yBAAA;EDu3KJ;ECr3KE;;;IAEE,SAXS;EDm4Kb;ECt3KE;;;IAEE,SAAA;EDy3KJ;ECv4KE;;;IAEE,8CAAA;ED04KJ;ECx4KE;;;IAEE,yBAAA;ED24KJ;ECz4KE;;;IAEE,SAXS;EDu5Kb;EC14KE;;;IAEE,SAAA;ED64KJ;EC35KE;;;IAEE,8CAAA;ED85KJ;EC55KE;;;IAEE,yBAAA;ED+5KJ;EC75KE;;;IAEE,SAXS;ED26Kb;EC95KE;;;IAEE,SAAA;EDi6KJ;EC/6KE;;;IAEE,8CAAA;EDk7KJ;ECh7KE;;;IAEE,yBAAA;EDm7KJ;ECj7KE;;;IAEE,SAXS;ED+7Kb;ECl7KE;;;IAEE,SAAA;EDq7KJ;ECn8KE;;;IAEE,8CAAA;EDs8KJ;ECp8KE;;;IAEE,yBAAA;EDu8KJ;ECr8KE;;;IAEE,SAXS;EDm9Kb;ECt8KE;;;IAEE,SAAA;EDy8KJ;ECv9KE;;;IAEE,8CAAA;ED09KJ;ECx9KE;;;IAEE,yBAAA;ED29KJ;ECz9KE;;;IAEE,SAXS;EDu+Kb;EC19KE;;;IAEE,SAAA;ED69KJ;EC3+KE;;;IAEE,8CAAA;ED8+KJ;EC5+KE;;;IAEE,yBAAA;ED++KJ;EC7+KE;;;IAEE,SAXS;ED2/Kb;EC9+KE;;;IAEE,SAAA;EDi/KJ;EC//KE;;;IAEE,8CAAA;EDkgLJ;EChgLE;;;IAEE,yBAAA;EDmgLJ;ECjgLE;;;IAEE,SAXS;ED+gLb;EClgLE;;;IAEE,SAAA;EDqgLJ;ECnhLE;;;IAEE,8CAAA;EDshLJ;ECphLE;;;IAEE,yBAAA;EDuhLJ;ECrhLE;;;IAEE,SAXS;EDmiLb;ECthLE;;;IAEE,SAAA;EDyhLJ;ECviLE;;;IAEE,8CAAA;ED0iLJ;ECxiLE;;;IAEE,yBAAA;ED2iLJ;ECziLE;;;IAEE,SAXS;EDujLb;EC1iLE;;;IAEE,SAAA;ED6iLJ;EC3jLE;;;IAEE,8CAAA;ED8jLJ;EC5jLE;;;IAEE,yBAAA;ED+jLJ;EC7jLE;;;IAEE,SAXS;ED2kLb;EC9jLE;;;IAEE,SAAA;EDikLJ;EC/kLE;;;IAEE,8CAAA;EDklLJ;EChlLE;;;IAEE,yBAAA;EDmlLJ;ECjlLE;;;IAEE,SAXS;ED+lLb;ECllLE;;;IAEE,SAAA;EDqlLJ;ECnmLE;;;IAEE,8CAAA;EDsmLJ;ECpmLE;;;IAEE,yBAAA;EDumLJ;ECrmLE;;;IAEE,SAXS;EDmnLb;ECtmLE;;;IAEE,SAAA;EDymLJ;ECvnLE;;;IAEE,8CAAA;ED0nLJ;ECxnLE;;;IAEE,yBAAA;ED2nLJ;ECznLE;;;IAEE,SAXS;EDuoLb;EC1nLE;;;IAEE,SAAA;ED6nLJ;EC3oLE;;;IAEE,8CAAA;ED8oLJ;EC5oLE;;;IAEE,yBAAA;ED+oLJ;EC7oLE;;;IAEE,SAXS;ED2pLb;EC9oLE;;;IAEE,SAAA;EDipLJ;EC/pLE;;;IAEE,8CAAA;EDkqLJ;EChqLE;;;IAEE,yBAAA;EDmqLJ;ECjqLE;;;IAEE,SAXS;ED+qLb;EClqLE;;;IAEE,SAAA;EDqqLJ;ECnrLE;;;IAEE,8CAAA;EDsrLJ;ECprLE;;;IAEE,yBAAA;EDurLJ;ECrrLE;;;IAEE,SAXS;EDmsLb;ECtrLE;;;IAEE,SAAA;EDyrLJ;ECnrLA;;IACE,cAAA;EDsrLF;AACF;AC1nLI;EAUA;;;IAEE,0BAAA;EDonLJ;EClnLE;;;IAEE,oBAPS;ED4nLb;ECnnLE;;;IAEE,kBAXS;EDioLb;EChoLE;;;IAEE,0BAAA;EDmoLJ;ECjoLE;;;IAEE,oBAPS;ED2oLb;ECloLE;;;IAEE,kBAXS;EDgpLb;EC/oLE;;;IAEE,0BAAA;EDkpLJ;EChpLE;;;IAEE,oBAPS;ED0pLb;ECjpLE;;;IAEE,kBAXS;ED+pLb;EC9pLE;;;IAEE,0BAAA;EDiqLJ;EC/pLE;;;IAEE,oBAPS;EDyqLb;EChqLE;;;IAEE,kBAXS;ED8qLb;EC7qLE;;;IAEE,0BAAA;EDgrLJ;EC9qLE;;;IAEE,oBAPS;EDwrLb;EC/qLE;;;IAEE,kBAXS;ED6rLb;EC5rLE;;;IAEE,0BAAA;ED+rLJ;EC7rLE;;;IAEE,oBAPS;EDusLb;EC9rLE;;;IAEE,kBAXS;ED4sLb;EC3sLE;;;IAEE,0BAAA;ED8sLJ;EC5sLE;;;IAEE,oBAPS;EDstLb;EC7sLE;;;IAEE,kBAXS;ED2tLb;EC1tLE;;;IAEE,0BAAA;ED6tLJ;EC3tLE;;;IAEE,oBAPS;EDquLb;EC5tLE;;;IAEE,kBAXS;ED0uLb;ECzuLE;;;IAEE,0BAAA;ED4uLJ;EC1uLE;;;IAEE,oBAPS;EDovLb;EC3uLE;;;IAEE,kBAXS;EDyvLb;ECxvLE;;;IAEE,4BAAA;ED2vLJ;ECzvLE;;;IAEE,qBAPS;EDmwLb;EC1vLE;;;IAEE,mBAXS;EDwwLb;ECvwLE;;;IAEE,4BAAA;ED0wLJ;ECxwLE;;;IAEE,qBAPS;EDkxLb;ECzwLE;;;IAEE,mBAXS;EDuxLb;ECtxLE;;;IAEE,4BAAA;EDyxLJ;ECvxLE;;;IAEE,qBAPS;EDiyLb;ECxxLE;;;IAEE,mBAXS;EDsyLb;ECryLE;;;IAEE,4BAAA;EDwyLJ;ECtyLE;;;IAEE,qBAPS;EDgzLb;ECvyLE;;;IAEE,mBAXS;EDqzLb;ECpzLE;;;IAEE,4BAAA;EDuzLJ;ECrzLE;;;IAEE,qBAPS;ED+zLb;ECtzLE;;;IAEE,mBAXS;EDo0Lb;ECn0LE;;;IAEE,4BAAA;EDs0LJ;ECp0LE;;;IAEE,qBAPS;ED80Lb;ECr0LE;;;IAEE,mBAXS;EDm1Lb;ECl1LE;;;IAEE,4BAAA;EDq1LJ;ECn1LE;;;IAEE,qBAPS;ED61Lb;ECp1LE;;;IAEE,mBAXS;EDk2Lb;ECj2LE;;;IAEE,4BAAA;EDo2LJ;ECl2LE;;;IAEE,qBAPS;ED42Lb;ECn2LE;;;IAEE,mBAXS;EDi3Lb;ECh3LE;;;IAEE,4BAAA;EDm3LJ;ECj3LE;;;IAEE,qBAPS;ED23Lb;ECl3LE;;;IAEE,mBAXS;EDg4Lb;EC/3LE;;;IAEE,4BAAA;EDk4LJ;ECh4LE;;;IAEE,qBAPS;ED04Lb;ECj4LE;;;IAEE,mBAXS;ED+4Lb;EC94LE;;;IAEE,4BAAA;EDi5LJ;EC/4LE;;;IAEE,qBAPS;EDy5Lb;ECh5LE;;;IAEE,mBAXS;ED85Lb;EC75LE;;;IAEE,4BAAA;EDg6LJ;EC95LE;;;IAEE,qBAPS;EDw6Lb;EC/5LE;;;IAEE,mBAXS;ED66Lb;EC56LE;;;IAEE,4BAAA;ED+6LJ;EC76LE;;;IAEE,qBAPS;EDu7Lb;EC96LE;;;IAEE,mBAXS;ED47Lb;EC37LE;;;IAEE,4BAAA;ED87LJ;EC57LE;;;IAEE,qBAPS;EDs8Lb;EC77LE;;;IAEE,mBAXS;ED28Lb;EC18LE;;;IAEE,4BAAA;ED68LJ;EC38LE;;;IAEE,qBAPS;EDq9Lb;EC58LE;;;IAEE,mBAXS;ED09Lb;ECrjME;;;IAEE,6CAAA;EDwjMJ;ECtjME;;;IAEE,uBAAA;EDyjMJ;ECvjME;;;IAEE,QAXS;EDqkMb;ECxjME;;;IAEE,SAAA;ED2jMJ;ECzkME;;;IAEE,6CAAA;ED4kMJ;EC1kME;;;IAEE,uBAAA;ED6kMJ;EC3kME;;;IAEE,QAXS;EDylMb;EC5kME;;;IAEE,SAAA;ED+kMJ;EC7lME;;;IAEE,6CAAA;EDgmMJ;EC9lME;;;IAEE,uBAAA;EDimMJ;EC/lME;;;IAEE,QAXS;ED6mMb;EChmME;;;IAEE,SAAA;EDmmMJ;ECjnME;;;IAEE,6CAAA;EDonMJ;EClnME;;;IAEE,uBAAA;EDqnMJ;ECnnME;;;IAEE,QAXS;EDioMb;ECpnME;;;IAEE,SAAA;EDunMJ;ECroME;;;IAEE,6CAAA;EDwoMJ;ECtoME;;;IAEE,uBAAA;EDyoMJ;ECvoME;;;IAEE,QAXS;EDqpMb;ECxoME;;;IAEE,SAAA;ED2oMJ;ECzpME;;;IAEE,6CAAA;ED4pMJ;EC1pME;;;IAEE,uBAAA;ED6pMJ;EC3pME;;;IAEE,QAXS;EDyqMb;EC5pME;;;IAEE,SAAA;ED+pMJ;EC7qME;;;IAEE,6CAAA;EDgrMJ;EC9qME;;;IAEE,uBAAA;EDirMJ;EC/qME;;;IAEE,QAXS;ED6rMb;EChrME;;;IAEE,SAAA;EDmrMJ;ECjsME;;;IAEE,6CAAA;EDosMJ;EClsME;;;IAEE,uBAAA;EDqsMJ;ECnsME;;;IAEE,QAXS;EDitMb;ECpsME;;;IAEE,SAAA;EDusMJ;ECrtME;;;IAEE,6CAAA;EDwtMJ;ECttME;;;IAEE,uBAAA;EDytMJ;ECvtME;;;IAEE,QAXS;EDquMb;ECxtME;;;IAEE,SAAA;ED2tMJ;ECzuME;;;IAEE,8CAAA;ED4uMJ;EC1uME;;;IAEE,yBAAA;ED6uMJ;EC3uME;;;IAEE,SAXS;EDyvMb;EC5uME;;;IAEE,SAAA;ED+uMJ;EC7vME;;;IAEE,8CAAA;EDgwMJ;EC9vME;;;IAEE,yBAAA;EDiwMJ;EC/vME;;;IAEE,SAXS;ED6wMb;EChwME;;;IAEE,SAAA;EDmwMJ;ECjxME;;;IAEE,8CAAA;EDoxMJ;EClxME;;;IAEE,yBAAA;EDqxMJ;ECnxME;;;IAEE,SAXS;EDiyMb;ECpxME;;;IAEE,SAAA;EDuxMJ;ECryME;;;IAEE,8CAAA;EDwyMJ;ECtyME;;;IAEE,yBAAA;EDyyMJ;ECvyME;;;IAEE,SAXS;EDqzMb;ECxyME;;;IAEE,SAAA;ED2yMJ;ECzzME;;;IAEE,8CAAA;ED4zMJ;EC1zME;;;IAEE,yBAAA;ED6zMJ;EC3zME;;;IAEE,SAXS;EDy0Mb;EC5zME;;;IAEE,SAAA;ED+zMJ;EC70ME;;;IAEE,8CAAA;EDg1MJ;EC90ME;;;IAEE,yBAAA;EDi1MJ;EC/0ME;;;IAEE,SAXS;ED61Mb;ECh1ME;;;IAEE,SAAA;EDm1MJ;ECj2ME;;;IAEE,8CAAA;EDo2MJ;ECl2ME;;;IAEE,yBAAA;EDq2MJ;ECn2ME;;;IAEE,SAXS;EDi3Mb;ECp2ME;;;IAEE,SAAA;EDu2MJ;ECr3ME;;;IAEE,8CAAA;EDw3MJ;ECt3ME;;;IAEE,yBAAA;EDy3MJ;ECv3ME;;;IAEE,SAXS;EDq4Mb;ECx3ME;;;IAEE,SAAA;ED23MJ;ECz4ME;;;IAEE,8CAAA;ED44MJ;EC14ME;;;IAEE,yBAAA;ED64MJ;EC34ME;;;IAEE,SAXS;EDy5Mb;EC54ME;;;IAEE,SAAA;ED+4MJ;EC75ME;;;IAEE,8CAAA;EDg6MJ;EC95ME;;;IAEE,yBAAA;EDi6MJ;EC/5ME;;;IAEE,SAXS;ED66Mb;ECh6ME;;;IAEE,SAAA;EDm6MJ;ECj7ME;;;IAEE,8CAAA;EDo7MJ;ECl7ME;;;IAEE,yBAAA;EDq7MJ;ECn7ME;;;IAEE,SAXS;EDi8Mb;ECp7ME;;;IAEE,SAAA;EDu7MJ;ECr8ME;;;IAEE,8CAAA;EDw8MJ;ECt8ME;;;IAEE,yBAAA;EDy8MJ;ECv8ME;;;IAEE,SAXS;EDq9Mb;ECx8ME;;;IAEE,SAAA;ED28MJ;ECz9ME;;;IAEE,8CAAA;ED49MJ;EC19ME;;;IAEE,yBAAA;ED69MJ;EC39ME;;;IAEE,SAXS;EDy+Mb;EC59ME;;;IAEE,SAAA;ED+9MJ;EC7+ME;;;IAEE,8CAAA;EDg/MJ;EC9+ME;;;IAEE,yBAAA;EDi/MJ;EC/+ME;;;IAEE,SAXS;ED6/Mb;ECh/ME;;;IAEE,SAAA;EDm/MJ;ECjgNE;;;IAEE,8CAAA;EDogNJ;EClgNE;;;IAEE,yBAAA;EDqgNJ;ECngNE;;;IAEE,SAXS;EDihNb;ECpgNE;;;IAEE,SAAA;EDugNJ;ECrhNE;;;IAEE,8CAAA;EDwhNJ;ECthNE;;;IAEE,yBAAA;EDyhNJ;ECvhNE;;;IAEE,SAXS;EDqiNb;ECxhNE;;;IAEE,SAAA;ED2hNJ;ECziNE;;;IAEE,8CAAA;ED4iNJ;EC1iNE;;;IAEE,yBAAA;ED6iNJ;EC3iNE;;;IAEE,SAXS;EDyjNb;EC5iNE;;;IAEE,SAAA;ED+iNJ;EC7jNE;;;IAEE,8CAAA;EDgkNJ;EC9jNE;;;IAEE,yBAAA;EDikNJ;EC/jNE;;;IAEE,SAXS;ED6kNb;EChkNE;;;IAEE,SAAA;EDmkNJ;ECjlNE;;;IAEE,8CAAA;EDolNJ;ECllNE;;;IAEE,yBAAA;EDqlNJ;ECnlNE;;;IAEE,SAXS;EDimNb;ECplNE;;;IAEE,SAAA;EDulNJ;ECrmNE;;;IAEE,8CAAA;EDwmNJ;ECtmNE;;;IAEE,yBAAA;EDymNJ;ECvmNE;;;IAEE,SAXS;EDqnNb;ECxmNE;;;IAEE,SAAA;ED2mNJ;ECznNE;;;IAEE,8CAAA;ED4nNJ;EC1nNE;;;IAEE,yBAAA;ED6nNJ;EC3nNE;;;IAEE,SAXS;EDyoNb;EC5nNE;;;IAEE,SAAA;ED+nNJ;EC7oNE;;;IAEE,8CAAA;EDgpNJ;EC9oNE;;;IAEE,yBAAA;EDipNJ;EC/oNE;;;IAEE,SAXS;ED6pNb;EChpNE;;;IAEE,SAAA;EDmpNJ;ECjqNE;;;IAEE,8CAAA;EDoqNJ;EClqNE;;;IAEE,yBAAA;EDqqNJ;ECnqNE;;;IAEE,SAXS;EDirNb;ECpqNE;;;IAEE,SAAA;EDuqNJ;ECrrNE;;;IAEE,8CAAA;EDwrNJ;ECtrNE;;;IAEE,yBAAA;EDyrNJ;ECvrNE;;;IAEE,SAXS;EDqsNb;ECxrNE;;;IAEE,SAAA;ED2rNJ;ECzsNE;;;IAEE,8CAAA;ED4sNJ;EC1sNE;;;IAEE,yBAAA;ED6sNJ;EC3sNE;;;IAEE,SAXS;EDytNb;EC5sNE;;;IAEE,SAAA;ED+sNJ;EC7tNE;;;IAEE,8CAAA;EDguNJ;EC9tNE;;;IAEE,yBAAA;EDiuNJ;EC/tNE;;;IAEE,SAXS;ED6uNb;EChuNE;;;IAEE,SAAA;EDmuNJ;ECjvNE;;;IAEE,8CAAA;EDovNJ;EClvNE;;;IAEE,yBAAA;EDqvNJ;ECnvNE;;;IAEE,SAXS;EDiwNb;ECpvNE;;;IAEE,SAAA;EDuvNJ;ECrwNE;;;IAEE,8CAAA;EDwwNJ;ECtwNE;;;IAEE,yBAAA;EDywNJ;ECvwNE;;;IAEE,SAXS;EDqxNb;ECxwNE;;;IAEE,SAAA;ED2wNJ;ECzxNE;;;IAEE,8CAAA;ED4xNJ;EC1xNE;;;IAEE,yBAAA;ED6xNJ;EC3xNE;;;IAEE,SAXS;EDyyNb;EC5xNE;;;IAEE,SAAA;ED+xNJ;EC7yNE;;;IAEE,8CAAA;EDgzNJ;EC9yNE;;;IAEE,yBAAA;EDizNJ;EC/yNE;;;IAEE,SAXS;ED6zNb;EChzNE;;;IAEE,SAAA;EDmzNJ;ECj0NE;;;IAEE,8CAAA;EDo0NJ;ECl0NE;;;IAEE,yBAAA;EDq0NJ;ECn0NE;;;IAEE,SAXS;EDi1Nb;ECp0NE;;;IAEE,SAAA;EDu0NJ;ECr1NE;;;IAEE,8CAAA;EDw1NJ;ECt1NE;;;IAEE,yBAAA;EDy1NJ;ECv1NE;;;IAEE,SAXS;EDq2Nb;ECx1NE;;;IAEE,SAAA;ED21NJ;ECz2NE;;;IAEE,8CAAA;ED42NJ;EC12NE;;;IAEE,yBAAA;ED62NJ;EC32NE;;;IAEE,SAXS;EDy3Nb;EC52NE;;;IAEE,SAAA;ED+2NJ;EC73NE;;;IAEE,8CAAA;EDg4NJ;EC93NE;;;IAEE,yBAAA;EDi4NJ;EC/3NE;;;IAEE,SAXS;ED64Nb;ECh4NE;;;IAEE,SAAA;EDm4NJ;ECj5NE;;;IAEE,8CAAA;EDo5NJ;ECl5NE;;;IAEE,yBAAA;EDq5NJ;ECn5NE;;;IAEE,SAXS;EDi6Nb;ECp5NE;;;IAEE,SAAA;EDu5NJ;ECr6NE;;;IAEE,8CAAA;EDw6NJ;ECt6NE;;;IAEE,yBAAA;EDy6NJ;ECv6NE;;;IAEE,SAXS;EDq7Nb;ECx6NE;;;IAEE,SAAA;ED26NJ;ECz7NE;;;IAEE,8CAAA;ED47NJ;EC17NE;;;IAEE,yBAAA;ED67NJ;EC37NE;;;IAEE,SAXS;EDy8Nb;EC57NE;;;IAEE,SAAA;ED+7NJ;EC78NE;;;IAEE,8CAAA;EDg9NJ;EC98NE;;;IAEE,yBAAA;EDi9NJ;EC/8NE;;;IAEE,SAXS;ED69Nb;ECh9NE;;;IAEE,SAAA;EDm9NJ;ECj+NE;;;IAEE,8CAAA;EDo+NJ;ECl+NE;;;IAEE,yBAAA;EDq+NJ;ECn+NE;;;IAEE,SAXS;EDi/Nb;ECp+NE;;;IAEE,SAAA;EDu+NJ;ECr/NE;;;IAEE,8CAAA;EDw/NJ;ECt/NE;;;IAEE,yBAAA;EDy/NJ;ECv/NE;;;IAEE,SAXS;EDqgOb;ECx/NE;;;IAEE,SAAA;ED2/NJ;ECzgOE;;;IAEE,8CAAA;ED4gOJ;EC1gOE;;;IAEE,yBAAA;ED6gOJ;EC3gOE;;;IAEE,SAXS;EDyhOb;EC5gOE;;;IAEE,SAAA;ED+gOJ;ECzgOA;;IACE,cAAA;ED4gOF;AACF;ACh9NI;EAUA;;;IAEE,0BAAA;ED08NJ;ECx8NE;;;IAEE,oBAPS;EDk9Nb;ECz8NE;;;IAEE,kBAXS;EDu9Nb;ECt9NE;;;IAEE,0BAAA;EDy9NJ;ECv9NE;;;IAEE,oBAPS;EDi+Nb;ECx9NE;;;IAEE,kBAXS;EDs+Nb;ECr+NE;;;IAEE,0BAAA;EDw+NJ;ECt+NE;;;IAEE,oBAPS;EDg/Nb;ECv+NE;;;IAEE,kBAXS;EDq/Nb;ECp/NE;;;IAEE,0BAAA;EDu/NJ;ECr/NE;;;IAEE,oBAPS;ED+/Nb;ECt/NE;;;IAEE,kBAXS;EDogOb;ECngOE;;;IAEE,0BAAA;EDsgOJ;ECpgOE;;;IAEE,oBAPS;ED8gOb;ECrgOE;;;IAEE,kBAXS;EDmhOb;EClhOE;;;IAEE,0BAAA;EDqhOJ;ECnhOE;;;IAEE,oBAPS;ED6hOb;ECphOE;;;IAEE,kBAXS;EDkiOb;ECjiOE;;;IAEE,0BAAA;EDoiOJ;ECliOE;;;IAEE,oBAPS;ED4iOb;ECniOE;;;IAEE,kBAXS;EDijOb;EChjOE;;;IAEE,0BAAA;EDmjOJ;ECjjOE;;;IAEE,oBAPS;ED2jOb;ECljOE;;;IAEE,kBAXS;EDgkOb;EC/jOE;;;IAEE,0BAAA;EDkkOJ;EChkOE;;;IAEE,oBAPS;ED0kOb;ECjkOE;;;IAEE,kBAXS;ED+kOb;EC9kOE;;;IAEE,4BAAA;EDilOJ;EC/kOE;;;IAEE,qBAPS;EDylOb;EChlOE;;;IAEE,mBAXS;ED8lOb;EC7lOE;;;IAEE,4BAAA;EDgmOJ;EC9lOE;;;IAEE,qBAPS;EDwmOb;EC/lOE;;;IAEE,mBAXS;ED6mOb;EC5mOE;;;IAEE,4BAAA;ED+mOJ;EC7mOE;;;IAEE,qBAPS;EDunOb;EC9mOE;;;IAEE,mBAXS;ED4nOb;EC3nOE;;;IAEE,4BAAA;ED8nOJ;EC5nOE;;;IAEE,qBAPS;EDsoOb;EC7nOE;;;IAEE,mBAXS;ED2oOb;EC1oOE;;;IAEE,4BAAA;ED6oOJ;EC3oOE;;;IAEE,qBAPS;EDqpOb;EC5oOE;;;IAEE,mBAXS;ED0pOb;ECzpOE;;;IAEE,4BAAA;ED4pOJ;EC1pOE;;;IAEE,qBAPS;EDoqOb;EC3pOE;;;IAEE,mBAXS;EDyqOb;ECxqOE;;;IAEE,4BAAA;ED2qOJ;ECzqOE;;;IAEE,qBAPS;EDmrOb;EC1qOE;;;IAEE,mBAXS;EDwrOb;ECvrOE;;;IAEE,4BAAA;ED0rOJ;ECxrOE;;;IAEE,qBAPS;EDksOb;ECzrOE;;;IAEE,mBAXS;EDusOb;ECtsOE;;;IAEE,4BAAA;EDysOJ;ECvsOE;;;IAEE,qBAPS;EDitOb;ECxsOE;;;IAEE,mBAXS;EDstOb;ECrtOE;;;IAEE,4BAAA;EDwtOJ;ECttOE;;;IAEE,qBAPS;EDguOb;ECvtOE;;;IAEE,mBAXS;EDquOb;ECpuOE;;;IAEE,4BAAA;EDuuOJ;ECruOE;;;IAEE,qBAPS;ED+uOb;ECtuOE;;;IAEE,mBAXS;EDovOb;ECnvOE;;;IAEE,4BAAA;EDsvOJ;ECpvOE;;;IAEE,qBAPS;ED8vOb;ECrvOE;;;IAEE,mBAXS;EDmwOb;EClwOE;;;IAEE,4BAAA;EDqwOJ;ECnwOE;;;IAEE,qBAPS;ED6wOb;ECpwOE;;;IAEE,mBAXS;EDkxOb;ECjxOE;;;IAEE,4BAAA;EDoxOJ;EClxOE;;;IAEE,qBAPS;ED4xOb;ECnxOE;;;IAEE,mBAXS;EDiyOb;EChyOE;;;IAEE,4BAAA;EDmyOJ;ECjyOE;;;IAEE,qBAPS;ED2yOb;EClyOE;;;IAEE,mBAXS;EDgzOb;EC34OE;;;IAEE,6CAAA;ED84OJ;EC54OE;;;IAEE,uBAAA;ED+4OJ;EC74OE;;;IAEE,QAXS;ED25Ob;EC94OE;;;IAEE,SAAA;EDi5OJ;EC/5OE;;;IAEE,6CAAA;EDk6OJ;ECh6OE;;;IAEE,uBAAA;EDm6OJ;ECj6OE;;;IAEE,QAXS;ED+6Ob;ECl6OE;;;IAEE,SAAA;EDq6OJ;ECn7OE;;;IAEE,6CAAA;EDs7OJ;ECp7OE;;;IAEE,uBAAA;EDu7OJ;ECr7OE;;;IAEE,QAXS;EDm8Ob;ECt7OE;;;IAEE,SAAA;EDy7OJ;ECv8OE;;;IAEE,6CAAA;ED08OJ;ECx8OE;;;IAEE,uBAAA;ED28OJ;ECz8OE;;;IAEE,QAXS;EDu9Ob;EC18OE;;;IAEE,SAAA;ED68OJ;EC39OE;;;IAEE,6CAAA;ED89OJ;EC59OE;;;IAEE,uBAAA;ED+9OJ;EC79OE;;;IAEE,QAXS;ED2+Ob;EC99OE;;;IAEE,SAAA;EDi+OJ;EC/+OE;;;IAEE,6CAAA;EDk/OJ;ECh/OE;;;IAEE,uBAAA;EDm/OJ;ECj/OE;;;IAEE,QAXS;ED+/Ob;ECl/OE;;;IAEE,SAAA;EDq/OJ;ECngPE;;;IAEE,6CAAA;EDsgPJ;ECpgPE;;;IAEE,uBAAA;EDugPJ;ECrgPE;;;IAEE,QAXS;EDmhPb;ECtgPE;;;IAEE,SAAA;EDygPJ;ECvhPE;;;IAEE,6CAAA;ED0hPJ;ECxhPE;;;IAEE,uBAAA;ED2hPJ;ECzhPE;;;IAEE,QAXS;EDuiPb;EC1hPE;;;IAEE,SAAA;ED6hPJ;EC3iPE;;;IAEE,6CAAA;ED8iPJ;EC5iPE;;;IAEE,uBAAA;ED+iPJ;EC7iPE;;;IAEE,QAXS;ED2jPb;EC9iPE;;;IAEE,SAAA;EDijPJ;EC/jPE;;;IAEE,8CAAA;EDkkPJ;EChkPE;;;IAEE,yBAAA;EDmkPJ;ECjkPE;;;IAEE,SAXS;ED+kPb;EClkPE;;;IAEE,SAAA;EDqkPJ;ECnlPE;;;IAEE,8CAAA;EDslPJ;ECplPE;;;IAEE,yBAAA;EDulPJ;ECrlPE;;;IAEE,SAXS;EDmmPb;ECtlPE;;;IAEE,SAAA;EDylPJ;ECvmPE;;;IAEE,8CAAA;ED0mPJ;ECxmPE;;;IAEE,yBAAA;ED2mPJ;ECzmPE;;;IAEE,SAXS;EDunPb;EC1mPE;;;IAEE,SAAA;ED6mPJ;EC3nPE;;;IAEE,8CAAA;ED8nPJ;EC5nPE;;;IAEE,yBAAA;ED+nPJ;EC7nPE;;;IAEE,SAXS;ED2oPb;EC9nPE;;;IAEE,SAAA;EDioPJ;EC/oPE;;;IAEE,8CAAA;EDkpPJ;EChpPE;;;IAEE,yBAAA;EDmpPJ;ECjpPE;;;IAEE,SAXS;ED+pPb;EClpPE;;;IAEE,SAAA;EDqpPJ;ECnqPE;;;IAEE,8CAAA;EDsqPJ;ECpqPE;;;IAEE,yBAAA;EDuqPJ;ECrqPE;;;IAEE,SAXS;EDmrPb;ECtqPE;;;IAEE,SAAA;EDyqPJ;ECvrPE;;;IAEE,8CAAA;ED0rPJ;ECxrPE;;;IAEE,yBAAA;ED2rPJ;ECzrPE;;;IAEE,SAXS;EDusPb;EC1rPE;;;IAEE,SAAA;ED6rPJ;EC3sPE;;;IAEE,8CAAA;ED8sPJ;EC5sPE;;;IAEE,yBAAA;ED+sPJ;EC7sPE;;;IAEE,SAXS;ED2tPb;EC9sPE;;;IAEE,SAAA;EDitPJ;EC/tPE;;;IAEE,8CAAA;EDkuPJ;EChuPE;;;IAEE,yBAAA;EDmuPJ;ECjuPE;;;IAEE,SAXS;ED+uPb;ECluPE;;;IAEE,SAAA;EDquPJ;ECnvPE;;;IAEE,8CAAA;EDsvPJ;ECpvPE;;;IAEE,yBAAA;EDuvPJ;ECrvPE;;;IAEE,SAXS;EDmwPb;ECtvPE;;;IAEE,SAAA;EDyvPJ;ECvwPE;;;IAEE,8CAAA;ED0wPJ;ECxwPE;;;IAEE,yBAAA;ED2wPJ;ECzwPE;;;IAEE,SAXS;EDuxPb;EC1wPE;;;IAEE,SAAA;ED6wPJ;EC3xPE;;;IAEE,8CAAA;ED8xPJ;EC5xPE;;;IAEE,yBAAA;ED+xPJ;EC7xPE;;;IAEE,SAXS;ED2yPb;EC9xPE;;;IAEE,SAAA;EDiyPJ;EC/yPE;;;IAEE,8CAAA;EDkzPJ;EChzPE;;;IAEE,yBAAA;EDmzPJ;ECjzPE;;;IAEE,SAXS;ED+zPb;EClzPE;;;IAEE,SAAA;EDqzPJ;ECn0PE;;;IAEE,8CAAA;EDs0PJ;ECp0PE;;;IAEE,yBAAA;EDu0PJ;ECr0PE;;;IAEE,SAXS;EDm1Pb;ECt0PE;;;IAEE,SAAA;EDy0PJ;ECv1PE;;;IAEE,8CAAA;ED01PJ;ECx1PE;;;IAEE,yBAAA;ED21PJ;ECz1PE;;;IAEE,SAXS;EDu2Pb;EC11PE;;;IAEE,SAAA;ED61PJ;EC32PE;;;IAEE,8CAAA;ED82PJ;EC52PE;;;IAEE,yBAAA;ED+2PJ;EC72PE;;;IAEE,SAXS;ED23Pb;EC92PE;;;IAEE,SAAA;EDi3PJ;EC/3PE;;;IAEE,8CAAA;EDk4PJ;ECh4PE;;;IAEE,yBAAA;EDm4PJ;ECj4PE;;;IAEE,SAXS;ED+4Pb;ECl4PE;;;IAEE,SAAA;EDq4PJ;ECn5PE;;;IAEE,8CAAA;EDs5PJ;ECp5PE;;;IAEE,yBAAA;EDu5PJ;ECr5PE;;;IAEE,SAXS;EDm6Pb;ECt5PE;;;IAEE,SAAA;EDy5PJ;ECv6PE;;;IAEE,8CAAA;ED06PJ;ECx6PE;;;IAEE,yBAAA;ED26PJ;ECz6PE;;;IAEE,SAXS;EDu7Pb;EC16PE;;;IAEE,SAAA;ED66PJ;EC37PE;;;IAEE,8CAAA;ED87PJ;EC57PE;;;IAEE,yBAAA;ED+7PJ;EC77PE;;;IAEE,SAXS;ED28Pb;EC97PE;;;IAEE,SAAA;EDi8PJ;EC/8PE;;;IAEE,8CAAA;EDk9PJ;ECh9PE;;;IAEE,yBAAA;EDm9PJ;ECj9PE;;;IAEE,SAXS;ED+9Pb;ECl9PE;;;IAEE,SAAA;EDq9PJ;ECn+PE;;;IAEE,8CAAA;EDs+PJ;ECp+PE;;;IAEE,yBAAA;EDu+PJ;ECr+PE;;;IAEE,SAXS;EDm/Pb;ECt+PE;;;IAEE,SAAA;EDy+PJ;ECv/PE;;;IAEE,8CAAA;ED0/PJ;ECx/PE;;;IAEE,yBAAA;ED2/PJ;ECz/PE;;;IAEE,SAXS;EDugQb;EC1/PE;;;IAEE,SAAA;ED6/PJ;EC3gQE;;;IAEE,8CAAA;ED8gQJ;EC5gQE;;;IAEE,yBAAA;ED+gQJ;EC7gQE;;;IAEE,SAXS;ED2hQb;EC9gQE;;;IAEE,SAAA;EDihQJ;EC/hQE;;;IAEE,8CAAA;EDkiQJ;EChiQE;;;IAEE,yBAAA;EDmiQJ;ECjiQE;;;IAEE,SAXS;ED+iQb;ECliQE;;;IAEE,SAAA;EDqiQJ;ECnjQE;;;IAEE,8CAAA;EDsjQJ;ECpjQE;;;IAEE,yBAAA;EDujQJ;ECrjQE;;;IAEE,SAXS;EDmkQb;ECtjQE;;;IAEE,SAAA;EDyjQJ;ECvkQE;;;IAEE,8CAAA;ED0kQJ;ECxkQE;;;IAEE,yBAAA;ED2kQJ;ECzkQE;;;IAEE,SAXS;EDulQb;EC1kQE;;;IAEE,SAAA;ED6kQJ;EC3lQE;;;IAEE,8CAAA;ED8lQJ;EC5lQE;;;IAEE,yBAAA;ED+lQJ;EC7lQE;;;IAEE,SAXS;ED2mQb;EC9lQE;;;IAEE,SAAA;EDimQJ;EC/mQE;;;IAEE,8CAAA;EDknQJ;EChnQE;;;IAEE,yBAAA;EDmnQJ;ECjnQE;;;IAEE,SAXS;ED+nQb;EClnQE;;;IAEE,SAAA;EDqnQJ;ECnoQE;;;IAEE,8CAAA;EDsoQJ;ECpoQE;;;IAEE,yBAAA;EDuoQJ;ECroQE;;;IAEE,SAXS;EDmpQb;ECtoQE;;;IAEE,SAAA;EDyoQJ;ECvpQE;;;IAEE,8CAAA;ED0pQJ;ECxpQE;;;IAEE,yBAAA;ED2pQJ;ECzpQE;;;IAEE,SAXS;EDuqQb;EC1pQE;;;IAEE,SAAA;ED6pQJ;EC3qQE;;;IAEE,8CAAA;ED8qQJ;EC5qQE;;;IAEE,yBAAA;ED+qQJ;EC7qQE;;;IAEE,SAXS;ED2rQb;EC9qQE;;;IAEE,SAAA;EDirQJ;EC/rQE;;;IAEE,8CAAA;EDksQJ;EChsQE;;;IAEE,yBAAA;EDmsQJ;ECjsQE;;;IAEE,SAXS;ED+sQb;EClsQE;;;IAEE,SAAA;EDqsQJ;ECntQE;;;IAEE,8CAAA;EDstQJ;ECptQE;;;IAEE,yBAAA;EDutQJ;ECrtQE;;;IAEE,SAXS;EDmuQb;ECttQE;;;IAEE,SAAA;EDytQJ;ECvuQE;;;IAEE,8CAAA;ED0uQJ;ECxuQE;;;IAEE,yBAAA;ED2uQJ;ECzuQE;;;IAEE,SAXS;EDuvQb;EC1uQE;;;IAEE,SAAA;ED6uQJ;EC3vQE;;;IAEE,8CAAA;ED8vQJ;EC5vQE;;;IAEE,yBAAA;ED+vQJ;EC7vQE;;;IAEE,SAXS;ED2wQb;EC9vQE;;;IAEE,SAAA;EDiwQJ;EC/wQE;;;IAEE,8CAAA;EDkxQJ;EChxQE;;;IAEE,yBAAA;EDmxQJ;ECjxQE;;;IAEE,SAXS;ED+xQb;EClxQE;;;IAEE,SAAA;EDqxQJ;ECnyQE;;;IAEE,8CAAA;EDsyQJ;ECpyQE;;;IAEE,yBAAA;EDuyQJ;ECryQE;;;IAEE,SAXS;EDmzQb;ECtyQE;;;IAEE,SAAA;EDyyQJ;ECvzQE;;;IAEE,8CAAA;ED0zQJ;ECxzQE;;;IAEE,yBAAA;ED2zQJ;ECzzQE;;;IAEE,SAXS;EDu0Qb;EC1zQE;;;IAEE,SAAA;ED6zQJ;EC30QE;;;IAEE,8CAAA;ED80QJ;EC50QE;;;IAEE,yBAAA;ED+0QJ;EC70QE;;;IAEE,SAXS;ED21Qb;EC90QE;;;IAEE,SAAA;EDi1QJ;EC/1QE;;;IAEE,8CAAA;EDk2QJ;ECh2QE;;;IAEE,yBAAA;EDm2QJ;ECj2QE;;;IAEE,SAXS;ED+2Qb;ECl2QE;;;IAEE,SAAA;EDq2QJ;EC/1QA;;IACE,cAAA;EDk2QF;AACF;ACtyQI;EAUA;;;IAEE,0BAAA;EDgyQJ;EC9xQE;;;IAEE,oBAPS;EDwyQb;EC/xQE;;;IAEE,kBAXS;ED6yQb;EC5yQE;;;IAEE,0BAAA;ED+yQJ;EC7yQE;;;IAEE,oBAPS;EDuzQb;EC9yQE;;;IAEE,kBAXS;ED4zQb;EC3zQE;;;IAEE,0BAAA;ED8zQJ;EC5zQE;;;IAEE,oBAPS;EDs0Qb;EC7zQE;;;IAEE,kBAXS;ED20Qb;EC10QE;;;IAEE,0BAAA;ED60QJ;EC30QE;;;IAEE,oBAPS;EDq1Qb;EC50QE;;;IAEE,kBAXS;ED01Qb;ECz1QE;;;IAEE,0BAAA;ED41QJ;EC11QE;;;IAEE,oBAPS;EDo2Qb;EC31QE;;;IAEE,kBAXS;EDy2Qb;ECx2QE;;;IAEE,0BAAA;ED22QJ;ECz2QE;;;IAEE,oBAPS;EDm3Qb;EC12QE;;;IAEE,kBAXS;EDw3Qb;ECv3QE;;;IAEE,0BAAA;ED03QJ;ECx3QE;;;IAEE,oBAPS;EDk4Qb;ECz3QE;;;IAEE,kBAXS;EDu4Qb;ECt4QE;;;IAEE,0BAAA;EDy4QJ;ECv4QE;;;IAEE,oBAPS;EDi5Qb;ECx4QE;;;IAEE,kBAXS;EDs5Qb;ECr5QE;;;IAEE,0BAAA;EDw5QJ;ECt5QE;;;IAEE,oBAPS;EDg6Qb;ECv5QE;;;IAEE,kBAXS;EDq6Qb;ECp6QE;;;IAEE,4BAAA;EDu6QJ;ECr6QE;;;IAEE,qBAPS;ED+6Qb;ECt6QE;;;IAEE,mBAXS;EDo7Qb;ECn7QE;;;IAEE,4BAAA;EDs7QJ;ECp7QE;;;IAEE,qBAPS;ED87Qb;ECr7QE;;;IAEE,mBAXS;EDm8Qb;ECl8QE;;;IAEE,4BAAA;EDq8QJ;ECn8QE;;;IAEE,qBAPS;ED68Qb;ECp8QE;;;IAEE,mBAXS;EDk9Qb;ECj9QE;;;IAEE,4BAAA;EDo9QJ;ECl9QE;;;IAEE,qBAPS;ED49Qb;ECn9QE;;;IAEE,mBAXS;EDi+Qb;ECh+QE;;;IAEE,4BAAA;EDm+QJ;ECj+QE;;;IAEE,qBAPS;ED2+Qb;ECl+QE;;;IAEE,mBAXS;EDg/Qb;EC/+QE;;;IAEE,4BAAA;EDk/QJ;ECh/QE;;;IAEE,qBAPS;ED0/Qb;ECj/QE;;;IAEE,mBAXS;ED+/Qb;EC9/QE;;;IAEE,4BAAA;EDigRJ;EC//QE;;;IAEE,qBAPS;EDygRb;EChgRE;;;IAEE,mBAXS;ED8gRb;EC7gRE;;;IAEE,4BAAA;EDghRJ;EC9gRE;;;IAEE,qBAPS;EDwhRb;EC/gRE;;;IAEE,mBAXS;ED6hRb;EC5hRE;;;IAEE,4BAAA;ED+hRJ;EC7hRE;;;IAEE,qBAPS;EDuiRb;EC9hRE;;;IAEE,mBAXS;ED4iRb;EC3iRE;;;IAEE,4BAAA;ED8iRJ;EC5iRE;;;IAEE,qBAPS;EDsjRb;EC7iRE;;;IAEE,mBAXS;ED2jRb;EC1jRE;;;IAEE,4BAAA;ED6jRJ;EC3jRE;;;IAEE,qBAPS;EDqkRb;EC5jRE;;;IAEE,mBAXS;ED0kRb;ECzkRE;;;IAEE,4BAAA;ED4kRJ;EC1kRE;;;IAEE,qBAPS;EDolRb;EC3kRE;;;IAEE,mBAXS;EDylRb;ECxlRE;;;IAEE,4BAAA;ED2lRJ;ECzlRE;;;IAEE,qBAPS;EDmmRb;EC1lRE;;;IAEE,mBAXS;EDwmRb;ECvmRE;;;IAEE,4BAAA;ED0mRJ;ECxmRE;;;IAEE,qBAPS;EDknRb;ECzmRE;;;IAEE,mBAXS;EDunRb;ECtnRE;;;IAEE,4BAAA;EDynRJ;ECvnRE;;;IAEE,qBAPS;EDioRb;ECxnRE;;;IAEE,mBAXS;EDsoRb;ECjuRE;;;IAEE,6CAAA;EDouRJ;ECluRE;;;IAEE,uBAAA;EDquRJ;ECnuRE;;;IAEE,QAXS;EDivRb;ECpuRE;;;IAEE,SAAA;EDuuRJ;ECrvRE;;;IAEE,6CAAA;EDwvRJ;ECtvRE;;;IAEE,uBAAA;EDyvRJ;ECvvRE;;;IAEE,QAXS;EDqwRb;ECxvRE;;;IAEE,SAAA;ED2vRJ;ECzwRE;;;IAEE,6CAAA;ED4wRJ;EC1wRE;;;IAEE,uBAAA;ED6wRJ;EC3wRE;;;IAEE,QAXS;EDyxRb;EC5wRE;;;IAEE,SAAA;ED+wRJ;EC7xRE;;;IAEE,6CAAA;EDgyRJ;EC9xRE;;;IAEE,uBAAA;EDiyRJ;EC/xRE;;;IAEE,QAXS;ED6yRb;EChyRE;;;IAEE,SAAA;EDmyRJ;ECjzRE;;;IAEE,6CAAA;EDozRJ;EClzRE;;;IAEE,uBAAA;EDqzRJ;ECnzRE;;;IAEE,QAXS;EDi0Rb;ECpzRE;;;IAEE,SAAA;EDuzRJ;ECr0RE;;;IAEE,6CAAA;EDw0RJ;ECt0RE;;;IAEE,uBAAA;EDy0RJ;ECv0RE;;;IAEE,QAXS;EDq1Rb;ECx0RE;;;IAEE,SAAA;ED20RJ;ECz1RE;;;IAEE,6CAAA;ED41RJ;EC11RE;;;IAEE,uBAAA;ED61RJ;EC31RE;;;IAEE,QAXS;EDy2Rb;EC51RE;;;IAEE,SAAA;ED+1RJ;EC72RE;;;IAEE,6CAAA;EDg3RJ;EC92RE;;;IAEE,uBAAA;EDi3RJ;EC/2RE;;;IAEE,QAXS;ED63Rb;ECh3RE;;;IAEE,SAAA;EDm3RJ;ECj4RE;;;IAEE,6CAAA;EDo4RJ;ECl4RE;;;IAEE,uBAAA;EDq4RJ;ECn4RE;;;IAEE,QAXS;EDi5Rb;ECp4RE;;;IAEE,SAAA;EDu4RJ;ECr5RE;;;IAEE,8CAAA;EDw5RJ;ECt5RE;;;IAEE,yBAAA;EDy5RJ;ECv5RE;;;IAEE,SAXS;EDq6Rb;ECx5RE;;;IAEE,SAAA;ED25RJ;ECz6RE;;;IAEE,8CAAA;ED46RJ;EC16RE;;;IAEE,yBAAA;ED66RJ;EC36RE;;;IAEE,SAXS;EDy7Rb;EC56RE;;;IAEE,SAAA;ED+6RJ;EC77RE;;;IAEE,8CAAA;EDg8RJ;EC97RE;;;IAEE,yBAAA;EDi8RJ;EC/7RE;;;IAEE,SAXS;ED68Rb;ECh8RE;;;IAEE,SAAA;EDm8RJ;ECj9RE;;;IAEE,8CAAA;EDo9RJ;ECl9RE;;;IAEE,yBAAA;EDq9RJ;ECn9RE;;;IAEE,SAXS;EDi+Rb;ECp9RE;;;IAEE,SAAA;EDu9RJ;ECr+RE;;;IAEE,8CAAA;EDw+RJ;ECt+RE;;;IAEE,yBAAA;EDy+RJ;ECv+RE;;;IAEE,SAXS;EDq/Rb;ECx+RE;;;IAEE,SAAA;ED2+RJ;ECz/RE;;;IAEE,8CAAA;ED4/RJ;EC1/RE;;;IAEE,yBAAA;ED6/RJ;EC3/RE;;;IAEE,SAXS;EDygSb;EC5/RE;;;IAEE,SAAA;ED+/RJ;EC7gSE;;;IAEE,8CAAA;EDghSJ;EC9gSE;;;IAEE,yBAAA;EDihSJ;EC/gSE;;;IAEE,SAXS;ED6hSb;EChhSE;;;IAEE,SAAA;EDmhSJ;ECjiSE;;;IAEE,8CAAA;EDoiSJ;ECliSE;;;IAEE,yBAAA;EDqiSJ;ECniSE;;;IAEE,SAXS;EDijSb;ECpiSE;;;IAEE,SAAA;EDuiSJ;ECrjSE;;;IAEE,8CAAA;EDwjSJ;ECtjSE;;;IAEE,yBAAA;EDyjSJ;ECvjSE;;;IAEE,SAXS;EDqkSb;ECxjSE;;;IAEE,SAAA;ED2jSJ;ECzkSE;;;IAEE,8CAAA;ED4kSJ;EC1kSE;;;IAEE,yBAAA;ED6kSJ;EC3kSE;;;IAEE,SAXS;EDylSb;EC5kSE;;;IAEE,SAAA;ED+kSJ;EC7lSE;;;IAEE,8CAAA;EDgmSJ;EC9lSE;;;IAEE,yBAAA;EDimSJ;EC/lSE;;;IAEE,SAXS;ED6mSb;EChmSE;;;IAEE,SAAA;EDmmSJ;ECjnSE;;;IAEE,8CAAA;EDonSJ;EClnSE;;;IAEE,yBAAA;EDqnSJ;ECnnSE;;;IAEE,SAXS;EDioSb;ECpnSE;;;IAEE,SAAA;EDunSJ;ECroSE;;;IAEE,8CAAA;EDwoSJ;ECtoSE;;;IAEE,yBAAA;EDyoSJ;ECvoSE;;;IAEE,SAXS;EDqpSb;ECxoSE;;;IAEE,SAAA;ED2oSJ;ECzpSE;;;IAEE,8CAAA;ED4pSJ;EC1pSE;;;IAEE,yBAAA;ED6pSJ;EC3pSE;;;IAEE,SAXS;EDyqSb;EC5pSE;;;IAEE,SAAA;ED+pSJ;EC7qSE;;;IAEE,8CAAA;EDgrSJ;EC9qSE;;;IAEE,yBAAA;EDirSJ;EC/qSE;;;IAEE,SAXS;ED6rSb;EChrSE;;;IAEE,SAAA;EDmrSJ;ECjsSE;;;IAEE,8CAAA;EDosSJ;EClsSE;;;IAEE,yBAAA;EDqsSJ;ECnsSE;;;IAEE,SAXS;EDitSb;ECpsSE;;;IAEE,SAAA;EDusSJ;ECrtSE;;;IAEE,8CAAA;EDwtSJ;ECttSE;;;IAEE,yBAAA;EDytSJ;ECvtSE;;;IAEE,SAXS;EDquSb;ECxtSE;;;IAEE,SAAA;ED2tSJ;ECzuSE;;;IAEE,8CAAA;ED4uSJ;EC1uSE;;;IAEE,yBAAA;ED6uSJ;EC3uSE;;;IAEE,SAXS;EDyvSb;EC5uSE;;;IAEE,SAAA;ED+uSJ;EC7vSE;;;IAEE,8CAAA;EDgwSJ;EC9vSE;;;IAEE,yBAAA;EDiwSJ;EC/vSE;;;IAEE,SAXS;ED6wSb;EChwSE;;;IAEE,SAAA;EDmwSJ;ECjxSE;;;IAEE,8CAAA;EDoxSJ;EClxSE;;;IAEE,yBAAA;EDqxSJ;ECnxSE;;;IAEE,SAXS;EDiySb;ECpxSE;;;IAEE,SAAA;EDuxSJ;ECrySE;;;IAEE,8CAAA;EDwySJ;ECtySE;;;IAEE,yBAAA;EDyySJ;ECvySE;;;IAEE,SAXS;EDqzSb;ECxySE;;;IAEE,SAAA;ED2ySJ;ECzzSE;;;IAEE,8CAAA;ED4zSJ;EC1zSE;;;IAEE,yBAAA;ED6zSJ;EC3zSE;;;IAEE,SAXS;EDy0Sb;EC5zSE;;;IAEE,SAAA;ED+zSJ;EC70SE;;;IAEE,8CAAA;EDg1SJ;EC90SE;;;IAEE,yBAAA;EDi1SJ;EC/0SE;;;IAEE,SAXS;ED61Sb;ECh1SE;;;IAEE,SAAA;EDm1SJ;ECj2SE;;;IAEE,8CAAA;EDo2SJ;ECl2SE;;;IAEE,yBAAA;EDq2SJ;ECn2SE;;;IAEE,SAXS;EDi3Sb;ECp2SE;;;IAEE,SAAA;EDu2SJ;ECr3SE;;;IAEE,8CAAA;EDw3SJ;ECt3SE;;;IAEE,yBAAA;EDy3SJ;ECv3SE;;;IAEE,SAXS;EDq4Sb;ECx3SE;;;IAEE,SAAA;ED23SJ;ECz4SE;;;IAEE,8CAAA;ED44SJ;EC14SE;;;IAEE,yBAAA;ED64SJ;EC34SE;;;IAEE,SAXS;EDy5Sb;EC54SE;;;IAEE,SAAA;ED+4SJ;EC75SE;;;IAEE,8CAAA;EDg6SJ;EC95SE;;;IAEE,yBAAA;EDi6SJ;EC/5SE;;;IAEE,SAXS;ED66Sb;ECh6SE;;;IAEE,SAAA;EDm6SJ;ECj7SE;;;IAEE,8CAAA;EDo7SJ;ECl7SE;;;IAEE,yBAAA;EDq7SJ;ECn7SE;;;IAEE,SAXS;EDi8Sb;ECp7SE;;;IAEE,SAAA;EDu7SJ;ECr8SE;;;IAEE,8CAAA;EDw8SJ;ECt8SE;;;IAEE,yBAAA;EDy8SJ;ECv8SE;;;IAEE,SAXS;EDq9Sb;ECx8SE;;;IAEE,SAAA;ED28SJ;ECz9SE;;;IAEE,8CAAA;ED49SJ;EC19SE;;;IAEE,yBAAA;ED69SJ;EC39SE;;;IAEE,SAXS;EDy+Sb;EC59SE;;;IAEE,SAAA;ED+9SJ;EC7+SE;;;IAEE,8CAAA;EDg/SJ;EC9+SE;;;IAEE,yBAAA;EDi/SJ;EC/+SE;;;IAEE,SAXS;ED6/Sb;ECh/SE;;;IAEE,SAAA;EDm/SJ;ECjgTE;;;IAEE,8CAAA;EDogTJ;EClgTE;;;IAEE,yBAAA;EDqgTJ;ECngTE;;;IAEE,SAXS;EDihTb;ECpgTE;;;IAEE,SAAA;EDugTJ;ECrhTE;;;IAEE,8CAAA;EDwhTJ;ECthTE;;;IAEE,yBAAA;EDyhTJ;ECvhTE;;;IAEE,SAXS;EDqiTb;ECxhTE;;;IAEE,SAAA;ED2hTJ;ECziTE;;;IAEE,8CAAA;ED4iTJ;EC1iTE;;;IAEE,yBAAA;ED6iTJ;EC3iTE;;;IAEE,SAXS;EDyjTb;EC5iTE;;;IAEE,SAAA;ED+iTJ;EC7jTE;;;IAEE,8CAAA;EDgkTJ;EC9jTE;;;IAEE,yBAAA;EDikTJ;EC/jTE;;;IAEE,SAXS;ED6kTb;EChkTE;;;IAEE,SAAA;EDmkTJ;ECjlTE;;;IAEE,8CAAA;EDolTJ;ECllTE;;;IAEE,yBAAA;EDqlTJ;ECnlTE;;;IAEE,SAXS;EDimTb;ECplTE;;;IAEE,SAAA;EDulTJ;ECrmTE;;;IAEE,8CAAA;EDwmTJ;ECtmTE;;;IAEE,yBAAA;EDymTJ;ECvmTE;;;IAEE,SAXS;EDqnTb;ECxmTE;;;IAEE,SAAA;ED2mTJ;ECznTE;;;IAEE,8CAAA;ED4nTJ;EC1nTE;;;IAEE,yBAAA;ED6nTJ;EC3nTE;;;IAEE,SAXS;EDyoTb;EC5nTE;;;IAEE,SAAA;ED+nTJ;EC7oTE;;;IAEE,8CAAA;EDgpTJ;EC9oTE;;;IAEE,yBAAA;EDipTJ;EC/oTE;;;IAEE,SAXS;ED6pTb;EChpTE;;;IAEE,SAAA;EDmpTJ;ECjqTE;;;IAEE,8CAAA;EDoqTJ;EClqTE;;;IAEE,yBAAA;EDqqTJ;ECnqTE;;;IAEE,SAXS;EDirTb;ECpqTE;;;IAEE,SAAA;EDuqTJ;ECrrTE;;;IAEE,8CAAA;EDwrTJ;ECtrTE;;;IAEE,yBAAA;EDyrTJ;ECvrTE;;;IAEE,SAXS;EDqsTb;ECxrTE;;;IAEE,SAAA;ED2rTJ;ECrrTA;;IACE,cAAA;EDwrTF;AACF;AC5nTI;EAUA;;;IAEE,0BAAA;EDsnTJ;ECpnTE;;;IAEE,oBAPS;ED8nTb;ECrnTE;;;IAEE,kBAXS;EDmoTb;ECloTE;;;IAEE,0BAAA;EDqoTJ;ECnoTE;;;IAEE,oBAPS;ED6oTb;ECpoTE;;;IAEE,kBAXS;EDkpTb;ECjpTE;;;IAEE,0BAAA;EDopTJ;EClpTE;;;IAEE,oBAPS;ED4pTb;ECnpTE;;;IAEE,kBAXS;EDiqTb;EChqTE;;;IAEE,0BAAA;EDmqTJ;ECjqTE;;;IAEE,oBAPS;ED2qTb;EClqTE;;;IAEE,kBAXS;EDgrTb;EC/qTE;;;IAEE,0BAAA;EDkrTJ;EChrTE;;;IAEE,oBAPS;ED0rTb;ECjrTE;;;IAEE,kBAXS;ED+rTb;EC9rTE;;;IAEE,0BAAA;EDisTJ;EC/rTE;;;IAEE,oBAPS;EDysTb;EChsTE;;;IAEE,kBAXS;ED8sTb;EC7sTE;;;IAEE,0BAAA;EDgtTJ;EC9sTE;;;IAEE,oBAPS;EDwtTb;EC/sTE;;;IAEE,kBAXS;ED6tTb;EC5tTE;;;IAEE,0BAAA;ED+tTJ;EC7tTE;;;IAEE,oBAPS;EDuuTb;EC9tTE;;;IAEE,kBAXS;ED4uTb;EC3uTE;;;IAEE,0BAAA;ED8uTJ;EC5uTE;;;IAEE,oBAPS;EDsvTb;EC7uTE;;;IAEE,kBAXS;ED2vTb;EC1vTE;;;IAEE,4BAAA;ED6vTJ;EC3vTE;;;IAEE,qBAPS;EDqwTb;EC5vTE;;;IAEE,mBAXS;ED0wTb;ECzwTE;;;IAEE,4BAAA;ED4wTJ;EC1wTE;;;IAEE,qBAPS;EDoxTb;EC3wTE;;;IAEE,mBAXS;EDyxTb;ECxxTE;;;IAEE,4BAAA;ED2xTJ;ECzxTE;;;IAEE,qBAPS;EDmyTb;EC1xTE;;;IAEE,mBAXS;EDwyTb;ECvyTE;;;IAEE,4BAAA;ED0yTJ;ECxyTE;;;IAEE,qBAPS;EDkzTb;ECzyTE;;;IAEE,mBAXS;EDuzTb;ECtzTE;;;IAEE,4BAAA;EDyzTJ;ECvzTE;;;IAEE,qBAPS;EDi0Tb;ECxzTE;;;IAEE,mBAXS;EDs0Tb;ECr0TE;;;IAEE,4BAAA;EDw0TJ;ECt0TE;;;IAEE,qBAPS;EDg1Tb;ECv0TE;;;IAEE,mBAXS;EDq1Tb;ECp1TE;;;IAEE,4BAAA;EDu1TJ;ECr1TE;;;IAEE,qBAPS;ED+1Tb;ECt1TE;;;IAEE,mBAXS;EDo2Tb;ECn2TE;;;IAEE,4BAAA;EDs2TJ;ECp2TE;;;IAEE,qBAPS;ED82Tb;ECr2TE;;;IAEE,mBAXS;EDm3Tb;ECl3TE;;;IAEE,4BAAA;EDq3TJ;ECn3TE;;;IAEE,qBAPS;ED63Tb;ECp3TE;;;IAEE,mBAXS;EDk4Tb;ECj4TE;;;IAEE,4BAAA;EDo4TJ;ECl4TE;;;IAEE,qBAPS;ED44Tb;ECn4TE;;;IAEE,mBAXS;EDi5Tb;ECh5TE;;;IAEE,4BAAA;EDm5TJ;ECj5TE;;;IAEE,qBAPS;ED25Tb;ECl5TE;;;IAEE,mBAXS;EDg6Tb;EC/5TE;;;IAEE,4BAAA;EDk6TJ;ECh6TE;;;IAEE,qBAPS;ED06Tb;ECj6TE;;;IAEE,mBAXS;ED+6Tb;EC96TE;;;IAEE,4BAAA;EDi7TJ;EC/6TE;;;IAEE,qBAPS;EDy7Tb;ECh7TE;;;IAEE,mBAXS;ED87Tb;EC77TE;;;IAEE,4BAAA;EDg8TJ;EC97TE;;;IAEE,qBAPS;EDw8Tb;EC/7TE;;;IAEE,mBAXS;ED68Tb;EC58TE;;;IAEE,4BAAA;ED+8TJ;EC78TE;;;IAEE,qBAPS;EDu9Tb;EC98TE;;;IAEE,mBAXS;ED49Tb;ECvjUE;;;IAEE,6CAAA;ED0jUJ;ECxjUE;;;IAEE,uBAAA;ED2jUJ;ECzjUE;;;IAEE,QAXS;EDukUb;EC1jUE;;;IAEE,SAAA;ED6jUJ;EC3kUE;;;IAEE,6CAAA;ED8kUJ;EC5kUE;;;IAEE,uBAAA;ED+kUJ;EC7kUE;;;IAEE,QAXS;ED2lUb;EC9kUE;;;IAEE,SAAA;EDilUJ;EC/lUE;;;IAEE,6CAAA;EDkmUJ;EChmUE;;;IAEE,uBAAA;EDmmUJ;ECjmUE;;;IAEE,QAXS;ED+mUb;EClmUE;;;IAEE,SAAA;EDqmUJ;ECnnUE;;;IAEE,6CAAA;EDsnUJ;ECpnUE;;;IAEE,uBAAA;EDunUJ;ECrnUE;;;IAEE,QAXS;EDmoUb;ECtnUE;;;IAEE,SAAA;EDynUJ;ECvoUE;;;IAEE,6CAAA;ED0oUJ;ECxoUE;;;IAEE,uBAAA;ED2oUJ;ECzoUE;;;IAEE,QAXS;EDupUb;EC1oUE;;;IAEE,SAAA;ED6oUJ;EC3pUE;;;IAEE,6CAAA;ED8pUJ;EC5pUE;;;IAEE,uBAAA;ED+pUJ;EC7pUE;;;IAEE,QAXS;ED2qUb;EC9pUE;;;IAEE,SAAA;EDiqUJ;EC/qUE;;;IAEE,6CAAA;EDkrUJ;EChrUE;;;IAEE,uBAAA;EDmrUJ;ECjrUE;;;IAEE,QAXS;ED+rUb;EClrUE;;;IAEE,SAAA;EDqrUJ;ECnsUE;;;IAEE,6CAAA;EDssUJ;ECpsUE;;;IAEE,uBAAA;EDusUJ;ECrsUE;;;IAEE,QAXS;EDmtUb;ECtsUE;;;IAEE,SAAA;EDysUJ;ECvtUE;;;IAEE,6CAAA;ED0tUJ;ECxtUE;;;IAEE,uBAAA;ED2tUJ;ECztUE;;;IAEE,QAXS;EDuuUb;EC1tUE;;;IAEE,SAAA;ED6tUJ;EC3uUE;;;IAEE,8CAAA;ED8uUJ;EC5uUE;;;IAEE,yBAAA;ED+uUJ;EC7uUE;;;IAEE,SAXS;ED2vUb;EC9uUE;;;IAEE,SAAA;EDivUJ;EC/vUE;;;IAEE,8CAAA;EDkwUJ;EChwUE;;;IAEE,yBAAA;EDmwUJ;ECjwUE;;;IAEE,SAXS;ED+wUb;EClwUE;;;IAEE,SAAA;EDqwUJ;ECnxUE;;;IAEE,8CAAA;EDsxUJ;ECpxUE;;;IAEE,yBAAA;EDuxUJ;ECrxUE;;;IAEE,SAXS;EDmyUb;ECtxUE;;;IAEE,SAAA;EDyxUJ;ECvyUE;;;IAEE,8CAAA;ED0yUJ;ECxyUE;;;IAEE,yBAAA;ED2yUJ;ECzyUE;;;IAEE,SAXS;EDuzUb;EC1yUE;;;IAEE,SAAA;ED6yUJ;EC3zUE;;;IAEE,8CAAA;ED8zUJ;EC5zUE;;;IAEE,yBAAA;ED+zUJ;EC7zUE;;;IAEE,SAXS;ED20Ub;EC9zUE;;;IAEE,SAAA;EDi0UJ;EC/0UE;;;IAEE,8CAAA;EDk1UJ;ECh1UE;;;IAEE,yBAAA;EDm1UJ;ECj1UE;;;IAEE,SAXS;ED+1Ub;ECl1UE;;;IAEE,SAAA;EDq1UJ;ECn2UE;;;IAEE,8CAAA;EDs2UJ;ECp2UE;;;IAEE,yBAAA;EDu2UJ;ECr2UE;;;IAEE,SAXS;EDm3Ub;ECt2UE;;;IAEE,SAAA;EDy2UJ;ECv3UE;;;IAEE,8CAAA;ED03UJ;ECx3UE;;;IAEE,yBAAA;ED23UJ;ECz3UE;;;IAEE,SAXS;EDu4Ub;EC13UE;;;IAEE,SAAA;ED63UJ;EC34UE;;;IAEE,8CAAA;ED84UJ;EC54UE;;;IAEE,yBAAA;ED+4UJ;EC74UE;;;IAEE,SAXS;ED25Ub;EC94UE;;;IAEE,SAAA;EDi5UJ;EC/5UE;;;IAEE,8CAAA;EDk6UJ;ECh6UE;;;IAEE,yBAAA;EDm6UJ;ECj6UE;;;IAEE,SAXS;ED+6Ub;ECl6UE;;;IAEE,SAAA;EDq6UJ;ECn7UE;;;IAEE,8CAAA;EDs7UJ;ECp7UE;;;IAEE,yBAAA;EDu7UJ;ECr7UE;;;IAEE,SAXS;EDm8Ub;ECt7UE;;;IAEE,SAAA;EDy7UJ;ECv8UE;;;IAEE,8CAAA;ED08UJ;ECx8UE;;;IAEE,yBAAA;ED28UJ;ECz8UE;;;IAEE,SAXS;EDu9Ub;EC18UE;;;IAEE,SAAA;ED68UJ;EC39UE;;;IAEE,8CAAA;ED89UJ;EC59UE;;;IAEE,yBAAA;ED+9UJ;EC79UE;;;IAEE,SAXS;ED2+Ub;EC99UE;;;IAEE,SAAA;EDi+UJ;EC/+UE;;;IAEE,8CAAA;EDk/UJ;ECh/UE;;;IAEE,yBAAA;EDm/UJ;ECj/UE;;;IAEE,SAXS;ED+/Ub;ECl/UE;;;IAEE,SAAA;EDq/UJ;ECngVE;;;IAEE,8CAAA;EDsgVJ;ECpgVE;;;IAEE,yBAAA;EDugVJ;ECrgVE;;;IAEE,SAXS;EDmhVb;ECtgVE;;;IAEE,SAAA;EDygVJ;ECvhVE;;;IAEE,8CAAA;ED0hVJ;ECxhVE;;;IAEE,yBAAA;ED2hVJ;ECzhVE;;;IAEE,SAXS;EDuiVb;EC1hVE;;;IAEE,SAAA;ED6hVJ;EC3iVE;;;IAEE,8CAAA;ED8iVJ;EC5iVE;;;IAEE,yBAAA;ED+iVJ;EC7iVE;;;IAEE,SAXS;ED2jVb;EC9iVE;;;IAEE,SAAA;EDijVJ;EC/jVE;;;IAEE,8CAAA;EDkkVJ;EChkVE;;;IAEE,yBAAA;EDmkVJ;ECjkVE;;;IAEE,SAXS;ED+kVb;EClkVE;;;IAEE,SAAA;EDqkVJ;ECnlVE;;;IAEE,8CAAA;EDslVJ;ECplVE;;;IAEE,yBAAA;EDulVJ;ECrlVE;;;IAEE,SAXS;EDmmVb;ECtlVE;;;IAEE,SAAA;EDylVJ;ECvmVE;;;IAEE,8CAAA;ED0mVJ;ECxmVE;;;IAEE,yBAAA;ED2mVJ;ECzmVE;;;IAEE,SAXS;EDunVb;EC1mVE;;;IAEE,SAAA;ED6mVJ;EC3nVE;;;IAEE,8CAAA;ED8nVJ;EC5nVE;;;IAEE,yBAAA;ED+nVJ;EC7nVE;;;IAEE,SAXS;ED2oVb;EC9nVE;;;IAEE,SAAA;EDioVJ;EC/oVE;;;IAEE,8CAAA;EDkpVJ;EChpVE;;;IAEE,yBAAA;EDmpVJ;ECjpVE;;;IAEE,SAXS;ED+pVb;EClpVE;;;IAEE,SAAA;EDqpVJ;ECnqVE;;;IAEE,8CAAA;EDsqVJ;ECpqVE;;;IAEE,yBAAA;EDuqVJ;ECrqVE;;;IAEE,SAXS;EDmrVb;ECtqVE;;;IAEE,SAAA;EDyqVJ;ECvrVE;;;IAEE,8CAAA;ED0rVJ;ECxrVE;;;IAEE,yBAAA;ED2rVJ;ECzrVE;;;IAEE,SAXS;EDusVb;EC1rVE;;;IAEE,SAAA;ED6rVJ;EC3sVE;;;IAEE,8CAAA;ED8sVJ;EC5sVE;;;IAEE,yBAAA;ED+sVJ;EC7sVE;;;IAEE,SAXS;ED2tVb;EC9sVE;;;IAEE,SAAA;EDitVJ;EC/tVE;;;IAEE,8CAAA;EDkuVJ;EChuVE;;;IAEE,yBAAA;EDmuVJ;ECjuVE;;;IAEE,SAXS;ED+uVb;ECluVE;;;IAEE,SAAA;EDquVJ;ECnvVE;;;IAEE,8CAAA;EDsvVJ;ECpvVE;;;IAEE,yBAAA;EDuvVJ;ECrvVE;;;IAEE,SAXS;EDmwVb;ECtvVE;;;IAEE,SAAA;EDyvVJ;ECvwVE;;;IAEE,8CAAA;ED0wVJ;ECxwVE;;;IAEE,yBAAA;ED2wVJ;ECzwVE;;;IAEE,SAXS;EDuxVb;EC1wVE;;;IAEE,SAAA;ED6wVJ;EC3xVE;;;IAEE,8CAAA;ED8xVJ;EC5xVE;;;IAEE,yBAAA;ED+xVJ;EC7xVE;;;IAEE,SAXS;ED2yVb;EC9xVE;;;IAEE,SAAA;EDiyVJ;EC/yVE;;;IAEE,8CAAA;EDkzVJ;EChzVE;;;IAEE,yBAAA;EDmzVJ;ECjzVE;;;IAEE,SAXS;ED+zVb;EClzVE;;;IAEE,SAAA;EDqzVJ;ECn0VE;;;IAEE,8CAAA;EDs0VJ;ECp0VE;;;IAEE,yBAAA;EDu0VJ;ECr0VE;;;IAEE,SAXS;EDm1Vb;ECt0VE;;;IAEE,SAAA;EDy0VJ;ECv1VE;;;IAEE,8CAAA;ED01VJ;ECx1VE;;;IAEE,yBAAA;ED21VJ;ECz1VE;;;IAEE,SAXS;EDu2Vb;EC11VE;;;IAEE,SAAA;ED61VJ;EC32VE;;;IAEE,8CAAA;ED82VJ;EC52VE;;;IAEE,yBAAA;ED+2VJ;EC72VE;;;IAEE,SAXS;ED23Vb;EC92VE;;;IAEE,SAAA;EDi3VJ;EC/3VE;;;IAEE,8CAAA;EDk4VJ;ECh4VE;;;IAEE,yBAAA;EDm4VJ;ECj4VE;;;IAEE,SAXS;ED+4Vb;ECl4VE;;;IAEE,SAAA;EDq4VJ;ECn5VE;;;IAEE,8CAAA;EDs5VJ;ECp5VE;;;IAEE,yBAAA;EDu5VJ;ECr5VE;;;IAEE,SAXS;EDm6Vb;ECt5VE;;;IAEE,SAAA;EDy5VJ;ECv6VE;;;IAEE,8CAAA;ED06VJ;ECx6VE;;;IAEE,yBAAA;ED26VJ;ECz6VE;;;IAEE,SAXS;EDu7Vb;EC16VE;;;IAEE,SAAA;ED66VJ;EC37VE;;;IAEE,8CAAA;ED87VJ;EC57VE;;;IAEE,yBAAA;ED+7VJ;EC77VE;;;IAEE,SAXS;ED28Vb;EC97VE;;;IAEE,SAAA;EDi8VJ;EC/8VE;;;IAEE,8CAAA;EDk9VJ;ECh9VE;;;IAEE,yBAAA;EDm9VJ;ECj9VE;;;IAEE,SAXS;ED+9Vb;ECl9VE;;;IAEE,SAAA;EDq9VJ;ECn+VE;;;IAEE,8CAAA;EDs+VJ;ECp+VE;;;IAEE,yBAAA;EDu+VJ;ECr+VE;;;IAEE,SAXS;EDm/Vb;ECt+VE;;;IAEE,SAAA;EDy+VJ;ECv/VE;;;IAEE,8CAAA;ED0/VJ;ECx/VE;;;IAEE,yBAAA;ED2/VJ;ECz/VE;;;IAEE,SAXS;EDugWb;EC1/VE;;;IAEE,SAAA;ED6/VJ;EC3gWE;;;IAEE,8CAAA;ED8gWJ;EC5gWE;;;IAEE,yBAAA;ED+gWJ;EC7gWE;;;IAEE,SAXS;ED2hWb;EC9gWE;;;IAEE,SAAA;EDihWJ;EC3gWA;;IACE,cAAA;ED8gWF;AACF;;AA/hWA,qCAAA;AACA;;EAEE,2BAAA;AAkiWF;ACl+VI;EAoBA;;;IAEE,0BAAA;EDk9VJ;ECh9VE;;;IAEE,oBAPS;ED09Vb;ECj9VE;;;IAEE,kBAXS;ED+9Vb;EC99VE;;;IAEE,0BAAA;EDi+VJ;EC/9VE;;;IAEE,oBAPS;EDy+Vb;ECh+VE;;;IAEE,kBAXS;ED8+Vb;EC7+VE;;;IAEE,0BAAA;EDg/VJ;EC9+VE;;;IAEE,oBAPS;EDw/Vb;EC/+VE;;;IAEE,kBAXS;ED6/Vb;EC5/VE;;;IAEE,0BAAA;ED+/VJ;EC7/VE;;;IAEE,oBAPS;EDugWb;EC9/VE;;;IAEE,kBAXS;ED4gWb;EC3gWE;;;IAEE,0BAAA;ED8gWJ;EC5gWE;;;IAEE,oBAPS;EDshWb;EC7gWE;;;IAEE,kBAXS;ED2hWb;EC1hWE;;;IAEE,0BAAA;ED6hWJ;EC3hWE;;;IAEE,oBAPS;EDqiWb;EC5hWE;;;IAEE,kBAXS;ED0iWb;ECziWE;;;IAEE,0BAAA;ED4iWJ;EC1iWE;;;IAEE,oBAPS;EDojWb;EC3iWE;;;IAEE,kBAXS;EDyjWb;ECxjWE;;;IAEE,0BAAA;ED2jWJ;ECzjWE;;;IAEE,oBAPS;EDmkWb;EC1jWE;;;IAEE,kBAXS;EDwkWb;ECvkWE;;;IAEE,0BAAA;ED0kWJ;ECxkWE;;;IAEE,oBAPS;EDklWb;ECzkWE;;;IAEE,kBAXS;EDulWb;ECtlWE;;;IAEE,4BAAA;EDylWJ;ECvlWE;;;IAEE,qBAPS;EDimWb;ECxlWE;;;IAEE,mBAXS;EDsmWb;ECrmWE;;;IAEE,4BAAA;EDwmWJ;ECtmWE;;;IAEE,qBAPS;EDgnWb;ECvmWE;;;IAEE,mBAXS;EDqnWb;ECpnWE;;;IAEE,4BAAA;EDunWJ;ECrnWE;;;IAEE,qBAPS;ED+nWb;ECtnWE;;;IAEE,mBAXS;EDooWb;ECnoWE;;;IAEE,4BAAA;EDsoWJ;ECpoWE;;;IAEE,qBAPS;ED8oWb;ECroWE;;;IAEE,mBAXS;EDmpWb;EClpWE;;;IAEE,4BAAA;EDqpWJ;ECnpWE;;;IAEE,qBAPS;ED6pWb;ECppWE;;;IAEE,mBAXS;EDkqWb;ECjqWE;;;IAEE,4BAAA;EDoqWJ;EClqWE;;;IAEE,qBAPS;ED4qWb;ECnqWE;;;IAEE,mBAXS;EDirWb;EChrWE;;;IAEE,4BAAA;EDmrWJ;ECjrWE;;;IAEE,qBAPS;ED2rWb;EClrWE;;;IAEE,mBAXS;EDgsWb;EC/rWE;;;IAEE,4BAAA;EDksWJ;EChsWE;;;IAEE,qBAPS;ED0sWb;ECjsWE;;;IAEE,mBAXS;ED+sWb;EC9sWE;;;IAEE,4BAAA;EDitWJ;EC/sWE;;;IAEE,qBAPS;EDytWb;EChtWE;;;IAEE,mBAXS;ED8tWb;EC7tWE;;;IAEE,4BAAA;EDguWJ;EC9tWE;;;IAEE,qBAPS;EDwuWb;EC/tWE;;;IAEE,mBAXS;ED6uWb;EC5uWE;;;IAEE,4BAAA;ED+uWJ;EC7uWE;;;IAEE,qBAPS;EDuvWb;EC9uWE;;;IAEE,mBAXS;ED4vWb;EC3vWE;;;IAEE,4BAAA;ED8vWJ;EC5vWE;;;IAEE,qBAPS;EDswWb;EC7vWE;;;IAEE,mBAXS;ED2wWb;EC1wWE;;;IAEE,4BAAA;ED6wWJ;EC3wWE;;;IAEE,qBAPS;EDqxWb;EC5wWE;;;IAEE,mBAXS;ED0xWb;ECzxWE;;;IAEE,4BAAA;ED4xWJ;EC1xWE;;;IAEE,qBAPS;EDoyWb;EC3xWE;;;IAEE,mBAXS;EDyyWb;ECxyWE;;;IAEE,4BAAA;ED2yWJ;ECzyWE;;;IAEE,qBAPS;EDmzWb;EC1yWE;;;IAEE,mBAXS;EDwzWb;ECn5WE;;;IAEE,6CAAA;EDs5WJ;ECp5WE;;;IAEE,uBAAA;EDu5WJ;ECr5WE;;;IAEE,QAXS;EDm6Wb;ECt5WE;;;IAEE,SAAA;EDy5WJ;ECv6WE;;;IAEE,6CAAA;ED06WJ;ECx6WE;;;IAEE,uBAAA;ED26WJ;ECz6WE;;;IAEE,QAXS;EDu7Wb;EC16WE;;;IAEE,SAAA;ED66WJ;EC37WE;;;IAEE,6CAAA;ED87WJ;EC57WE;;;IAEE,uBAAA;ED+7WJ;EC77WE;;;IAEE,QAXS;ED28Wb;EC97WE;;;IAEE,SAAA;EDi8WJ;EC/8WE;;;IAEE,6CAAA;EDk9WJ;ECh9WE;;;IAEE,uBAAA;EDm9WJ;ECj9WE;;;IAEE,QAXS;ED+9Wb;ECl9WE;;;IAEE,SAAA;EDq9WJ;ECn+WE;;;IAEE,6CAAA;EDs+WJ;ECp+WE;;;IAEE,uBAAA;EDu+WJ;ECr+WE;;;IAEE,QAXS;EDm/Wb;ECt+WE;;;IAEE,SAAA;EDy+WJ;ECv/WE;;;IAEE,6CAAA;ED0/WJ;ECx/WE;;;IAEE,uBAAA;ED2/WJ;ECz/WE;;;IAEE,QAXS;EDugXb;EC1/WE;;;IAEE,SAAA;ED6/WJ;EC3gXE;;;IAEE,6CAAA;ED8gXJ;EC5gXE;;;IAEE,uBAAA;ED+gXJ;EC7gXE;;;IAEE,QAXS;ED2hXb;EC9gXE;;;IAEE,SAAA;EDihXJ;EC/hXE;;;IAEE,6CAAA;EDkiXJ;EChiXE;;;IAEE,uBAAA;EDmiXJ;ECjiXE;;;IAEE,QAXS;ED+iXb;ECliXE;;;IAEE,SAAA;EDqiXJ;ECnjXE;;;IAEE,6CAAA;EDsjXJ;ECpjXE;;;IAEE,uBAAA;EDujXJ;ECrjXE;;;IAEE,QAXS;EDmkXb;ECtjXE;;;IAEE,SAAA;EDyjXJ;ECvkXE;;;IAEE,8CAAA;ED0kXJ;ECxkXE;;;IAEE,yBAAA;ED2kXJ;ECzkXE;;;IAEE,SAXS;EDulXb;EC1kXE;;;IAEE,SAAA;ED6kXJ;EC3lXE;;;IAEE,8CAAA;ED8lXJ;EC5lXE;;;IAEE,yBAAA;ED+lXJ;EC7lXE;;;IAEE,SAXS;ED2mXb;EC9lXE;;;IAEE,SAAA;EDimXJ;EC/mXE;;;IAEE,8CAAA;EDknXJ;EChnXE;;;IAEE,yBAAA;EDmnXJ;ECjnXE;;;IAEE,SAXS;ED+nXb;EClnXE;;;IAEE,SAAA;EDqnXJ;ECnoXE;;;IAEE,8CAAA;EDsoXJ;ECpoXE;;;IAEE,yBAAA;EDuoXJ;ECroXE;;;IAEE,SAXS;EDmpXb;ECtoXE;;;IAEE,SAAA;EDyoXJ;ECvpXE;;;IAEE,8CAAA;ED0pXJ;ECxpXE;;;IAEE,yBAAA;ED2pXJ;ECzpXE;;;IAEE,SAXS;EDuqXb;EC1pXE;;;IAEE,SAAA;ED6pXJ;EC3qXE;;;IAEE,8CAAA;ED8qXJ;EC5qXE;;;IAEE,yBAAA;ED+qXJ;EC7qXE;;;IAEE,SAXS;ED2rXb;EC9qXE;;;IAEE,SAAA;EDirXJ;EC/rXE;;;IAEE,8CAAA;EDksXJ;EChsXE;;;IAEE,yBAAA;EDmsXJ;ECjsXE;;;IAEE,SAXS;ED+sXb;EClsXE;;;IAEE,SAAA;EDqsXJ;ECntXE;;;IAEE,8CAAA;EDstXJ;ECptXE;;;IAEE,yBAAA;EDutXJ;ECrtXE;;;IAEE,SAXS;EDmuXb;ECttXE;;;IAEE,SAAA;EDytXJ;ECvuXE;;;IAEE,8CAAA;ED0uXJ;ECxuXE;;;IAEE,yBAAA;ED2uXJ;ECzuXE;;;IAEE,SAXS;EDuvXb;EC1uXE;;;IAEE,SAAA;ED6uXJ;EC3vXE;;;IAEE,8CAAA;ED8vXJ;EC5vXE;;;IAEE,yBAAA;ED+vXJ;EC7vXE;;;IAEE,SAXS;ED2wXb;EC9vXE;;;IAEE,SAAA;EDiwXJ;EC/wXE;;;IAEE,8CAAA;EDkxXJ;EChxXE;;;IAEE,yBAAA;EDmxXJ;ECjxXE;;;IAEE,SAXS;ED+xXb;EClxXE;;;IAEE,SAAA;EDqxXJ;ECnyXE;;;IAEE,8CAAA;EDsyXJ;ECpyXE;;;IAEE,yBAAA;EDuyXJ;ECryXE;;;IAEE,SAXS;EDmzXb;ECtyXE;;;IAEE,SAAA;EDyyXJ;ECvzXE;;;IAEE,8CAAA;ED0zXJ;ECxzXE;;;IAEE,yBAAA;ED2zXJ;ECzzXE;;;IAEE,SAXS;EDu0Xb;EC1zXE;;;IAEE,SAAA;ED6zXJ;EC30XE;;;IAEE,8CAAA;ED80XJ;EC50XE;;;IAEE,yBAAA;ED+0XJ;EC70XE;;;IAEE,SAXS;ED21Xb;EC90XE;;;IAEE,SAAA;EDi1XJ;EC/1XE;;;IAEE,8CAAA;EDk2XJ;ECh2XE;;;IAEE,yBAAA;EDm2XJ;ECj2XE;;;IAEE,SAXS;ED+2Xb;ECl2XE;;;IAEE,SAAA;EDq2XJ;ECn3XE;;;IAEE,8CAAA;EDs3XJ;ECp3XE;;;IAEE,yBAAA;EDu3XJ;ECr3XE;;;IAEE,SAXS;EDm4Xb;ECt3XE;;;IAEE,SAAA;EDy3XJ;ECv4XE;;;IAEE,8CAAA;ED04XJ;ECx4XE;;;IAEE,yBAAA;ED24XJ;ECz4XE;;;IAEE,SAXS;EDu5Xb;EC14XE;;;IAEE,SAAA;ED64XJ;EC35XE;;;IAEE,8CAAA;ED85XJ;EC55XE;;;IAEE,yBAAA;ED+5XJ;EC75XE;;;IAEE,SAXS;ED26Xb;EC95XE;;;IAEE,SAAA;EDi6XJ;EC/6XE;;;IAEE,8CAAA;EDk7XJ;ECh7XE;;;IAEE,yBAAA;EDm7XJ;ECj7XE;;;IAEE,SAXS;ED+7Xb;ECl7XE;;;IAEE,SAAA;EDq7XJ;ECn8XE;;;IAEE,8CAAA;EDs8XJ;ECp8XE;;;IAEE,yBAAA;EDu8XJ;ECr8XE;;;IAEE,SAXS;EDm9Xb;ECt8XE;;;IAEE,SAAA;EDy8XJ;ECv9XE;;;IAEE,8CAAA;ED09XJ;ECx9XE;;;IAEE,yBAAA;ED29XJ;ECz9XE;;;IAEE,SAXS;EDu+Xb;EC19XE;;;IAEE,SAAA;ED69XJ;EC3+XE;;;IAEE,8CAAA;ED8+XJ;EC5+XE;;;IAEE,yBAAA;ED++XJ;EC7+XE;;;IAEE,SAXS;ED2/Xb;EC9+XE;;;IAEE,SAAA;EDi/XJ;EC//XE;;;IAEE,8CAAA;EDkgYJ;EChgYE;;;IAEE,yBAAA;EDmgYJ;ECjgYE;;;IAEE,SAXS;ED+gYb;EClgYE;;;IAEE,SAAA;EDqgYJ;ECnhYE;;;IAEE,8CAAA;EDshYJ;ECphYE;;;IAEE,yBAAA;EDuhYJ;ECrhYE;;;IAEE,SAXS;EDmiYb;ECthYE;;;IAEE,SAAA;EDyhYJ;ECviYE;;;IAEE,8CAAA;ED0iYJ;ECxiYE;;;IAEE,yBAAA;ED2iYJ;ECziYE;;;IAEE,SAXS;EDujYb;EC1iYE;;;IAEE,SAAA;ED6iYJ;EC3jYE;;;IAEE,8CAAA;ED8jYJ;EC5jYE;;;IAEE,yBAAA;ED+jYJ;EC7jYE;;;IAEE,SAXS;ED2kYb;EC9jYE;;;IAEE,SAAA;EDikYJ;EC/kYE;;;IAEE,8CAAA;EDklYJ;EChlYE;;;IAEE,yBAAA;EDmlYJ;ECjlYE;;;IAEE,SAXS;ED+lYb;ECllYE;;;IAEE,SAAA;EDqlYJ;ECnmYE;;;IAEE,8CAAA;EDsmYJ;ECpmYE;;;IAEE,yBAAA;EDumYJ;ECrmYE;;;IAEE,SAXS;EDmnYb;ECtmYE;;;IAEE,SAAA;EDymYJ;ECvnYE;;;IAEE,8CAAA;ED0nYJ;ECxnYE;;;IAEE,yBAAA;ED2nYJ;ECznYE;;;IAEE,SAXS;EDuoYb;EC1nYE;;;IAEE,SAAA;ED6nYJ;EC3oYE;;;IAEE,8CAAA;ED8oYJ;EC5oYE;;;IAEE,yBAAA;ED+oYJ;EC7oYE;;;IAEE,SAXS;ED2pYb;EC9oYE;;;IAEE,SAAA;EDipYJ;EC/pYE;;;IAEE,8CAAA;EDkqYJ;EChqYE;;;IAEE,yBAAA;EDmqYJ;ECjqYE;;;IAEE,SAXS;ED+qYb;EClqYE;;;IAEE,SAAA;EDqqYJ;ECnrYE;;;IAEE,8CAAA;EDsrYJ;ECprYE;;;IAEE,yBAAA;EDurYJ;ECrrYE;;;IAEE,SAXS;EDmsYb;ECtrYE;;;IAEE,SAAA;EDyrYJ;ECvsYE;;;IAEE,8CAAA;ED0sYJ;ECxsYE;;;IAEE,yBAAA;ED2sYJ;ECzsYE;;;IAEE,SAXS;EDutYb;EC1sYE;;;IAEE,SAAA;ED6sYJ;EC3tYE;;;IAEE,8CAAA;ED8tYJ;EC5tYE;;;IAEE,yBAAA;ED+tYJ;EC7tYE;;;IAEE,SAXS;ED2uYb;EC9tYE;;;IAEE,SAAA;EDiuYJ;EC/uYE;;;IAEE,8CAAA;EDkvYJ;EChvYE;;;IAEE,yBAAA;EDmvYJ;ECjvYE;;;IAEE,SAXS;ED+vYb;EClvYE;;;IAEE,SAAA;EDqvYJ;ECnwYE;;;IAEE,8CAAA;EDswYJ;ECpwYE;;;IAEE,yBAAA;EDuwYJ;ECrwYE;;;IAEE,SAXS;EDmxYb;ECtwYE;;;IAEE,SAAA;EDywYJ;ECvxYE;;;IAEE,8CAAA;ED0xYJ;ECxxYE;;;IAEE,yBAAA;ED2xYJ;ECzxYE;;;IAEE,SAXS;EDuyYb;EC1xYE;;;IAEE,SAAA;ED6xYJ;EC3yYE;;;IAEE,8CAAA;ED8yYJ;EC5yYE;;;IAEE,yBAAA;ED+yYJ;EC7yYE;;;IAEE,SAXS;ED2zYb;EC9yYE;;;IAEE,SAAA;EDizYJ;EC/zYE;;;IAEE,8CAAA;EDk0YJ;ECh0YE;;;IAEE,yBAAA;EDm0YJ;ECj0YE;;;IAEE,SAXS;ED+0Yb;ECl0YE;;;IAEE,SAAA;EDq0YJ;ECn1YE;;;IAEE,8CAAA;EDs1YJ;ECp1YE;;;IAEE,yBAAA;EDu1YJ;ECr1YE;;;IAEE,SAXS;EDm2Yb;ECt1YE;;;IAEE,SAAA;EDy1YJ;ECv2YE;;;IAEE,8CAAA;ED02YJ;ECx2YE;;;IAEE,yBAAA;ED22YJ;ECz2YE;;;IAEE,SAXS;EDu3Yb;EC12YE;;;IAEE,SAAA;ED62YJ;ECv2YA;;IACE,cAAA;ED02YF;AACF;ACxzYI;EAoBA;;;IAEE,0BAAA;EDwyYJ;ECtyYE;;;IAEE,oBAPS;EDgzYb;ECvyYE;;;IAEE,kBAXS;EDqzYb;ECpzYE;;;IAEE,0BAAA;EDuzYJ;ECrzYE;;;IAEE,oBAPS;ED+zYb;ECtzYE;;;IAEE,kBAXS;EDo0Yb;ECn0YE;;;IAEE,0BAAA;EDs0YJ;ECp0YE;;;IAEE,oBAPS;ED80Yb;ECr0YE;;;IAEE,kBAXS;EDm1Yb;ECl1YE;;;IAEE,0BAAA;EDq1YJ;ECn1YE;;;IAEE,oBAPS;ED61Yb;ECp1YE;;;IAEE,kBAXS;EDk2Yb;ECj2YE;;;IAEE,0BAAA;EDo2YJ;ECl2YE;;;IAEE,oBAPS;ED42Yb;ECn2YE;;;IAEE,kBAXS;EDi3Yb;ECh3YE;;;IAEE,0BAAA;EDm3YJ;ECj3YE;;;IAEE,oBAPS;ED23Yb;ECl3YE;;;IAEE,kBAXS;EDg4Yb;EC/3YE;;;IAEE,0BAAA;EDk4YJ;ECh4YE;;;IAEE,oBAPS;ED04Yb;ECj4YE;;;IAEE,kBAXS;ED+4Yb;EC94YE;;;IAEE,0BAAA;EDi5YJ;EC/4YE;;;IAEE,oBAPS;EDy5Yb;ECh5YE;;;IAEE,kBAXS;ED85Yb;EC75YE;;;IAEE,0BAAA;EDg6YJ;EC95YE;;;IAEE,oBAPS;EDw6Yb;EC/5YE;;;IAEE,kBAXS;ED66Yb;EC56YE;;;IAEE,4BAAA;ED+6YJ;EC76YE;;;IAEE,qBAPS;EDu7Yb;EC96YE;;;IAEE,mBAXS;ED47Yb;EC37YE;;;IAEE,4BAAA;ED87YJ;EC57YE;;;IAEE,qBAPS;EDs8Yb;EC77YE;;;IAEE,mBAXS;ED28Yb;EC18YE;;;IAEE,4BAAA;ED68YJ;EC38YE;;;IAEE,qBAPS;EDq9Yb;EC58YE;;;IAEE,mBAXS;ED09Yb;ECz9YE;;;IAEE,4BAAA;ED49YJ;EC19YE;;;IAEE,qBAPS;EDo+Yb;EC39YE;;;IAEE,mBAXS;EDy+Yb;ECx+YE;;;IAEE,4BAAA;ED2+YJ;ECz+YE;;;IAEE,qBAPS;EDm/Yb;EC1+YE;;;IAEE,mBAXS;EDw/Yb;ECv/YE;;;IAEE,4BAAA;ED0/YJ;ECx/YE;;;IAEE,qBAPS;EDkgZb;ECz/YE;;;IAEE,mBAXS;EDugZb;ECtgZE;;;IAEE,4BAAA;EDygZJ;ECvgZE;;;IAEE,qBAPS;EDihZb;ECxgZE;;;IAEE,mBAXS;EDshZb;ECrhZE;;;IAEE,4BAAA;EDwhZJ;ECthZE;;;IAEE,qBAPS;EDgiZb;ECvhZE;;;IAEE,mBAXS;EDqiZb;ECpiZE;;;IAEE,4BAAA;EDuiZJ;ECriZE;;;IAEE,qBAPS;ED+iZb;ECtiZE;;;IAEE,mBAXS;EDojZb;ECnjZE;;;IAEE,4BAAA;EDsjZJ;ECpjZE;;;IAEE,qBAPS;ED8jZb;ECrjZE;;;IAEE,mBAXS;EDmkZb;EClkZE;;;IAEE,4BAAA;EDqkZJ;ECnkZE;;;IAEE,qBAPS;ED6kZb;ECpkZE;;;IAEE,mBAXS;EDklZb;ECjlZE;;;IAEE,4BAAA;EDolZJ;ECllZE;;;IAEE,qBAPS;ED4lZb;ECnlZE;;;IAEE,mBAXS;EDimZb;EChmZE;;;IAEE,4BAAA;EDmmZJ;ECjmZE;;;IAEE,qBAPS;ED2mZb;EClmZE;;;IAEE,mBAXS;EDgnZb;EC/mZE;;;IAEE,4BAAA;EDknZJ;EChnZE;;;IAEE,qBAPS;ED0nZb;ECjnZE;;;IAEE,mBAXS;ED+nZb;EC9nZE;;;IAEE,4BAAA;EDioZJ;EC/nZE;;;IAEE,qBAPS;EDyoZb;EChoZE;;;IAEE,mBAXS;ED8oZb;ECzuZE;;;IAEE,6CAAA;ED4uZJ;EC1uZE;;;IAEE,uBAAA;ED6uZJ;EC3uZE;;;IAEE,QAXS;EDyvZb;EC5uZE;;;IAEE,SAAA;ED+uZJ;EC7vZE;;;IAEE,6CAAA;EDgwZJ;EC9vZE;;;IAEE,uBAAA;EDiwZJ;EC/vZE;;;IAEE,QAXS;ED6wZb;EChwZE;;;IAEE,SAAA;EDmwZJ;ECjxZE;;;IAEE,6CAAA;EDoxZJ;EClxZE;;;IAEE,uBAAA;EDqxZJ;ECnxZE;;;IAEE,QAXS;EDiyZb;ECpxZE;;;IAEE,SAAA;EDuxZJ;ECryZE;;;IAEE,6CAAA;EDwyZJ;ECtyZE;;;IAEE,uBAAA;EDyyZJ;ECvyZE;;;IAEE,QAXS;EDqzZb;ECxyZE;;;IAEE,SAAA;ED2yZJ;ECzzZE;;;IAEE,6CAAA;ED4zZJ;EC1zZE;;;IAEE,uBAAA;ED6zZJ;EC3zZE;;;IAEE,QAXS;EDy0Zb;EC5zZE;;;IAEE,SAAA;ED+zZJ;EC70ZE;;;IAEE,6CAAA;EDg1ZJ;EC90ZE;;;IAEE,uBAAA;EDi1ZJ;EC/0ZE;;;IAEE,QAXS;ED61Zb;ECh1ZE;;;IAEE,SAAA;EDm1ZJ;ECj2ZE;;;IAEE,6CAAA;EDo2ZJ;ECl2ZE;;;IAEE,uBAAA;EDq2ZJ;ECn2ZE;;;IAEE,QAXS;EDi3Zb;ECp2ZE;;;IAEE,SAAA;EDu2ZJ;ECr3ZE;;;IAEE,6CAAA;EDw3ZJ;ECt3ZE;;;IAEE,uBAAA;EDy3ZJ;ECv3ZE;;;IAEE,QAXS;EDq4Zb;ECx3ZE;;;IAEE,SAAA;ED23ZJ;ECz4ZE;;;IAEE,6CAAA;ED44ZJ;EC14ZE;;;IAEE,uBAAA;ED64ZJ;EC34ZE;;;IAEE,QAXS;EDy5Zb;EC54ZE;;;IAEE,SAAA;ED+4ZJ;EC75ZE;;;IAEE,8CAAA;EDg6ZJ;EC95ZE;;;IAEE,yBAAA;EDi6ZJ;EC/5ZE;;;IAEE,SAXS;ED66Zb;ECh6ZE;;;IAEE,SAAA;EDm6ZJ;ECj7ZE;;;IAEE,8CAAA;EDo7ZJ;ECl7ZE;;;IAEE,yBAAA;EDq7ZJ;ECn7ZE;;;IAEE,SAXS;EDi8Zb;ECp7ZE;;;IAEE,SAAA;EDu7ZJ;ECr8ZE;;;IAEE,8CAAA;EDw8ZJ;ECt8ZE;;;IAEE,yBAAA;EDy8ZJ;ECv8ZE;;;IAEE,SAXS;EDq9Zb;ECx8ZE;;;IAEE,SAAA;ED28ZJ;ECz9ZE;;;IAEE,8CAAA;ED49ZJ;EC19ZE;;;IAEE,yBAAA;ED69ZJ;EC39ZE;;;IAEE,SAXS;EDy+Zb;EC59ZE;;;IAEE,SAAA;ED+9ZJ;EC7+ZE;;;IAEE,8CAAA;EDg/ZJ;EC9+ZE;;;IAEE,yBAAA;EDi/ZJ;EC/+ZE;;;IAEE,SAXS;ED6/Zb;ECh/ZE;;;IAEE,SAAA;EDm/ZJ;ECjgaE;;;IAEE,8CAAA;EDogaJ;EClgaE;;;IAEE,yBAAA;EDqgaJ;ECngaE;;;IAEE,SAXS;EDihab;ECpgaE;;;IAEE,SAAA;EDugaJ;ECrhaE;;;IAEE,8CAAA;EDwhaJ;ECthaE;;;IAEE,yBAAA;EDyhaJ;ECvhaE;;;IAEE,SAXS;EDqiab;ECxhaE;;;IAEE,SAAA;ED2haJ;ECziaE;;;IAEE,8CAAA;ED4iaJ;EC1iaE;;;IAEE,yBAAA;ED6iaJ;EC3iaE;;;IAEE,SAXS;EDyjab;EC5iaE;;;IAEE,SAAA;ED+iaJ;EC7jaE;;;IAEE,8CAAA;EDgkaJ;EC9jaE;;;IAEE,yBAAA;EDikaJ;EC/jaE;;;IAEE,SAXS;ED6kab;EChkaE;;;IAEE,SAAA;EDmkaJ;ECjlaE;;;IAEE,8CAAA;EDolaJ;ECllaE;;;IAEE,yBAAA;EDqlaJ;ECnlaE;;;IAEE,SAXS;EDimab;ECplaE;;;IAEE,SAAA;EDulaJ;ECrmaE;;;IAEE,8CAAA;EDwmaJ;ECtmaE;;;IAEE,yBAAA;EDymaJ;ECvmaE;;;IAEE,SAXS;EDqnab;ECxmaE;;;IAEE,SAAA;ED2maJ;ECznaE;;;IAEE,8CAAA;ED4naJ;EC1naE;;;IAEE,yBAAA;ED6naJ;EC3naE;;;IAEE,SAXS;EDyoab;EC5naE;;;IAEE,SAAA;ED+naJ;EC7oaE;;;IAEE,8CAAA;EDgpaJ;EC9oaE;;;IAEE,yBAAA;EDipaJ;EC/oaE;;;IAEE,SAXS;ED6pab;EChpaE;;;IAEE,SAAA;EDmpaJ;ECjqaE;;;IAEE,8CAAA;EDoqaJ;EClqaE;;;IAEE,yBAAA;EDqqaJ;ECnqaE;;;IAEE,SAXS;EDirab;ECpqaE;;;IAEE,SAAA;EDuqaJ;ECrraE;;;IAEE,8CAAA;EDwraJ;ECtraE;;;IAEE,yBAAA;EDyraJ;ECvraE;;;IAEE,SAXS;EDqsab;ECxraE;;;IAEE,SAAA;ED2raJ;ECzsaE;;;IAEE,8CAAA;ED4saJ;EC1saE;;;IAEE,yBAAA;ED6saJ;EC3saE;;;IAEE,SAXS;EDytab;EC5saE;;;IAEE,SAAA;ED+saJ;EC7taE;;;IAEE,8CAAA;EDguaJ;EC9taE;;;IAEE,yBAAA;EDiuaJ;EC/taE;;;IAEE,SAXS;ED6uab;EChuaE;;;IAEE,SAAA;EDmuaJ;ECjvaE;;;IAEE,8CAAA;EDovaJ;EClvaE;;;IAEE,yBAAA;EDqvaJ;ECnvaE;;;IAEE,SAXS;EDiwab;ECpvaE;;;IAEE,SAAA;EDuvaJ;ECrwaE;;;IAEE,8CAAA;EDwwaJ;ECtwaE;;;IAEE,yBAAA;EDywaJ;ECvwaE;;;IAEE,SAXS;EDqxab;ECxwaE;;;IAEE,SAAA;ED2waJ;ECzxaE;;;IAEE,8CAAA;ED4xaJ;EC1xaE;;;IAEE,yBAAA;ED6xaJ;EC3xaE;;;IAEE,SAXS;EDyyab;EC5xaE;;;IAEE,SAAA;ED+xaJ;EC7yaE;;;IAEE,8CAAA;EDgzaJ;EC9yaE;;;IAEE,yBAAA;EDizaJ;EC/yaE;;;IAEE,SAXS;ED6zab;EChzaE;;;IAEE,SAAA;EDmzaJ;ECj0aE;;;IAEE,8CAAA;EDo0aJ;ECl0aE;;;IAEE,yBAAA;EDq0aJ;ECn0aE;;;IAEE,SAXS;EDi1ab;ECp0aE;;;IAEE,SAAA;EDu0aJ;ECr1aE;;;IAEE,8CAAA;EDw1aJ;ECt1aE;;;IAEE,yBAAA;EDy1aJ;ECv1aE;;;IAEE,SAXS;EDq2ab;ECx1aE;;;IAEE,SAAA;ED21aJ;ECz2aE;;;IAEE,8CAAA;ED42aJ;EC12aE;;;IAEE,yBAAA;ED62aJ;EC32aE;;;IAEE,SAXS;EDy3ab;EC52aE;;;IAEE,SAAA;ED+2aJ;EC73aE;;;IAEE,8CAAA;EDg4aJ;EC93aE;;;IAEE,yBAAA;EDi4aJ;EC/3aE;;;IAEE,SAXS;ED64ab;ECh4aE;;;IAEE,SAAA;EDm4aJ;ECj5aE;;;IAEE,8CAAA;EDo5aJ;ECl5aE;;;IAEE,yBAAA;EDq5aJ;ECn5aE;;;IAEE,SAXS;EDi6ab;ECp5aE;;;IAEE,SAAA;EDu5aJ;ECr6aE;;;IAEE,8CAAA;EDw6aJ;ECt6aE;;;IAEE,yBAAA;EDy6aJ;ECv6aE;;;IAEE,SAXS;EDq7ab;ECx6aE;;;IAEE,SAAA;ED26aJ;ECz7aE;;;IAEE,8CAAA;ED47aJ;EC17aE;;;IAEE,yBAAA;ED67aJ;EC37aE;;;IAEE,SAXS;EDy8ab;EC57aE;;;IAEE,SAAA;ED+7aJ;EC78aE;;;IAEE,8CAAA;EDg9aJ;EC98aE;;;IAEE,yBAAA;EDi9aJ;EC/8aE;;;IAEE,SAXS;ED69ab;ECh9aE;;;IAEE,SAAA;EDm9aJ;ECj+aE;;;IAEE,8CAAA;EDo+aJ;ECl+aE;;;IAEE,yBAAA;EDq+aJ;ECn+aE;;;IAEE,SAXS;EDi/ab;ECp+aE;;;IAEE,SAAA;EDu+aJ;ECr/aE;;;IAEE,8CAAA;EDw/aJ;ECt/aE;;;IAEE,yBAAA;EDy/aJ;ECv/aE;;;IAEE,SAXS;EDqgbb;ECx/aE;;;IAEE,SAAA;ED2/aJ;ECzgbE;;;IAEE,8CAAA;ED4gbJ;EC1gbE;;;IAEE,yBAAA;ED6gbJ;EC3gbE;;;IAEE,SAXS;EDyhbb;EC5gbE;;;IAEE,SAAA;ED+gbJ;EC7hbE;;;IAEE,8CAAA;EDgibJ;EC9hbE;;;IAEE,yBAAA;EDiibJ;EC/hbE;;;IAEE,SAXS;ED6ibb;EChibE;;;IAEE,SAAA;EDmibJ;ECjjbE;;;IAEE,8CAAA;EDojbJ;ECljbE;;;IAEE,yBAAA;EDqjbJ;ECnjbE;;;IAEE,SAXS;EDikbb;ECpjbE;;;IAEE,SAAA;EDujbJ;ECrkbE;;;IAEE,8CAAA;EDwkbJ;ECtkbE;;;IAEE,yBAAA;EDykbJ;ECvkbE;;;IAEE,SAXS;EDqlbb;ECxkbE;;;IAEE,SAAA;ED2kbJ;ECzlbE;;;IAEE,8CAAA;ED4lbJ;EC1lbE;;;IAEE,yBAAA;ED6lbJ;EC3lbE;;;IAEE,SAXS;EDymbb;EC5lbE;;;IAEE,SAAA;ED+lbJ;EC7mbE;;;IAEE,8CAAA;EDgnbJ;EC9mbE;;;IAEE,yBAAA;EDinbJ;EC/mbE;;;IAEE,SAXS;ED6nbb;EChnbE;;;IAEE,SAAA;EDmnbJ;ECjobE;;;IAEE,8CAAA;EDoobJ;EClobE;;;IAEE,yBAAA;EDqobJ;ECnobE;;;IAEE,SAXS;EDipbb;ECpobE;;;IAEE,SAAA;EDuobJ;ECrpbE;;;IAEE,8CAAA;EDwpbJ;ECtpbE;;;IAEE,yBAAA;EDypbJ;ECvpbE;;;IAEE,SAXS;EDqqbb;ECxpbE;;;IAEE,SAAA;ED2pbJ;ECzqbE;;;IAEE,8CAAA;ED4qbJ;EC1qbE;;;IAEE,yBAAA;ED6qbJ;EC3qbE;;;IAEE,SAXS;EDyrbb;EC5qbE;;;IAEE,SAAA;ED+qbJ;EC7rbE;;;IAEE,8CAAA;EDgsbJ;EC9rbE;;;IAEE,yBAAA;EDisbJ;EC/rbE;;;IAEE,SAXS;ED6sbb;EChsbE;;;IAEE,SAAA;EDmsbJ;EC7rbA;;IACE,cAAA;EDgsbF;AACF;AC9obI;EAoBA;;;IAEE,0BAAA;ED8nbJ;EC5nbE;;;IAEE,oBAPS;EDsobb;EC7nbE;;;IAEE,kBAXS;ED2obb;EC1obE;;;IAEE,0BAAA;ED6obJ;EC3obE;;;IAEE,oBAPS;EDqpbb;EC5obE;;;IAEE,kBAXS;ED0pbb;ECzpbE;;;IAEE,0BAAA;ED4pbJ;EC1pbE;;;IAEE,oBAPS;EDoqbb;EC3pbE;;;IAEE,kBAXS;EDyqbb;ECxqbE;;;IAEE,0BAAA;ED2qbJ;ECzqbE;;;IAEE,oBAPS;EDmrbb;EC1qbE;;;IAEE,kBAXS;EDwrbb;ECvrbE;;;IAEE,0BAAA;ED0rbJ;ECxrbE;;;IAEE,oBAPS;EDksbb;ECzrbE;;;IAEE,kBAXS;EDusbb;ECtsbE;;;IAEE,0BAAA;EDysbJ;ECvsbE;;;IAEE,oBAPS;EDitbb;ECxsbE;;;IAEE,kBAXS;EDstbb;ECrtbE;;;IAEE,0BAAA;EDwtbJ;ECttbE;;;IAEE,oBAPS;EDgubb;ECvtbE;;;IAEE,kBAXS;EDqubb;ECpubE;;;IAEE,0BAAA;EDuubJ;ECrubE;;;IAEE,oBAPS;ED+ubb;ECtubE;;;IAEE,kBAXS;EDovbb;ECnvbE;;;IAEE,0BAAA;EDsvbJ;ECpvbE;;;IAEE,oBAPS;ED8vbb;ECrvbE;;;IAEE,kBAXS;EDmwbb;EClwbE;;;IAEE,4BAAA;EDqwbJ;ECnwbE;;;IAEE,qBAPS;ED6wbb;ECpwbE;;;IAEE,mBAXS;EDkxbb;ECjxbE;;;IAEE,4BAAA;EDoxbJ;EClxbE;;;IAEE,qBAPS;ED4xbb;ECnxbE;;;IAEE,mBAXS;EDiybb;EChybE;;;IAEE,4BAAA;EDmybJ;ECjybE;;;IAEE,qBAPS;ED2ybb;EClybE;;;IAEE,mBAXS;EDgzbb;EC/ybE;;;IAEE,4BAAA;EDkzbJ;EChzbE;;;IAEE,qBAPS;ED0zbb;ECjzbE;;;IAEE,mBAXS;ED+zbb;EC9zbE;;;IAEE,4BAAA;EDi0bJ;EC/zbE;;;IAEE,qBAPS;EDy0bb;ECh0bE;;;IAEE,mBAXS;ED80bb;EC70bE;;;IAEE,4BAAA;EDg1bJ;EC90bE;;;IAEE,qBAPS;EDw1bb;EC/0bE;;;IAEE,mBAXS;ED61bb;EC51bE;;;IAEE,4BAAA;ED+1bJ;EC71bE;;;IAEE,qBAPS;EDu2bb;EC91bE;;;IAEE,mBAXS;ED42bb;EC32bE;;;IAEE,4BAAA;ED82bJ;EC52bE;;;IAEE,qBAPS;EDs3bb;EC72bE;;;IAEE,mBAXS;ED23bb;EC13bE;;;IAEE,4BAAA;ED63bJ;EC33bE;;;IAEE,qBAPS;EDq4bb;EC53bE;;;IAEE,mBAXS;ED04bb;ECz4bE;;;IAEE,4BAAA;ED44bJ;EC14bE;;;IAEE,qBAPS;EDo5bb;EC34bE;;;IAEE,mBAXS;EDy5bb;ECx5bE;;;IAEE,4BAAA;ED25bJ;ECz5bE;;;IAEE,qBAPS;EDm6bb;EC15bE;;;IAEE,mBAXS;EDw6bb;ECv6bE;;;IAEE,4BAAA;ED06bJ;ECx6bE;;;IAEE,qBAPS;EDk7bb;ECz6bE;;;IAEE,mBAXS;EDu7bb;ECt7bE;;;IAEE,4BAAA;EDy7bJ;ECv7bE;;;IAEE,qBAPS;EDi8bb;ECx7bE;;;IAEE,mBAXS;EDs8bb;ECr8bE;;;IAEE,4BAAA;EDw8bJ;ECt8bE;;;IAEE,qBAPS;EDg9bb;ECv8bE;;;IAEE,mBAXS;EDq9bb;ECp9bE;;;IAEE,4BAAA;EDu9bJ;ECr9bE;;;IAEE,qBAPS;ED+9bb;ECt9bE;;;IAEE,mBAXS;EDo+bb;EC/jcE;;;IAEE,6CAAA;EDkkcJ;EChkcE;;;IAEE,uBAAA;EDmkcJ;ECjkcE;;;IAEE,QAXS;ED+kcb;EClkcE;;;IAEE,SAAA;EDqkcJ;ECnlcE;;;IAEE,6CAAA;EDslcJ;ECplcE;;;IAEE,uBAAA;EDulcJ;ECrlcE;;;IAEE,QAXS;EDmmcb;ECtlcE;;;IAEE,SAAA;EDylcJ;ECvmcE;;;IAEE,6CAAA;ED0mcJ;ECxmcE;;;IAEE,uBAAA;ED2mcJ;ECzmcE;;;IAEE,QAXS;EDuncb;EC1mcE;;;IAEE,SAAA;ED6mcJ;EC3ncE;;;IAEE,6CAAA;ED8ncJ;EC5ncE;;;IAEE,uBAAA;ED+ncJ;EC7ncE;;;IAEE,QAXS;ED2ocb;EC9ncE;;;IAEE,SAAA;EDiocJ;EC/ocE;;;IAEE,6CAAA;EDkpcJ;EChpcE;;;IAEE,uBAAA;EDmpcJ;ECjpcE;;;IAEE,QAXS;ED+pcb;EClpcE;;;IAEE,SAAA;EDqpcJ;ECnqcE;;;IAEE,6CAAA;EDsqcJ;ECpqcE;;;IAEE,uBAAA;EDuqcJ;ECrqcE;;;IAEE,QAXS;EDmrcb;ECtqcE;;;IAEE,SAAA;EDyqcJ;ECvrcE;;;IAEE,6CAAA;ED0rcJ;ECxrcE;;;IAEE,uBAAA;ED2rcJ;ECzrcE;;;IAEE,QAXS;EDuscb;EC1rcE;;;IAEE,SAAA;ED6rcJ;EC3scE;;;IAEE,6CAAA;ED8scJ;EC5scE;;;IAEE,uBAAA;ED+scJ;EC7scE;;;IAEE,QAXS;ED2tcb;EC9scE;;;IAEE,SAAA;EDitcJ;EC/tcE;;;IAEE,6CAAA;EDkucJ;EChucE;;;IAEE,uBAAA;EDmucJ;ECjucE;;;IAEE,QAXS;ED+ucb;EClucE;;;IAEE,SAAA;EDqucJ;ECnvcE;;;IAEE,8CAAA;EDsvcJ;ECpvcE;;;IAEE,yBAAA;EDuvcJ;ECrvcE;;;IAEE,SAXS;EDmwcb;ECtvcE;;;IAEE,SAAA;EDyvcJ;ECvwcE;;;IAEE,8CAAA;ED0wcJ;ECxwcE;;;IAEE,yBAAA;ED2wcJ;ECzwcE;;;IAEE,SAXS;EDuxcb;EC1wcE;;;IAEE,SAAA;ED6wcJ;EC3xcE;;;IAEE,8CAAA;ED8xcJ;EC5xcE;;;IAEE,yBAAA;ED+xcJ;EC7xcE;;;IAEE,SAXS;ED2ycb;EC9xcE;;;IAEE,SAAA;EDiycJ;EC/ycE;;;IAEE,8CAAA;EDkzcJ;EChzcE;;;IAEE,yBAAA;EDmzcJ;ECjzcE;;;IAEE,SAXS;ED+zcb;EClzcE;;;IAEE,SAAA;EDqzcJ;ECn0cE;;;IAEE,8CAAA;EDs0cJ;ECp0cE;;;IAEE,yBAAA;EDu0cJ;ECr0cE;;;IAEE,SAXS;EDm1cb;ECt0cE;;;IAEE,SAAA;EDy0cJ;ECv1cE;;;IAEE,8CAAA;ED01cJ;ECx1cE;;;IAEE,yBAAA;ED21cJ;ECz1cE;;;IAEE,SAXS;EDu2cb;EC11cE;;;IAEE,SAAA;ED61cJ;EC32cE;;;IAEE,8CAAA;ED82cJ;EC52cE;;;IAEE,yBAAA;ED+2cJ;EC72cE;;;IAEE,SAXS;ED23cb;EC92cE;;;IAEE,SAAA;EDi3cJ;EC/3cE;;;IAEE,8CAAA;EDk4cJ;ECh4cE;;;IAEE,yBAAA;EDm4cJ;ECj4cE;;;IAEE,SAXS;ED+4cb;ECl4cE;;;IAEE,SAAA;EDq4cJ;ECn5cE;;;IAEE,8CAAA;EDs5cJ;ECp5cE;;;IAEE,yBAAA;EDu5cJ;ECr5cE;;;IAEE,SAXS;EDm6cb;ECt5cE;;;IAEE,SAAA;EDy5cJ;ECv6cE;;;IAEE,8CAAA;ED06cJ;ECx6cE;;;IAEE,yBAAA;ED26cJ;ECz6cE;;;IAEE,SAXS;EDu7cb;EC16cE;;;IAEE,SAAA;ED66cJ;EC37cE;;;IAEE,8CAAA;ED87cJ;EC57cE;;;IAEE,yBAAA;ED+7cJ;EC77cE;;;IAEE,SAXS;ED28cb;EC97cE;;;IAEE,SAAA;EDi8cJ;EC/8cE;;;IAEE,8CAAA;EDk9cJ;ECh9cE;;;IAEE,yBAAA;EDm9cJ;ECj9cE;;;IAEE,SAXS;ED+9cb;ECl9cE;;;IAEE,SAAA;EDq9cJ;ECn+cE;;;IAEE,8CAAA;EDs+cJ;ECp+cE;;;IAEE,yBAAA;EDu+cJ;ECr+cE;;;IAEE,SAXS;EDm/cb;ECt+cE;;;IAEE,SAAA;EDy+cJ;ECv/cE;;;IAEE,8CAAA;ED0/cJ;ECx/cE;;;IAEE,yBAAA;ED2/cJ;ECz/cE;;;IAEE,SAXS;EDugdb;EC1/cE;;;IAEE,SAAA;ED6/cJ;EC3gdE;;;IAEE,8CAAA;ED8gdJ;EC5gdE;;;IAEE,yBAAA;ED+gdJ;EC7gdE;;;IAEE,SAXS;ED2hdb;EC9gdE;;;IAEE,SAAA;EDihdJ;EC/hdE;;;IAEE,8CAAA;EDkidJ;EChidE;;;IAEE,yBAAA;EDmidJ;ECjidE;;;IAEE,SAXS;ED+idb;EClidE;;;IAEE,SAAA;EDqidJ;ECnjdE;;;IAEE,8CAAA;EDsjdJ;ECpjdE;;;IAEE,yBAAA;EDujdJ;ECrjdE;;;IAEE,SAXS;EDmkdb;ECtjdE;;;IAEE,SAAA;EDyjdJ;ECvkdE;;;IAEE,8CAAA;ED0kdJ;ECxkdE;;;IAEE,yBAAA;ED2kdJ;ECzkdE;;;IAEE,SAXS;EDuldb;EC1kdE;;;IAEE,SAAA;ED6kdJ;EC3ldE;;;IAEE,8CAAA;ED8ldJ;EC5ldE;;;IAEE,yBAAA;ED+ldJ;EC7ldE;;;IAEE,SAXS;ED2mdb;EC9ldE;;;IAEE,SAAA;EDimdJ;EC/mdE;;;IAEE,8CAAA;EDkndJ;EChndE;;;IAEE,yBAAA;EDmndJ;ECjndE;;;IAEE,SAXS;ED+ndb;EClndE;;;IAEE,SAAA;EDqndJ;ECnodE;;;IAEE,8CAAA;EDsodJ;ECpodE;;;IAEE,yBAAA;EDuodJ;ECrodE;;;IAEE,SAXS;EDmpdb;ECtodE;;;IAEE,SAAA;EDyodJ;ECvpdE;;;IAEE,8CAAA;ED0pdJ;ECxpdE;;;IAEE,yBAAA;ED2pdJ;ECzpdE;;;IAEE,SAXS;EDuqdb;EC1pdE;;;IAEE,SAAA;ED6pdJ;EC3qdE;;;IAEE,8CAAA;ED8qdJ;EC5qdE;;;IAEE,yBAAA;ED+qdJ;EC7qdE;;;IAEE,SAXS;ED2rdb;EC9qdE;;;IAEE,SAAA;EDirdJ;EC/rdE;;;IAEE,8CAAA;EDksdJ;EChsdE;;;IAEE,yBAAA;EDmsdJ;ECjsdE;;;IAEE,SAXS;ED+sdb;EClsdE;;;IAEE,SAAA;EDqsdJ;ECntdE;;;IAEE,8CAAA;EDstdJ;ECptdE;;;IAEE,yBAAA;EDutdJ;ECrtdE;;;IAEE,SAXS;EDmudb;ECttdE;;;IAEE,SAAA;EDytdJ;ECvudE;;;IAEE,8CAAA;ED0udJ;ECxudE;;;IAEE,yBAAA;ED2udJ;ECzudE;;;IAEE,SAXS;EDuvdb;EC1udE;;;IAEE,SAAA;ED6udJ;EC3vdE;;;IAEE,8CAAA;ED8vdJ;EC5vdE;;;IAEE,yBAAA;ED+vdJ;EC7vdE;;;IAEE,SAXS;ED2wdb;EC9vdE;;;IAEE,SAAA;EDiwdJ;EC/wdE;;;IAEE,8CAAA;EDkxdJ;EChxdE;;;IAEE,yBAAA;EDmxdJ;ECjxdE;;;IAEE,SAXS;ED+xdb;EClxdE;;;IAEE,SAAA;EDqxdJ;ECnydE;;;IAEE,8CAAA;EDsydJ;ECpydE;;;IAEE,yBAAA;EDuydJ;ECrydE;;;IAEE,SAXS;EDmzdb;ECtydE;;;IAEE,SAAA;EDyydJ;ECvzdE;;;IAEE,8CAAA;ED0zdJ;ECxzdE;;;IAEE,yBAAA;ED2zdJ;ECzzdE;;;IAEE,SAXS;EDu0db;EC1zdE;;;IAEE,SAAA;ED6zdJ;EC30dE;;;IAEE,8CAAA;ED80dJ;EC50dE;;;IAEE,yBAAA;ED+0dJ;EC70dE;;;IAEE,SAXS;ED21db;EC90dE;;;IAEE,SAAA;EDi1dJ;EC/1dE;;;IAEE,8CAAA;EDk2dJ;ECh2dE;;;IAEE,yBAAA;EDm2dJ;ECj2dE;;;IAEE,SAXS;ED+2db;ECl2dE;;;IAEE,SAAA;EDq2dJ;ECn3dE;;;IAEE,8CAAA;EDs3dJ;ECp3dE;;;IAEE,yBAAA;EDu3dJ;ECr3dE;;;IAEE,SAXS;EDm4db;ECt3dE;;;IAEE,SAAA;EDy3dJ;ECv4dE;;;IAEE,8CAAA;ED04dJ;ECx4dE;;;IAEE,yBAAA;ED24dJ;ECz4dE;;;IAEE,SAXS;EDu5db;EC14dE;;;IAEE,SAAA;ED64dJ;EC35dE;;;IAEE,8CAAA;ED85dJ;EC55dE;;;IAEE,yBAAA;ED+5dJ;EC75dE;;;IAEE,SAXS;ED26db;EC95dE;;;IAEE,SAAA;EDi6dJ;EC/6dE;;;IAEE,8CAAA;EDk7dJ;ECh7dE;;;IAEE,yBAAA;EDm7dJ;ECj7dE;;;IAEE,SAXS;ED+7db;ECl7dE;;;IAEE,SAAA;EDq7dJ;ECn8dE;;;IAEE,8CAAA;EDs8dJ;ECp8dE;;;IAEE,yBAAA;EDu8dJ;ECr8dE;;;IAEE,SAXS;EDm9db;ECt8dE;;;IAEE,SAAA;EDy8dJ;ECv9dE;;;IAEE,8CAAA;ED09dJ;ECx9dE;;;IAEE,yBAAA;ED29dJ;ECz9dE;;;IAEE,SAXS;EDu+db;EC19dE;;;IAEE,SAAA;ED69dJ;EC3+dE;;;IAEE,8CAAA;ED8+dJ;EC5+dE;;;IAEE,yBAAA;ED++dJ;EC7+dE;;;IAEE,SAXS;ED2/db;EC9+dE;;;IAEE,SAAA;EDi/dJ;EC//dE;;;IAEE,8CAAA;EDkgeJ;EChgeE;;;IAEE,yBAAA;EDmgeJ;ECjgeE;;;IAEE,SAXS;ED+geb;EClgeE;;;IAEE,SAAA;EDqgeJ;ECnheE;;;IAEE,8CAAA;EDsheJ;ECpheE;;;IAEE,yBAAA;EDuheJ;ECrheE;;;IAEE,SAXS;EDmieb;ECtheE;;;IAEE,SAAA;EDyheJ;ECnheA;;IACE,cAAA;EDsheF;AACF;ACp+dI;EAoBA;;;IAEE,0BAAA;EDo9dJ;ECl9dE;;;IAEE,oBAPS;ED49db;ECn9dE;;;IAEE,kBAXS;EDi+db;ECh+dE;;;IAEE,0BAAA;EDm+dJ;ECj+dE;;;IAEE,oBAPS;ED2+db;ECl+dE;;;IAEE,kBAXS;EDg/db;EC/+dE;;;IAEE,0BAAA;EDk/dJ;ECh/dE;;;IAEE,oBAPS;ED0/db;ECj/dE;;;IAEE,kBAXS;ED+/db;EC9/dE;;;IAEE,0BAAA;EDigeJ;EC//dE;;;IAEE,oBAPS;EDygeb;EChgeE;;;IAEE,kBAXS;ED8geb;EC7geE;;;IAEE,0BAAA;EDgheJ;EC9geE;;;IAEE,oBAPS;EDwheb;EC/geE;;;IAEE,kBAXS;ED6heb;EC5heE;;;IAEE,0BAAA;ED+heJ;EC7heE;;;IAEE,oBAPS;EDuieb;EC9heE;;;IAEE,kBAXS;ED4ieb;EC3ieE;;;IAEE,0BAAA;ED8ieJ;EC5ieE;;;IAEE,oBAPS;EDsjeb;EC7ieE;;;IAEE,kBAXS;ED2jeb;EC1jeE;;;IAEE,0BAAA;ED6jeJ;EC3jeE;;;IAEE,oBAPS;EDqkeb;EC5jeE;;;IAEE,kBAXS;ED0keb;ECzkeE;;;IAEE,0BAAA;ED4keJ;EC1keE;;;IAEE,oBAPS;EDoleb;EC3keE;;;IAEE,kBAXS;EDyleb;ECxleE;;;IAEE,4BAAA;ED2leJ;ECzleE;;;IAEE,qBAPS;EDmmeb;EC1leE;;;IAEE,mBAXS;EDwmeb;ECvmeE;;;IAEE,4BAAA;ED0meJ;ECxmeE;;;IAEE,qBAPS;EDkneb;ECzmeE;;;IAEE,mBAXS;EDuneb;ECtneE;;;IAEE,4BAAA;EDyneJ;ECvneE;;;IAEE,qBAPS;EDioeb;ECxneE;;;IAEE,mBAXS;EDsoeb;ECroeE;;;IAEE,4BAAA;EDwoeJ;ECtoeE;;;IAEE,qBAPS;EDgpeb;ECvoeE;;;IAEE,mBAXS;EDqpeb;ECppeE;;;IAEE,4BAAA;EDupeJ;ECrpeE;;;IAEE,qBAPS;ED+peb;ECtpeE;;;IAEE,mBAXS;EDoqeb;ECnqeE;;;IAEE,4BAAA;EDsqeJ;ECpqeE;;;IAEE,qBAPS;ED8qeb;ECrqeE;;;IAEE,mBAXS;EDmreb;EClreE;;;IAEE,4BAAA;EDqreJ;ECnreE;;;IAEE,qBAPS;ED6reb;ECpreE;;;IAEE,mBAXS;EDkseb;ECjseE;;;IAEE,4BAAA;EDoseJ;EClseE;;;IAEE,qBAPS;ED4seb;ECnseE;;;IAEE,mBAXS;EDiteb;EChteE;;;IAEE,4BAAA;EDmteJ;ECjteE;;;IAEE,qBAPS;ED2teb;EClteE;;;IAEE,mBAXS;EDgueb;EC/teE;;;IAEE,4BAAA;EDkueJ;EChueE;;;IAEE,qBAPS;ED0ueb;ECjueE;;;IAEE,mBAXS;ED+ueb;EC9ueE;;;IAEE,4BAAA;EDiveJ;EC/ueE;;;IAEE,qBAPS;EDyveb;EChveE;;;IAEE,mBAXS;ED8veb;EC7veE;;;IAEE,4BAAA;EDgweJ;EC9veE;;;IAEE,qBAPS;EDwweb;EC/veE;;;IAEE,mBAXS;ED6web;EC5weE;;;IAEE,4BAAA;ED+weJ;EC7weE;;;IAEE,qBAPS;EDuxeb;EC9weE;;;IAEE,mBAXS;ED4xeb;EC3xeE;;;IAEE,4BAAA;ED8xeJ;EC5xeE;;;IAEE,qBAPS;EDsyeb;EC7xeE;;;IAEE,mBAXS;ED2yeb;EC1yeE;;;IAEE,4BAAA;ED6yeJ;EC3yeE;;;IAEE,qBAPS;EDqzeb;EC5yeE;;;IAEE,mBAXS;ED0zeb;ECr5eE;;;IAEE,6CAAA;EDw5eJ;ECt5eE;;;IAEE,uBAAA;EDy5eJ;ECv5eE;;;IAEE,QAXS;EDq6eb;ECx5eE;;;IAEE,SAAA;ED25eJ;ECz6eE;;;IAEE,6CAAA;ED46eJ;EC16eE;;;IAEE,uBAAA;ED66eJ;EC36eE;;;IAEE,QAXS;EDy7eb;EC56eE;;;IAEE,SAAA;ED+6eJ;EC77eE;;;IAEE,6CAAA;EDg8eJ;EC97eE;;;IAEE,uBAAA;EDi8eJ;EC/7eE;;;IAEE,QAXS;ED68eb;ECh8eE;;;IAEE,SAAA;EDm8eJ;ECj9eE;;;IAEE,6CAAA;EDo9eJ;ECl9eE;;;IAEE,uBAAA;EDq9eJ;ECn9eE;;;IAEE,QAXS;EDi+eb;ECp9eE;;;IAEE,SAAA;EDu9eJ;ECr+eE;;;IAEE,6CAAA;EDw+eJ;ECt+eE;;;IAEE,uBAAA;EDy+eJ;ECv+eE;;;IAEE,QAXS;EDq/eb;ECx+eE;;;IAEE,SAAA;ED2+eJ;ECz/eE;;;IAEE,6CAAA;ED4/eJ;EC1/eE;;;IAEE,uBAAA;ED6/eJ;EC3/eE;;;IAEE,QAXS;EDygfb;EC5/eE;;;IAEE,SAAA;ED+/eJ;EC7gfE;;;IAEE,6CAAA;EDghfJ;EC9gfE;;;IAEE,uBAAA;EDihfJ;EC/gfE;;;IAEE,QAXS;ED6hfb;EChhfE;;;IAEE,SAAA;EDmhfJ;ECjifE;;;IAEE,6CAAA;EDoifJ;EClifE;;;IAEE,uBAAA;EDqifJ;ECnifE;;;IAEE,QAXS;EDijfb;ECpifE;;;IAEE,SAAA;EDuifJ;ECrjfE;;;IAEE,6CAAA;EDwjfJ;ECtjfE;;;IAEE,uBAAA;EDyjfJ;ECvjfE;;;IAEE,QAXS;EDqkfb;ECxjfE;;;IAEE,SAAA;ED2jfJ;ECzkfE;;;IAEE,8CAAA;ED4kfJ;EC1kfE;;;IAEE,yBAAA;ED6kfJ;EC3kfE;;;IAEE,SAXS;EDylfb;EC5kfE;;;IAEE,SAAA;ED+kfJ;EC7lfE;;;IAEE,8CAAA;EDgmfJ;EC9lfE;;;IAEE,yBAAA;EDimfJ;EC/lfE;;;IAEE,SAXS;ED6mfb;EChmfE;;;IAEE,SAAA;EDmmfJ;ECjnfE;;;IAEE,8CAAA;EDonfJ;EClnfE;;;IAEE,yBAAA;EDqnfJ;ECnnfE;;;IAEE,SAXS;EDiofb;ECpnfE;;;IAEE,SAAA;EDunfJ;ECrofE;;;IAEE,8CAAA;EDwofJ;ECtofE;;;IAEE,yBAAA;EDyofJ;ECvofE;;;IAEE,SAXS;EDqpfb;ECxofE;;;IAEE,SAAA;ED2ofJ;ECzpfE;;;IAEE,8CAAA;ED4pfJ;EC1pfE;;;IAEE,yBAAA;ED6pfJ;EC3pfE;;;IAEE,SAXS;EDyqfb;EC5pfE;;;IAEE,SAAA;ED+pfJ;EC7qfE;;;IAEE,8CAAA;EDgrfJ;EC9qfE;;;IAEE,yBAAA;EDirfJ;EC/qfE;;;IAEE,SAXS;ED6rfb;EChrfE;;;IAEE,SAAA;EDmrfJ;ECjsfE;;;IAEE,8CAAA;EDosfJ;EClsfE;;;IAEE,yBAAA;EDqsfJ;ECnsfE;;;IAEE,SAXS;EDitfb;ECpsfE;;;IAEE,SAAA;EDusfJ;ECrtfE;;;IAEE,8CAAA;EDwtfJ;ECttfE;;;IAEE,yBAAA;EDytfJ;ECvtfE;;;IAEE,SAXS;EDqufb;ECxtfE;;;IAEE,SAAA;ED2tfJ;ECzufE;;;IAEE,8CAAA;ED4ufJ;EC1ufE;;;IAEE,yBAAA;ED6ufJ;EC3ufE;;;IAEE,SAXS;EDyvfb;EC5ufE;;;IAEE,SAAA;ED+ufJ;EC7vfE;;;IAEE,8CAAA;EDgwfJ;EC9vfE;;;IAEE,yBAAA;EDiwfJ;EC/vfE;;;IAEE,SAXS;ED6wfb;EChwfE;;;IAEE,SAAA;EDmwfJ;ECjxfE;;;IAEE,8CAAA;EDoxfJ;EClxfE;;;IAEE,yBAAA;EDqxfJ;ECnxfE;;;IAEE,SAXS;EDiyfb;ECpxfE;;;IAEE,SAAA;EDuxfJ;ECryfE;;;IAEE,8CAAA;EDwyfJ;ECtyfE;;;IAEE,yBAAA;EDyyfJ;ECvyfE;;;IAEE,SAXS;EDqzfb;ECxyfE;;;IAEE,SAAA;ED2yfJ;ECzzfE;;;IAEE,8CAAA;ED4zfJ;EC1zfE;;;IAEE,yBAAA;ED6zfJ;EC3zfE;;;IAEE,SAXS;EDy0fb;EC5zfE;;;IAEE,SAAA;ED+zfJ;EC70fE;;;IAEE,8CAAA;EDg1fJ;EC90fE;;;IAEE,yBAAA;EDi1fJ;EC/0fE;;;IAEE,SAXS;ED61fb;ECh1fE;;;IAEE,SAAA;EDm1fJ;ECj2fE;;;IAEE,8CAAA;EDo2fJ;ECl2fE;;;IAEE,yBAAA;EDq2fJ;ECn2fE;;;IAEE,SAXS;EDi3fb;ECp2fE;;;IAEE,SAAA;EDu2fJ;ECr3fE;;;IAEE,8CAAA;EDw3fJ;ECt3fE;;;IAEE,yBAAA;EDy3fJ;ECv3fE;;;IAEE,SAXS;EDq4fb;ECx3fE;;;IAEE,SAAA;ED23fJ;ECz4fE;;;IAEE,8CAAA;ED44fJ;EC14fE;;;IAEE,yBAAA;ED64fJ;EC34fE;;;IAEE,SAXS;EDy5fb;EC54fE;;;IAEE,SAAA;ED+4fJ;EC75fE;;;IAEE,8CAAA;EDg6fJ;EC95fE;;;IAEE,yBAAA;EDi6fJ;EC/5fE;;;IAEE,SAXS;ED66fb;ECh6fE;;;IAEE,SAAA;EDm6fJ;ECj7fE;;;IAEE,8CAAA;EDo7fJ;ECl7fE;;;IAEE,yBAAA;EDq7fJ;ECn7fE;;;IAEE,SAXS;EDi8fb;ECp7fE;;;IAEE,SAAA;EDu7fJ;ECr8fE;;;IAEE,8CAAA;EDw8fJ;ECt8fE;;;IAEE,yBAAA;EDy8fJ;ECv8fE;;;IAEE,SAXS;EDq9fb;ECx8fE;;;IAEE,SAAA;ED28fJ;ECz9fE;;;IAEE,8CAAA;ED49fJ;EC19fE;;;IAEE,yBAAA;ED69fJ;EC39fE;;;IAEE,SAXS;EDy+fb;EC59fE;;;IAEE,SAAA;ED+9fJ;EC7+fE;;;IAEE,8CAAA;EDg/fJ;EC9+fE;;;IAEE,yBAAA;EDi/fJ;EC/+fE;;;IAEE,SAXS;ED6/fb;ECh/fE;;;IAEE,SAAA;EDm/fJ;ECjggBE;;;IAEE,8CAAA;EDoggBJ;EClggBE;;;IAEE,yBAAA;EDqggBJ;ECnggBE;;;IAEE,SAXS;EDihgBb;ECpggBE;;;IAEE,SAAA;EDuggBJ;ECrhgBE;;;IAEE,8CAAA;EDwhgBJ;ECthgBE;;;IAEE,yBAAA;EDyhgBJ;ECvhgBE;;;IAEE,SAXS;EDqigBb;ECxhgBE;;;IAEE,SAAA;ED2hgBJ;ECzigBE;;;IAEE,8CAAA;ED4igBJ;EC1igBE;;;IAEE,yBAAA;ED6igBJ;EC3igBE;;;IAEE,SAXS;EDyjgBb;EC5igBE;;;IAEE,SAAA;ED+igBJ;EC7jgBE;;;IAEE,8CAAA;EDgkgBJ;EC9jgBE;;;IAEE,yBAAA;EDikgBJ;EC/jgBE;;;IAEE,SAXS;ED6kgBb;EChkgBE;;;IAEE,SAAA;EDmkgBJ;ECjlgBE;;;IAEE,8CAAA;EDolgBJ;ECllgBE;;;IAEE,yBAAA;EDqlgBJ;ECnlgBE;;;IAEE,SAXS;EDimgBb;ECplgBE;;;IAEE,SAAA;EDulgBJ;ECrmgBE;;;IAEE,8CAAA;EDwmgBJ;ECtmgBE;;;IAEE,yBAAA;EDymgBJ;ECvmgBE;;;IAEE,SAXS;EDqngBb;ECxmgBE;;;IAEE,SAAA;ED2mgBJ;ECzngBE;;;IAEE,8CAAA;ED4ngBJ;EC1ngBE;;;IAEE,yBAAA;ED6ngBJ;EC3ngBE;;;IAEE,SAXS;EDyogBb;EC5ngBE;;;IAEE,SAAA;ED+ngBJ;EC7ogBE;;;IAEE,8CAAA;EDgpgBJ;EC9ogBE;;;IAEE,yBAAA;EDipgBJ;EC/ogBE;;;IAEE,SAXS;ED6pgBb;EChpgBE;;;IAEE,SAAA;EDmpgBJ;ECjqgBE;;;IAEE,8CAAA;EDoqgBJ;EClqgBE;;;IAEE,yBAAA;EDqqgBJ;ECnqgBE;;;IAEE,SAXS;EDirgBb;ECpqgBE;;;IAEE,SAAA;EDuqgBJ;ECrrgBE;;;IAEE,8CAAA;EDwrgBJ;ECtrgBE;;;IAEE,yBAAA;EDyrgBJ;ECvrgBE;;;IAEE,SAXS;EDqsgBb;ECxrgBE;;;IAEE,SAAA;ED2rgBJ;ECzsgBE;;;IAEE,8CAAA;ED4sgBJ;EC1sgBE;;;IAEE,yBAAA;ED6sgBJ;EC3sgBE;;;IAEE,SAXS;EDytgBb;EC5sgBE;;;IAEE,SAAA;ED+sgBJ;EC7tgBE;;;IAEE,8CAAA;EDgugBJ;EC9tgBE;;;IAEE,yBAAA;EDiugBJ;EC/tgBE;;;IAEE,SAXS;ED6ugBb;EChugBE;;;IAEE,SAAA;EDmugBJ;ECjvgBE;;;IAEE,8CAAA;EDovgBJ;EClvgBE;;;IAEE,yBAAA;EDqvgBJ;ECnvgBE;;;IAEE,SAXS;EDiwgBb;ECpvgBE;;;IAEE,SAAA;EDuvgBJ;ECrwgBE;;;IAEE,8CAAA;EDwwgBJ;ECtwgBE;;;IAEE,yBAAA;EDywgBJ;ECvwgBE;;;IAEE,SAXS;EDqxgBb;ECxwgBE;;;IAEE,SAAA;ED2wgBJ;ECzxgBE;;;IAEE,8CAAA;ED4xgBJ;EC1xgBE;;;IAEE,yBAAA;ED6xgBJ;EC3xgBE;;;IAEE,SAXS;EDyygBb;EC5xgBE;;;IAEE,SAAA;ED+xgBJ;EC7ygBE;;;IAEE,8CAAA;EDgzgBJ;EC9ygBE;;;IAEE,yBAAA;EDizgBJ;EC/ygBE;;;IAEE,SAXS;ED6zgBb;EChzgBE;;;IAEE,SAAA;EDmzgBJ;ECj0gBE;;;IAEE,8CAAA;EDo0gBJ;ECl0gBE;;;IAEE,yBAAA;EDq0gBJ;ECn0gBE;;;IAEE,SAXS;EDi1gBb;ECp0gBE;;;IAEE,SAAA;EDu0gBJ;ECr1gBE;;;IAEE,8CAAA;EDw1gBJ;ECt1gBE;;;IAEE,yBAAA;EDy1gBJ;ECv1gBE;;;IAEE,SAXS;EDq2gBb;ECx1gBE;;;IAEE,SAAA;ED21gBJ;ECz2gBE;;;IAEE,8CAAA;ED42gBJ;EC12gBE;;;IAEE,yBAAA;ED62gBJ;EC32gBE;;;IAEE,SAXS;EDy3gBb;EC52gBE;;;IAEE,SAAA;ED+2gBJ;ECz2gBA;;IACE,cAAA;ED42gBF;AACF;AC1zgBI;EAoBA;;;IAEE,0BAAA;ED0ygBJ;ECxygBE;;;IAEE,oBAPS;EDkzgBb;ECzygBE;;;IAEE,kBAXS;EDuzgBb;ECtzgBE;;;IAEE,0BAAA;EDyzgBJ;ECvzgBE;;;IAEE,oBAPS;EDi0gBb;ECxzgBE;;;IAEE,kBAXS;EDs0gBb;ECr0gBE;;;IAEE,0BAAA;EDw0gBJ;ECt0gBE;;;IAEE,oBAPS;EDg1gBb;ECv0gBE;;;IAEE,kBAXS;EDq1gBb;ECp1gBE;;;IAEE,0BAAA;EDu1gBJ;ECr1gBE;;;IAEE,oBAPS;ED+1gBb;ECt1gBE;;;IAEE,kBAXS;EDo2gBb;ECn2gBE;;;IAEE,0BAAA;EDs2gBJ;ECp2gBE;;;IAEE,oBAPS;ED82gBb;ECr2gBE;;;IAEE,kBAXS;EDm3gBb;ECl3gBE;;;IAEE,0BAAA;EDq3gBJ;ECn3gBE;;;IAEE,oBAPS;ED63gBb;ECp3gBE;;;IAEE,kBAXS;EDk4gBb;ECj4gBE;;;IAEE,0BAAA;EDo4gBJ;ECl4gBE;;;IAEE,oBAPS;ED44gBb;ECn4gBE;;;IAEE,kBAXS;EDi5gBb;ECh5gBE;;;IAEE,0BAAA;EDm5gBJ;ECj5gBE;;;IAEE,oBAPS;ED25gBb;ECl5gBE;;;IAEE,kBAXS;EDg6gBb;EC/5gBE;;;IAEE,0BAAA;EDk6gBJ;ECh6gBE;;;IAEE,oBAPS;ED06gBb;ECj6gBE;;;IAEE,kBAXS;ED+6gBb;EC96gBE;;;IAEE,4BAAA;EDi7gBJ;EC/6gBE;;;IAEE,qBAPS;EDy7gBb;ECh7gBE;;;IAEE,mBAXS;ED87gBb;EC77gBE;;;IAEE,4BAAA;EDg8gBJ;EC97gBE;;;IAEE,qBAPS;EDw8gBb;EC/7gBE;;;IAEE,mBAXS;ED68gBb;EC58gBE;;;IAEE,4BAAA;ED+8gBJ;EC78gBE;;;IAEE,qBAPS;EDu9gBb;EC98gBE;;;IAEE,mBAXS;ED49gBb;EC39gBE;;;IAEE,4BAAA;ED89gBJ;EC59gBE;;;IAEE,qBAPS;EDs+gBb;EC79gBE;;;IAEE,mBAXS;ED2+gBb;EC1+gBE;;;IAEE,4BAAA;ED6+gBJ;EC3+gBE;;;IAEE,qBAPS;EDq/gBb;EC5+gBE;;;IAEE,mBAXS;ED0/gBb;ECz/gBE;;;IAEE,4BAAA;ED4/gBJ;EC1/gBE;;;IAEE,qBAPS;EDoghBb;EC3/gBE;;;IAEE,mBAXS;EDyghBb;ECxghBE;;;IAEE,4BAAA;ED2ghBJ;ECzghBE;;;IAEE,qBAPS;EDmhhBb;EC1ghBE;;;IAEE,mBAXS;EDwhhBb;ECvhhBE;;;IAEE,4BAAA;ED0hhBJ;ECxhhBE;;;IAEE,qBAPS;EDkihBb;ECzhhBE;;;IAEE,mBAXS;EDuihBb;ECtihBE;;;IAEE,4BAAA;EDyihBJ;ECvihBE;;;IAEE,qBAPS;EDijhBb;ECxihBE;;;IAEE,mBAXS;EDsjhBb;ECrjhBE;;;IAEE,4BAAA;EDwjhBJ;ECtjhBE;;;IAEE,qBAPS;EDgkhBb;ECvjhBE;;;IAEE,mBAXS;EDqkhBb;ECpkhBE;;;IAEE,4BAAA;EDukhBJ;ECrkhBE;;;IAEE,qBAPS;ED+khBb;ECtkhBE;;;IAEE,mBAXS;EDolhBb;ECnlhBE;;;IAEE,4BAAA;EDslhBJ;ECplhBE;;;IAEE,qBAPS;ED8lhBb;ECrlhBE;;;IAEE,mBAXS;EDmmhBb;EClmhBE;;;IAEE,4BAAA;EDqmhBJ;ECnmhBE;;;IAEE,qBAPS;ED6mhBb;ECpmhBE;;;IAEE,mBAXS;EDknhBb;ECjnhBE;;;IAEE,4BAAA;EDonhBJ;EClnhBE;;;IAEE,qBAPS;ED4nhBb;ECnnhBE;;;IAEE,mBAXS;EDiohBb;EChohBE;;;IAEE,4BAAA;EDmohBJ;ECjohBE;;;IAEE,qBAPS;ED2ohBb;EClohBE;;;IAEE,mBAXS;EDgphBb;EC3uhBE;;;IAEE,6CAAA;ED8uhBJ;EC5uhBE;;;IAEE,uBAAA;ED+uhBJ;EC7uhBE;;;IAEE,QAXS;ED2vhBb;EC9uhBE;;;IAEE,SAAA;EDivhBJ;EC/vhBE;;;IAEE,6CAAA;EDkwhBJ;EChwhBE;;;IAEE,uBAAA;EDmwhBJ;ECjwhBE;;;IAEE,QAXS;ED+whBb;EClwhBE;;;IAEE,SAAA;EDqwhBJ;ECnxhBE;;;IAEE,6CAAA;EDsxhBJ;ECpxhBE;;;IAEE,uBAAA;EDuxhBJ;ECrxhBE;;;IAEE,QAXS;EDmyhBb;ECtxhBE;;;IAEE,SAAA;EDyxhBJ;ECvyhBE;;;IAEE,6CAAA;ED0yhBJ;ECxyhBE;;;IAEE,uBAAA;ED2yhBJ;ECzyhBE;;;IAEE,QAXS;EDuzhBb;EC1yhBE;;;IAEE,SAAA;ED6yhBJ;EC3zhBE;;;IAEE,6CAAA;ED8zhBJ;EC5zhBE;;;IAEE,uBAAA;ED+zhBJ;EC7zhBE;;;IAEE,QAXS;ED20hBb;EC9zhBE;;;IAEE,SAAA;EDi0hBJ;EC/0hBE;;;IAEE,6CAAA;EDk1hBJ;ECh1hBE;;;IAEE,uBAAA;EDm1hBJ;ECj1hBE;;;IAEE,QAXS;ED+1hBb;ECl1hBE;;;IAEE,SAAA;EDq1hBJ;ECn2hBE;;;IAEE,6CAAA;EDs2hBJ;ECp2hBE;;;IAEE,uBAAA;EDu2hBJ;ECr2hBE;;;IAEE,QAXS;EDm3hBb;ECt2hBE;;;IAEE,SAAA;EDy2hBJ;ECv3hBE;;;IAEE,6CAAA;ED03hBJ;ECx3hBE;;;IAEE,uBAAA;ED23hBJ;ECz3hBE;;;IAEE,QAXS;EDu4hBb;EC13hBE;;;IAEE,SAAA;ED63hBJ;EC34hBE;;;IAEE,6CAAA;ED84hBJ;EC54hBE;;;IAEE,uBAAA;ED+4hBJ;EC74hBE;;;IAEE,QAXS;ED25hBb;EC94hBE;;;IAEE,SAAA;EDi5hBJ;EC/5hBE;;;IAEE,8CAAA;EDk6hBJ;ECh6hBE;;;IAEE,yBAAA;EDm6hBJ;ECj6hBE;;;IAEE,SAXS;ED+6hBb;ECl6hBE;;;IAEE,SAAA;EDq6hBJ;ECn7hBE;;;IAEE,8CAAA;EDs7hBJ;ECp7hBE;;;IAEE,yBAAA;EDu7hBJ;ECr7hBE;;;IAEE,SAXS;EDm8hBb;ECt7hBE;;;IAEE,SAAA;EDy7hBJ;ECv8hBE;;;IAEE,8CAAA;ED08hBJ;ECx8hBE;;;IAEE,yBAAA;ED28hBJ;ECz8hBE;;;IAEE,SAXS;EDu9hBb;EC18hBE;;;IAEE,SAAA;ED68hBJ;EC39hBE;;;IAEE,8CAAA;ED89hBJ;EC59hBE;;;IAEE,yBAAA;ED+9hBJ;EC79hBE;;;IAEE,SAXS;ED2+hBb;EC99hBE;;;IAEE,SAAA;EDi+hBJ;EC/+hBE;;;IAEE,8CAAA;EDk/hBJ;ECh/hBE;;;IAEE,yBAAA;EDm/hBJ;ECj/hBE;;;IAEE,SAXS;ED+/hBb;ECl/hBE;;;IAEE,SAAA;EDq/hBJ;ECngiBE;;;IAEE,8CAAA;EDsgiBJ;ECpgiBE;;;IAEE,yBAAA;EDugiBJ;ECrgiBE;;;IAEE,SAXS;EDmhiBb;ECtgiBE;;;IAEE,SAAA;EDygiBJ;ECvhiBE;;;IAEE,8CAAA;ED0hiBJ;ECxhiBE;;;IAEE,yBAAA;ED2hiBJ;ECzhiBE;;;IAEE,SAXS;EDuiiBb;EC1hiBE;;;IAEE,SAAA;ED6hiBJ;EC3iiBE;;;IAEE,8CAAA;ED8iiBJ;EC5iiBE;;;IAEE,yBAAA;ED+iiBJ;EC7iiBE;;;IAEE,SAXS;ED2jiBb;EC9iiBE;;;IAEE,SAAA;EDijiBJ;EC/jiBE;;;IAEE,8CAAA;EDkkiBJ;EChkiBE;;;IAEE,yBAAA;EDmkiBJ;ECjkiBE;;;IAEE,SAXS;ED+kiBb;EClkiBE;;;IAEE,SAAA;EDqkiBJ;ECnliBE;;;IAEE,8CAAA;EDsliBJ;ECpliBE;;;IAEE,yBAAA;EDuliBJ;ECrliBE;;;IAEE,SAXS;EDmmiBb;ECtliBE;;;IAEE,SAAA;EDyliBJ;ECvmiBE;;;IAEE,8CAAA;ED0miBJ;ECxmiBE;;;IAEE,yBAAA;ED2miBJ;ECzmiBE;;;IAEE,SAXS;EDuniBb;EC1miBE;;;IAEE,SAAA;ED6miBJ;EC3niBE;;;IAEE,8CAAA;ED8niBJ;EC5niBE;;;IAEE,yBAAA;ED+niBJ;EC7niBE;;;IAEE,SAXS;ED2oiBb;EC9niBE;;;IAEE,SAAA;EDioiBJ;EC/oiBE;;;IAEE,8CAAA;EDkpiBJ;EChpiBE;;;IAEE,yBAAA;EDmpiBJ;ECjpiBE;;;IAEE,SAXS;ED+piBb;EClpiBE;;;IAEE,SAAA;EDqpiBJ;ECnqiBE;;;IAEE,8CAAA;EDsqiBJ;ECpqiBE;;;IAEE,yBAAA;EDuqiBJ;ECrqiBE;;;IAEE,SAXS;EDmriBb;ECtqiBE;;;IAEE,SAAA;EDyqiBJ;ECvriBE;;;IAEE,8CAAA;ED0riBJ;ECxriBE;;;IAEE,yBAAA;ED2riBJ;ECzriBE;;;IAEE,SAXS;EDusiBb;EC1riBE;;;IAEE,SAAA;ED6riBJ;EC3siBE;;;IAEE,8CAAA;ED8siBJ;EC5siBE;;;IAEE,yBAAA;ED+siBJ;EC7siBE;;;IAEE,SAXS;ED2tiBb;EC9siBE;;;IAEE,SAAA;EDitiBJ;EC/tiBE;;;IAEE,8CAAA;EDkuiBJ;EChuiBE;;;IAEE,yBAAA;EDmuiBJ;ECjuiBE;;;IAEE,SAXS;ED+uiBb;ECluiBE;;;IAEE,SAAA;EDquiBJ;ECnviBE;;;IAEE,8CAAA;EDsviBJ;ECpviBE;;;IAEE,yBAAA;EDuviBJ;ECrviBE;;;IAEE,SAXS;EDmwiBb;ECtviBE;;;IAEE,SAAA;EDyviBJ;ECvwiBE;;;IAEE,8CAAA;ED0wiBJ;ECxwiBE;;;IAEE,yBAAA;ED2wiBJ;ECzwiBE;;;IAEE,SAXS;EDuxiBb;EC1wiBE;;;IAEE,SAAA;ED6wiBJ;EC3xiBE;;;IAEE,8CAAA;ED8xiBJ;EC5xiBE;;;IAEE,yBAAA;ED+xiBJ;EC7xiBE;;;IAEE,SAXS;ED2yiBb;EC9xiBE;;;IAEE,SAAA;EDiyiBJ;EC/yiBE;;;IAEE,8CAAA;EDkziBJ;EChziBE;;;IAEE,yBAAA;EDmziBJ;ECjziBE;;;IAEE,SAXS;ED+ziBb;EClziBE;;;IAEE,SAAA;EDqziBJ;ECn0iBE;;;IAEE,8CAAA;EDs0iBJ;ECp0iBE;;;IAEE,yBAAA;EDu0iBJ;ECr0iBE;;;IAEE,SAXS;EDm1iBb;ECt0iBE;;;IAEE,SAAA;EDy0iBJ;ECv1iBE;;;IAEE,8CAAA;ED01iBJ;ECx1iBE;;;IAEE,yBAAA;ED21iBJ;ECz1iBE;;;IAEE,SAXS;EDu2iBb;EC11iBE;;;IAEE,SAAA;ED61iBJ;EC32iBE;;;IAEE,8CAAA;ED82iBJ;EC52iBE;;;IAEE,yBAAA;ED+2iBJ;EC72iBE;;;IAEE,SAXS;ED23iBb;EC92iBE;;;IAEE,SAAA;EDi3iBJ;EC/3iBE;;;IAEE,8CAAA;EDk4iBJ;ECh4iBE;;;IAEE,yBAAA;EDm4iBJ;ECj4iBE;;;IAEE,SAXS;ED+4iBb;ECl4iBE;;;IAEE,SAAA;EDq4iBJ;ECn5iBE;;;IAEE,8CAAA;EDs5iBJ;ECp5iBE;;;IAEE,yBAAA;EDu5iBJ;ECr5iBE;;;IAEE,SAXS;EDm6iBb;ECt5iBE;;;IAEE,SAAA;EDy5iBJ;ECv6iBE;;;IAEE,8CAAA;ED06iBJ;ECx6iBE;;;IAEE,yBAAA;ED26iBJ;ECz6iBE;;;IAEE,SAXS;EDu7iBb;EC16iBE;;;IAEE,SAAA;ED66iBJ;EC37iBE;;;IAEE,8CAAA;ED87iBJ;EC57iBE;;;IAEE,yBAAA;ED+7iBJ;EC77iBE;;;IAEE,SAXS;ED28iBb;EC97iBE;;;IAEE,SAAA;EDi8iBJ;EC/8iBE;;;IAEE,8CAAA;EDk9iBJ;ECh9iBE;;;IAEE,yBAAA;EDm9iBJ;ECj9iBE;;;IAEE,SAXS;ED+9iBb;ECl9iBE;;;IAEE,SAAA;EDq9iBJ;ECn+iBE;;;IAEE,8CAAA;EDs+iBJ;ECp+iBE;;;IAEE,yBAAA;EDu+iBJ;ECr+iBE;;;IAEE,SAXS;EDm/iBb;ECt+iBE;;;IAEE,SAAA;EDy+iBJ;ECv/iBE;;;IAEE,8CAAA;ED0/iBJ;ECx/iBE;;;IAEE,yBAAA;ED2/iBJ;ECz/iBE;;;IAEE,SAXS;EDugjBb;EC1/iBE;;;IAEE,SAAA;ED6/iBJ;EC3gjBE;;;IAEE,8CAAA;ED8gjBJ;EC5gjBE;;;IAEE,yBAAA;ED+gjBJ;EC7gjBE;;;IAEE,SAXS;ED2hjBb;EC9gjBE;;;IAEE,SAAA;EDihjBJ;EC/hjBE;;;IAEE,8CAAA;EDkijBJ;EChijBE;;;IAEE,yBAAA;EDmijBJ;ECjijBE;;;IAEE,SAXS;ED+ijBb;EClijBE;;;IAEE,SAAA;EDqijBJ;ECnjjBE;;;IAEE,8CAAA;EDsjjBJ;ECpjjBE;;;IAEE,yBAAA;EDujjBJ;ECrjjBE;;;IAEE,SAXS;EDmkjBb;ECtjjBE;;;IAEE,SAAA;EDyjjBJ;ECvkjBE;;;IAEE,8CAAA;ED0kjBJ;ECxkjBE;;;IAEE,yBAAA;ED2kjBJ;ECzkjBE;;;IAEE,SAXS;EDuljBb;EC1kjBE;;;IAEE,SAAA;ED6kjBJ;EC3ljBE;;;IAEE,8CAAA;ED8ljBJ;EC5ljBE;;;IAEE,yBAAA;ED+ljBJ;EC7ljBE;;;IAEE,SAXS;ED2mjBb;EC9ljBE;;;IAEE,SAAA;EDimjBJ;EC/mjBE;;;IAEE,8CAAA;EDknjBJ;EChnjBE;;;IAEE,yBAAA;EDmnjBJ;ECjnjBE;;;IAEE,SAXS;ED+njBb;EClnjBE;;;IAEE,SAAA;EDqnjBJ;ECnojBE;;;IAEE,8CAAA;EDsojBJ;ECpojBE;;;IAEE,yBAAA;EDuojBJ;ECrojBE;;;IAEE,SAXS;EDmpjBb;ECtojBE;;;IAEE,SAAA;EDyojBJ;ECvpjBE;;;IAEE,8CAAA;ED0pjBJ;ECxpjBE;;;IAEE,yBAAA;ED2pjBJ;ECzpjBE;;;IAEE,SAXS;EDuqjBb;EC1pjBE;;;IAEE,SAAA;ED6pjBJ;EC3qjBE;;;IAEE,8CAAA;ED8qjBJ;EC5qjBE;;;IAEE,yBAAA;ED+qjBJ;EC7qjBE;;;IAEE,SAXS;ED2rjBb;EC9qjBE;;;IAEE,SAAA;EDirjBJ;EC/rjBE;;;IAEE,8CAAA;EDksjBJ;EChsjBE;;;IAEE,yBAAA;EDmsjBJ;ECjsjBE;;;IAEE,SAXS;ED+sjBb;EClsjBE;;;IAEE,SAAA;EDqsjBJ;EC/rjBA;;IACE,cAAA;EDksjBF;AACF;AChpjBI;EAoBA;;;IAEE,0BAAA;EDgojBJ;EC9njBE;;;IAEE,oBAPS;EDwojBb;EC/njBE;;;IAEE,kBAXS;ED6ojBb;EC5ojBE;;;IAEE,0BAAA;ED+ojBJ;EC7ojBE;;;IAEE,oBAPS;EDupjBb;EC9ojBE;;;IAEE,kBAXS;ED4pjBb;EC3pjBE;;;IAEE,0BAAA;ED8pjBJ;EC5pjBE;;;IAEE,oBAPS;EDsqjBb;EC7pjBE;;;IAEE,kBAXS;ED2qjBb;EC1qjBE;;;IAEE,0BAAA;ED6qjBJ;EC3qjBE;;;IAEE,oBAPS;EDqrjBb;EC5qjBE;;;IAEE,kBAXS;ED0rjBb;ECzrjBE;;;IAEE,0BAAA;ED4rjBJ;EC1rjBE;;;IAEE,oBAPS;EDosjBb;EC3rjBE;;;IAEE,kBAXS;EDysjBb;ECxsjBE;;;IAEE,0BAAA;ED2sjBJ;ECzsjBE;;;IAEE,oBAPS;EDmtjBb;EC1sjBE;;;IAEE,kBAXS;EDwtjBb;ECvtjBE;;;IAEE,0BAAA;ED0tjBJ;ECxtjBE;;;IAEE,oBAPS;EDkujBb;ECztjBE;;;IAEE,kBAXS;EDuujBb;ECtujBE;;;IAEE,0BAAA;EDyujBJ;ECvujBE;;;IAEE,oBAPS;EDivjBb;ECxujBE;;;IAEE,kBAXS;EDsvjBb;ECrvjBE;;;IAEE,0BAAA;EDwvjBJ;ECtvjBE;;;IAEE,oBAPS;EDgwjBb;ECvvjBE;;;IAEE,kBAXS;EDqwjBb;ECpwjBE;;;IAEE,4BAAA;EDuwjBJ;ECrwjBE;;;IAEE,qBAPS;ED+wjBb;ECtwjBE;;;IAEE,mBAXS;EDoxjBb;ECnxjBE;;;IAEE,4BAAA;EDsxjBJ;ECpxjBE;;;IAEE,qBAPS;ED8xjBb;ECrxjBE;;;IAEE,mBAXS;EDmyjBb;EClyjBE;;;IAEE,4BAAA;EDqyjBJ;ECnyjBE;;;IAEE,qBAPS;ED6yjBb;ECpyjBE;;;IAEE,mBAXS;EDkzjBb;ECjzjBE;;;IAEE,4BAAA;EDozjBJ;EClzjBE;;;IAEE,qBAPS;ED4zjBb;ECnzjBE;;;IAEE,mBAXS;EDi0jBb;ECh0jBE;;;IAEE,4BAAA;EDm0jBJ;ECj0jBE;;;IAEE,qBAPS;ED20jBb;ECl0jBE;;;IAEE,mBAXS;EDg1jBb;EC/0jBE;;;IAEE,4BAAA;EDk1jBJ;ECh1jBE;;;IAEE,qBAPS;ED01jBb;ECj1jBE;;;IAEE,mBAXS;ED+1jBb;EC91jBE;;;IAEE,4BAAA;EDi2jBJ;EC/1jBE;;;IAEE,qBAPS;EDy2jBb;ECh2jBE;;;IAEE,mBAXS;ED82jBb;EC72jBE;;;IAEE,4BAAA;EDg3jBJ;EC92jBE;;;IAEE,qBAPS;EDw3jBb;EC/2jBE;;;IAEE,mBAXS;ED63jBb;EC53jBE;;;IAEE,4BAAA;ED+3jBJ;EC73jBE;;;IAEE,qBAPS;EDu4jBb;EC93jBE;;;IAEE,mBAXS;ED44jBb;EC34jBE;;;IAEE,4BAAA;ED84jBJ;EC54jBE;;;IAEE,qBAPS;EDs5jBb;EC74jBE;;;IAEE,mBAXS;ED25jBb;EC15jBE;;;IAEE,4BAAA;ED65jBJ;EC35jBE;;;IAEE,qBAPS;EDq6jBb;EC55jBE;;;IAEE,mBAXS;ED06jBb;ECz6jBE;;;IAEE,4BAAA;ED46jBJ;EC16jBE;;;IAEE,qBAPS;EDo7jBb;EC36jBE;;;IAEE,mBAXS;EDy7jBb;ECx7jBE;;;IAEE,4BAAA;ED27jBJ;ECz7jBE;;;IAEE,qBAPS;EDm8jBb;EC17jBE;;;IAEE,mBAXS;EDw8jBb;ECv8jBE;;;IAEE,4BAAA;ED08jBJ;ECx8jBE;;;IAEE,qBAPS;EDk9jBb;ECz8jBE;;;IAEE,mBAXS;EDu9jBb;ECt9jBE;;;IAEE,4BAAA;EDy9jBJ;ECv9jBE;;;IAEE,qBAPS;EDi+jBb;ECx9jBE;;;IAEE,mBAXS;EDs+jBb;ECjkkBE;;;IAEE,6CAAA;EDokkBJ;EClkkBE;;;IAEE,uBAAA;EDqkkBJ;ECnkkBE;;;IAEE,QAXS;EDilkBb;ECpkkBE;;;IAEE,SAAA;EDukkBJ;ECrlkBE;;;IAEE,6CAAA;EDwlkBJ;ECtlkBE;;;IAEE,uBAAA;EDylkBJ;ECvlkBE;;;IAEE,QAXS;EDqmkBb;ECxlkBE;;;IAEE,SAAA;ED2lkBJ;ECzmkBE;;;IAEE,6CAAA;ED4mkBJ;EC1mkBE;;;IAEE,uBAAA;ED6mkBJ;EC3mkBE;;;IAEE,QAXS;EDynkBb;EC5mkBE;;;IAEE,SAAA;ED+mkBJ;EC7nkBE;;;IAEE,6CAAA;EDgokBJ;EC9nkBE;;;IAEE,uBAAA;EDiokBJ;EC/nkBE;;;IAEE,QAXS;ED6okBb;EChokBE;;;IAEE,SAAA;EDmokBJ;ECjpkBE;;;IAEE,6CAAA;EDopkBJ;EClpkBE;;;IAEE,uBAAA;EDqpkBJ;ECnpkBE;;;IAEE,QAXS;EDiqkBb;ECppkBE;;;IAEE,SAAA;EDupkBJ;ECrqkBE;;;IAEE,6CAAA;EDwqkBJ;ECtqkBE;;;IAEE,uBAAA;EDyqkBJ;ECvqkBE;;;IAEE,QAXS;EDqrkBb;ECxqkBE;;;IAEE,SAAA;ED2qkBJ;ECzrkBE;;;IAEE,6CAAA;ED4rkBJ;EC1rkBE;;;IAEE,uBAAA;ED6rkBJ;EC3rkBE;;;IAEE,QAXS;EDyskBb;EC5rkBE;;;IAEE,SAAA;ED+rkBJ;EC7skBE;;;IAEE,6CAAA;EDgtkBJ;EC9skBE;;;IAEE,uBAAA;EDitkBJ;EC/skBE;;;IAEE,QAXS;ED6tkBb;EChtkBE;;;IAEE,SAAA;EDmtkBJ;ECjukBE;;;IAEE,6CAAA;EDoukBJ;EClukBE;;;IAEE,uBAAA;EDqukBJ;ECnukBE;;;IAEE,QAXS;EDivkBb;ECpukBE;;;IAEE,SAAA;EDuukBJ;ECrvkBE;;;IAEE,8CAAA;EDwvkBJ;ECtvkBE;;;IAEE,yBAAA;EDyvkBJ;ECvvkBE;;;IAEE,SAXS;EDqwkBb;ECxvkBE;;;IAEE,SAAA;ED2vkBJ;ECzwkBE;;;IAEE,8CAAA;ED4wkBJ;EC1wkBE;;;IAEE,yBAAA;ED6wkBJ;EC3wkBE;;;IAEE,SAXS;EDyxkBb;EC5wkBE;;;IAEE,SAAA;ED+wkBJ;EC7xkBE;;;IAEE,8CAAA;EDgykBJ;EC9xkBE;;;IAEE,yBAAA;EDiykBJ;EC/xkBE;;;IAEE,SAXS;ED6ykBb;EChykBE;;;IAEE,SAAA;EDmykBJ;ECjzkBE;;;IAEE,8CAAA;EDozkBJ;EClzkBE;;;IAEE,yBAAA;EDqzkBJ;ECnzkBE;;;IAEE,SAXS;EDi0kBb;ECpzkBE;;;IAEE,SAAA;EDuzkBJ;ECr0kBE;;;IAEE,8CAAA;EDw0kBJ;ECt0kBE;;;IAEE,yBAAA;EDy0kBJ;ECv0kBE;;;IAEE,SAXS;EDq1kBb;ECx0kBE;;;IAEE,SAAA;ED20kBJ;ECz1kBE;;;IAEE,8CAAA;ED41kBJ;EC11kBE;;;IAEE,yBAAA;ED61kBJ;EC31kBE;;;IAEE,SAXS;EDy2kBb;EC51kBE;;;IAEE,SAAA;ED+1kBJ;EC72kBE;;;IAEE,8CAAA;EDg3kBJ;EC92kBE;;;IAEE,yBAAA;EDi3kBJ;EC/2kBE;;;IAEE,SAXS;ED63kBb;ECh3kBE;;;IAEE,SAAA;EDm3kBJ;ECj4kBE;;;IAEE,8CAAA;EDo4kBJ;ECl4kBE;;;IAEE,yBAAA;EDq4kBJ;ECn4kBE;;;IAEE,SAXS;EDi5kBb;ECp4kBE;;;IAEE,SAAA;EDu4kBJ;ECr5kBE;;;IAEE,8CAAA;EDw5kBJ;ECt5kBE;;;IAEE,yBAAA;EDy5kBJ;ECv5kBE;;;IAEE,SAXS;EDq6kBb;ECx5kBE;;;IAEE,SAAA;ED25kBJ;ECz6kBE;;;IAEE,8CAAA;ED46kBJ;EC16kBE;;;IAEE,yBAAA;ED66kBJ;EC36kBE;;;IAEE,SAXS;EDy7kBb;EC56kBE;;;IAEE,SAAA;ED+6kBJ;EC77kBE;;;IAEE,8CAAA;EDg8kBJ;EC97kBE;;;IAEE,yBAAA;EDi8kBJ;EC/7kBE;;;IAEE,SAXS;ED68kBb;ECh8kBE;;;IAEE,SAAA;EDm8kBJ;ECj9kBE;;;IAEE,8CAAA;EDo9kBJ;ECl9kBE;;;IAEE,yBAAA;EDq9kBJ;ECn9kBE;;;IAEE,SAXS;EDi+kBb;ECp9kBE;;;IAEE,SAAA;EDu9kBJ;ECr+kBE;;;IAEE,8CAAA;EDw+kBJ;ECt+kBE;;;IAEE,yBAAA;EDy+kBJ;ECv+kBE;;;IAEE,SAXS;EDq/kBb;ECx+kBE;;;IAEE,SAAA;ED2+kBJ;ECz/kBE;;;IAEE,8CAAA;ED4/kBJ;EC1/kBE;;;IAEE,yBAAA;ED6/kBJ;EC3/kBE;;;IAEE,SAXS;EDyglBb;EC5/kBE;;;IAEE,SAAA;ED+/kBJ;EC7glBE;;;IAEE,8CAAA;EDghlBJ;EC9glBE;;;IAEE,yBAAA;EDihlBJ;EC/glBE;;;IAEE,SAXS;ED6hlBb;EChhlBE;;;IAEE,SAAA;EDmhlBJ;ECjilBE;;;IAEE,8CAAA;EDoilBJ;EClilBE;;;IAEE,yBAAA;EDqilBJ;ECnilBE;;;IAEE,SAXS;EDijlBb;ECpilBE;;;IAEE,SAAA;EDuilBJ;ECrjlBE;;;IAEE,8CAAA;EDwjlBJ;ECtjlBE;;;IAEE,yBAAA;EDyjlBJ;ECvjlBE;;;IAEE,SAXS;EDqklBb;ECxjlBE;;;IAEE,SAAA;ED2jlBJ;ECzklBE;;;IAEE,8CAAA;ED4klBJ;EC1klBE;;;IAEE,yBAAA;ED6klBJ;EC3klBE;;;IAEE,SAXS;EDyllBb;EC5klBE;;;IAEE,SAAA;ED+klBJ;EC7llBE;;;IAEE,8CAAA;EDgmlBJ;EC9llBE;;;IAEE,yBAAA;EDimlBJ;EC/llBE;;;IAEE,SAXS;ED6mlBb;EChmlBE;;;IAEE,SAAA;EDmmlBJ;ECjnlBE;;;IAEE,8CAAA;EDonlBJ;EClnlBE;;;IAEE,yBAAA;EDqnlBJ;ECnnlBE;;;IAEE,SAXS;EDiolBb;ECpnlBE;;;IAEE,SAAA;EDunlBJ;ECrolBE;;;IAEE,8CAAA;EDwolBJ;ECtolBE;;;IAEE,yBAAA;EDyolBJ;ECvolBE;;;IAEE,SAXS;EDqplBb;ECxolBE;;;IAEE,SAAA;ED2olBJ;ECzplBE;;;IAEE,8CAAA;ED4plBJ;EC1plBE;;;IAEE,yBAAA;ED6plBJ;EC3plBE;;;IAEE,SAXS;EDyqlBb;EC5plBE;;;IAEE,SAAA;ED+plBJ;EC7qlBE;;;IAEE,8CAAA;EDgrlBJ;EC9qlBE;;;IAEE,yBAAA;EDirlBJ;EC/qlBE;;;IAEE,SAXS;ED6rlBb;EChrlBE;;;IAEE,SAAA;EDmrlBJ;ECjslBE;;;IAEE,8CAAA;EDoslBJ;EClslBE;;;IAEE,yBAAA;EDqslBJ;ECnslBE;;;IAEE,SAXS;EDitlBb;ECpslBE;;;IAEE,SAAA;EDuslBJ;ECrtlBE;;;IAEE,8CAAA;EDwtlBJ;ECttlBE;;;IAEE,yBAAA;EDytlBJ;ECvtlBE;;;IAEE,SAXS;EDqulBb;ECxtlBE;;;IAEE,SAAA;ED2tlBJ;ECzulBE;;;IAEE,8CAAA;ED4ulBJ;EC1ulBE;;;IAEE,yBAAA;ED6ulBJ;EC3ulBE;;;IAEE,SAXS;EDyvlBb;EC5ulBE;;;IAEE,SAAA;ED+ulBJ;EC7vlBE;;;IAEE,8CAAA;EDgwlBJ;EC9vlBE;;;IAEE,yBAAA;EDiwlBJ;EC/vlBE;;;IAEE,SAXS;ED6wlBb;EChwlBE;;;IAEE,SAAA;EDmwlBJ;ECjxlBE;;;IAEE,8CAAA;EDoxlBJ;EClxlBE;;;IAEE,yBAAA;EDqxlBJ;ECnxlBE;;;IAEE,SAXS;EDiylBb;ECpxlBE;;;IAEE,SAAA;EDuxlBJ;ECrylBE;;;IAEE,8CAAA;EDwylBJ;ECtylBE;;;IAEE,yBAAA;EDyylBJ;ECvylBE;;;IAEE,SAXS;EDqzlBb;ECxylBE;;;IAEE,SAAA;ED2ylBJ;ECzzlBE;;;IAEE,8CAAA;ED4zlBJ;EC1zlBE;;;IAEE,yBAAA;ED6zlBJ;EC3zlBE;;;IAEE,SAXS;EDy0lBb;EC5zlBE;;;IAEE,SAAA;ED+zlBJ;EC70lBE;;;IAEE,8CAAA;EDg1lBJ;EC90lBE;;;IAEE,yBAAA;EDi1lBJ;EC/0lBE;;;IAEE,SAXS;ED61lBb;ECh1lBE;;;IAEE,SAAA;EDm1lBJ;ECj2lBE;;;IAEE,8CAAA;EDo2lBJ;ECl2lBE;;;IAEE,yBAAA;EDq2lBJ;ECn2lBE;;;IAEE,SAXS;EDi3lBb;ECp2lBE;;;IAEE,SAAA;EDu2lBJ;ECr3lBE;;;IAEE,8CAAA;EDw3lBJ;ECt3lBE;;;IAEE,yBAAA;EDy3lBJ;ECv3lBE;;;IAEE,SAXS;EDq4lBb;ECx3lBE;;;IAEE,SAAA;ED23lBJ;ECz4lBE;;;IAEE,8CAAA;ED44lBJ;EC14lBE;;;IAEE,yBAAA;ED64lBJ;EC34lBE;;;IAEE,SAXS;EDy5lBb;EC54lBE;;;IAEE,SAAA;ED+4lBJ;EC75lBE;;;IAEE,8CAAA;EDg6lBJ;EC95lBE;;;IAEE,yBAAA;EDi6lBJ;EC/5lBE;;;IAEE,SAXS;ED66lBb;ECh6lBE;;;IAEE,SAAA;EDm6lBJ;ECj7lBE;;;IAEE,8CAAA;EDo7lBJ;ECl7lBE;;;IAEE,yBAAA;EDq7lBJ;ECn7lBE;;;IAEE,SAXS;EDi8lBb;ECp7lBE;;;IAEE,SAAA;EDu7lBJ;ECr8lBE;;;IAEE,8CAAA;EDw8lBJ;ECt8lBE;;;IAEE,yBAAA;EDy8lBJ;ECv8lBE;;;IAEE,SAXS;EDq9lBb;ECx8lBE;;;IAEE,SAAA;ED28lBJ;ECz9lBE;;;IAEE,8CAAA;ED49lBJ;EC19lBE;;;IAEE,yBAAA;ED69lBJ;EC39lBE;;;IAEE,SAXS;EDy+lBb;EC59lBE;;;IAEE,SAAA;ED+9lBJ;EC7+lBE;;;IAEE,8CAAA;EDg/lBJ;EC9+lBE;;;IAEE,yBAAA;EDi/lBJ;EC/+lBE;;;IAEE,SAXS;ED6/lBb;ECh/lBE;;;IAEE,SAAA;EDm/lBJ;ECjgmBE;;;IAEE,8CAAA;EDogmBJ;EClgmBE;;;IAEE,yBAAA;EDqgmBJ;ECngmBE;;;IAEE,SAXS;EDihmBb;ECpgmBE;;;IAEE,SAAA;EDugmBJ;ECrhmBE;;;IAEE,8CAAA;EDwhmBJ;ECthmBE;;;IAEE,yBAAA;EDyhmBJ;ECvhmBE;;;IAEE,SAXS;EDqimBb;ECxhmBE;;;IAEE,SAAA;ED2hmBJ;ECrhmBA;;IACE,cAAA;EDwhmBF;AACF;;AAjimBA,cAAA;AACA;;EAEE,WAAA;AAoimBF;;AAjimBA;;EAEE,aDfa;ACmjmBf;;AAjimBA;;EAEE,cDfY;ACmjmBd;;AAjimBA;;EAEE,cDnBY;ACujmBd;;AAjimBA;;EAEE,cDvBY;AC2jmBd;;AA9hmBA,iBAAA;AACA;;EAEE,WDvCa;ACwkmBf;;AA9hmBA;;EAEE,YDnCe;ACokmBjB;;AA9hmBA;;EAEE,YDvCe;ACwkmBjB;;AA9hmBA;;EAEE,YD3Ce;AC4kmBjB;;AA9hmBA;;EAEE,YD/Ce;ACglmBjB;;AA9hmBA;;EAEE,YAAA;AAiimBF;;AA9hmBA,kBAAA;AACA;;EAEE,iBDtEa;ACummBf;;AA9hmBA;;EAEE,kBDlEe;ACmmmBjB;;AA9hmBA;;EAEE,kBDtEe;ACummBjB;;AA9hmBA;;EAEE,kBD1Ee;AC2mmBjB;;AA9hmBA;;EAEE,kBD9Ee;AC+mmBjB;;AA9hmBA,mBAAA;AACA;;EAEE,gBExGc;AFyomBhB;;AA9hmBA;;EAEE,gBE9Gc;AF+omBhB;;AA9hmBA;;EAEE,gBEpHc;AFqpmBhB;;AA9hmBA;;EAEE,iBE1Hc;AF2pmBhB;;AA9hmBA;;EAEE,iBEhIc;AFiqmBhB;;AA9hmBA;;EAEE,iBEtIe;AFuqmBjB;;AA9hmBA;EACE,2BAAA;AAiimBF;;AA9hmBA,iBAAA;AACA;;;EAGE,YDpIa;ACqqmBf;;AA9hmBA;;;EAGE,aD3HgB;AC4pmBlB;;AA9hmBA;;;EAGE,aDhIgB;ACiqmBlB;;AA9hmBA;;;EAGE,aDrIgB;ACsqmBlB;;AA9hmBA;;;EAGE,aD1IgB;AC2qmBlB;;AA9hmBA,mBAAA;AACA;;EAEE,mBDlKa;ACmsmBf;;AA9hmBA;;EAEE,oBDxJgB;ACyrmBlB;;AA9hmBA;;EAEE,oBD5JgB;AC6rmBlB;;AA9hmBA;;EAEE,oBDhKgB;ACismBlB;;AA9hmBA;;EAEE,oBDpKgB;ACqsmBlB;;AA9hmBA,mBAAA;AACA;;EAEE,kBD5La;AC6tmBf;;AA9hmBA;;EAEE,kBDpLiB;ACqtmBnB;;AA9hmBA;;EAEE,mBDvLgB;ACwtmBlB;;AA9hmBA;;EAEE,mBD3LgB;AC4tmBlB;;AA9hmBA;;EAEE,mBD/LgB;ACgumBlB;;AA9hmBA;;EAEE,mBDnMgB;ACoumBlB;;AA3hmBA,yBAAA;AACA;;EAEE,WAAA;EACA,2FAAA;AA8hmBF;;AA3hmBA;;EAEE,WAAA;EACA,4FAAA;AA8hmBF;;AA3hmBA,oEAAA;AACA;;EAEE,uBAAA;AA8hmBF;;AA3hmBA;;EAEE,8BAAA;AA8hmBF;;AA3hmBA;;EAEE,8BAAA;AA8hmBF;;AA3hmBA;;EAEE,iCAAA;AA8hmBF;;AA3hmBA,cAAA;AACA;;EAEE,mBAAA;AA8hmBF;;AA3hmBA;;EAEE,sBAAA;AA8hmBF;;AA3hmBA;;EAEE,qBAAA;AA8hmBF;;AA3hmBA;;EAEE,yBAAA;AA8hmBF;;AA3hmBA;;EAEE,4BAAA;AA8hmBF;;AA3hmBA,8DAAA;AACA;;EAEE,oBAAA;AA8hmBF;;AA3hmBA;;EAEE,2BAAA;AA8hmBF;;AA3hmBA;;EAEE,2BAAA;AA8hmBF;;AA3hmBA;;EAEE,8BAAA;AA8hmBF;;AA3hmBA;;EAEE,2CAAA;AA8hmBF;;AA3hmBA,yBAAA;AACA;;EAEE,6CAAA;AA8hmBF;;AA3hmBA,iBAAA;AAIE;;EAEE,kBALe;AAgimBnB;;AA7hmBE;;EAEE,gBALe;AAqimBnB;;AAlimBE;;EAEE,mBALe;AA0imBnB;;AAvimBE;;EAEE,oBALe;AA+imBnB;;AAtimBA,sCAAA;AAIE;;EAEE,sBALiB;AA2imBrB;;AAnimBE;;EAEE,oBAViB;AAgjmBrB;;AAnimBE;;EAEE,aAAA;EACA,sBAhBiB;AAsjmBrB;;AAnimBE;;EAEE,aAAA;EACA,oBAtBiB;AA4jmBrB;;AAzjmBE;;EAEE,uBALiB;AAikmBrB;;AAzjmBE;;EAEE,qBAViB;AAskmBrB;;AAzjmBE;;EAEE,aAAA;EACA,uBAhBiB;AA4kmBrB;;AAzjmBE;;EAEE,aAAA;EACA,qBAtBiB;AAklmBrB;;AA/kmBE;;EAEE,8BALiB;AAulmBrB;;AA/kmBE;;EAEE,4BAViB;AA4lmBrB;;AA/kmBE;;EAEE,aAAA;EACA,8BAhBiB;AAkmmBrB;;AA/kmBE;;EAEE,aAAA;EACA,4BAtBiB;AAwmmBrB;;AArmmBE;;EAEE,6BALiB;AA6mmBrB;;AArmmBE;;EAEE,2BAViB;AAknmBrB;;AArmmBE;;EAEE,aAAA;EACA,6BAhBiB;AAwnmBrB;;AArmmBE;;EAEE,aAAA;EACA,2BAtBiB;AA8nmBrB;;AA3nmBE;;EAEE,6BALiB;AAmomBrB;;AA3nmBE;;EAEE,2BAViB;AAwomBrB;;AA3nmBE;;EAEE,aAAA;EACA,6BAhBiB;AA8omBrB;;AA3nmBE;;EAEE,aAAA;EACA,2BAtBiB;AAopmBrB;;AAjpmBE;;EAEE,oBALiB;AAypmBrB;;AAjpmBE;;EAEE,kBAViB;AA8pmBrB;;AAjpmBE;;EAEE,aAAA;EACA,oBAhBiB;AAoqmBrB;;AAjpmBE;;EAEE,aAAA;EACA,kBAtBiB;AA0qmBrB;;AAhpmBA,qCAAA;AACA;;EAEE,iBAAA;AAmpmBF;;AAhpmBA;;EAEE,cAAA;AAmpmBF;;AAhpmBA;;EAEE,gBAAA;EACA,2BAAA;AAmpmBF;;AA7omBA,6BAAA;AACA;EACE,aAAA;AAgpmBF;;AA7omBA;EACE,aAAA;AAgpmBF;;AA7omBA;EACE,aAAA;AAgpmBF;;AA7omBA;EACE,aAAA;AAgpmBF;;AA7omBA;EACE,aAAA;AAgpmBF;;AA7omBA;EACE,aAAA;AAgpmBF;;AA7omBA;EACE,aAAA;AAgpmBF;;AA1omBA;;;EAGE,UAAA;AA6omBF;;AA1omBA;;;EAGE,YDzZa;ACsinBf;;AA1omBA;;;EAGE,aDhZgB;AC6hnBlB;;AA1omBA;;;EAGE,aDrZgB;ACkinBlB;;AA1omBA;;;EAGE,aD1ZgB;ACuinBlB;;AA1omBA;;;EAGE,aD/ZgB;AC4inBlB;;AA1omBA;;;EAGE,aAAA;AA6omBF;;AA1omBA;;;EAGE,eD7ba;AC0knBf;;AA1omBA;;;EAGE,gBDpbgB;ACiknBlB;;AA1omBA;;;EAGE,gBDzbgB;ACsknBlB;;AA1omBA;;;EAGE,gBD9bgB;AC2knBlB;;AA1omBA;;;EAGE,gBDncgB;ACglnBlB;;AAvomBA,aAAA;AACA;;EAEE,kBAAA;EACA,MAAA;EACA,QAAA;AA0omBF;;AAvomBA,SAAA;AACA;;EAEE,wCAAA;EACA,6BAAA;AA0omBF;;AAvomBA,WAAA;AACA;;EAEE,YAAA;AA0omBF","sourcesContent":["/* Host Variables */\n:host {\n  --grid-auto-row-height: 0;\n  --grid-fill-color: var(--ids-layout-grid-color-background);\n  --grid-text-color: var(--ids-layout-grid-color-text);\n  --min-col-width: 0;\n  --max-col-width: 1fr;\n  --min-row-height: 0;\n  --min-row-width: 1fr;\n  --sticky-position: 0;\n}\n\n/* Grid Variables */\n$prefix: 'ids-layout-grid';\n$spacing-unit: 8px;\n$grid-cols: 24;\n$grid-rows: 50;\n$grid-gap-sm: $spacing-unit;\n$grid-gap: $spacing-unit * 2;\n$grid-gap-md: $spacing-unit * 3;\n$grid-gap-lg: $spacing-unit * 4;\n$grid-gap-xl: $spacing-unit * 5;\n$grid-margin-xs: $spacing-unit;\n$grid-margin-sm: $spacing-unit * 2;\n$grid-margin-md: $spacing-unit * 3;\n$grid-margin-lg: $spacing-unit * 4;\n$grid-margin-xl: $spacing-unit * 5;\n$grid-padding-xxs: calc($spacing-unit / 2);\n$grid-padding-xs: $spacing-unit;\n$grid-padding-sm: $spacing-unit * 2;\n$grid-padding-md: $spacing-unit * 3;\n$grid-padding-lg: $spacing-unit * 4;\n$grid-padding-xl: $spacing-unit * 5;\n$min-col-width: var(--min-col-width);\n$max-col-width: var(--max-col-width);\n$min-row-height: var(--min-row-height);\n$max-row-height: var(--max-row-height);\n$max-width: var(--max-width);\n\n/* Host and ids-layout-grid Base */\n:host,\n.#{$prefix} {\n  display: grid;\n  grid-gap: $grid-gap;\n  justify-content: start;\n  box-sizing: border-box;\n}\n\n/* Grid Columms - Base */\n@for $i from 1 through $grid-cols {\n  :host([cols='#{$i}']),\n  .#{$prefix}-cols-#{$i} {\n    width: 100%;\n    grid-template-columns: repeat($i, minmax($min-col-width, $max-col-width));\n  }\n\n  :host(.#{$prefix}) > ::slotted([col-span='#{$i}']),\n  .#{$prefix} > .#{$prefix}-col-span-#{$i} {\n    grid-column: span $i / span $i;\n  }\n\n  :host(.#{$prefix}) > ::slotted([col-start='#{$i}']),\n  .#{$prefix} > .#{$prefix}-col-start-#{$i} {\n    grid-column-start: $i;\n  }\n\n  :host(.#{$prefix}) > ::slotted([col-end='#{$i}']),\n  .#{$prefix} > .#{$prefix}-col-end-#{$i} {\n    grid-column-end: $i;\n  }\n}\n\n/* Grid Rows - Base */\n@for $i from 1 through $grid-rows {\n  :host([rows='#{$i}']),\n  .#{$prefix}-rows-#{$i} {\n    grid-template-rows: repeat($i, minmax(0, 1fr));\n  }\n\n  :host(.#{$prefix}) > ::slotted([row-span='#{$i}']),\n  .#{$prefix} > .#{$prefix}-row-span-#{$i} {\n    grid-row: span $i / span $i;\n  }\n\n  :host(.#{$prefix}) > ::slotted([order='#{$i}']),\n  .#{$prefix} > .#{$prefix}-order-#{$i} {\n    order: $i;\n  }\n\n  :host(.#{$prefix}) > ::slotted([order='-1']),\n  .#{$prefix} > .#{$prefix}-order--1 {\n    order: -1;\n  }\n}\n","@use '../../themes/mixins/ids-core-mixins' as *;\n@use './ids-layout-grid-base' as *;\n@use './ids-layout-grid-responsive' as *;\n\n// ================================================\n// Main\n\n/* Use media queries by default */\n:host(:not([enable-container])),\n.#{$prefix}:not([enable-container]) {\n  @include media-queries;\n}\n\n/* Use container queries if enabled */\n:host([enable-container]),\n.#{$prefix}[enable-container] {\n  container-type: inline-size;\n\n  @include container-queries;\n}\n\n/* Grid Gaps */\n:host([gap='none']),\n.#{$prefix}.#{$prefix}-gap-none {\n  grid-gap: 0;\n}\n\n:host([gap='sm']),\n.#{$prefix}.#{$prefix}-gap-sm {\n  grid-gap: $grid-gap-sm;\n}\n\n:host([gap='md']),\n.#{$prefix}.#{$prefix}-gap-md {\n  grid-gap: $grid-gap-md;\n}\n\n:host([gap='lg']),\n.#{$prefix}.#{$prefix}-gap-lg {\n  grid-gap: $grid-gap-lg;\n}\n\n:host([gap='xl']),\n.#{$prefix}.#{$prefix}-gap-xl {\n  grid-gap: $grid-gap-xl;\n}\n\n// ================================================\n// Box Model\n\n/* Grid Margins */\n:host([margin='xs']),\n.#{$prefix}.#{$prefix}-margin-xs {\n  margin: $grid-margin-xs;\n}\n\n:host([margin='sm']),\n.#{$prefix}.#{$prefix}-margin-sm {\n  margin: $grid-margin-sm;\n}\n\n:host([margin='md']),\n.#{$prefix}.#{$prefix}-margin-md {\n  margin: $grid-margin-md;\n}\n\n:host([margin='lg']),\n.#{$prefix}.#{$prefix}-margin-lg {\n  margin: $grid-margin-lg;\n}\n\n:host([margin='xl']),\n.#{$prefix}.#{$prefix}-margin-xl {\n  margin: $grid-margin-xl;\n}\n\n:host([margin='auto']),\n.#{$prefix}.#{$prefix}-margin-auto {\n  margin: auto;\n}\n\n/* Grid Margin Y */\n:host([margin-y='xs']),\n.#{$prefix}.#{$prefix}-margin-y-xs {\n  margin-block: $grid-margin-xs;\n}\n\n:host([margin-y='sm']),\n.#{$prefix}.#{$prefix}-margin-y-sm {\n  margin-block: $grid-margin-sm;\n}\n\n:host([margin-y='md']),\n.#{$prefix}.#{$prefix}-margin-y-md {\n  margin-block: $grid-margin-md;\n}\n\n:host([margin-y='lg']),\n.#{$prefix}.#{$prefix}-margin-y-lg {\n  margin-block: $grid-margin-lg;\n}\n\n:host([margin-y='xl']),\n.#{$prefix}.#{$prefix}-margin-y-xl {\n  margin-block: $grid-margin-xl;\n}\n\n/* Grid Max Width */\n:host([max-width='xs']),\n.#{$prefix}.#{$prefix}-max-width-xs {\n  max-width: $breakpoint-xs;\n}\n\n:host([max-width='sm']),\n.#{$prefix}.#{$prefix}-max-width-sm {\n  max-width: $breakpoint-sm;\n}\n\n:host([max-width='md']),\n.#{$prefix}.#{$prefix}-max-width-md {\n  max-width: $breakpoint-md;\n}\n\n:host([max-width='lg']),\n.#{$prefix}.#{$prefix}-max-width-lg {\n  max-width: $breakpoint-lg;\n}\n\n:host([max-width='xl']),\n.#{$prefix}.#{$prefix}-max-width-xl {\n  max-width: $breakpoint-xl;\n}\n\n:host([max-width='xxl']),\n.#{$prefix}.#{$prefix}-max-width-xxl {\n  max-width: $breakpoint-xxl;\n}\n\n:host([max-width$='px']) {\n  max-width: var(--max-width);\n}\n\n/* Grid Padding */\n:host([padding='xs']),\n::slotted([padding='xs']),\n.#{$prefix}.#{$prefix}-padding-xs {\n  padding: $grid-padding-xs;\n}\n\n:host([padding='sm']),\n::slotted([padding='sm']),\n.#{$prefix}.#{$prefix}-padding-sm {\n  padding: $grid-padding-sm;\n}\n\n:host([padding='md']),\n::slotted([padding='md']),\n.#{$prefix}.#{$prefix}-padding-md {\n  padding: $grid-padding-md;\n}\n\n:host([padding='lg']),\n::slotted([padding='lg']),\n.#{$prefix}.#{$prefix}-padding-lg {\n  padding: $grid-padding-lg;\n}\n\n:host([padding='xl']),\n::slotted([padding='xl']),\n.#{$prefix}.#{$prefix}-padding-xl {\n  padding: $grid-padding-xl;\n}\n\n/* Grid Padding X */\n:host([padding-x='xs']),\n.#{$prefix}.#{$prefix}-padding-x-xs {\n  padding-inline: $grid-padding-xs;\n}\n\n:host([padding-x='sm']),\n.#{$prefix}.#{$prefix}-padding-x-sm {\n  padding-inline: $grid-padding-sm;\n}\n\n:host([padding-x='md']),\n.#{$prefix}.#{$prefix}-padding-x-md {\n  padding-inline: $grid-padding-md;\n}\n\n:host([padding-x='lg']),\n.#{$prefix}.#{$prefix}-padding-x-lg {\n  padding-inline: $grid-padding-lg;\n}\n\n:host([padding-x='xl']),\n.#{$prefix}.#{$prefix}-padding-x-xl {\n  padding-inline: $grid-padding-xl;\n}\n\n/* Grid Padding Y */\n:host([padding-y='xs']),\n.#{$prefix}.#{$prefix}-padding-y-xs {\n  padding-block: $grid-padding-xs;\n}\n\n:host([padding-y='xxs']),\n.#{$prefix}.#{$prefix}-padding-y-xxs {\n  padding-block: $grid-padding-xxs;\n}\n\n:host([padding-y='sm']),\n.#{$prefix}.#{$prefix}-padding-y-sm {\n  padding-block: $grid-padding-sm;\n}\n\n:host([padding-y='md']),\n.#{$prefix}.#{$prefix}-padding-y-md {\n  padding-block: $grid-padding-md;\n}\n\n:host([padding-y='lg']),\n.#{$prefix}.#{$prefix}-padding-y-lg {\n  padding-block: $grid-padding-lg;\n}\n\n:host([padding-y='xl']),\n.#{$prefix}.#{$prefix}-padding-y-xl {\n  padding-block: $grid-padding-xl;\n}\n\n// ================================================\n// Grid Layout\n\n/* Grid - Auto Fit/Fill */\n:host([auto-fit]),\n.#{$prefix}-auto-fit {\n  width: 100%;\n  grid-template-columns: repeat(auto-fit, minmax($min-col-width, $max-col-width));\n}\n\n:host([auto-fill]),\n.#{$prefix}-auto-fill {\n  width: 100%;\n  grid-template-columns: repeat(auto-fill, minmax($min-col-width, $max-col-width));\n}\n\n/* Grid - Auto Columns - TODO - Add settings for grid-auto-columns */\n:host(.#{$prefix}-cols-auto),\n.#{$prefix}-cols-auto {\n  grid-auto-columns: auto;\n}\n\n:host(.#{$prefix}-cols-min),\n.#{$prefix}-cols-min\t{\n  grid-auto-columns: min-content;\n}\n\n:host(.#{$prefix}-cols-max),\n.#{$prefix}-cols-max {\n  grid-auto-columns: max-content;\n}\n\n:host(.#{$prefix}-cols-fr),\n.#{$prefix}-cols-fr {\n  grid-auto-columns: minmax(0, 1fr);\n}\n\n/* Grid Flow */\n:host([flow='row']),\n.#{$prefix}-flow-row {\n  grid-auto-flow: row;\n}\n\n:host([flow='column']),\n.#{$prefix}-flow-col {\n  grid-auto-flow: column;\n}\n\n:host([flow='dense']),\n.#{$prefix}-flow-dense {\n  grid-auto-flow: dense;\n}\n\n:host([flow='row-dense']),\n.#{$prefix}-flow-row-dense {\n  grid-auto-flow: row dense;\n}\n\n:host([flow='column-dense']),\n.#{$prefix}-flow-col-dense {\n  grid-auto-flow: column dense;\n}\n\n/* Grid - Auto Rows - TODO - Add settings for grid-auto-rows */\n:host(.#{$prefix}-auto-rows-auto),\n.#{$prefix}-auto-rows-auto {\n  grid-auto-rows: auto;\n}\n\n:host(.#{$prefix}-auto-rows-min),\n.#{$prefix}-auto-rows-min {\n  grid-auto-rows: min-content;\n}\n\n:host(.#{$prefix}-auto-rows-max),\n.#{$prefix}-auto-rows-max {\n  grid-auto-rows: max-content;\n}\n\n:host(.#{$prefix}-auto-rows-fr),\n.#{$prefix}-auto-rows-fr {\n  grid-auto-rows: minmax(0, 1fr);\n}\n\n:host([row-height]),\n.#{$prefix}-auto-row-height {\n  grid-auto-rows: var(--grid-auto-row-height);\n}\n\n/* Grid - Template Rows */\n:host([template-rows]),\n.#{$prefix}-template-rows {\n  grid-template-rows: var(--grid-template-rows);\n}\n\n/** Align items */\n$align-items-list: start end center stretch;\n\n@each $align-items in $align-items-list {\n  :host([align-items='#{$align-items}']),\n  .#{$prefix}-align-items-#{$align-items} {\n    align-items: $align-items;\n  }\n}\n\n/* Justify Content and Align Content */\n$align-content-list: start center space-between space-around space-evenly end;\n\n@each $align-content in $align-content-list {\n  :host([justify-content='#{$align-content}']),\n  .#{$prefix}-justify-#{$align-content} {\n    justify-content: $align-content;\n  }\n\n  :host([align-content='#{$align-content}']),\n  .#{$prefix}-align-#{$align-content} {\n    align-content: $align-content;\n  }\n\n  ::slotted([justify-content='#{$align-content}']),\n  .#{$prefix} > .#{$prefix}-justify-#{$align-content} {\n    display: grid;\n    justify-content: $align-content;\n  }\n\n  ::slotted([align-content='#{$align-content}']),\n  .#{$prefix} > .#{$prefix}-align-#{$align-content} {\n    display: grid;\n    align-content: $align-content;\n  }\n}\n\n/* Grid Col/Row Span All and Sticky */\n::slotted([col-span='all']),\n.#{$prefix} > .#{$prefix}-col-span-all {\n  grid-column: 1 / -1;\n}\n\n::slotted([row-span='all']),\n.#{$prefix} > .#{$prefix}-row-span-all {\n  grid-row: 1 / -1;\n}\n\n::slotted([sticky]),\n.#{$prefix} > .#{$prefix}-sticky {\n  position: sticky;\n  top: var(--sticky-position);\n}\n\n// ================================================\n// Hide Cells\n\n/* Hide Cell on Breakpoints */\n:host > ::slotted([hide='xs']) {\n  display: none;\n}\n\n:host > ::slotted([hide='sm']) {\n  display: none;\n}\n\n:host > ::slotted([hide='md']) {\n  display: none;\n}\n\n:host > ::slotted([hide='lg']) {\n  display: none;\n}\n\n:host > ::slotted([hide='xl']) {\n  display: none;\n}\n\n:host > ::slotted([hide='xxl']) {\n  display: none;\n}\n\n:host > ::slotted([hide='always']) {\n  display: none;\n}\n\n// ================================================\n// Row and column gap\n\n:host([row-gap='none']),\n::slotted([row-gap='none']),\n.#{$prefix}.#{$prefix}-row-gap-none {\n  row-gap: 0;\n}\n\n:host([row-gap='xs']),\n::slotted([row-gap='xs']),\n.#{$prefix}.#{$prefix}-row-gap-xs {\n  row-gap: $grid-padding-xs;\n}\n\n:host([row-gap='sm']),\n::slotted([row-gap='sm']),\n.#{$prefix}.#{$prefix}-row-gap-sm {\n  row-gap: $grid-padding-sm;\n}\n\n:host([row-gap='md']),\n::slotted([row-gap='md']),\n.#{$prefix}.#{$prefix}-row-gap-md {\n  row-gap: $grid-padding-md;\n}\n\n:host([row-gap='lg']),\n::slotted([row-gap='lg']),\n.#{$prefix}.#{$prefix}-row-gap-lg {\n  row-gap: $grid-padding-lg;\n}\n\n:host([row-gap='xl']),\n::slotted([row-gap='xl']),\n.#{$prefix}.#{$prefix}-row-gap-xl {\n  row-gap: $grid-padding-xl;\n}\n\n:host([col-gap='none']),\n::slotted([col-gap='none']),\n.#{$prefix}.#{$prefix}-col-gap-none {\n  column-gap: 0;\n}\n\n:host([col-gap='xs']),\n::slotted([col-gap='xs']),\n.#{$prefix}.#{$prefix}-col-gap-xs {\n  column-gap: $grid-padding-xs;\n}\n\n:host([col-gap='sm']),\n::slotted([col-gap='sm']),\n.#{$prefix}.#{$prefix}-col-gap-sm {\n  column-gap: $grid-padding-sm;\n}\n\n:host([col-gap='md']),\n::slotted([col-gap='md']),\n.#{$prefix}.#{$prefix}-col-gap-md {\n  column-gap: $grid-padding-md;\n}\n\n:host([col-gap='lg']),\n::slotted([col-gap='lg']),\n.#{$prefix}.#{$prefix}-col-gap-lg {\n  column-gap: $grid-padding-lg;\n}\n\n:host([col-gap='xl']),\n::slotted([col-gap='xl']),\n.#{$prefix}.#{$prefix}-col-gap-xl {\n  column-gap: $grid-padding-xl;\n}\n\n// ================================================\n// Demo Utilities\n\n/* Editable */\n::slotted([editable]) > ids-button,\n.#{$prefix} > .#{$prefix}-cell.editable > ids-button {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n/* Fill */\n::slotted([fill]),\n.#{$prefix} > .#{$prefix}-cell.fill {\n  background-color: var(--grid-fill-color);\n  color: var(--grid-text-color);\n}\n\n/* Height */\n::slotted([height='auto']),\n.#{$prefix} > .#{$prefix}-height-auto {\n  height: auto;\n}\n","// ================================================\n// Viewport and Container Queries\n@use '../../themes/mixins/ids-core-mixins' as *;\n@use './ids-layout-grid-base' as *;\n\n// Base Media Queries\n@mixin grid-rows($size) {\n  @for $i from 1 through $grid-rows {\n    &[rows-#{$size}='#{$i}'],\n    &.#{$prefix}-rows-#{$size}-#{$i} {\n      grid-template-rows: repeat($i, minmax(0, 1fr));\n    }\n    & > ::slotted([row-span-#{$size}='#{$i}']),\n    &.#{$prefix} > .#{$prefix}-row-span-#{$size}-#{$i} {\n      grid-row: span $i / span $i;\n    }\n    & > ::slotted([order-#{$size}='#{$i}']),\n    &.#{$prefix} > .#{$prefix}-order-#{$size}-#{$i} {\n      order: $i;\n    }\n    & > ::slotted([order-#{$size}='-1']),\n    &.#{$prefix} > .#{$prefix}-order-#{$size}--1 {\n      order: -1;\n    }\n  }\n}\n\n@mixin hide-show($size) {\n  & > ::slotted([hide='#{$size}']) {\n    display: block;\n  }\n}\n\n@each $size, $breakpoint in (xs: $breakpoint-xs, sm: $breakpoint-sm, md: $breakpoint-md, lg: $breakpoint-lg, xl: $breakpoint-xl, xxl: $breakpoint-xxl) {\n  @media (min-width: #{$breakpoint}) {\n    @for $i from 1 through $grid-cols {\n      :host(:not([enable-container])[cols-#{$size}='#{$i}']),\n      .#{$prefix}-cols-#{$size}-#{$i} {\n        width: 100%;\n        grid-template-columns: repeat(#{$i}, minmax($min-col-width, $max-col-width));\n      }\n    }\n\n    :host([flow-#{$size}=\"row\"]),\n    .#{$prefix}-flow-#{$size}-row {\n      grid-auto-flow: row;\n    }\n    :host([flow-#{$size}=\"column\"]),\n    .#{$prefix}-flow-#{$size}-col {\n      grid-auto-flow: column;\n    }\n    :host([flow-#{$size}=\"dense\"]),\n    .#{$prefix}-flow-#{$size}-dense {\n      grid-auto-flow: dense;\n    }\n    :host([flow-#{$size}=\"row-dense\"]),\n    .#{$prefix}-flow-#{$size}-row-dense {\n      grid-auto-flow: row dense;\n    }\n    :host([flow-#{$size}=\"column-dense\"]),\n    .#{$prefix}-flow-#{$size}-col-dense {\n      grid-auto-flow: column dense;\n    }\n  }\n}\n\n@each $size, $breakpoint in (xs: $breakpoint-xs, sm: $breakpoint-sm, md: $breakpoint-md, lg: $breakpoint-lg, xl: $breakpoint-xl, xxl: $breakpoint-xxl) {\n  @container (min-width: #{$breakpoint}) {\n    @for $i from 1 through $grid-cols {\n      :host([cols-#{$size}='#{$i}']),\n      .#{$prefix}-cols-#{$size}-#{$i} {\n        width: 100%;\n        grid-template-columns: repeat(#{$i}, minmax($min-col-width, $max-col-width));\n      }\n    }\n  }\n}\n\n@mixin container-queries {\n  @each $size, $breakpoint in (xs: $breakpoint-xs, sm: $breakpoint-sm, md: $breakpoint-md, lg: $breakpoint-lg, xl: $breakpoint-xl, xxl: $breakpoint-xxl) {\n    @container (min-width: #{$breakpoint}) {\n      @include grid-cols($size);\n      @include grid-rows($size);\n      @include hide-show($size);\n    }\n  }\n}\n\n@mixin media-queries {\n  @each $size, $breakpoint in (xs: $breakpoint-xs, sm: $breakpoint-sm, md: $breakpoint-md, lg: $breakpoint-lg, xl: $breakpoint-xl, xxl: $breakpoint-xxl) {\n    @media (min-width: #{$breakpoint}) {\n      @include grid-cols($size);\n      @include grid-rows($size);\n      @include hide-show($size);\n    }\n  }\n}\n\n@mixin grid-cols($size) {\n  @for $i from 1 through $grid-cols {\n    & > ::slotted([col-span-#{$size}='#{$i}']),\n    &.#{$prefix} > .#{$prefix}-col-span-#{$size}-#{$i} {\n      grid-column: span $i / span $i;\n    }\n    & > ::slotted([col-start-#{$size}='#{$i}']),\n    &.#{$prefix} > .#{$prefix}-col-start-#{$size}-#{$i} {\n      grid-column-start: $i;\n    }\n    & > ::slotted([col-end-#{$size}='#{$i}']),\n    &.#{$prefix} > .#{$prefix}-col-end-#{$size}-#{$i} {\n      grid-column-end: $i;\n    }\n  }\n}\n\n","// Breakpoints - this cant be tokens\n$breakpoint-xxl: 1440px;\n$breakpoint-xl: 1280px;\n$breakpoint-lg: 1024px;\n$breakpoint-md: 840px;\n$breakpoint-sm: 600px;\n$breakpoint-xs: 320px;\n\n// Sets Text Antialiasing\n@mixin antialiased {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n// vendor prefixed transitions for regular attributes (non-vendor prefixed)\n@mixin transition($transitions-list...) {\n  @each $prefix in $prefixes {\n    #{$prefix}transition: $transitions-list;\n  }\n}\n\n// make the text invisible visually but readable by screen readers\n@mixin audible() {\n  clip: rect(0, 0, 0, 0);\n  height: 0;\n  line-height: 0;\n  min-height: 0;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
